// @ts-nocheck
import { Dayjs } from 'dayjs';
/* tslint:disable */
/* eslint-disable */
/**
 * ShareHeritage API
 * The ShareHeritage API description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 *
 * @export
 * @interface AcceptDocumentSuggestionDto
 */
export interface AcceptDocumentSuggestionDto {
  /**
   *
   * @type {string}
   * @memberof AcceptDocumentSuggestionDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof AcceptDocumentSuggestionDto
   */
  path?: string;
}
/**
 *
 * @export
 * @interface AccountsStatementDto
 */
export interface AccountsStatementDto {
  /**
   *
   * @type {Dayjs}
   * @memberof AccountsStatementDto
   */
  asOf: Dayjs;
  /**
   * Closing date (card I): operations before it are folded into initialBalance.
   * @type {Dayjs}
   * @memberof AccountsStatementDto
   */
  periodStart: Dayjs | null;
  /**
   *
   * @type {HouseSummaryDto}
   * @memberof AccountsStatementDto
   */
  house: HouseSummaryDto | null;
  /**
   * Sorted by position, descending.
   * @type {Array<MemberPositionDto>}
   * @memberof AccountsStatementDto
   */
  members: Array<MemberPositionDto>;
  /**
   *
   * @type {StatementCheckDto}
   * @memberof AccountsStatementDto
   */
  check: StatementCheckDto;
}
/**
 *
 * @export
 * @interface AddPracticalInformationAttachmentsDto
 */
export interface AddPracticalInformationAttachmentsDto {
  /**
   * IDs of virtual files (already uploaded) to attach to the practical information.
   * @type {Array<string>}
   * @memberof AddPracticalInformationAttachmentsDto
   */
  fileIds: Array<string>;
}
/**
 *
 * @export
 * @interface AddProjectAttachmentsDto
 */
export interface AddProjectAttachmentsDto {
  /**
   * IDs des VirtualFiles déjà uploadés à attacher au projet
   * @type {Array<string>}
   * @memberof AddProjectAttachmentsDto
   */
  attachmentIds: Array<string>;
}
/**
 *
 * @export
 * @interface AddressResponseDto
 */
export interface AddressResponseDto {
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  formattedAddress: string;
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  streetNumber: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  route: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  locality: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  postalCode: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  country: string | null;
  /**
   *
   * @type {number}
   * @memberof AddressResponseDto
   */
  latitude: number;
  /**
   *
   * @type {number}
   * @memberof AddressResponseDto
   */
  longitude: number;
  /**
   *
   * @type {string}
   * @memberof AddressResponseDto
   */
  googlePlaceId: string | null;
}
/**
 *
 * @export
 * @interface AgentTranscriptionDto
 */
export interface AgentTranscriptionDto {
  /**
   * Texte dicté, placé dans le champ de Lucien pour être relu avant envoi.
   * @type {string}
   * @memberof AgentTranscriptionDto
   */
  transcript: string;
}
/**
 *
 * @export
 * @interface AlbumPhotoDto
 */
export interface AlbumPhotoDto {
  /**
   *
   * @type {string}
   * @memberof AlbumPhotoDto
   */
  storageFileId: string;
  /**
   *
   * @type {string}
   * @memberof AlbumPhotoDto
   */
  url: string;
  /**
   *
   * @type {string}
   * @memberof AlbumPhotoDto
   */
  previewUrl?: string;
  /**
   *
   * @type {string}
   * @memberof AlbumPhotoDto
   */
  thumbnailUrl?: string;
  /**
   *
   * @type {string}
   * @memberof AlbumPhotoDto
   */
  blurhash?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof AlbumPhotoDto
   */
  taggedAt: Dayjs;
}
/**
 *
 * @export
 * @interface AnnouncementDto
 */
export interface AnnouncementDto {
  /**
   *
   * @type {string}
   * @memberof AnnouncementDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AnnouncementDto
   */
  level: AnnouncementDtoLevelEnum;
  /**
   *
   * @type {string}
   * @memberof AnnouncementDto
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof AnnouncementDto
   */
  isActive: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof AnnouncementDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof AnnouncementDto
   */
  updatedAt: Dayjs;
}

export const AnnouncementDtoLevelEnum = {
  Info: 'INFO',
  Warning: 'WARNING',
  Critical: 'CRITICAL',
} as const;

export type AnnouncementDtoLevelEnum =
  (typeof AnnouncementDtoLevelEnum)[keyof typeof AnnouncementDtoLevelEnum];

/**
 *
 * @export
 * @interface AssetAnnouncementDto
 */
export interface AssetAnnouncementDto {
  /**
   *
   * @type {string}
   * @memberof AssetAnnouncementDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetAnnouncementDto
   */
  level: AssetAnnouncementDtoLevelEnum;
  /**
   *
   * @type {string}
   * @memberof AssetAnnouncementDto
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetAnnouncementDto
   */
  isActive: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetAnnouncementDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetAnnouncementDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof AssetAnnouncementDto
   */
  createdById: string;
}

export const AssetAnnouncementDtoLevelEnum = {
  Info: 'INFO',
  Warning: 'WARNING',
  Critical: 'CRITICAL',
} as const;

export type AssetAnnouncementDtoLevelEnum =
  (typeof AssetAnnouncementDtoLevelEnum)[keyof typeof AssetAnnouncementDtoLevelEnum];

/**
 *
 * @export
 * @interface AssetDetailsDto
 */
export interface AssetDetailsDto {
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  type: AssetDetailsDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  status: AssetDetailsDtoStatusEnum;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  description?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetDetailsDto
   */
  acquisitionDate?: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetDetailsDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetDetailsDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {boolean}
   * @memberof AssetDetailsDto
   */
  isOwner: boolean;
  /**
   * Signed URL for the asset photo
   * @type {string}
   * @memberof AssetDetailsDto
   */
  imageUrl?: string;
  /**
   * Signed URL for the asset photo preview
   * @type {string}
   * @memberof AssetDetailsDto
   */
  previewUrl?: string;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  currentUserRole: AssetDetailsDtoCurrentUserRoleEnum;
  /**
   * Granular permissions for the current user on this asset
   * @type {object}
   * @memberof AssetDetailsDto
   */
  currentUserPermissions?: object;
  /**
   *
   * @type {AddressResponseDto}
   * @memberof AssetDetailsDto
   */
  address: AddressResponseDto;
  /**
   * The current usage metrics for this asset.
   * @type {AssetUsageDto}
   * @memberof AssetDetailsDto
   */
  usage: AssetUsageDto;
  /**
   *
   * @type {UserDto}
   * @memberof AssetDetailsDto
   */
  owner: UserDto;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  legalStructure?: AssetDetailsDtoLegalStructureEnum;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  taxRegime?: AssetDetailsDtoTaxRegimeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetDetailsDto
   */
  specialStatuses?: Array<AssetDetailsDtoSpecialStatusesEnum>;
  /**
   *
   * @type {boolean}
   * @memberof AssetDetailsDto
   */
  hasDismemberment: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  shareType?: AssetDetailsDtoShareTypeEnum;
  /**
   *
   * @type {number}
   * @memberof AssetDetailsDto
   */
  totalShares?: number;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  ownerOperationalRole?: AssetDetailsDtoOwnerOperationalRoleEnum;
  /**
   *
   * @type {number}
   * @memberof AssetDetailsDto
   */
  ownerShares?: number;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  ownerOwnershipNature?: AssetDetailsDtoOwnerOwnershipNatureEnum;
  /**
   *
   * @type {boolean}
   * @memberof AssetDetailsDto
   */
  ownerHasVotingRights?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  currentUserOperationalRole?: AssetDetailsDtoCurrentUserOperationalRoleEnum;
  /**
   *
   * @type {number}
   * @memberof AssetDetailsDto
   */
  currentUserShares?: number;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  currentUserOwnershipNature?: AssetDetailsDtoCurrentUserOwnershipNatureEnum;
  /**
   *
   * @type {boolean}
   * @memberof AssetDetailsDto
   */
  currentUserHasVotingRights?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  managementMode?: AssetDetailsDtoManagementModeEnum;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  syndicLibreType?: AssetDetailsDtoSyndicLibreTypeEnum;
  /**
   *
   * @type {string}
   * @memberof AssetDetailsDto
   */
  rentalDeclarationRegime?: AssetDetailsDtoRentalDeclarationRegimeEnum;
  /**
   *
   * @type {number}
   * @memberof AssetDetailsDto
   */
  defaultLocativeShare?: number;
}

export const AssetDetailsDtoTypeEnum = {
  RealEstate: 'REAL_ESTATE',
  Movable: 'MOVABLE',
  Financial: 'FINANCIAL',
  Intellectual: 'INTELLECTUAL',
  Business: 'BUSINESS',
} as const;

export type AssetDetailsDtoTypeEnum =
  (typeof AssetDetailsDtoTypeEnum)[keyof typeof AssetDetailsDtoTypeEnum];
export const AssetDetailsDtoStatusEnum = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
} as const;

export type AssetDetailsDtoStatusEnum =
  (typeof AssetDetailsDtoStatusEnum)[keyof typeof AssetDetailsDtoStatusEnum];
export const AssetDetailsDtoCurrentUserRoleEnum = {
  Manager: 'manager',
  Member: 'member',
  Viewer: 'viewer',
} as const;

export type AssetDetailsDtoCurrentUserRoleEnum =
  (typeof AssetDetailsDtoCurrentUserRoleEnum)[keyof typeof AssetDetailsDtoCurrentUserRoleEnum];
export const AssetDetailsDtoLegalStructureEnum = {
  FullOwnership: 'FULL_OWNERSHIP',
  Indivision: 'INDIVISION',
  Sci: 'SCI',
  SarlFamille: 'SARL_FAMILLE',
} as const;

export type AssetDetailsDtoLegalStructureEnum =
  (typeof AssetDetailsDtoLegalStructureEnum)[keyof typeof AssetDetailsDtoLegalStructureEnum];
export const AssetDetailsDtoTaxRegimeEnum = {
  Ir: 'IR',
  Is: 'IS',
} as const;

export type AssetDetailsDtoTaxRegimeEnum =
  (typeof AssetDetailsDtoTaxRegimeEnum)[keyof typeof AssetDetailsDtoTaxRegimeEnum];
export const AssetDetailsDtoSpecialStatusesEnum = {
  Lmnp: 'LMNP',
  MonumentHistorique: 'MONUMENT_HISTORIQUE',
} as const;

export type AssetDetailsDtoSpecialStatusesEnum =
  (typeof AssetDetailsDtoSpecialStatusesEnum)[keyof typeof AssetDetailsDtoSpecialStatusesEnum];
export const AssetDetailsDtoShareTypeEnum = {
  Percentage: 'PERCENTAGE',
  Tantiemes: 'TANTIEMES',
  PartsSociales: 'PARTS_SOCIALES',
} as const;

export type AssetDetailsDtoShareTypeEnum =
  (typeof AssetDetailsDtoShareTypeEnum)[keyof typeof AssetDetailsDtoShareTypeEnum];
export const AssetDetailsDtoOwnerOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type AssetDetailsDtoOwnerOperationalRoleEnum =
  (typeof AssetDetailsDtoOwnerOperationalRoleEnum)[keyof typeof AssetDetailsDtoOwnerOperationalRoleEnum];
export const AssetDetailsDtoOwnerOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type AssetDetailsDtoOwnerOwnershipNatureEnum =
  (typeof AssetDetailsDtoOwnerOwnershipNatureEnum)[keyof typeof AssetDetailsDtoOwnerOwnershipNatureEnum];
export const AssetDetailsDtoCurrentUserOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type AssetDetailsDtoCurrentUserOperationalRoleEnum =
  (typeof AssetDetailsDtoCurrentUserOperationalRoleEnum)[keyof typeof AssetDetailsDtoCurrentUserOperationalRoleEnum];
export const AssetDetailsDtoCurrentUserOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type AssetDetailsDtoCurrentUserOwnershipNatureEnum =
  (typeof AssetDetailsDtoCurrentUserOwnershipNatureEnum)[keyof typeof AssetDetailsDtoCurrentUserOwnershipNatureEnum];
export const AssetDetailsDtoManagementModeEnum = {
  SyndicPro: 'SYNDIC_PRO',
  SyndicLibre: 'SYNDIC_LIBRE',
  NoCopro: 'NO_COPRO',
  Unknown: 'UNKNOWN',
} as const;

export type AssetDetailsDtoManagementModeEnum =
  (typeof AssetDetailsDtoManagementModeEnum)[keyof typeof AssetDetailsDtoManagementModeEnum];
export const AssetDetailsDtoSyndicLibreTypeEnum = {
  Benevole: 'BENEVOLE',
  Cooperatif: 'COOPERATIF',
  Unknown: 'UNKNOWN',
} as const;

export type AssetDetailsDtoSyndicLibreTypeEnum =
  (typeof AssetDetailsDtoSyndicLibreTypeEnum)[keyof typeof AssetDetailsDtoSyndicLibreTypeEnum];
export const AssetDetailsDtoRentalDeclarationRegimeEnum = {
  Reel: 'REEL',
  MicroFoncier: 'MICRO_FONCIER',
} as const;

export type AssetDetailsDtoRentalDeclarationRegimeEnum =
  (typeof AssetDetailsDtoRentalDeclarationRegimeEnum)[keyof typeof AssetDetailsDtoRentalDeclarationRegimeEnum];

/**
 *
 * @export
 * @interface AssetDto
 */
export interface AssetDto {
  /**
   *
   * @type {string}
   * @memberof AssetDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetDto
   */
  type: AssetDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof AssetDto
   */
  status: AssetDtoStatusEnum;
  /**
   *
   * @type {string}
   * @memberof AssetDto
   */
  description?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetDto
   */
  acquisitionDate?: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {boolean}
   * @memberof AssetDto
   */
  isOwner: boolean;
  /**
   * Signed URL for the asset photo
   * @type {string}
   * @memberof AssetDto
   */
  imageUrl?: string;
  /**
   * Signed URL for the asset photo preview
   * @type {string}
   * @memberof AssetDto
   */
  previewUrl?: string;
}

export const AssetDtoTypeEnum = {
  RealEstate: 'REAL_ESTATE',
  Movable: 'MOVABLE',
  Financial: 'FINANCIAL',
  Intellectual: 'INTELLECTUAL',
  Business: 'BUSINESS',
} as const;

export type AssetDtoTypeEnum = (typeof AssetDtoTypeEnum)[keyof typeof AssetDtoTypeEnum];
export const AssetDtoStatusEnum = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
} as const;

export type AssetDtoStatusEnum = (typeof AssetDtoStatusEnum)[keyof typeof AssetDtoStatusEnum];

/**
 *
 * @export
 * @interface AssetMemberBalanceDto
 */
export interface AssetMemberBalanceDto {
  /**
   *
   * @type {string}
   * @memberof AssetMemberBalanceDto
   */
  assetMemberId: string;
  /**
   * Absent pour un co-indivisaire non inscrit, qui n_a pas de compte.
   * @type {string}
   * @memberof AssetMemberBalanceDto
   */
  userId?: string | null;
  /**
   * Renseigne a la place de userId pour un co-indivisaire non inscrit.
   * @type {string}
   * @memberof AssetMemberBalanceDto
   */
  placeholderMemberId?: string | null;
  /**
   *
   * @type {string}
   * @memberof AssetMemberBalanceDto
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AssetMemberBalanceDto
   */
  lastName?: string | null;
  /**
   * Nom affichable, toujours rempli : prenom nom, sinon e-mail estime, sinon « Membre sans nom ».
   * @type {string}
   * @memberof AssetMemberBalanceDto
   */
  displayName: string;
  /**
   * Solde initial a la date pivot (0 si aucun solde initial saisi)
   * @type {number}
   * @memberof AssetMemberBalanceDto
   */
  initialBalance: number;
  /**
   * Activite depuis la date pivot (netBalance - initialBalance)
   * @type {number}
   * @memberof AssetMemberBalanceDto
   */
  activity: number;
  /**
   * Solde net actuel (initialBalance + activity)
   * @type {number}
   * @memberof AssetMemberBalanceDto
   */
  netBalance: number;
}
/**
 *
 * @export
 * @interface AssetMemberDto
 */
export interface AssetMemberDto {
  /**
   *
   * @type {string}
   * @memberof AssetMemberDto
   */
  id: string;
  /**
   * Real AssetMember row id, always populated. Unlike `id` (which is the literal string \"owner\" for the owner\'s synthetic entry, kept for backward compatibility), this is always a genuine UUID — use it when a real AssetMember foreign key is needed (e.g. initial balances, reminders).
   * @type {string}
   * @memberof AssetMemberDto
   */
  assetMemberId?: string;
  /**
   *
   * @type {string}
   * @memberof AssetMemberDto
   */
  role: AssetMemberDtoRoleEnum;
  /**
   * Granular permissions for this member
   * @type {object}
   * @memberof AssetMemberDto
   */
  permissions: object;
  /**
   *
   * @type {Dayjs}
   * @memberof AssetMemberDto
   */
  joinedAt: Dayjs;
  /**
   *
   * @type {AssetMemberUserDto}
   * @memberof AssetMemberDto
   */
  user: AssetMemberUserDto;
  /**
   * True if this member is a non-registered placeholder.
   * @type {boolean}
   * @memberof AssetMemberDto
   */
  isPlaceholder: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetMemberDto
   */
  operationalRole?: AssetMemberDtoOperationalRoleEnum;
  /**
   *
   * @type {number}
   * @memberof AssetMemberDto
   */
  shares?: number;
  /**
   *
   * @type {string}
   * @memberof AssetMemberDto
   */
  ownershipNature?: AssetMemberDtoOwnershipNatureEnum;
  /**
   *
   * @type {boolean}
   * @memberof AssetMemberDto
   */
  isMandate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetMemberDto
   */
  hasVotingRights?: boolean;
}

export const AssetMemberDtoRoleEnum = {
  Manager: 'manager',
  Member: 'member',
  Viewer: 'viewer',
} as const;

export type AssetMemberDtoRoleEnum =
  (typeof AssetMemberDtoRoleEnum)[keyof typeof AssetMemberDtoRoleEnum];
export const AssetMemberDtoOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type AssetMemberDtoOperationalRoleEnum =
  (typeof AssetMemberDtoOperationalRoleEnum)[keyof typeof AssetMemberDtoOperationalRoleEnum];
export const AssetMemberDtoOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type AssetMemberDtoOwnershipNatureEnum =
  (typeof AssetMemberDtoOwnershipNatureEnum)[keyof typeof AssetMemberDtoOwnershipNatureEnum];

/**
 *
 * @export
 * @interface AssetMemberUserDto
 */
export interface AssetMemberUserDto {
  /**
   *
   * @type {string}
   * @memberof AssetMemberUserDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetMemberUserDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof AssetMemberUserDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof AssetMemberUserDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof AssetMemberUserDto
   */
  profilePictureUrl?: string;
}
/**
 *
 * @export
 * @interface AssetMembersDto
 */
export interface AssetMembersDto {
  /**
   *
   * @type {string}
   * @memberof AssetMembersDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetMembersDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetMembersDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof AssetMembersDto
   */
  type: string;
  /**
   *
   * @type {AssetMemberUserDto}
   * @memberof AssetMembersDto
   */
  owner: AssetMemberUserDto;
  /**
   *
   * @type {Array<AssetMemberDto>}
   * @memberof AssetMembersDto
   */
  members: Array<AssetMemberDto>;
  /**
   *
   * @type {Array<PendingInvitationDto>}
   * @memberof AssetMembersDto
   */
  pendingInvitations: Array<PendingInvitationDto>;
}
/**
 *
 * @export
 * @interface AssetPreviewDto
 */
export interface AssetPreviewDto {
  /**
   *
   * @type {string}
   * @memberof AssetPreviewDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetPreviewDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetPreviewDto
   */
  type: AssetPreviewDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof AssetPreviewDto
   */
  status: AssetPreviewDtoStatusEnum;
}

export const AssetPreviewDtoTypeEnum = {
  RealEstate: 'REAL_ESTATE',
  Movable: 'MOVABLE',
  Financial: 'FINANCIAL',
  Intellectual: 'INTELLECTUAL',
  Business: 'BUSINESS',
} as const;

export type AssetPreviewDtoTypeEnum =
  (typeof AssetPreviewDtoTypeEnum)[keyof typeof AssetPreviewDtoTypeEnum];
export const AssetPreviewDtoStatusEnum = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
} as const;

export type AssetPreviewDtoStatusEnum =
  (typeof AssetPreviewDtoStatusEnum)[keyof typeof AssetPreviewDtoStatusEnum];

/**
 *
 * @export
 * @interface AssetPreviewWithCommunityAndOwnerInfoDto
 */
export interface AssetPreviewWithCommunityAndOwnerInfoDto {
  /**
   *
   * @type {string}
   * @memberof AssetPreviewWithCommunityAndOwnerInfoDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetPreviewWithCommunityAndOwnerInfoDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetPreviewWithCommunityAndOwnerInfoDto
   */
  type: AssetPreviewWithCommunityAndOwnerInfoDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof AssetPreviewWithCommunityAndOwnerInfoDto
   */
  status: AssetPreviewWithCommunityAndOwnerInfoDtoStatusEnum;
  /**
   * Indicates if the community feed is enabled for this asset based on the owner\'s subscription plan.
   * @type {boolean}
   * @memberof AssetPreviewWithCommunityAndOwnerInfoDto
   */
  allowMyCommunity: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetPreviewWithCommunityAndOwnerInfoDto
   */
  isOwner: boolean;
}

export const AssetPreviewWithCommunityAndOwnerInfoDtoTypeEnum = {
  RealEstate: 'REAL_ESTATE',
  Movable: 'MOVABLE',
  Financial: 'FINANCIAL',
  Intellectual: 'INTELLECTUAL',
  Business: 'BUSINESS',
} as const;

export type AssetPreviewWithCommunityAndOwnerInfoDtoTypeEnum =
  (typeof AssetPreviewWithCommunityAndOwnerInfoDtoTypeEnum)[keyof typeof AssetPreviewWithCommunityAndOwnerInfoDtoTypeEnum];
export const AssetPreviewWithCommunityAndOwnerInfoDtoStatusEnum = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
} as const;

export type AssetPreviewWithCommunityAndOwnerInfoDtoStatusEnum =
  (typeof AssetPreviewWithCommunityAndOwnerInfoDtoStatusEnum)[keyof typeof AssetPreviewWithCommunityAndOwnerInfoDtoStatusEnum];

/**
 *
 * @export
 * @interface AssetStatsDto
 */
export interface AssetStatsDto {
  /**
   *
   * @type {number}
   * @memberof AssetStatsDto
   */
  totalBalance: number;
  /**
   *
   * @type {number}
   * @memberof AssetStatsDto
   */
  totalExpenses: number;
  /**
   *
   * @type {number}
   * @memberof AssetStatsDto
   */
  totalRevenues: number;
  /**
   *
   * @type {Array<CategoryStatsDto>}
   * @memberof AssetStatsDto
   */
  expensesByCategory: Array<CategoryStatsDto>;
  /**
   *
   * @type {Array<CategoryStatsDto>}
   * @memberof AssetStatsDto
   */
  revenuesByCategory: Array<CategoryStatsDto>;
  /**
   * Total expenses for the current year
   * @type {number}
   * @memberof AssetStatsDto
   */
  yearlyExpenseTotal: number;
  /**
   * Annual budget cap configured for the asset
   * @type {number}
   * @memberof AssetStatsDto
   */
  annualBudgetCap?: number | null;
  /**
   * Years with at least one operation, plus current year
   * @type {Array<number>}
   * @memberof AssetStatsDto
   */
  availableYears: Array<number>;
  /**
   * Total budget from forecast lines for the requested year (null if no forecast)
   * @type {number}
   * @memberof AssetStatsDto
   */
  budgetForecastTotal?: number | null;
}
/**
 *
 * @export
 * @interface AssetStorageItemDto
 */
export interface AssetStorageItemDto {
  /**
   * The id of the file in the virtual file system
   * @type {string}
   * @memberof AssetStorageItemDto
   */
  id: string;
  /**
   * The path of the folder the file is stored in
   * @type {string}
   * @memberof AssetStorageItemDto
   */
  path: string;
  /**
   * The name of the file
   * @type {string}
   * @memberof AssetStorageItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetStorageItemDto
   */
  mimeType: string;
  /**
   *
   * @type {number}
   * @memberof AssetStorageItemDto
   */
  size: number;
  /**
   *
   * @type {string}
   * @memberof AssetStorageItemDto
   */
  type: AssetStorageItemDtoTypeEnum;
  /**
   * Last modified date
   * @type {Dayjs}
   * @memberof AssetStorageItemDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {FileUploaderDto}
   * @memberof AssetStorageItemDto
   */
  createdBy: FileUploaderDto;
  /**
   *
   * @type {string}
   * @memberof AssetStorageItemDto
   */
  externalUrl?: string;
}

export const AssetStorageItemDtoTypeEnum = {
  File: 'file',
  Folder: 'folder',
  Video: 'video',
  ExternalLink: 'external_link',
} as const;

export type AssetStorageItemDtoTypeEnum =
  (typeof AssetStorageItemDtoTypeEnum)[keyof typeof AssetStorageItemDtoTypeEnum];

/**
 *
 * @export
 * @interface AssetUsageDto
 */
export interface AssetUsageDto {
  /**
   * Usage metrics for videos within this asset.
   * @type {UsageDto}
   * @memberof AssetUsageDto
   */
  videos: UsageDto;
  /**
   * Usage metrics for storage within this asset (in MB).
   * @type {StorageUsageDto}
   * @memberof AssetUsageDto
   */
  storage: StorageUsageDto;
}
/**
 *
 * @export
 * @interface AssetWeatherDto
 */
export interface AssetWeatherDto {
  /**
   * The assets for which the weather is given. Multiple assets are grouped together if they are in the same city and postal code.
   * @type {Array<AssetDto>}
   * @memberof AssetWeatherDto
   */
  assets: Array<AssetDto>;
  /**
   * The address to which the weather is given
   * @type {AddressResponseDto}
   * @memberof AssetWeatherDto
   */
  address: AddressResponseDto;
  /**
   * The weather right now. There may be 1 hour of delay.
   * @type {WeatherCurrentConditionsDto}
   * @memberof AssetWeatherDto
   */
  currentConditions: WeatherCurrentConditionsDto | null;
  /**
   * The weather in the next few hours.
   * @type {Array<WeatherForecastHourDto>}
   * @memberof AssetWeatherDto
   */
  forecastByHour: Array<WeatherForecastHourDto> | null;
  /**
   * The weather in the next few days.
   * @type {Array<WeatherForecastDayDto>}
   * @memberof AssetWeatherDto
   */
  forecastByDay: Array<WeatherForecastDayDto> | null;
}
/**
 *
 * @export
 * @interface AssetWithExpensesEquilibrium
 */
export interface AssetWithExpensesEquilibrium {
  /**
   *
   * @type {string}
   * @memberof AssetWithExpensesEquilibrium
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof AssetWithExpensesEquilibrium
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetWithExpensesEquilibrium
   */
  type: AssetWithExpensesEquilibriumTypeEnum;
  /**
   *
   * @type {string}
   * @memberof AssetWithExpensesEquilibrium
   */
  status: AssetWithExpensesEquilibriumStatusEnum;
  /**
   *
   * @type {UserEquilibriumDto}
   * @memberof AssetWithExpensesEquilibrium
   */
  expensesEquilibrium: UserEquilibriumDto;
}

export const AssetWithExpensesEquilibriumTypeEnum = {
  RealEstate: 'REAL_ESTATE',
  Movable: 'MOVABLE',
  Financial: 'FINANCIAL',
  Intellectual: 'INTELLECTUAL',
  Business: 'BUSINESS',
} as const;

export type AssetWithExpensesEquilibriumTypeEnum =
  (typeof AssetWithExpensesEquilibriumTypeEnum)[keyof typeof AssetWithExpensesEquilibriumTypeEnum];
export const AssetWithExpensesEquilibriumStatusEnum = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
} as const;

export type AssetWithExpensesEquilibriumStatusEnum =
  (typeof AssetWithExpensesEquilibriumStatusEnum)[keyof typeof AssetWithExpensesEquilibriumStatusEnum];

/**
 *
 * @export
 * @interface AssetsControllerUpdateBudgetCap200Response
 */
export interface AssetsControllerUpdateBudgetCap200Response {
  /**
   *
   * @type {number}
   * @memberof AssetsControllerUpdateBudgetCap200Response
   */
  annualBudgetCap?: number | null;
}
/**
 *
 * @export
 * @interface AttachmentDto
 */
export interface AttachmentDto {
  /**
   * The virtual file\'s unique ID.
   * @type {string}
   * @memberof AttachmentDto
   */
  id: string;
  /**
   * The name of the file.
   * @type {string}
   * @memberof AttachmentDto
   */
  name: string;
  /**
   * The file\'s MIME type (e.g., \'application/pdf\').
   * @type {string}
   * @memberof AttachmentDto
   */
  mimeType: string;
  /**
   * The file size in bytes.
   * @type {number}
   * @memberof AttachmentDto
   */
  size: number;
  /**
   * A blurhash string for image placeholders.
   * @type {string}
   * @memberof AttachmentDto
   */
  blurhash?: string;
  /**
   * Signed URLs for accessing the file and its previews.
   * @type {AttachmentUrlsDto}
   * @memberof AttachmentDto
   */
  urls: AttachmentUrlsDto;
  /**
   * The date the file was uploaded.
   * @type {Dayjs}
   * @memberof AttachmentDto
   */
  createdAt: Dayjs;
  /**
   * Video data/info if attachment is a video.
   * @type {VideoDto}
   * @memberof AttachmentDto
   */
  video?: VideoDto;
}
/**
 *
 * @export
 * @interface AttachmentUrlsDto
 */
export interface AttachmentUrlsDto {
  /**
   * URL to the original file.
   * @type {string}
   * @memberof AttachmentUrlsDto
   */
  fileUrl: string;
  /**
   * URL to the large preview.
   * @type {string}
   * @memberof AttachmentUrlsDto
   */
  previewLargeUrl?: string;
  /**
   * URL to the medium preview.
   * @type {string}
   * @memberof AttachmentUrlsDto
   */
  previewMediumUrl?: string;
  /**
   * URL to the thumbnail preview.
   * @type {string}
   * @memberof AttachmentUrlsDto
   */
  previewThumbnailUrl?: string;
}
/**
 *
 * @export
 * @interface AutocompleteSuggestionV2Dto
 */
export interface AutocompleteSuggestionV2Dto {
  /**
   *
   * @type {PlacePredictionDetailsDto}
   * @memberof AutocompleteSuggestionV2Dto
   */
  placePrediction: PlacePredictionDetailsDto;
  /**
   *
   * @type {string}
   * @memberof AutocompleteSuggestionV2Dto
   */
  kind?: string;
}
/**
 *
 * @export
 * @interface AutocompleteV2ResponseDto
 */
export interface AutocompleteV2ResponseDto {
  /**
   *
   * @type {Array<AutocompleteSuggestionV2Dto>}
   * @memberof AutocompleteV2ResponseDto
   */
  suggestions: Array<AutocompleteSuggestionV2Dto>;
}
/**
 *
 * @export
 * @interface BalanceDetailDto
 */
export interface BalanceDetailDto {
  /**
   * The target entity (user or bank account)
   * @type {SettlementTargetDto}
   * @memberof BalanceDetailDto
   */
  target: SettlementTargetDto;
  /**
   * Total amount (positive if owed to me, negative if I owe)
   * @type {number}
   * @memberof BalanceDetailDto
   */
  totalAmount: number;
  /**
   * Detailed list of expenses contributing to the balance
   * @type {Array<BalanceDetailItemDto>}
   * @memberof BalanceDetailDto
   */
  items: Array<BalanceDetailItemDto>;
  /**
   * Start of the open accounting period (asset closing date), when one is set. Items before it are not listed.
   * @type {Dayjs}
   * @memberof BalanceDetailDto
   */
  periodStart?: Dayjs;
}
/**
 *
 * @export
 * @interface BalanceDetailItemDto
 */
export interface BalanceDetailItemDto {
  /**
   * An expense share, or a money transfer between the two parties.
   * @type {string}
   * @memberof BalanceDetailItemDto
   */
  kind: BalanceDetailItemDtoKindEnum;
  /**
   * Set when kind is EXPENSE.
   * @type {string}
   * @memberof BalanceDetailItemDto
   */
  expenseId?: string;
  /**
   * Set when kind is TRANSFER.
   * @type {string}
   * @memberof BalanceDetailItemDto
   */
  transferId?: string;
  /**
   * Expense title. Empty for a transfer, labelled by the client.
   * @type {string}
   * @memberof BalanceDetailItemDto
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof BalanceDetailItemDto
   */
  amount: number;
  /**
   *
   * @type {Dayjs}
   * @memberof BalanceDetailItemDto
   */
  paidAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof BalanceDetailItemDto
   */
  type?: BalanceDetailItemDtoTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof BalanceDetailItemDto
   */
  isIncome: boolean;
  /**
   *
   * @type {BalanceDetailPaidByDto}
   * @memberof BalanceDetailItemDto
   */
  paidBy?: BalanceDetailPaidByDto;
  /**
   *
   * @type {BalanceDetailPaidByBankAccountDto}
   * @memberof BalanceDetailItemDto
   */
  paidByBankAccount?: BalanceDetailPaidByBankAccountDto;
  /**
   *
   * @type {BalanceDetailPaidByContactDto}
   * @memberof BalanceDetailItemDto
   */
  paidByContact?: BalanceDetailPaidByContactDto;
  /**
   * Sender of the transfer. Set when kind is TRANSFER.
   * @type {BalanceDetailPartyDto}
   * @memberof BalanceDetailItemDto
   */
  from?: BalanceDetailPartyDto;
  /**
   * Recipient of the transfer. Set when kind is TRANSFER.
   * @type {BalanceDetailPartyDto}
   * @memberof BalanceDetailItemDto
   */
  to?: BalanceDetailPartyDto;
  /**
   * The amount the current user owes or is owed for this expense
   * @type {number}
   * @memberof BalanceDetailItemDto
   */
  myShareAmount: number;
  /**
   * Shares already settled on this expense, over all its shares. Set when kind is EXPENSE and the expense is neither an income nor a settlement.
   * @type {number}
   * @memberof BalanceDetailItemDto
   */
  settledSharesCount?: number;
  /**
   * Total number of shares on this expense. Set alongside settledSharesCount.
   * @type {number}
   * @memberof BalanceDetailItemDto
   */
  totalSharesCount?: number;
}

export const BalanceDetailItemDtoKindEnum = {
  Expense: 'EXPENSE',
  Transfer: 'TRANSFER',
} as const;

export type BalanceDetailItemDtoKindEnum =
  (typeof BalanceDetailItemDtoKindEnum)[keyof typeof BalanceDetailItemDtoKindEnum];
export const BalanceDetailItemDtoTypeEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type BalanceDetailItemDtoTypeEnum =
  (typeof BalanceDetailItemDtoTypeEnum)[keyof typeof BalanceDetailItemDtoTypeEnum];

/**
 *
 * @export
 * @interface BalanceDetailPaidByBankAccountDto
 */
export interface BalanceDetailPaidByBankAccountDto {
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByBankAccountDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByBankAccountDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface BalanceDetailPaidByContactDto
 */
export interface BalanceDetailPaidByContactDto {
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByContactDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByContactDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByContactDto
   */
  lastName?: string;
  /**
   * Nom de l\'entreprise, ou prénom + nom
   * @type {string}
   * @memberof BalanceDetailPaidByContactDto
   */
  displayName: string;
}
/**
 *
 * @export
 * @interface BalanceDetailPaidByDto
 */
export interface BalanceDetailPaidByDto {
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPaidByDto
   */
  lastName: string;
}
/**
 *
 * @export
 * @interface BalanceDetailPartyDto
 */
export interface BalanceDetailPartyDto {
  /**
   *
   * @type {string}
   * @memberof BalanceDetailPartyDto
   */
  id: string;
  /**
   * Set for a member, registered or not.
   * @type {string}
   * @memberof BalanceDetailPartyDto
   */
  firstName?: string;
  /**
   * Set for a member, registered or not.
   * @type {string}
   * @memberof BalanceDetailPartyDto
   */
  lastName?: string;
  /**
   * Set for a bank account.
   * @type {string}
   * @memberof BalanceDetailPartyDto
   */
  name?: string;
}
/**
 *
 * @export
 * @interface BankAccountBalanceDto
 */
export interface BankAccountBalanceDto {
  /**
   * The balance statement\'s unique identifier.
   * @type {string}
   * @memberof BankAccountBalanceDto
   */
  id: string;
  /**
   * The recorded balance amount.
   * @type {number}
   * @memberof BankAccountBalanceDto
   */
  amount: number;
  /**
   * The statement date.
   * @type {Dayjs}
   * @memberof BankAccountBalanceDto
   */
  recordedAt: Dayjs;
  /**
   * The member who recorded this statement, or null if they left the asset.
   * @type {BankAccountBalanceRecordedByDto}
   * @memberof BankAccountBalanceDto
   */
  recordedBy?: BankAccountBalanceRecordedByDto | null;
}
/**
 *
 * @export
 * @interface BankAccountBalanceRecordedByDto
 */
export interface BankAccountBalanceRecordedByDto {
  /**
   *
   * @type {string}
   * @memberof BankAccountBalanceRecordedByDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BankAccountBalanceRecordedByDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof BankAccountBalanceRecordedByDto
   */
  lastName: string;
}
/**
 *
 * @export
 * @interface BankAccountDto
 */
export interface BankAccountDto {
  /**
   * The bank account\'s unique identifier.
   * @type {string}
   * @memberof BankAccountDto
   */
  id: string;
  /**
   * The name of the bank account.
   * @type {string}
   * @memberof BankAccountDto
   */
  name: string;
  /**
   * The name of the bank, e.g. \"Crédit Agricole\".
   * @type {string}
   * @memberof BankAccountDto
   */
  bankName?: string;
  /**
   * The bank logo domain key used by Brandfetch.
   * @type {string}
   * @memberof BankAccountDto
   */
  bankDomain?: string;
  /**
   * Free text detail, e.g. \"Île-de-France\".
   * @type {string}
   * @memberof BankAccountDto
   */
  bankDetail?: string;
  /**
   * Beneficiary name printed on statements.
   * @type {string}
   * @memberof BankAccountDto
   */
  holderName?: string | null;
  /**
   * IBAN, without spaces.
   * @type {string}
   * @memberof BankAccountDto
   */
  iban?: string | null;
  /**
   * BIC / SWIFT code.
   * @type {string}
   * @memberof BankAccountDto
   */
  bic?: string | null;
  /**
   * The ID of the asset this bank account belongs to.
   * @type {string}
   * @memberof BankAccountDto
   */
  assetId: string;
  /**
   * The most recent balance statement, or null if none was recorded yet.
   * @type {BankAccountLatestBalanceDto}
   * @memberof BankAccountDto
   */
  latestBalance?: BankAccountLatestBalanceDto | null;
}
/**
 *
 * @export
 * @interface BankAccountLatestBalanceDto
 */
export interface BankAccountLatestBalanceDto {
  /**
   * The most recently recorded balance amount.
   * @type {number}
   * @memberof BankAccountLatestBalanceDto
   */
  amount: number;
  /**
   * The date the balance was recorded for.
   * @type {Dayjs}
   * @memberof BankAccountLatestBalanceDto
   */
  recordedAt: Dayjs;
}
/**
 *
 * @export
 * @interface BatchBalanceItemDto
 */
export interface BatchBalanceItemDto {
  /**
   *
   * @type {string}
   * @memberof BatchBalanceItemDto
   */
  assetMemberId: string;
  /**
   *
   * @type {number}
   * @memberof BatchBalanceItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof BatchBalanceItemDto
   */
  label?: string;
}
/**
 *
 * @export
 * @interface BedDto
 */
export interface BedDto {
  /**
   *
   * @type {string}
   * @memberof BedDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BedDto
   */
  type: BedDtoTypeEnum;
  /**
   *
   * @type {number}
   * @memberof BedDto
   */
  widthCm?: number;
  /**
   *
   * @type {number}
   * @memberof BedDto
   */
  lengthCm?: number;
  /**
   *
   * @type {string}
   * @memberof BedDto
   */
  label?: string;
  /**
   *
   * @type {number}
   * @memberof BedDto
   */
  position: number;
  /**
   * Capacité de couchage dérivée du type
   * @type {number}
   * @memberof BedDto
   */
  capacity: number;
  /**
   *
   * @type {Dayjs}
   * @memberof BedDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof BedDto
   */
  updatedAt: Dayjs;
}

export const BedDtoTypeEnum = {
  Single: 'SINGLE',
  Double: 'DOUBLE',
  Queen: 'QUEEN',
  King: 'KING',
  Bunk: 'BUNK',
  SofaBed: 'SOFA_BED',
  Baby: 'BABY',
  Cot: 'COT',
} as const;

export type BedDtoTypeEnum = (typeof BedDtoTypeEnum)[keyof typeof BedDtoTypeEnum];

/**
 *
 * @export
 * @interface BedsSummaryDto
 */
export interface BedsSummaryDto {
  /**
   *
   * @type {number}
   * @memberof BedsSummaryDto
   */
  total: number;
  /**
   *
   * @type {Array<string>}
   * @memberof BedsSummaryDto
   */
  byType: Array<BedsSummaryDtoByTypeEnum>;
  /**
   * Répartition par largeur de couchage en cm (140, 160…)
   * @type {Array<CountByKeyDto>}
   * @memberof BedsSummaryDto
   */
  byWidthCm: Array<CountByKeyDto>;
}

export const BedsSummaryDtoByTypeEnum = {
  Single: 'SINGLE',
  Double: 'DOUBLE',
  Queen: 'QUEEN',
  King: 'KING',
  Bunk: 'BUNK',
  SofaBed: 'SOFA_BED',
  Baby: 'BABY',
  Cot: 'COT',
} as const;

export type BedsSummaryDtoByTypeEnum =
  (typeof BedsSummaryDtoByTypeEnum)[keyof typeof BedsSummaryDtoByTypeEnum];

/**
 *
 * @export
 * @interface BetweenMembersDto
 */
export interface BetweenMembersDto {
  /**
   *
   * @type {number}
   * @memberof BetweenMembersDto
   */
  owes: number;
  /**
   *
   * @type {number}
   * @memberof BetweenMembersDto
   */
  owed: number;
  /**
   * Number of members this one owes or is owed by.
   * @type {number}
   * @memberof BetweenMembersDto
   */
  counterparties: number;
}
/**
 *
 * @export
 * @interface BudgetBreakdownDto
 */
export interface BudgetBreakdownDto {
  /**
   *
   * @type {string}
   * @memberof BudgetBreakdownDto
   */
  metric: BudgetBreakdownDtoMetricEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetBreakdownDto
   */
  formulaLabel: string;
  /**
   *
   * @type {Array<BudgetBreakdownTermDto>}
   * @memberof BudgetBreakdownDto
   */
  formulaTerms: Array<BudgetBreakdownTermDto>;
  /**
   * Sum of lines.amount — always exactly equal to it
   * @type {number}
   * @memberof BudgetBreakdownDto
   */
  total: number;
  /**
   *
   * @type {Array<BudgetBreakdownLineDto>}
   * @memberof BudgetBreakdownDto
   */
  lines: Array<BudgetBreakdownLineDto>;
}

export const BudgetBreakdownDtoMetricEnum = {
  Realized: 'REALIZED',
  Remaining: 'REMAINING',
  ProjectedOverrun: 'PROJECTED_OVERRUN',
} as const;

export type BudgetBreakdownDtoMetricEnum =
  (typeof BudgetBreakdownDtoMetricEnum)[keyof typeof BudgetBreakdownDtoMetricEnum];

/**
 *
 * @export
 * @interface BudgetBreakdownLineDto
 */
export interface BudgetBreakdownLineDto {
  /**
   *
   * @type {string}
   * @memberof BudgetBreakdownLineDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BudgetBreakdownLineDto
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof BudgetBreakdownLineDto
   */
  category: BudgetBreakdownLineDtoCategoryEnum;
  /**
   * Signed contribution to the total: positive for planned/spent, negative for a deduction
   * @type {number}
   * @memberof BudgetBreakdownLineDto
   */
  amount: number;
  /**
   *
   * @type {Dayjs}
   * @memberof BudgetBreakdownLineDto
   */
  date?: Dayjs | null;
  /**
   *
   * @type {string}
   * @memberof BudgetBreakdownLineDto
   */
  origin: BudgetBreakdownLineDtoOriginEnum;
  /**
   *
   * @type {boolean}
   * @memberof BudgetBreakdownLineDto
   */
  isPaid: boolean;
}

export const BudgetBreakdownLineDtoCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type BudgetBreakdownLineDtoCategoryEnum =
  (typeof BudgetBreakdownLineDtoCategoryEnum)[keyof typeof BudgetBreakdownLineDtoCategoryEnum];
export const BudgetBreakdownLineDtoOriginEnum = {
  Recurrence: 'RECURRENCE',
  Manual: 'MANUAL',
  RealExpense: 'REAL_EXPENSE',
} as const;

export type BudgetBreakdownLineDtoOriginEnum =
  (typeof BudgetBreakdownLineDtoOriginEnum)[keyof typeof BudgetBreakdownLineDtoOriginEnum];

/**
 *
 * @export
 * @interface BudgetBreakdownTermDto
 */
export interface BudgetBreakdownTermDto {
  /**
   *
   * @type {string}
   * @memberof BudgetBreakdownTermDto
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof BudgetBreakdownTermDto
   */
  value: number;
  /**
   *
   * @type {number}
   * @memberof BudgetBreakdownTermDto
   */
  sign: BudgetBreakdownTermDtoSignEnum;
}

export const BudgetBreakdownTermDtoSignEnum = {
  NUMBER_1: 1,
  NUMBER_MINUS_1: -1,
} as const;

export type BudgetBreakdownTermDtoSignEnum =
  (typeof BudgetBreakdownTermDtoSignEnum)[keyof typeof BudgetBreakdownTermDtoSignEnum];

/**
 *
 * @export
 * @interface BudgetDailyLifeCategorySuggestionDto
 */
export interface BudgetDailyLifeCategorySuggestionDto {
  /**
   *
   * @type {string}
   * @memberof BudgetDailyLifeCategorySuggestionDto
   */
  category: BudgetDailyLifeCategorySuggestionDtoCategoryEnum;
  /**
   *
   * @type {number}
   * @memberof BudgetDailyLifeCategorySuggestionDto
   */
  previousYearAmount: number;
  /**
   *
   * @type {number}
   * @memberof BudgetDailyLifeCategorySuggestionDto
   */
  expenseCount: number;
}

export const BudgetDailyLifeCategorySuggestionDtoCategoryEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type BudgetDailyLifeCategorySuggestionDtoCategoryEnum =
  (typeof BudgetDailyLifeCategorySuggestionDtoCategoryEnum)[keyof typeof BudgetDailyLifeCategorySuggestionDtoCategoryEnum];

/**
 *
 * @export
 * @interface BudgetDailyLifeSubCategorySuggestionDto
 */
export interface BudgetDailyLifeSubCategorySuggestionDto {
  /**
   *
   * @type {string}
   * @memberof BudgetDailyLifeSubCategorySuggestionDto
   */
  subCategory: BudgetDailyLifeSubCategorySuggestionDtoSubCategoryEnum;
  /**
   *
   * @type {number}
   * @memberof BudgetDailyLifeSubCategorySuggestionDto
   */
  previousYearAmount: number;
  /**
   *
   * @type {number}
   * @memberof BudgetDailyLifeSubCategorySuggestionDto
   */
  expenseCount: number;
  /**
   * Détail par catégorie de la rubrique, pour que le wizard détaille la Vie quotidienne comme les Frais fixes. Additif : le total de la rubrique reste `previousYearAmount`.
   * @type {Array<BudgetDailyLifeCategorySuggestionDto>}
   * @memberof BudgetDailyLifeSubCategorySuggestionDto
   */
  byCategory: Array<BudgetDailyLifeCategorySuggestionDto>;
}

export const BudgetDailyLifeSubCategorySuggestionDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type BudgetDailyLifeSubCategorySuggestionDtoSubCategoryEnum =
  (typeof BudgetDailyLifeSubCategorySuggestionDtoSubCategoryEnum)[keyof typeof BudgetDailyLifeSubCategorySuggestionDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface BudgetDailyLifeSuggestionDto
 */
export interface BudgetDailyLifeSuggestionDto {
  /**
   * Single N−1 envelope for the whole daily-life section.
   * @type {number}
   * @memberof BudgetDailyLifeSuggestionDto
   */
  previousYearTotal: number;
  /**
   *
   * @type {Array<BudgetDailyLifeSubCategorySuggestionDto>}
   * @memberof BudgetDailyLifeSuggestionDto
   */
  bySubCategory: Array<BudgetDailyLifeSubCategorySuggestionDto>;
}
/**
 *
 * @export
 * @interface BudgetFixedCostSuggestionDto
 */
export interface BudgetFixedCostSuggestionDto {
  /**
   *
   * @type {string}
   * @memberof BudgetFixedCostSuggestionDto
   */
  category: BudgetFixedCostSuggestionDtoCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetFixedCostSuggestionDto
   */
  mainCategory: BudgetFixedCostSuggestionDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetFixedCostSuggestionDto
   */
  subCategory: BudgetFixedCostSuggestionDtoSubCategoryEnum;
  /**
   * Amount actually paid on this category over N−1.
   * @type {number}
   * @memberof BudgetFixedCostSuggestionDto
   */
  previousYearAmount: number;
  /**
   *
   * @type {number}
   * @memberof BudgetFixedCostSuggestionDto
   */
  expenseCount: number;
}

export const BudgetFixedCostSuggestionDtoCategoryEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type BudgetFixedCostSuggestionDtoCategoryEnum =
  (typeof BudgetFixedCostSuggestionDtoCategoryEnum)[keyof typeof BudgetFixedCostSuggestionDtoCategoryEnum];
export const BudgetFixedCostSuggestionDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type BudgetFixedCostSuggestionDtoMainCategoryEnum =
  (typeof BudgetFixedCostSuggestionDtoMainCategoryEnum)[keyof typeof BudgetFixedCostSuggestionDtoMainCategoryEnum];
export const BudgetFixedCostSuggestionDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type BudgetFixedCostSuggestionDtoSubCategoryEnum =
  (typeof BudgetFixedCostSuggestionDtoSubCategoryEnum)[keyof typeof BudgetFixedCostSuggestionDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface BudgetForecastExclusionDto
 */
export interface BudgetForecastExclusionDto {
  /**
   *
   * @type {string}
   * @memberof BudgetForecastExclusionDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastExclusionDto
   */
  expenseId: string;
  /**
   *
   * @type {number}
   * @memberof BudgetForecastExclusionDto
   */
  budgetYear: number;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastExclusionDto
   */
  excludedById: string;
  /**
   *
   * @type {Dayjs}
   * @memberof BudgetForecastExclusionDto
   */
  createdAt: Dayjs;
}
/**
 *
 * @export
 * @interface BudgetForecastLineDto
 */
export interface BudgetForecastLineDto {
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof BudgetForecastLineDto
   */
  year: number;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineDto
   */
  mainCategory: BudgetForecastLineDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineDto
   */
  subCategory?: BudgetForecastLineDtoSubCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineDto
   */
  subCategoryEntryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineDto
   */
  subCategoryEntryLabel?: string | null;
  /**
   *
   * @type {number}
   * @memberof BudgetForecastLineDto
   */
  amount: number;
}

export const BudgetForecastLineDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type BudgetForecastLineDtoMainCategoryEnum =
  (typeof BudgetForecastLineDtoMainCategoryEnum)[keyof typeof BudgetForecastLineDtoMainCategoryEnum];
export const BudgetForecastLineDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type BudgetForecastLineDtoSubCategoryEnum =
  (typeof BudgetForecastLineDtoSubCategoryEnum)[keyof typeof BudgetForecastLineDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface BudgetForecastLineRequestDto
 */
export interface BudgetForecastLineRequestDto {
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineRequestDto
   */
  mainCategory: BudgetForecastLineRequestDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineRequestDto
   */
  subCategory?: BudgetForecastLineRequestDtoSubCategoryEnum;
  /**
   * ID of the named sub-line (ExpenseSubCategory) this amount belongs to. Omitted for an unsplit lump line for the whole rubric.
   * @type {string}
   * @memberof BudgetForecastLineRequestDto
   */
  subCategoryEntryId?: string;
  /**
   * Final budgeted amount, typed directly or via the « vs N−1 » %.
   * @type {number}
   * @memberof BudgetForecastLineRequestDto
   */
  amount: number;
  /**
   * Reconciliation key.
   * @type {string}
   * @memberof BudgetForecastLineRequestDto
   */
  category?: BudgetForecastLineRequestDtoCategoryEnum;
  /**
   * 1 = yearly, 12 = monthly, 0.5 = biennial.
   * @type {number}
   * @memberof BudgetForecastLineRequestDto
   */
  frequencyPerYear?: number;
  /**
   * Multiply by the number of households.
   * @type {boolean}
   * @memberof BudgetForecastLineRequestDto
   */
  perHousehold?: boolean;
  /**
   * Actual N−1 amount snapshotted at suggestion time. The % is derived from it.
   * @type {number}
   * @memberof BudgetForecastLineRequestDto
   */
  previousYearAmount?: number;
  /**
   * Précision libre saisie sur la ligne.
   * @type {string}
   * @memberof BudgetForecastLineRequestDto
   */
  note?: string;
  /**
   *
   * @type {string}
   * @memberof BudgetForecastLineRequestDto
   */
  sourceType?: BudgetForecastLineRequestDtoSourceTypeEnum;
  /**
   * Informative project reference, not a FK.
   * @type {string}
   * @memberof BudgetForecastLineRequestDto
   */
  sourceProjectId?: string;
}

export const BudgetForecastLineRequestDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type BudgetForecastLineRequestDtoMainCategoryEnum =
  (typeof BudgetForecastLineRequestDtoMainCategoryEnum)[keyof typeof BudgetForecastLineRequestDtoMainCategoryEnum];
export const BudgetForecastLineRequestDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type BudgetForecastLineRequestDtoSubCategoryEnum =
  (typeof BudgetForecastLineRequestDtoSubCategoryEnum)[keyof typeof BudgetForecastLineRequestDtoSubCategoryEnum];
export const BudgetForecastLineRequestDtoCategoryEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type BudgetForecastLineRequestDtoCategoryEnum =
  (typeof BudgetForecastLineRequestDtoCategoryEnum)[keyof typeof BudgetForecastLineRequestDtoCategoryEnum];
export const BudgetForecastLineRequestDtoSourceTypeEnum = {
  SuggestionPreviousYear: 'SUGGESTION_PREVIOUS_YEAR',
  Project: 'PROJECT',
  Manual: 'MANUAL',
} as const;

export type BudgetForecastLineRequestDtoSourceTypeEnum =
  (typeof BudgetForecastLineRequestDtoSourceTypeEnum)[keyof typeof BudgetForecastLineRequestDtoSourceTypeEnum];

/**
 *
 * @export
 * @interface BudgetForecastViewDto
 */
export interface BudgetForecastViewDto {
  /**
   *
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  year: number;
  /**
   * Number of recurring series automatically integrated
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  autoBundleCount: number;
  /**
   * Sum of all AUTO line totals
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  autoBundleAmount: number;
  /**
   *
   * @type {Array<ForecastViewLineDto>}
   * @memberof BudgetForecastViewDto
   */
  lines: Array<ForecastViewLineDto>;
  /**
   * Sum of materialized (paid) amounts across CHARGE-nature lines
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  realizedPaid: number;
  /**
   * Sum of identified pending amounts (virtual + forecast) across CHARGE-nature lines
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  identifiedPending: number;
  /**
   * Effective annual budget cap for charges (forecast charges total if it exists, else manual asset cap)
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  cap?: number | null;
  /**
   * cap - realizedPaid - identifiedPending; can be negative if over cap
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  remainingToCommit: number;
  /**
   * Sum of totalAmount across PRODUCT-nature lines
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  productsSubtotal: number;
  /**
   * Sum of totalAmount across CHARGE-nature lines
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  chargesSubtotal: number;
  /**
   * productsSubtotal - chargesSubtotal
   * @type {number}
   * @memberof BudgetForecastViewDto
   */
  balance: number;
  /**
   * Real expenses excluded from this year\'s budget. Kept out of lines and of every subtotal, but returned so the front can show a per-rubric \"N operations excluded (- X EUR)\" counter.
   * @type {Array<ForecastExcludedLineDto>}
   * @memberof BudgetForecastViewDto
   */
  excludedLines: Array<ForecastExcludedLineDto>;
}
/**
 *
 * @export
 * @interface BudgetFundCallSuggestionDto
 */
export interface BudgetFundCallSuggestionDto {
  /**
   * 12 = monthly, 4 = quarterly, 1 = yearly, 0.5 = every other year.
   * @type {number}
   * @memberof BudgetFundCallSuggestionDto
   */
  frequencyPerYear: number;
  /**
   * Rounded up to the euro so the suggestion never falls short.
   * @type {number}
   * @memberof BudgetFundCallSuggestionDto
   */
  amountPerHouseholdPerOccurrence: number;
  /**
   *
   * @type {number}
   * @memberof BudgetFundCallSuggestionDto
   */
  annualAmountPerHousehold: number;
  /**
   *
   * @type {number}
   * @memberof BudgetFundCallSuggestionDto
   */
  totalAnnualAmount: number;
}
/**
 *
 * @export
 * @interface BudgetHouseholdShareDto
 */
export interface BudgetHouseholdShareDto {
  /**
   *
   * @type {string}
   * @memberof BudgetHouseholdShareDto
   */
  householdId: string;
  /**
   *
   * @type {string}
   * @memberof BudgetHouseholdShareDto
   */
  householdName: string;
  /**
   * 0-100 percentage. Always sums to 100 across households.
   * @type {number}
   * @memberof BudgetHouseholdShareDto
   */
  percentage: number;
  /**
   *
   * @type {number}
   * @memberof BudgetHouseholdShareDto
   */
  annualAmount: number;
  /**
   *
   * @type {number}
   * @memberof BudgetHouseholdShareDto
   */
  monthlyAmount: number;
}
/**
 *
 * @export
 * @interface BudgetProjectSuggestionDto
 */
export interface BudgetProjectSuggestionDto {
  /**
   *
   * @type {string}
   * @memberof BudgetProjectSuggestionDto
   */
  projectId: string;
  /**
   *
   * @type {string}
   * @memberof BudgetProjectSuggestionDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof BudgetProjectSuggestionDto
   */
  status: BudgetProjectSuggestionDtoStatusEnum;
  /**
   *
   * @type {number}
   * @memberof BudgetProjectSuggestionDto
   */
  estimatedCost?: number | null;
}

export const BudgetProjectSuggestionDtoStatusEnum = {
  IdeaBox: 'IDEA_BOX',
  IdeaToVote: 'IDEA_TO_VOTE',
  ProjectValidated: 'PROJECT_VALIDATED',
  ProjectInProgress: 'PROJECT_IN_PROGRESS',
  ProjectCompleted: 'PROJECT_COMPLETED',
} as const;

export type BudgetProjectSuggestionDtoStatusEnum =
  (typeof BudgetProjectSuggestionDtoStatusEnum)[keyof typeof BudgetProjectSuggestionDtoStatusEnum];

/**
 *
 * @export
 * @interface BudgetSectionTotalDto
 */
export interface BudgetSectionTotalDto {
  /**
   *
   * @type {string}
   * @memberof BudgetSectionTotalDto
   */
  section: BudgetSectionTotalDtoSectionEnum;
  /**
   *
   * @type {number}
   * @memberof BudgetSectionTotalDto
   */
  lineCount: number;
  /**
   * Sum of the annual amounts of the section lines.
   * @type {number}
   * @memberof BudgetSectionTotalDto
   */
  plannedAmount: number;
  /**
   * Sum of previousYearAmount over the section lines that carry one.
   * @type {number}
   * @memberof BudgetSectionTotalDto
   */
  previousYearAmount?: number | null;
}

export const BudgetSectionTotalDtoSectionEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  Projects: 'PROJECTS',
  Income: 'INCOME',
} as const;

export type BudgetSectionTotalDtoSectionEnum =
  (typeof BudgetSectionTotalDtoSectionEnum)[keyof typeof BudgetSectionTotalDtoSectionEnum];

/**
 *
 * @export
 * @interface BudgetSimulationDto
 */
export interface BudgetSimulationDto {
  /**
   *
   * @type {string}
   * @memberof BudgetSimulationDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof BudgetSimulationDto
   */
  year: number;
  /**
   *
   * @type {number}
   * @memberof BudgetSimulationDto
   */
  personalBudgetMax?: number | null;
  /**
   *
   * @type {Array<string>}
   * @memberof BudgetSimulationDto
   */
  selectedForecastLineIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof BudgetSimulationDto
   */
  selectedProjectIds: Array<string>;
}
/**
 *
 * @export
 * @interface BudgetSuggestionsDto
 */
export interface BudgetSuggestionsDto {
  /**
   * Year the budget is being prepared for.
   * @type {number}
   * @memberof BudgetSuggestionsDto
   */
  year: number;
  /**
   * Year the suggestions are read from (year − 1).
   * @type {number}
   * @memberof BudgetSuggestionsDto
   */
  previousYear: number;
  /**
   *
   * @type {Array<BudgetFixedCostSuggestionDto>}
   * @memberof BudgetSuggestionsDto
   */
  fixedCosts: Array<BudgetFixedCostSuggestionDto>;
  /**
   *
   * @type {BudgetDailyLifeSuggestionDto}
   * @memberof BudgetSuggestionsDto
   */
  dailyLife: BudgetDailyLifeSuggestionDto;
  /**
   * Projects still in « À voter » or « Boîte à idées ».
   * @type {Array<BudgetProjectSuggestionDto>}
   * @memberof BudgetSuggestionsDto
   */
  projects: Array<BudgetProjectSuggestionDto>;
}
/**
 *
 * @export
 * @interface BudgetTrackingDto
 */
export interface BudgetTrackingDto {
  /**
   *
   * @type {number}
   * @memberof BudgetTrackingDto
   */
  year: number;
  /**
   *
   * @type {Array<BudgetTrackingRowDto>}
   * @memberof BudgetTrackingDto
   */
  rows: Array<BudgetTrackingRowDto>;
  /**
   * Categories seen in the real expenses but absent from the budget. Informative.
   * @type {Array<BudgetTrackingUnplannedRowDto>}
   * @memberof BudgetTrackingDto
   */
  unplanned: Array<BudgetTrackingUnplannedRowDto>;
  /**
   *
   * @type {number}
   * @memberof BudgetTrackingDto
   */
  plannedTotal: number;
  /**
   * Real total over the reconciled rows only.
   * @type {number}
   * @memberof BudgetTrackingDto
   */
  actualTotal: number;
  /**
   * Everything really spent over the year, budgeted or not, settlements and incomes excluded. Same figure as the finances hub: one realised amount, one gauge.
   * @type {number}
   * @memberof BudgetTrackingDto
   */
  spentTotal: number;
  /**
   *
   * @type {number}
   * @memberof BudgetTrackingDto
   */
  varianceTotal: number;
  /**
   *
   * @type {number}
   * @memberof BudgetTrackingDto
   */
  unplannedTotal: number;
}
/**
 *
 * @export
 * @interface BudgetTrackingRowDto
 */
export interface BudgetTrackingRowDto {
  /**
   * Stable grouping key: the ExpenseType when the row is reconciled, \"line:<id>\" otherwise.
   * @type {string}
   * @memberof BudgetTrackingRowDto
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingRowDto
   */
  category?: BudgetTrackingRowDtoCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingRowDto
   */
  mainCategory: BudgetTrackingRowDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingRowDto
   */
  subCategory?: BudgetTrackingRowDtoSubCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingRowDto
   */
  section: BudgetTrackingRowDtoSectionEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingRowDto
   */
  subCategoryEntryLabel?: string | null;
  /**
   * Budget lines aggregated in this row. Two lines of the same category share one row.
   * @type {Array<string>}
   * @memberof BudgetTrackingRowDto
   */
  lineIds: Array<string>;
  /**
   * Sum of the annual amounts of the lines in this row.
   * @type {number}
   * @memberof BudgetTrackingRowDto
   */
  plannedAmount: number;
  /**
   * true when this row is matched against real expenses. false ⇒ the lines carry no category.
   * @type {boolean}
   * @memberof BudgetTrackingRowDto
   */
  isReconciled: boolean;
  /**
   * Real amount over the calendar year. Null when the row is not reconciled.
   * @type {number}
   * @memberof BudgetTrackingRowDto
   */
  actualAmount?: number | null;
  /**
   * Number of real expenses behind actualAmount.
   * @type {number}
   * @memberof BudgetTrackingRowDto
   */
  actualExpenseCount: number;
  /**
   * actualAmount − plannedAmount.
   * @type {number}
   * @memberof BudgetTrackingRowDto
   */
  varianceAmount?: number | null;
  /**
   * variance / plannedAmount × 100. Null when nothing was planned (€ mode only).
   * @type {number}
   * @memberof BudgetTrackingRowDto
   */
  variancePercent?: number | null;
  /**
   * Sum of previousYearAmount over the lines of this row.
   * @type {number}
   * @memberof BudgetTrackingRowDto
   */
  previousYearAmount?: number | null;
  /**
   * Real N vs previousYearAmount, in percent. Null without an N−1 reference.
   * @type {number}
   * @memberof BudgetTrackingRowDto
   */
  evolutionPercent?: number | null;
}

export const BudgetTrackingRowDtoCategoryEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type BudgetTrackingRowDtoCategoryEnum =
  (typeof BudgetTrackingRowDtoCategoryEnum)[keyof typeof BudgetTrackingRowDtoCategoryEnum];
export const BudgetTrackingRowDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type BudgetTrackingRowDtoMainCategoryEnum =
  (typeof BudgetTrackingRowDtoMainCategoryEnum)[keyof typeof BudgetTrackingRowDtoMainCategoryEnum];
export const BudgetTrackingRowDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type BudgetTrackingRowDtoSubCategoryEnum =
  (typeof BudgetTrackingRowDtoSubCategoryEnum)[keyof typeof BudgetTrackingRowDtoSubCategoryEnum];
export const BudgetTrackingRowDtoSectionEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  Projects: 'PROJECTS',
  Income: 'INCOME',
} as const;

export type BudgetTrackingRowDtoSectionEnum =
  (typeof BudgetTrackingRowDtoSectionEnum)[keyof typeof BudgetTrackingRowDtoSectionEnum];

/**
 *
 * @export
 * @interface BudgetTrackingUnplannedRowDto
 */
export interface BudgetTrackingUnplannedRowDto {
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingUnplannedRowDto
   */
  category: BudgetTrackingUnplannedRowDtoCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingUnplannedRowDto
   */
  mainCategory: BudgetTrackingUnplannedRowDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingUnplannedRowDto
   */
  subCategory: BudgetTrackingUnplannedRowDtoSubCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetTrackingUnplannedRowDto
   */
  section: BudgetTrackingUnplannedRowDtoSectionEnum;
  /**
   *
   * @type {boolean}
   * @memberof BudgetTrackingUnplannedRowDto
   */
  isIncome: boolean;
  /**
   *
   * @type {number}
   * @memberof BudgetTrackingUnplannedRowDto
   */
  actualAmount: number;
  /**
   *
   * @type {number}
   * @memberof BudgetTrackingUnplannedRowDto
   */
  actualExpenseCount: number;
}

export const BudgetTrackingUnplannedRowDtoCategoryEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type BudgetTrackingUnplannedRowDtoCategoryEnum =
  (typeof BudgetTrackingUnplannedRowDtoCategoryEnum)[keyof typeof BudgetTrackingUnplannedRowDtoCategoryEnum];
export const BudgetTrackingUnplannedRowDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type BudgetTrackingUnplannedRowDtoMainCategoryEnum =
  (typeof BudgetTrackingUnplannedRowDtoMainCategoryEnum)[keyof typeof BudgetTrackingUnplannedRowDtoMainCategoryEnum];
export const BudgetTrackingUnplannedRowDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type BudgetTrackingUnplannedRowDtoSubCategoryEnum =
  (typeof BudgetTrackingUnplannedRowDtoSubCategoryEnum)[keyof typeof BudgetTrackingUnplannedRowDtoSubCategoryEnum];
export const BudgetTrackingUnplannedRowDtoSectionEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  Projects: 'PROJECTS',
  Income: 'INCOME',
} as const;

export type BudgetTrackingUnplannedRowDtoSectionEnum =
  (typeof BudgetTrackingUnplannedRowDtoSectionEnum)[keyof typeof BudgetTrackingUnplannedRowDtoSectionEnum];

/**
 *
 * @export
 * @interface BudgetYearDto
 */
export interface BudgetYearDto {
  /**
   *
   * @type {number}
   * @memberof BudgetYearDto
   */
  year: number;
  /**
   *
   * @type {Array<BudgetYearLineDto>}
   * @memberof BudgetYearDto
   */
  lines: Array<BudgetYearLineDto>;
  /**
   *
   * @type {Array<BudgetSectionTotalDto>}
   * @memberof BudgetYearDto
   */
  sectionTotals: Array<BudgetSectionTotalDto>;
  /**
   * Sum of the annual amounts of every non-income line.
   * @type {number}
   * @memberof BudgetYearDto
   */
  expenseTotal: number;
  /**
   * Sum of the annual amounts of every income line.
   * @type {number}
   * @memberof BudgetYearDto
   */
  incomeTotal: number;
  /**
   * Calculated cap = expenseTotal. Never stored.
   * @type {number}
   * @memberof BudgetYearDto
   */
  calculatedCap: number;
  /**
   * incomeTotal − expenseTotal. Negative ⇒ deficit.
   * @type {number}
   * @memberof BudgetYearDto
   */
  balance: number;
  /**
   * max(0, expenseTotal − incomes other than fund calls): what is left to call.
   * @type {number}
   * @memberof BudgetYearDto
   */
  financingNeed: number;
  /**
   * Sum of previousYearAmount over the non-income lines that carry one.
   * @type {number}
   * @memberof BudgetYearDto
   */
  previousYearExpenseTotal?: number | null;
  /**
   *
   * @type {number}
   * @memberof BudgetYearDto
   */
  householdCount: number;
  /**
   * Empty when the asset has no household: the front hides the block.
   * @type {Array<BudgetHouseholdShareDto>}
   * @memberof BudgetYearDto
   */
  householdShares: Array<BudgetHouseholdShareDto>;
  /**
   * true when the split comes from the financial governance shares, false when equal.
   * @type {boolean}
   * @memberof BudgetYearDto
   */
  isGovernanceBased: boolean;
  /**
   * Sum of the households capital shares, in % of the asset. Away from 100 the governance is incomplete: the split is still normalised over the households, the front warns.
   * @type {number}
   * @memberof BudgetYearDto
   */
  householdSharesTotal: number;
  /**
   * Null when the asset has no household (no division by zero).
   * @type {BudgetFundCallSuggestionDto}
   * @memberof BudgetYearDto
   */
  fundCallSuggestion?: BudgetFundCallSuggestionDto | null;
}
/**
 *
 * @export
 * @interface BudgetYearLineDto
 */
export interface BudgetYearLineDto {
  /**
   *
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof BudgetYearLineDto
   */
  year: number;
  /**
   * Derived from mainCategory, never stored.
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  section: BudgetYearLineDtoSectionEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  mainCategory: BudgetYearLineDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  subCategory?: BudgetYearLineDtoSubCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  subCategoryEntryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  subCategoryEntryLabel?: string | null;
  /**
   * Reconciliation key against real expenses. Null ⇒ this line is never reconciled.
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  category?: BudgetYearLineDtoCategoryEnum | null;
  /**
   * Amount as entered: yearly for an expense, per occurrence for an income.
   * @type {number}
   * @memberof BudgetYearLineDto
   */
  amount: number;
  /**
   * Précision libre saisie sur la ligne.
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  note?: string | null;
  /**
   *
   * @type {number}
   * @memberof BudgetYearLineDto
   */
  frequencyPerYear: number;
  /**
   *
   * @type {boolean}
   * @memberof BudgetYearLineDto
   */
  perHousehold: boolean;
  /**
   * Expense: amount. Income: amount × frequencyPerYear × (perHousehold ? households : 1).
   * @type {number}
   * @memberof BudgetYearLineDto
   */
  annualAmount: number;
  /**
   * Actual N−1 amount snapshotted at suggestion time.
   * @type {number}
   * @memberof BudgetYearLineDto
   */
  previousYearAmount?: number | null;
  /**
   * (amount / previousYearAmount − 1) × 100. Derived, never stored.
   * @type {number}
   * @memberof BudgetYearLineDto
   */
  previousYearVariationPercent?: number | null;
  /**
   *
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  sourceType: BudgetYearLineDtoSourceTypeEnum;
  /**
   * Informative project reference, not a FK.
   * @type {string}
   * @memberof BudgetYearLineDto
   */
  sourceProjectId?: string | null;
}

export const BudgetYearLineDtoSectionEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  Projects: 'PROJECTS',
  Income: 'INCOME',
} as const;

export type BudgetYearLineDtoSectionEnum =
  (typeof BudgetYearLineDtoSectionEnum)[keyof typeof BudgetYearLineDtoSectionEnum];
export const BudgetYearLineDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type BudgetYearLineDtoMainCategoryEnum =
  (typeof BudgetYearLineDtoMainCategoryEnum)[keyof typeof BudgetYearLineDtoMainCategoryEnum];
export const BudgetYearLineDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type BudgetYearLineDtoSubCategoryEnum =
  (typeof BudgetYearLineDtoSubCategoryEnum)[keyof typeof BudgetYearLineDtoSubCategoryEnum];
export const BudgetYearLineDtoCategoryEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type BudgetYearLineDtoCategoryEnum =
  (typeof BudgetYearLineDtoCategoryEnum)[keyof typeof BudgetYearLineDtoCategoryEnum];
export const BudgetYearLineDtoSourceTypeEnum = {
  SuggestionPreviousYear: 'SUGGESTION_PREVIOUS_YEAR',
  Project: 'PROJECT',
  Manual: 'MANUAL',
} as const;

export type BudgetYearLineDtoSourceTypeEnum =
  (typeof BudgetYearLineDtoSourceTypeEnum)[keyof typeof BudgetYearLineDtoSourceTypeEnum];

/**
 *
 * @export
 * @interface BuildingDto
 */
export interface BuildingDto {
  /**
   *
   * @type {string}
   * @memberof BuildingDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BuildingDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof BuildingDto
   */
  type?: BuildingDtoTypeEnum | null;
  /**
   *
   * @type {number}
   * @memberof BuildingDto
   */
  position: number;
  /**
   * Capacité totale du bâtiment (somme des pièces non hors service)
   * @type {number}
   * @memberof BuildingDto
   */
  capacity: number;
  /**
   *
   * @type {Array<FloorDto>}
   * @memberof BuildingDto
   */
  floors: Array<FloorDto>;
  /**
   *
   * @type {Array<RoomDto>}
   * @memberof BuildingDto
   */
  rooms: Array<RoomDto>;
  /**
   *
   * @type {Dayjs}
   * @memberof BuildingDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof BuildingDto
   */
  updatedAt: Dayjs;
}

export const BuildingDtoTypeEnum = {
  MainHouse: 'MAIN_HOUSE',
  Apartment: 'APARTMENT',
  Annex: 'ANNEX',
  Garage: 'GARAGE',
  PoolHouse: 'POOL_HOUSE',
  Outbuilding: 'OUTBUILDING',
  Land: 'LAND',
  Other: 'OTHER',
} as const;

export type BuildingDtoTypeEnum = (typeof BuildingDtoTypeEnum)[keyof typeof BuildingDtoTypeEnum];

/**
 *
 * @export
 * @interface BulkBudgetForecastExclusionDto
 */
export interface BulkBudgetForecastExclusionDto {
  /**
   * Ids of the real expenses to exclude or re-include
   * @type {Array<string>}
   * @memberof BulkBudgetForecastExclusionDto
   */
  expenseIds: Array<string>;
  /**
   * Budget year the exclusions apply to
   * @type {number}
   * @memberof BulkBudgetForecastExclusionDto
   */
  budgetYear: number;
  /**
   * true excludes the expenses, false re-includes them
   * @type {boolean}
   * @memberof BulkBudgetForecastExclusionDto
   */
  excluded: boolean;
}
/**
 *
 * @export
 * @interface CapacityByBuildingDto
 */
export interface CapacityByBuildingDto {
  /**
   *
   * @type {string}
   * @memberof CapacityByBuildingDto
   */
  buildingId: string;
  /**
   *
   * @type {string}
   * @memberof CapacityByBuildingDto
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof CapacityByBuildingDto
   */
  capacity: number;
}
/**
 *
 * @export
 * @interface CartographySummaryDto
 */
export interface CartographySummaryDto {
  /**
   * Nombre de pièces avec couchage non hors service
   * @type {number}
   * @memberof CartographySummaryDto
   */
  bedroomCount: number;
  /**
   * Nombre total de lits sur pièces non hors service
   * @type {number}
   * @memberof CartographySummaryDto
   */
  bedCount: number;
  /**
   * Nombre de salles de bain et salles d’eau non hors service
   * @type {number}
   * @memberof CartographySummaryDto
   */
  bathroomCount: number;
  /**
   * Capacité totale d\'accueil (Σ capacités des lits)
   * @type {number}
   * @memberof CartographySummaryDto
   */
  totalCapacity: number;
  /**
   *
   * @type {SleepingRoomsSummaryDto}
   * @memberof CartographySummaryDto
   */
  sleepingRooms: SleepingRoomsSummaryDto;
  /**
   *
   * @type {BedsSummaryDto}
   * @memberof CartographySummaryDto
   */
  beds: BedsSummaryDto;
  /**
   *
   * @type {WashroomsSummaryDto}
   * @memberof CartographySummaryDto
   */
  washrooms: WashroomsSummaryDto;
  /**
   *
   * @type {Array<CapacityByBuildingDto>}
   * @memberof CartographySummaryDto
   */
  capacityByBuilding: Array<CapacityByBuildingDto>;
}
/**
 *
 * @export
 * @interface CartographyTreeDto
 */
export interface CartographyTreeDto {
  /**
   *
   * @type {Array<BuildingDto>}
   * @memberof CartographyTreeDto
   */
  buildings: Array<BuildingDto>;
}
/**
 *
 * @export
 * @interface CategoryStatsDto
 */
export interface CategoryStatsDto {
  /**
   *
   * @type {string}
   * @memberof CategoryStatsDto
   */
  category: CategoryStatsDtoCategoryEnum;
  /**
   *
   * @type {number}
   * @memberof CategoryStatsDto
   */
  total: number;
}

export const CategoryStatsDtoCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type CategoryStatsDtoCategoryEnum =
  (typeof CategoryStatsDtoCategoryEnum)[keyof typeof CategoryStatsDtoCategoryEnum];

/**
 *
 * @export
 * @interface ChangePasswordDto
 */
export interface ChangePasswordDto {
  /**
   *
   * @type {string}
   * @memberof ChangePasswordDto
   */
  oldPassword: string;
  /**
   *
   * @type {string}
   * @memberof ChangePasswordDto
   */
  newPassword: string;
}
/**
 *
 * @export
 * @interface ChatRequestDto
 */
export interface ChatRequestDto {
  /**
   * Historique de la conversation au format UIMessage (AI SDK)
   * @type {Array<object>}
   * @memberof ChatRequestDto
   */
  messages: Array<object>;
  /**
   * Fuseau horaire IANA de l\'utilisateur (Europe/Paris par défaut)
   * @type {string}
   * @memberof ChatRequestDto
   */
  timezone?: string;
}
/**
 *
 * @export
 * @interface CheckEmailStatusDto
 */
export interface CheckEmailStatusDto {
  /**
   *
   * @type {string}
   * @memberof CheckEmailStatusDto
   */
  email: string;
}
/**
 *
 * @export
 * @interface CheckPushSubscriptionDto
 */
export interface CheckPushSubscriptionDto {
  /**
   * The endpoint of the push subscription to check.
   * @type {string}
   * @memberof CheckPushSubscriptionDto
   */
  endpoint: string;
}
/**
 *
 * @export
 * @interface ChecklistDraftDto
 */
export interface ChecklistDraftDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistDraftDto
   */
  title: string;
  /**
   *
   * @type {Array<ChecklistDraftItemDto>}
   * @memberof ChecklistDraftDto
   */
  items: Array<ChecklistDraftItemDto>;
  /**
   * Transcription brute de la dictée, à afficher dans « Voir ce que j\'ai dit ».
   * @type {string}
   * @memberof ChecklistDraftDto
   */
  transcript: string;
}
/**
 *
 * @export
 * @interface ChecklistDraftItemDto
 */
export interface ChecklistDraftItemDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistDraftItemDto
   */
  label: string;
}
/**
 *
 * @export
 * @interface ChecklistDto
 */
export interface ChecklistDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistDto
   */
  assetId: string;
  /**
   *
   * @type {Dayjs}
   * @memberof ChecklistDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ChecklistDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof ChecklistDto
   */
  templateKey?: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistDto
   */
  icon?: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistDto
   */
  color?: string;
}
/**
 *
 * @export
 * @interface ChecklistItemDto
 */
export interface ChecklistItemDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistItemDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistItemDto
   */
  label: string;
}
/**
 *
 * @export
 * @interface ChecklistItemSubmissionDto
 */
export interface ChecklistItemSubmissionDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistItemSubmissionDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistItemSubmissionDto
   */
  checklistItemId: string;
  /**
   *
   * @type {boolean}
   * @memberof ChecklistItemSubmissionDto
   */
  isChecked: boolean;
  /**
   *
   * @type {string}
   * @memberof ChecklistItemSubmissionDto
   */
  label: string;
}
/**
 *
 * @export
 * @interface ChecklistSubmissionDto
 */
export interface ChecklistSubmissionDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmissionDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmissionDto
   */
  checklistId: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmissionDto
   */
  title: string;
  /**
   *
   * @type {Dayjs}
   * @memberof ChecklistSubmissionDto
   */
  submittedAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ChecklistSubmissionDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {ChecklistSubmitterDto}
   * @memberof ChecklistSubmissionDto
   */
  submittedBy?: ChecklistSubmitterDto | null;
  /**
   *
   * @type {Array<ChecklistItemSubmissionDto>}
   * @memberof ChecklistSubmissionDto
   */
  items: Array<ChecklistItemSubmissionDto>;
  /**
   *
   * @type {number}
   * @memberof ChecklistSubmissionDto
   */
  durationSeconds?: number | null;
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmissionDto
   */
  globalComment?: string | null;
}
/**
 *
 * @export
 * @interface ChecklistSubmissionSummaryDto
 */
export interface ChecklistSubmissionSummaryDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmissionSummaryDto
   */
  id: string;
  /**
   *
   * @type {Dayjs}
   * @memberof ChecklistSubmissionSummaryDto
   */
  submittedAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmissionSummaryDto
   */
  submitterFirstName: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmissionSummaryDto
   */
  submitterLastName: string;
  /**
   *
   * @type {number}
   * @memberof ChecklistSubmissionSummaryDto
   */
  checkedItemsCount: number;
  /**
   *
   * @type {number}
   * @memberof ChecklistSubmissionSummaryDto
   */
  totalItemsCount: number;
}
/**
 *
 * @export
 * @interface ChecklistSubmitterDto
 */
export interface ChecklistSubmitterDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmitterDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmitterDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistSubmitterDto
   */
  lastName: string;
}
/**
 *
 * @export
 * @interface ChecklistTemplateDto
 */
export interface ChecklistTemplateDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistTemplateDto
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistTemplateDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistTemplateDto
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistTemplateDto
   */
  audience: ChecklistTemplateDtoAudienceEnum;
  /**
   * Tabler icon name
   * @type {string}
   * @memberof ChecklistTemplateDto
   */
  icon: string;
  /**
   * Color key
   * @type {string}
   * @memberof ChecklistTemplateDto
   */
  color: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ChecklistTemplateDto
   */
  items: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ChecklistTemplateDto
   */
  itemsCount: number;
}

export const ChecklistTemplateDtoAudienceEnum = {
  All: 'ALL',
  Provider: 'PROVIDER',
  Occupants: 'OCCUPANTS',
} as const;

export type ChecklistTemplateDtoAudienceEnum =
  (typeof ChecklistTemplateDtoAudienceEnum)[keyof typeof ChecklistTemplateDtoAudienceEnum];

/**
 *
 * @export
 * @interface ChecklistWithItemsDto
 */
export interface ChecklistWithItemsDto {
  /**
   *
   * @type {string}
   * @memberof ChecklistWithItemsDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistWithItemsDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistWithItemsDto
   */
  assetId: string;
  /**
   *
   * @type {Dayjs}
   * @memberof ChecklistWithItemsDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ChecklistWithItemsDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {Array<ChecklistItemDto>}
   * @memberof ChecklistWithItemsDto
   */
  items: Array<ChecklistItemDto>;
  /**
   *
   * @type {string}
   * @memberof ChecklistWithItemsDto
   */
  templateKey?: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistWithItemsDto
   */
  icon?: string;
  /**
   *
   * @type {string}
   * @memberof ChecklistWithItemsDto
   */
  color?: string;
}
/**
 *
 * @export
 * @interface CircuitDto
 */
export interface CircuitDto {
  /**
   *
   * @type {number}
   * @memberof CircuitDto
   */
  owes: number;
  /**
   *
   * @type {number}
   * @memberof CircuitDto
   */
  owed: number;
}
/**
 *
 * @export
 * @interface ClassifyAttachmentDto
 */
export interface ClassifyAttachmentDto {
  /**
   * Dossier de destination dans Documents, au format chemin (« /Factures/2026/ »). Le fichier est déplacé, jamais copié : le même objet reste dans le stockage.
   * @type {string}
   * @memberof ClassifyAttachmentDto
   */
  path: string;
}
/**
 *
 * @export
 * @interface CommentDto
 */
export interface CommentDto {
  /**
   *
   * @type {string}
   * @memberof CommentDto
   */
  id: string;
  /**
   *
   * @type {UserDto}
   * @memberof CommentDto
   */
  author: UserDto;
  /**
   *
   * @type {string}
   * @memberof CommentDto
   */
  text: string;
  /**
   *
   * @type {Dayjs}
   * @memberof CommentDto
   */
  createdAt: Dayjs;
}
/**
 *
 * @export
 * @interface CommentsSummaryDto
 */
export interface CommentsSummaryDto {
  /**
   *
   * @type {number}
   * @memberof CommentsSummaryDto
   */
  count: number;
  /**
   *
   * @type {Array<CommentDto>}
   * @memberof CommentsSummaryDto
   */
  items?: Array<CommentDto>;
}
/**
 *
 * @export
 * @interface CommunityBirthdayDto
 */
export interface CommunityBirthdayDto {
  /**
   *
   * @type {UserDto}
   * @memberof CommunityBirthdayDto
   */
  user: UserDto;
  /**
   * 0 is january, 11 is december
   * @type {number}
   * @memberof CommunityBirthdayDto
   */
  month: number;
  /**
   * 0 is sunday, 6 is saturday
   * @type {number}
   * @memberof CommunityBirthdayDto
   */
  dayOfMonth: number;
}
/**
 *
 * @export
 * @interface CommunityChecklistDto
 */
export interface CommunityChecklistDto {
  /**
   *
   * @type {number}
   * @memberof CommunityChecklistDto
   */
  checklistSubmissions: number;
}
/**
 *
 * @export
 * @interface CommunityDataDto
 */
export interface CommunityDataDto {
  /**
   *
   * @type {CommunityInstructionsDto}
   * @memberof CommunityDataDto
   */
  instructions: CommunityInstructionsDto;
  /**
   *
   * @type {CommunityChecklistDto}
   * @memberof CommunityDataDto
   */
  checklists: CommunityChecklistDto;
  /**
   *
   * @type {CommunityEventsDto}
   * @memberof CommunityDataDto
   */
  events: CommunityEventsDto;
  /**
   *
   * @type {CommunityExpensesDto}
   * @memberof CommunityDataDto
   */
  expenses: CommunityExpensesDto;
  /**
   *
   * @type {CommunityUsersDto}
   * @memberof CommunityDataDto
   */
  users: CommunityUsersDto;
}
/**
 *
 * @export
 * @interface CommunityEventsDto
 */
export interface CommunityEventsDto {
  /**
   *
   * @type {number}
   * @memberof CommunityEventsDto
   */
  occupationsThisYear: number;
  /**
   *
   * @type {Array<EventDetailsDto>}
   * @memberof CommunityEventsDto
   */
  futureOccupations: Array<EventDetailsDto>;
  /**
   *
   * @type {Array<EventDetailsDto>}
   * @memberof CommunityEventsDto
   */
  futureEvents: Array<EventDetailsDto>;
}
/**
 *
 * @export
 * @interface CommunityExpensesDto
 */
export interface CommunityExpensesDto {
  /**
   *
   * @type {Array<AssetWithExpensesEquilibrium>}
   * @memberof CommunityExpensesDto
   */
  equilibriumForMyAssets: Array<AssetWithExpensesEquilibrium>;
}
/**
 *
 * @export
 * @interface CommunityFeedItemDto
 */
export interface CommunityFeedItemDto {
  /**
   *
   * @type {string}
   * @memberof CommunityFeedItemDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CommunityFeedItemDto
   */
  type: CommunityFeedItemDtoTypeEnum;
  /**
   *
   * @type {UserDto}
   * @memberof CommunityFeedItemDto
   */
  author: UserDto;
  /**
   *
   * @type {Array<AssetPreviewDto>}
   * @memberof CommunityFeedItemDto
   */
  assets: Array<AssetPreviewDto>;
  /**
   *
   * @type {TranslatedString}
   * @memberof CommunityFeedItemDto
   */
  content: TranslatedString;
  /**
   *
   * @type {Array<StorageFileDto>}
   * @memberof CommunityFeedItemDto
   */
  files: Array<StorageFileDto>;
  /**
   * Description libre d\'un album.
   * @type {string}
   * @memberof CommunityFeedItemDto
   */
  description?: string | null;
  /**
   * Où les photos de l\'album ont été prises.
   * @type {string}
   * @memberof CommunityFeedItemDto
   */
  place?: string | null;
  /**
   * Quand les photos ont été prises, pas quand l\'album a été publié.
   * @type {Dayjs}
   * @memberof CommunityFeedItemDto
   */
  takenAt?: Dayjs | null;
  /**
   * Le lecteur peut-il modifier ou supprimer cet élément : son auteur, le propriétaire du bien, ou son gestionnaire. Calculé ici pour que le front n_ait pas à rejouer la règle de droits — et pour qu_il masque le menu « … » au lieu d_afficher une action qui échoue.
   * @type {boolean}
   * @memberof CommunityFeedItemDto
   */
  canManage: boolean;
  /**
   * Documents joints au message, distincts des photos d’album (`files`).
   * @type {Array<AttachmentDto>}
   * @memberof CommunityFeedItemDto
   */
  attachments: Array<AttachmentDto>;
  /**
   *
   * @type {boolean}
   * @memberof CommunityFeedItemDto
   */
  wasEdited: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CommunityFeedItemDto
   */
  inGuestbook: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof CommunityFeedItemDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof CommunityFeedItemDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {LikesSummaryDto}
   * @memberof CommunityFeedItemDto
   */
  likes: LikesSummaryDto;
  /**
   *
   * @type {CommentsSummaryDto}
   * @memberof CommunityFeedItemDto
   */
  comments: CommentsSummaryDto;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  instruction: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  practicalInformation: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  expense: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  checklist: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  checklistSubmission: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  contact: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  event: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  project: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  bankAccount: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  document: object | null;
  /**
   * Only contains { id: string } - frontend uses this for URL generation
   * @type {object}
   * @memberof CommunityFeedItemDto
   */
  moneyTransfer: object | null;
}

export const CommunityFeedItemDtoTypeEnum = {
  PostRegular: 'POST_REGULAR',
  PostMemory: 'POST_MEMORY',
  InstructionCreated: 'INSTRUCTION_CREATED',
  InstructionEdited: 'INSTRUCTION_EDITED',
  PracticalInformationCreated: 'PRACTICAL_INFORMATION_CREATED',
  PracticalInformationEdited: 'PRACTICAL_INFORMATION_EDITED',
  ExpenseCreated: 'EXPENSE_CREATED',
  ExpenseEdited: 'EXPENSE_EDITED',
  ChecklistCreated: 'CHECKLIST_CREATED',
  ChecklistEdited: 'CHECKLIST_EDITED',
  ChecklistSubmitted: 'CHECKLIST_SUBMITTED',
  ContactCreated: 'CONTACT_CREATED',
  ContactEdited: 'CONTACT_EDITED',
  AssetMemberAdded: 'ASSET_MEMBER_ADDED',
  EventCreated: 'EVENT_CREATED',
  EventEdited: 'EVENT_EDITED',
  DocumentUploaded: 'DOCUMENT_UPLOADED',
  ProjectCreated: 'PROJECT_CREATED',
  ProjectEdited: 'PROJECT_EDITED',
  BankAccountCreated: 'BANK_ACCOUNT_CREATED',
  MoneyTransferCreated: 'MONEY_TRANSFER_CREATED',
  OnboardingCompleted: 'ONBOARDING_COMPLETED',
} as const;

export type CommunityFeedItemDtoTypeEnum =
  (typeof CommunityFeedItemDtoTypeEnum)[keyof typeof CommunityFeedItemDtoTypeEnum];

/**
 *
 * @export
 * @interface CommunityInstructionsDto
 */
export interface CommunityInstructionsDto {
  /**
   *
   * @type {number}
   * @memberof CommunityInstructionsDto
   */
  instructionsCreated: number;
}
/**
 *
 * @export
 * @interface CommunityMemberDto
 */
export interface CommunityMemberDto {
  /**
   *
   * @type {AssetMemberUserDto}
   * @memberof CommunityMemberDto
   */
  user: AssetMemberUserDto;
}
/**
 *
 * @export
 * @interface CommunityMembersDto
 */
export interface CommunityMembersDto {
  /**
   *
   * @type {Array<CommunityMemberDto>}
   * @memberof CommunityMembersDto
   */
  members: Array<CommunityMemberDto>;
}
/**
 *
 * @export
 * @interface CommunityUserDto
 */
export interface CommunityUserDto {
  /**
   *
   * @type {UserDto}
   * @memberof CommunityUserDto
   */
  user: UserDto;
  /**
   *
   * @type {boolean}
   * @memberof CommunityUserDto
   */
  isActive: boolean;
}
/**
 *
 * @export
 * @interface CommunityUsersDto
 */
export interface CommunityUsersDto {
  /**
   *
   * @type {Array<CommunityBirthdayDto>}
   * @memberof CommunityUsersDto
   */
  birthdays: Array<CommunityBirthdayDto>;
  /**
   * The list of all the members of all your assets.
   * @type {Array<CommunityUserDto>}
   * @memberof CommunityUsersDto
   */
  membersOfMyAssets: Array<CommunityUserDto>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const CompanyContactRole = {
  Main: 'MAIN',
  Accounting: 'ACCOUNTING',
  Technical: 'TECHNICAL',
  Other: 'OTHER',
} as const;

export type CompanyContactRole = (typeof CompanyContactRole)[keyof typeof CompanyContactRole];

/**
 *
 * @export
 * @interface CompanySearchResultDto
 */
export interface CompanySearchResultDto {
  /**
   *
   * @type {string}
   * @memberof CompanySearchResultDto
   */
  name: string;
  /**
   * SIRET du siège
   * @type {string}
   * @memberof CompanySearchResultDto
   */
  siret: string;
  /**
   * Adresse du siège sur une ligne
   * @type {string}
   * @memberof CompanySearchResultDto
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof CompanySearchResultDto
   */
  postalCode?: string;
  /**
   *
   * @type {string}
   * @memberof CompanySearchResultDto
   */
  city?: string;
}
/**
 *
 * @export
 * @interface ContactCategoriesResponseDto
 */
export interface ContactCategoriesResponseDto {
  /**
   * Mapping of contact categories to their subcategories
   * @type {object}
   * @memberof ContactCategoriesResponseDto
   */
  categories: object;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ContactCategory = {
  FamilyCommunity: 'Family & Community',
  ProfessionalsServices: 'Professionals & Services',
  EmergenciesInstitutions: 'Emergencies & Institutions',
} as const;

export type ContactCategory = (typeof ContactCategory)[keyof typeof ContactCategory];

/**
 *
 * @export
 * @interface ContactDeletionBlockerDto
 */
export interface ContactDeletionBlockerDto {
  /**
   *
   * @type {string}
   * @memberof ContactDeletionBlockerDto
   */
  type: ContactDeletionBlockerDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ContactDeletionBlockerDto
   */
  entityType: ContactDeletionBlockerDtoEntityTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ContactDeletionBlockerDto
   */
  entityId: string;
  /**
   * Short human label for display (e.g. expense title + amount)
   * @type {string}
   * @memberof ContactDeletionBlockerDto
   */
  label: string;
  /**
   * Date associated with the entity, for sorting/display
   * @type {Dayjs}
   * @memberof ContactDeletionBlockerDto
   */
  date?: Dayjs;
}

export const ContactDeletionBlockerDtoTypeEnum = {
  ExpensePaid: 'EXPENSE_PAID',
} as const;

export type ContactDeletionBlockerDtoTypeEnum =
  (typeof ContactDeletionBlockerDtoTypeEnum)[keyof typeof ContactDeletionBlockerDtoTypeEnum];
export const ContactDeletionBlockerDtoEntityTypeEnum = {
  Expense: 'EXPENSE',
} as const;

export type ContactDeletionBlockerDtoEntityTypeEnum =
  (typeof ContactDeletionBlockerDtoEntityTypeEnum)[keyof typeof ContactDeletionBlockerDtoEntityTypeEnum];

/**
 *
 * @export
 * @interface ContactDeletionCheckDto
 */
export interface ContactDeletionCheckDto {
  /**
   *
   * @type {boolean}
   * @memberof ContactDeletionCheckDto
   */
  canDelete: boolean;
  /**
   *
   * @type {Array<ContactDeletionBlockerDto>}
   * @memberof ContactDeletionCheckDto
   */
  blockers: Array<ContactDeletionBlockerDto>;
}
/**
 *
 * @export
 * @interface ContactDto
 */
export interface ContactDto {
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  id: string;
  /**
   *
   * @type {ContactKind}
   * @memberof ContactDto
   */
  kind: ContactKind;
  /**
   * Nom à afficher : nom de l\'entreprise, ou prénom + nom
   * @type {string}
   * @memberof ContactDto
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  siret?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  websiteUrl?: string;
  /**
   * N° client ou de contrat
   * @type {string}
   * @memberof ContactDto
   */
  customerReference?: string;
  /**
   *
   * @type {PaymentMode}
   * @memberof ContactDto
   */
  usualPaymentMode?: PaymentMode;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  notes?: string;
  /**
   * Contact principal en premier
   * @type {Array<InterlocutorDto>}
   * @memberof ContactDto
   */
  interlocutors: Array<InterlocutorDto>;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  phoneNumber?: string;
  /**
   *
   * @type {AddressResponseDto}
   * @memberof ContactDto
   */
  address: AddressResponseDto;
  /**
   *
   * @type {boolean}
   * @memberof ContactDto
   */
  isEmergencyContact: boolean;
  /**
   * Family relationship type
   * @type {string}
   * @memberof ContactDto
   */
  familyRelationType?: ContactDtoFamilyRelationTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof ContactDto
   */
  isFavorite: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof ContactDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ContactDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  imageUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDto
   */
  imagePath?: string;
  /**
   *
   * @type {ContactCategory}
   * @memberof ContactDto
   */
  category?: ContactCategory;
  /**
   *
   * @type {ContactSubCategory}
   * @memberof ContactDto
   */
  subcategory?: ContactSubCategory;
  /**
   *
   * @type {Array<MessagingChannelDto>}
   * @memberof ContactDto
   */
  messagingChannels: Array<MessagingChannelDto>;
  /**
   *
   * @type {Array<PaymentMethodDto>}
   * @memberof ContactDto
   */
  paymentMethods: Array<PaymentMethodDto>;
}

export const ContactDtoFamilyRelationTypeEnum = {
  Child: 'CHILD',
  Parent: 'PARENT',
  Grandchild: 'GRANDCHILD',
  Grandparent: 'GRANDPARENT',
  Sibling: 'SIBLING',
  Cousin: 'COUSIN',
  Uncle: 'UNCLE',
  Aunt: 'AUNT',
  Nephew: 'NEPHEW',
  Niece: 'NIECE',
  Spouse: 'SPOUSE',
  Partner: 'PARTNER',
} as const;

export type ContactDtoFamilyRelationTypeEnum =
  (typeof ContactDtoFamilyRelationTypeEnum)[keyof typeof ContactDtoFamilyRelationTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ContactKind = {
  Person: 'PERSON',
  Company: 'COMPANY',
} as const;

export type ContactKind = (typeof ContactKind)[keyof typeof ContactKind];

/**
 *
 * @export
 * @interface ContactPreviewDto
 */
export interface ContactPreviewDto {
  /**
   *
   * @type {string}
   * @memberof ContactPreviewDto
   */
  id: string;
  /**
   *
   * @type {ContactKind}
   * @memberof ContactPreviewDto
   */
  kind: ContactKind;
  /**
   * Nom à afficher : nom de l\'entreprise, ou prénom + nom
   * @type {string}
   * @memberof ContactPreviewDto
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof ContactPreviewDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof ContactPreviewDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof ContactPreviewDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof ContactPreviewDto
   */
  companyName?: string;
  /**
   * Company only: used to show its logo
   * @type {string}
   * @memberof ContactPreviewDto
   */
  websiteUrl?: string;
  /**
   * Company only: used to show its logo
   * @type {string}
   * @memberof ContactPreviewDto
   */
  email?: string;
  /**
   *
   * @type {MainInterlocutorDto}
   * @memberof ContactPreviewDto
   */
  mainInterlocutor?: MainInterlocutorDto;
  /**
   *
   * @type {string}
   * @memberof ContactPreviewDto
   */
  phoneNumber?: string;
  /**
   * Family relationship type
   * @type {string}
   * @memberof ContactPreviewDto
   */
  familyRelationType?: ContactPreviewDtoFamilyRelationTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof ContactPreviewDto
   */
  isFavorite: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ContactPreviewDto
   */
  isEmergencyContact: boolean;
  /**
   *
   * @type {string}
   * @memberof ContactPreviewDto
   */
  imageUrl?: string;
  /**
   *
   * @type {ContactCategory}
   * @memberof ContactPreviewDto
   */
  category?: ContactCategory;
  /**
   *
   * @type {ContactSubCategory}
   * @memberof ContactPreviewDto
   */
  subcategory?: ContactSubCategory;
}

export const ContactPreviewDtoFamilyRelationTypeEnum = {
  Child: 'CHILD',
  Parent: 'PARENT',
  Grandchild: 'GRANDCHILD',
  Grandparent: 'GRANDPARENT',
  Sibling: 'SIBLING',
  Cousin: 'COUSIN',
  Uncle: 'UNCLE',
  Aunt: 'AUNT',
  Nephew: 'NEPHEW',
  Niece: 'NIECE',
  Spouse: 'SPOUSE',
  Partner: 'PARTNER',
} as const;

export type ContactPreviewDtoFamilyRelationTypeEnum =
  (typeof ContactPreviewDtoFamilyRelationTypeEnum)[keyof typeof ContactPreviewDtoFamilyRelationTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const ContactSubCategory = {
  FamilyMemberOwnerCoOwner: 'Family Member Owner / Co-owner',
  FamilyMemberUserNonOwner: 'Family Member User (non-owner)',
  SeasonalLongTermTenant: 'Seasonal / Long-term Tenant',
  TrustedPersonCaretaker: 'Trusted Person / Caretaker',
  DirectNeighborEmergencyContact: 'Direct Neighbor (Emergency Contact)',
  CondominiumTrusteeIfApplicable: 'Condominium Trustee (if applicable)',
  Plumber: 'Plumber',
  Electrician: 'Electrician',
  Mason: 'Mason',
  Roofer: 'Roofer',
  HeatingEngineerBoilerMaintenance: 'Heating Engineer / Boiler Maintenance',
  Glazier: 'Glazier',
  LocksmithMetalworker: 'Locksmith / Metalworker',
  Architect: 'Architect',
  ProjectManagerWorksSupervisor: 'Project Manager / Works Supervisor',
  InteriorDecorator: 'Interior Decorator',
  GardenerLandscaper: 'Gardener / Landscaper',
  CleaningLadyCleaningService: 'Cleaning Lady / Cleaning Service',
  ConciergeHomeHelp: 'Concierge / Home Help',
  AntennaInstallerTvInstallation: 'Antenna Installer / TV Installation',
  AlarmInstallationHomeAutomation: 'Alarm Installation / Home Automation',
  PoolMaintenance: 'Pool Maintenance',
  ChimneySweep: 'Chimney Sweep',
  GarageMechanicIfSharedVehicles: 'Garage / Mechanic (if shared vehicles)',
  ElectricitySupplier: 'Electricity Supplier',
  GasSupplier: 'Gas Supplier',
  WaterSupplier: 'Water Supplier',
  FuelWoodPelletsSupplier: 'Fuel / Wood / Pellets Supplier',
  InternetServiceProviderIsp: 'Internet Service Provider (ISP)',
  PhoneTvOperator: 'Phone / TV Operator',
  BankSharedPropertyAccount: 'Bank / Shared Property Account',
  HomeInsurance: 'Home Insurance',
  GroceryDeliveryLocalCaterer: 'Grocery Delivery / Local Caterer',
  NotaryForSuccessionTransmission: 'Notary (for succession / transmission)',
  WealthManagementAdvisor: 'Wealth Management Advisor',
  LawyerRealEstateFamilyLaw: 'Lawyer (Real Estate, Family Law)',
  AccountantTaxSpecialist: 'Accountant / Tax Specialist',
  RealEstateAgentRentalManager: 'Real Estate Agent / Rental Manager',
  ProfessionalRentalManagerAgency: 'Professional Rental Manager (Agency)',
  Bailiff: 'Bailiff',
  ShipyardWintering: 'Shipyard / Wintering',
  MarineMechanic: 'Marine Mechanic',
  HarborMasterMarina: 'Harbor Master / Marina',
  FittingsEquipmentSupplier: 'Fittings / Equipment Supplier',
  MarineInsuranceBoat: 'Marine Insurance (Boat)',
  RvDealerRepairer: 'RV Dealer / Repairer',
  TechnicalInspectionRv: 'Technical Inspection (RV)',
  VehicleInsuranceRv: 'Vehicle Insurance (RV)',
  ForestryExpertSilviculturalManager: 'Forestry Expert / Silvicultural Manager',
  ForestryCooperativeWoodBuyer: 'Forestry Cooperative / Wood Buyer',
  SurveyorLandExpert: 'Surveyor / Land Expert',
  VeterinarianEquineOrGeneral: 'Veterinarian (Equine or General)',
  Farrier: 'Farrier',
  StableEquestrianCenterBoarding: 'Stable / Equestrian Center (Boarding)',
  AnimalFeedSupplier: 'Animal Feed Supplier',
  EquineAnimalInsurance: 'Equine / Animal Insurance',
  AnimalTrainerBehaviorist: 'Animal Trainer / Behaviorist',
  Firefighters: 'Firefighters',
  PoliceGendarmerie: 'Police / Gendarmerie',
  LocalGeneralPractitioner: 'Local General Practitioner',
  HospitalClinic: 'Hospital / Clinic',
  Pharmacy: 'Pharmacy',
  TownHallMunicipalServices: 'Town Hall / Municipal Services',
} as const;

export type ContactSubCategory = (typeof ContactSubCategory)[keyof typeof ContactSubCategory];

/**
 *
 * @export
 * @interface ConvertPlaceholderMemberDto
 */
export interface ConvertPlaceholderMemberDto {
  /**
   * Id of the existing user this placeholder actually is.
   * @type {string}
   * @memberof ConvertPlaceholderMemberDto
   */
  targetUserId: string;
}
/**
 *
 * @export
 * @interface CountByKeyDto
 */
export interface CountByKeyDto {
  /**
   * Clé comptée (type de pièce, type de lit, équipement…)
   * @type {string}
   * @memberof CountByKeyDto
   */
  key: string;
  /**
   *
   * @type {number}
   * @memberof CountByKeyDto
   */
  count: number;
}
/**
 *
 * @export
 * @interface CountryDto
 */
export interface CountryDto {
  /**
   * Code ISO du pays
   * @type {string}
   * @memberof CountryDto
   */
  'country-code': string;
  /**
   * Nom du pays
   * @type {string}
   * @memberof CountryDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CountryDto
   */
  'alpha-2': string;
}
/**
 *
 * @export
 * @interface CreateAnnouncementDto
 */
export interface CreateAnnouncementDto {
  /**
   *
   * @type {string}
   * @memberof CreateAnnouncementDto
   */
  level: CreateAnnouncementDtoLevelEnum;
  /**
   *
   * @type {string}
   * @memberof CreateAnnouncementDto
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateAnnouncementDto
   */
  publish?: boolean;
}

export const CreateAnnouncementDtoLevelEnum = {
  Info: 'INFO',
  Warning: 'WARNING',
  Critical: 'CRITICAL',
} as const;

export type CreateAnnouncementDtoLevelEnum =
  (typeof CreateAnnouncementDtoLevelEnum)[keyof typeof CreateAnnouncementDtoLevelEnum];

/**
 *
 * @export
 * @interface CreateAssetAnnouncementDto
 */
export interface CreateAssetAnnouncementDto {
  /**
   *
   * @type {string}
   * @memberof CreateAssetAnnouncementDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof CreateAssetAnnouncementDto
   */
  level?: CreateAssetAnnouncementDtoLevelEnum;
  /**
   *
   * @type {boolean}
   * @memberof CreateAssetAnnouncementDto
   */
  publish?: boolean;
}

export const CreateAssetAnnouncementDtoLevelEnum = {
  Info: 'INFO',
  Warning: 'WARNING',
  Critical: 'CRITICAL',
} as const;

export type CreateAssetAnnouncementDtoLevelEnum =
  (typeof CreateAssetAnnouncementDtoLevelEnum)[keyof typeof CreateAssetAnnouncementDtoLevelEnum];

/**
 *
 * @export
 * @interface CreateAssetDto
 */
export interface CreateAssetDto {
  /**
   * Nom du bien
   * @type {string}
   * @memberof CreateAssetDto
   */
  name: string;
  /**
   * Description détaillée du bien
   * @type {string}
   * @memberof CreateAssetDto
   */
  description?: string;
  /**
   * Date d\'acquisition du bien
   * @type {Dayjs}
   * @memberof CreateAssetDto
   */
  acquisitionDate?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof CreateAssetDto
   */
  placeId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAssetDto
   */
  type: CreateAssetDtoTypeEnum;
  /**
   * The usage type of the property
   * @type {string}
   * @memberof CreateAssetDto
   */
  subType?: CreateAssetDtoSubTypeEnum;
}

export const CreateAssetDtoTypeEnum = {
  RealEstate: 'REAL_ESTATE',
  Movable: 'MOVABLE',
  Financial: 'FINANCIAL',
  Intellectual: 'INTELLECTUAL',
  Business: 'BUSINESS',
} as const;

export type CreateAssetDtoTypeEnum =
  (typeof CreateAssetDtoTypeEnum)[keyof typeof CreateAssetDtoTypeEnum];
export const CreateAssetDtoSubTypeEnum = {
  FamilyProperty: 'FAMILY_PROPERTY',
  PrimaryResidence: 'PRIMARY_RESIDENCE',
  RentalProperty: 'RENTAL_PROPERTY',
} as const;

export type CreateAssetDtoSubTypeEnum =
  (typeof CreateAssetDtoSubTypeEnum)[keyof typeof CreateAssetDtoSubTypeEnum];

/**
 *
 * @export
 * @interface CreateBankAccountBalanceDto
 */
export interface CreateBankAccountBalanceDto {
  /**
   * The recorded balance amount. Can be negative (overdraft).
   * @type {number}
   * @memberof CreateBankAccountBalanceDto
   */
  amount: number;
  /**
   * The statement date. Defaults to now.
   * @type {Dayjs}
   * @memberof CreateBankAccountBalanceDto
   */
  recordedAt?: Dayjs;
}
/**
 *
 * @export
 * @interface CreateBankAccountDto
 */
export interface CreateBankAccountDto {
  /**
   *
   * @type {string}
   * @memberof CreateBankAccountDto
   */
  name: string;
  /**
   * The name of the bank, e.g. \"Crédit Agricole\".
   * @type {string}
   * @memberof CreateBankAccountDto
   */
  bankName?: string;
  /**
   * The bank logo domain key used by Brandfetch, e.g. \"credit-agricole.fr\".
   * @type {string}
   * @memberof CreateBankAccountDto
   */
  bankDomain?: string;
  /**
   * Free text detail, e.g. \"Île-de-France\".
   * @type {string}
   * @memberof CreateBankAccountDto
   */
  bankDetail?: string;
  /**
   * Beneficiary name printed on statements, e.g. \"Indivision Rochette\".
   * @type {string}
   * @memberof CreateBankAccountDto
   */
  holderName?: string | null;
  /**
   * IBAN, spaces allowed (stored without them).
   * @type {string}
   * @memberof CreateBankAccountDto
   */
  iban?: string | null;
  /**
   * BIC / SWIFT code.
   * @type {string}
   * @memberof CreateBankAccountDto
   */
  bic?: string | null;
}
/**
 *
 * @export
 * @interface CreateBedDto
 */
export interface CreateBedDto {
  /**
   *
   * @type {string}
   * @memberof CreateBedDto
   */
  type: CreateBedDtoTypeEnum;
  /**
   * Largeur en cm
   * @type {number}
   * @memberof CreateBedDto
   */
  widthCm?: number;
  /**
   * Longueur en cm
   * @type {number}
   * @memberof CreateBedDto
   */
  lengthCm?: number;
  /**
   * Libellé personnalisé
   * @type {string}
   * @memberof CreateBedDto
   */
  label?: string;
  /**
   *
   * @type {number}
   * @memberof CreateBedDto
   */
  position?: number;
}

export const CreateBedDtoTypeEnum = {
  Single: 'SINGLE',
  Double: 'DOUBLE',
  Queen: 'QUEEN',
  King: 'KING',
  Bunk: 'BUNK',
  SofaBed: 'SOFA_BED',
  Baby: 'BABY',
  Cot: 'COT',
} as const;

export type CreateBedDtoTypeEnum = (typeof CreateBedDtoTypeEnum)[keyof typeof CreateBedDtoTypeEnum];

/**
 *
 * @export
 * @interface CreateBudgetForecastExclusionDto
 */
export interface CreateBudgetForecastExclusionDto {
  /**
   * Id of the real expense to exclude from the forecast
   * @type {string}
   * @memberof CreateBudgetForecastExclusionDto
   */
  expenseId: string;
  /**
   * Budget year the exclusion applies to
   * @type {number}
   * @memberof CreateBudgetForecastExclusionDto
   */
  budgetYear: number;
}
/**
 *
 * @export
 * @interface CreateBuildingDto
 */
export interface CreateBuildingDto {
  /**
   * Nom du bâtiment
   * @type {string}
   * @memberof CreateBuildingDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateBuildingDto
   */
  type?: CreateBuildingDtoTypeEnum | null;
  /**
   * Position dans la liste (ordre)
   * @type {number}
   * @memberof CreateBuildingDto
   */
  position?: number;
}

export const CreateBuildingDtoTypeEnum = {
  MainHouse: 'MAIN_HOUSE',
  Apartment: 'APARTMENT',
  Annex: 'ANNEX',
  Garage: 'GARAGE',
  PoolHouse: 'POOL_HOUSE',
  Outbuilding: 'OUTBUILDING',
  Land: 'LAND',
  Other: 'OTHER',
} as const;

export type CreateBuildingDtoTypeEnum =
  (typeof CreateBuildingDtoTypeEnum)[keyof typeof CreateBuildingDtoTypeEnum];

/**
 *
 * @export
 * @interface CreateChecklistDto
 */
export interface CreateChecklistDto {
  /**
   *
   * @type {string}
   * @memberof CreateChecklistDto
   */
  title: string;
  /**
   * Key of the ShareHeritage template this checklist was created from
   * @type {string}
   * @memberof CreateChecklistDto
   */
  templateKey?: string;
  /**
   * Tabler icon name
   * @type {string}
   * @memberof CreateChecklistDto
   */
  icon?: string;
  /**
   * Color key
   * @type {string}
   * @memberof CreateChecklistDto
   */
  color?: string;
}
/**
 *
 * @export
 * @interface CreateChecklistItemSubmissionDto
 */
export interface CreateChecklistItemSubmissionDto {
  /**
   *
   * @type {string}
   * @memberof CreateChecklistItemSubmissionDto
   */
  checklistItemId: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateChecklistItemSubmissionDto
   */
  isChecked: boolean;
}
/**
 *
 * @export
 * @interface CreateChecklistSubmissionDto
 */
export interface CreateChecklistSubmissionDto {
  /**
   *
   * @type {Array<CreateChecklistItemSubmissionDto>}
   * @memberof CreateChecklistSubmissionDto
   */
  items: Array<CreateChecklistItemSubmissionDto>;
  /**
   * Durée totale en secondes
   * @type {number}
   * @memberof CreateChecklistSubmissionDto
   */
  durationSeconds?: number;
  /**
   * Commentaire global (max 500 caractères)
   * @type {string}
   * @memberof CreateChecklistSubmissionDto
   */
  globalComment?: string;
}
/**
 *
 * @export
 * @interface CreateCommentDto
 */
export interface CreateCommentDto {
  /**
   *
   * @type {string}
   * @memberof CreateCommentDto
   */
  message: string;
}
/**
 *
 * @export
 * @interface CreateCommunityFeedItemDto
 */
export interface CreateCommunityFeedItemDto {
  /**
   *
   * @type {string}
   * @memberof CreateCommunityFeedItemDto
   */
  type: CreateCommunityFeedItemDtoTypeEnum;
  /**
   * Texte du message ; sert de nom d\'album quand le type est POST_MEMORY.
   * @type {string}
   * @memberof CreateCommunityFeedItemDto
   */
  message: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateCommunityFeedItemDto
   */
  files: Array<string> | null;
  /**
   * List of the assets you want to publish the message in.
   * @type {Array<string>}
   * @memberof CreateCommunityFeedItemDto
   */
  assets: Array<string>;
  /**
   * Description libre d\'un album, sous son titre.
   * @type {string}
   * @memberof CreateCommunityFeedItemDto
   */
  description?: string | null;
  /**
   * Fichiers joints au message (documents). Distincts de `files`, qui porte les photos d\'un album.
   * @type {Array<string>}
   * @memberof CreateCommunityFeedItemDto
   */
  attachmentIds?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof CreateCommunityFeedItemDto
   */
  inGuestbook?: boolean;
  /**
   * Où les photos ont été prises. Propre à un album (POST_MEMORY).
   * @type {string}
   * @memberof CreateCommunityFeedItemDto
   */
  place?: string;
  /**
   * Quand les photos ont été prises (ISO 8601), pas quand l\'album est publié. Le front le pré-remplit depuis l\'EXIF de la première photo, sinon aujourd\'hui.
   * @type {string}
   * @memberof CreateCommunityFeedItemDto
   */
  takenAt?: string;
}

export const CreateCommunityFeedItemDtoTypeEnum = {
  PostRegular: 'POST_REGULAR',
  PostMemory: 'POST_MEMORY',
  InstructionCreated: 'INSTRUCTION_CREATED',
  InstructionEdited: 'INSTRUCTION_EDITED',
  PracticalInformationCreated: 'PRACTICAL_INFORMATION_CREATED',
  PracticalInformationEdited: 'PRACTICAL_INFORMATION_EDITED',
  ExpenseCreated: 'EXPENSE_CREATED',
  ExpenseEdited: 'EXPENSE_EDITED',
  ChecklistCreated: 'CHECKLIST_CREATED',
  ChecklistEdited: 'CHECKLIST_EDITED',
  ChecklistSubmitted: 'CHECKLIST_SUBMITTED',
  ContactCreated: 'CONTACT_CREATED',
  ContactEdited: 'CONTACT_EDITED',
  AssetMemberAdded: 'ASSET_MEMBER_ADDED',
  EventCreated: 'EVENT_CREATED',
  EventEdited: 'EVENT_EDITED',
  DocumentUploaded: 'DOCUMENT_UPLOADED',
  ProjectCreated: 'PROJECT_CREATED',
  ProjectEdited: 'PROJECT_EDITED',
  BankAccountCreated: 'BANK_ACCOUNT_CREATED',
  MoneyTransferCreated: 'MONEY_TRANSFER_CREATED',
  OnboardingCompleted: 'ONBOARDING_COMPLETED',
} as const;

export type CreateCommunityFeedItemDtoTypeEnum =
  (typeof CreateCommunityFeedItemDtoTypeEnum)[keyof typeof CreateCommunityFeedItemDtoTypeEnum];

/**
 *
 * @export
 * @interface CreateContactDto
 */
export interface CreateContactDto {
  /**
   * Personne ou entreprise
   * @type {ContactKind}
   * @memberof CreateContactDto
   */
  kind?: ContactKind;
  /**
   * Civilité du contact (personne uniquement)
   * @type {string}
   * @memberof CreateContactDto
   */
  title?: CreateContactDtoTitleEnum;
  /**
   * Prénom du contact (personne uniquement)
   * @type {string}
   * @memberof CreateContactDto
   */
  firstName?: string;
  /**
   * Nom du contact (personne uniquement)
   * @type {string}
   * @memberof CreateContactDto
   */
  lastName?: string;
  /**
   * Nom de l\'entreprise (entreprise uniquement)
   * @type {string}
   * @memberof CreateContactDto
   */
  companyName?: string;
  /**
   * 14 chiffres, espaces ignorés
   * @type {string}
   * @memberof CreateContactDto
   */
  siret?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContactDto
   */
  websiteUrl?: string;
  /**
   * N° client ou de contrat
   * @type {string}
   * @memberof CreateContactDto
   */
  customerReference?: string;
  /**
   *
   * @type {PaymentMode}
   * @memberof CreateContactDto
   */
  usualPaymentMode?: PaymentMode;
  /**
   *
   * @type {string}
   * @memberof CreateContactDto
   */
  notes?: string;
  /**
   * Interlocuteurs de l\'entreprise. Absent = inchangés ; présent = remplace la liste (les absents sont retirés).
   * @type {Array<UpsertInterlocutorDto>}
   * @memberof CreateContactDto
   */
  interlocutors?: Array<UpsertInterlocutorDto>;
  /**
   * Email du contact
   * @type {string}
   * @memberof CreateContactDto
   */
  email: string | null;
  /**
   * Numéro du contact
   * @type {string}
   * @memberof CreateContactDto
   */
  phoneNumber: string | null;
  /**
   * Est-ce un contact d\'urgence
   * @type {boolean}
   * @memberof CreateContactDto
   */
  isEmergencyContact: boolean;
  /**
   * Family relationship type
   * @type {string}
   * @memberof CreateContactDto
   */
  familyRelationType?: CreateContactDtoFamilyRelationTypeEnum;
  /**
   * Les canaux de messagerie
   * @type {Array<CreateMessagingChannelDto>}
   * @memberof CreateContactDto
   */
  messagingChannels?: Array<CreateMessagingChannelDto>;
  /**
   * Les moyens de paiment
   * @type {Array<CreatePaymentMethodDto>}
   * @memberof CreateContactDto
   */
  paymentMethods?: Array<CreatePaymentMethodDto>;
  /**
   *
   * @type {string}
   * @memberof CreateContactDto
   */
  imagePath?: string;
  /**
   *
   * @type {string}
   * @memberof CreateContactDto
   */
  placeId: string;
  /**
   *
   * @type {ContactCategory}
   * @memberof CreateContactDto
   */
  category?: ContactCategory;
  /**
   *
   * @type {ContactSubCategory}
   * @memberof CreateContactDto
   */
  subcategory?: ContactSubCategory;
}

export const CreateContactDtoTitleEnum = {
  Mr: 'mr',
  Ms: 'ms',
  Other: 'other',
} as const;

export type CreateContactDtoTitleEnum =
  (typeof CreateContactDtoTitleEnum)[keyof typeof CreateContactDtoTitleEnum];
export const CreateContactDtoFamilyRelationTypeEnum = {
  Child: 'CHILD',
  Parent: 'PARENT',
  Grandchild: 'GRANDCHILD',
  Grandparent: 'GRANDPARENT',
  Sibling: 'SIBLING',
  Cousin: 'COUSIN',
  Uncle: 'UNCLE',
  Aunt: 'AUNT',
  Nephew: 'NEPHEW',
  Niece: 'NIECE',
  Spouse: 'SPOUSE',
  Partner: 'PARTNER',
} as const;

export type CreateContactDtoFamilyRelationTypeEnum =
  (typeof CreateContactDtoFamilyRelationTypeEnum)[keyof typeof CreateContactDtoFamilyRelationTypeEnum];

/**
 *
 * @export
 * @interface CreateDirectoryDto
 */
export interface CreateDirectoryDto {
  /**
   *
   * @type {string}
   * @memberof CreateDirectoryDto
   */
  path: string;
  /**
   *
   * @type {string}
   * @memberof CreateDirectoryDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface CreateEntityExportDto
 */
export interface CreateEntityExportDto {
  /**
   *
   * @type {string}
   * @memberof CreateEntityExportDto
   */
  entityType: CreateEntityExportDtoEntityTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateEntityExportDto
   */
  type: CreateEntityExportDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateEntityExportDto
   */
  rule?: CreateEntityExportDtoRuleEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateEntityExportDto
   */
  entityIds?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof CreateEntityExportDto
   */
  isPublic?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateEntityExportDto
   */
  expiresAt?: string;
}

export const CreateEntityExportDtoEntityTypeEnum = {
  Contact: 'CONTACT',
  Checklist: 'CHECKLIST',
  Instruction: 'INSTRUCTION',
  Event: 'EVENT',
  AssetStorageItem: 'ASSET_STORAGE_ITEM',
  PracticalInformation: 'PRACTICAL_INFORMATION',
} as const;

export type CreateEntityExportDtoEntityTypeEnum =
  (typeof CreateEntityExportDtoEntityTypeEnum)[keyof typeof CreateEntityExportDtoEntityTypeEnum];
export const CreateEntityExportDtoTypeEnum = {
  Static: 'STATIC',
  Dynamic: 'DYNAMIC',
  Single: 'SINGLE',
} as const;

export type CreateEntityExportDtoTypeEnum =
  (typeof CreateEntityExportDtoTypeEnum)[keyof typeof CreateEntityExportDtoTypeEnum];
export const CreateEntityExportDtoRuleEnum = {
  All: 'ALL',
  Emergency: 'EMERGENCY',
  DateRange: 'DATE_RANGE',
} as const;

export type CreateEntityExportDtoRuleEnum =
  (typeof CreateEntityExportDtoRuleEnum)[keyof typeof CreateEntityExportDtoRuleEnum];

/**
 *
 * @export
 * @interface CreateEntityLinkDto
 */
export interface CreateEntityLinkDto {
  /**
   *
   * @type {string}
   * @memberof CreateEntityLinkDto
   */
  sourceType: CreateEntityLinkDtoSourceTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateEntityLinkDto
   */
  sourceId: string;
  /**
   *
   * @type {string}
   * @memberof CreateEntityLinkDto
   */
  targetType: CreateEntityLinkDtoTargetTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateEntityLinkDto
   */
  targetId: string;
}

export const CreateEntityLinkDtoSourceTypeEnum = {
  Task: 'task',
  Project: 'project',
  Contact: 'contact',
  VirtualFile: 'virtualFile',
  Expense: 'expense',
  CommunityFeedItem: 'communityFeedItem',
  Room: 'room',
  Event: 'event',
  InventoryItem: 'inventoryItem',
} as const;

export type CreateEntityLinkDtoSourceTypeEnum =
  (typeof CreateEntityLinkDtoSourceTypeEnum)[keyof typeof CreateEntityLinkDtoSourceTypeEnum];
export const CreateEntityLinkDtoTargetTypeEnum = {
  Task: 'task',
  Project: 'project',
  Contact: 'contact',
  VirtualFile: 'virtualFile',
  Expense: 'expense',
  CommunityFeedItem: 'communityFeedItem',
  Room: 'room',
  Event: 'event',
  InventoryItem: 'inventoryItem',
} as const;

export type CreateEntityLinkDtoTargetTypeEnum =
  (typeof CreateEntityLinkDtoTargetTypeEnum)[keyof typeof CreateEntityLinkDtoTargetTypeEnum];

/**
 *
 * @export
 * @interface CreateEventDto
 */
export interface CreateEventDto {
  /**
   * Nom du de l\'événement
   * @type {string}
   * @memberof CreateEventDto
   */
  name: string;
  /**
   * Type d\'événement
   * @type {string}
   * @memberof CreateEventDto
   */
  type: string;
  /**
   * Date de début
   * @type {Dayjs}
   * @memberof CreateEventDto
   */
  startTime: Dayjs;
  /**
   * Date de fin
   * @type {Dayjs}
   * @memberof CreateEventDto
   */
  endTime: Dayjs;
  /**
   *
   * @type {boolean}
   * @memberof CreateEventDto
   */
  isExclusiveOccupation: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateEventDto
   */
  description: string;
  /**
   * Identifiant Google Places de l’adresse de l’événement
   * @type {string}
   * @memberof CreateEventDto
   */
  placeId?: string;
  /**
   * Lien de visioconférence (Meet, Zoom, Teams, etc.)
   * @type {string}
   * @memberof CreateEventDto
   */
  videoConferenceUrl?: string;
  /**
   * Règle de récurrence
   * @type {RecurrenceDto}
   * @memberof CreateEventDto
   */
  recurrence?: RecurrenceDto | null;
  /**
   * Reminder duration in seconds before the event starts (e.g., 900 for 15 minutes)
   * @type {number}
   * @memberof CreateEventDto
   */
  reminderDurationSeconds?: number;
  /**
   * List of participant user IDs
   * @type {Array<string>}
   * @memberof CreateEventDto
   */
  participantIds?: Array<string>;
  /**
   * Households concerned by the event (0..N). Each one must belong to the asset. Takes precedence over the deprecated `householdId`.
   * @type {Array<string>}
   * @memberof CreateEventDto
   */
  householdIds?: Array<string>;
  /**
   * Deprecated: use `householdIds`. Kept for one release so clients built before the multi-household change keep working.
   * @type {string}
   * @memberof CreateEventDto
   * @deprecated
   */
  householdId?: string;
  /**
   * Chambres occupées par ce séjour. Chaque chambre doit appartenir au même bien et porter un couchage. Un tableau vide détache toutes les chambres.
   * @type {Array<string>}
   * @memberof CreateEventDto
   */
  roomIds?: Array<string>;
}
/**
 *
 * @export
 * @interface CreateExpenseDto
 */
export interface CreateExpenseDto {
  /**
   *
   * @type {string}
   * @memberof CreateExpenseDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseDto
   */
  merchant?: string;
  /**
   * Free-text note explaining the operation details.
   * @type {string}
   * @memberof CreateExpenseDto
   */
  note?: string;
  /**
   *
   * @type {number}
   * @memberof CreateExpenseDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseDto
   */
  currency: CreateExpenseDtoCurrencyEnum;
  /**
   * ID of the user who paid. Required if neither paidByBankAccountId, paidByContactId nor paidByPlaceholderMemberId is set.
   * @type {string}
   * @memberof CreateExpenseDto
   */
  paidBy?: string;
  /**
   * ID of the bank account that paid. Required if neither paidBy, paidByContactId nor paidByPlaceholderMemberId is set.
   * @type {string}
   * @memberof CreateExpenseDto
   */
  paidByBankAccountId?: string;
  /**
   * ID of the contact (tiers) who paid. Required if neither paidBy, paidByBankAccountId nor paidByPlaceholderMemberId is set.
   * @type {string}
   * @memberof CreateExpenseDto
   */
  paidByContactId?: string;
  /**
   * ID of the placeholder member (unregistered co-owner) who paid. Required if neither paidBy, paidByBankAccountId nor paidByContactId is set.
   * @type {string}
   * @memberof CreateExpenseDto
   */
  paidByPlaceholderMemberId?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof CreateExpenseDto
   */
  paidAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseDto
   */
  splitType: CreateExpenseDtoSplitTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseDto
   */
  splitScope?: CreateExpenseDtoSplitScopeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseDto
   */
  type: CreateExpenseDtoTypeEnum;
  /**
   * An array of virtual file IDs to attach to the expense.
   * @type {Array<string>}
   * @memberof CreateExpenseDto
   */
  attachmentIds?: Array<string>;
  /**
   * ID of the bank account to reimburse (intermediary). If null, reimburses the payer.
   * @type {string}
   * @memberof CreateExpenseDto
   */
  reimburseToBankAccount?: string;
  /**
   * Per-user shares. Required when splitScope is INDIVIDUAL (default).
   * @type {Array<CreateExpenseShareDto>}
   * @memberof CreateExpenseDto
   */
  shares?: Array<CreateExpenseShareDto>;
  /**
   * Per-household shares. Required when splitScope is HOUSEHOLD.
   * @type {Array<CreateHouseholdShareDto>}
   * @memberof CreateExpenseDto
   */
  householdShares?: Array<CreateHouseholdShareDto>;
  /**
   *
   * @type {RecurrenceDto}
   * @memberof CreateExpenseDto
   */
  recurrence?: RecurrenceDto;
  /**
   * Share (0-100) of this expense attributable to rental use, for tax-deductible charges (régime réel).
   * @type {number}
   * @memberof CreateExpenseDto
   */
  locativeShare?: number;
}

export const CreateExpenseDtoCurrencyEnum = {
  Eur: 'EUR',
} as const;

export type CreateExpenseDtoCurrencyEnum =
  (typeof CreateExpenseDtoCurrencyEnum)[keyof typeof CreateExpenseDtoCurrencyEnum];
export const CreateExpenseDtoSplitTypeEnum = {
  Equal: 'EQUAL',
  Amount: 'AMOUNT',
  Percentage: 'PERCENTAGE',
  Prorata: 'PRORATA',
} as const;

export type CreateExpenseDtoSplitTypeEnum =
  (typeof CreateExpenseDtoSplitTypeEnum)[keyof typeof CreateExpenseDtoSplitTypeEnum];
export const CreateExpenseDtoSplitScopeEnum = {
  Individual: 'INDIVIDUAL',
  Household: 'HOUSEHOLD',
} as const;

export type CreateExpenseDtoSplitScopeEnum =
  (typeof CreateExpenseDtoSplitScopeEnum)[keyof typeof CreateExpenseDtoSplitScopeEnum];
export const CreateExpenseDtoTypeEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type CreateExpenseDtoTypeEnum =
  (typeof CreateExpenseDtoTypeEnum)[keyof typeof CreateExpenseDtoTypeEnum];

/**
 *
 * @export
 * @interface CreateExpenseShareDto
 */
export interface CreateExpenseShareDto {
  /**
   *
   * @type {string}
   * @memberof CreateExpenseShareDto
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseShareDto
   */
  placeholderMemberId?: string;
  /**
   *
   * @type {number}
   * @memberof CreateExpenseShareDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof CreateExpenseShareDto
   */
  percentage?: number;
}
/**
 *
 * @export
 * @interface CreateExpenseSubCategoryDto
 */
export interface CreateExpenseSubCategoryDto {
  /**
   *
   * @type {string}
   * @memberof CreateExpenseSubCategoryDto
   */
  mainCategory: CreateExpenseSubCategoryDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseSubCategoryDto
   */
  subCategory: CreateExpenseSubCategoryDtoSubCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof CreateExpenseSubCategoryDto
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof CreateExpenseSubCategoryDto
   */
  position?: number;
}

export const CreateExpenseSubCategoryDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type CreateExpenseSubCategoryDtoMainCategoryEnum =
  (typeof CreateExpenseSubCategoryDtoMainCategoryEnum)[keyof typeof CreateExpenseSubCategoryDtoMainCategoryEnum];
export const CreateExpenseSubCategoryDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type CreateExpenseSubCategoryDtoSubCategoryEnum =
  (typeof CreateExpenseSubCategoryDtoSubCategoryEnum)[keyof typeof CreateExpenseSubCategoryDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface CreateFloorDto
 */
export interface CreateFloorDto {
  /**
   * Nom du niveau
   * @type {string}
   * @memberof CreateFloorDto
   */
  name: string;
  /**
   * Numéro de niveau (0 = rdc, 1 = 1er étage, -1 = sous-sol)
   * @type {number}
   * @memberof CreateFloorDto
   */
  level: number;
  /**
   *
   * @type {number}
   * @memberof CreateFloorDto
   */
  position?: number;
}
/**
 *
 * @export
 * @interface CreateFundCallDto
 */
export interface CreateFundCallDto {
  /**
   *
   * @type {string}
   * @memberof CreateFundCallDto
   */
  type: CreateFundCallDtoTypeEnum;
  /**
   * `ALL` (défaut) = état des comptes du gestionnaire. `SELF` = relevé qu’un membre émet sur sa propre position, ouvert à tout membre.
   * @type {string}
   * @memberof CreateFundCallDto
   */
  scope?: CreateFundCallDtoScopeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateFundCallDto
   */
  periodLabel: string;
  /**
   *
   * @type {string}
   * @memberof CreateFundCallDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof CreateFundCallDto
   */
  fraction?: CreateFundCallDtoFractionEnum;
  /**
   * Ajouter le solde courant à la quote-part appelée.
   * @type {boolean}
   * @memberof CreateFundCallDto
   */
  includeCurrentBalance?: boolean;
  /**
   * Joindre l’état des comptes de tous les membres au relevé individuel. Défaut : le choix du dernier appel du bien, sinon non.
   * @type {boolean}
   * @memberof CreateFundCallDto
   */
  includeStatement?: boolean;
  /**
   * Échéance de règlement. Défaut : J+30.
   * @type {string}
   * @memberof CreateFundCallDto
   */
  dueDate?: string;
  /**
   * Date du prochain état. Défaut : échéance + 10 jours.
   * @type {string}
   * @memberof CreateFundCallDto
   */
  nextStatementDate?: string;
}

export const CreateFundCallDtoTypeEnum = {
  Statement: 'STATEMENT',
  FundCall: 'FUND_CALL',
} as const;

export type CreateFundCallDtoTypeEnum =
  (typeof CreateFundCallDtoTypeEnum)[keyof typeof CreateFundCallDtoTypeEnum];
export const CreateFundCallDtoScopeEnum = {
  Self: 'SELF',
  All: 'ALL',
} as const;

export type CreateFundCallDtoScopeEnum =
  (typeof CreateFundCallDtoScopeEnum)[keyof typeof CreateFundCallDtoScopeEnum];
export const CreateFundCallDtoFractionEnum = {
  Year: 'YEAR',
  Half: 'HALF',
  Quarter: 'QUARTER',
  Month: 'MONTH',
} as const;

export type CreateFundCallDtoFractionEnum =
  (typeof CreateFundCallDtoFractionEnum)[keyof typeof CreateFundCallDtoFractionEnum];

/**
 *
 * @export
 * @interface CreateHouseholdDto
 */
export interface CreateHouseholdDto {
  /**
   *
   * @type {string}
   * @memberof CreateHouseholdDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateHouseholdDto
   */
  color: string;
  /**
   *
   * @type {string}
   * @memberof CreateHouseholdDto
   */
  costBearerMode?: CreateHouseholdDtoCostBearerModeEnum;
  /**
   * AssetMember id of the household representative (head).
   * @type {string}
   * @memberof CreateHouseholdDto
   */
  headMemberId?: string;
  /**
   * AssetMember ids to attach to this household at creation.
   * @type {Array<string>}
   * @memberof CreateHouseholdDto
   */
  memberIds?: Array<string>;
}

export const CreateHouseholdDtoCostBearerModeEnum = {
  Representative: 'REPRESENTATIVE',
  OwnersSplit: 'OWNERS_SPLIT',
} as const;

export type CreateHouseholdDtoCostBearerModeEnum =
  (typeof CreateHouseholdDtoCostBearerModeEnum)[keyof typeof CreateHouseholdDtoCostBearerModeEnum];

/**
 *
 * @export
 * @interface CreateHouseholdShareDto
 */
export interface CreateHouseholdShareDto {
  /**
   *
   * @type {string}
   * @memberof CreateHouseholdShareDto
   */
  householdId: string;
  /**
   *
   * @type {number}
   * @memberof CreateHouseholdShareDto
   */
  amount?: number;
  /**
   *
   * @type {number}
   * @memberof CreateHouseholdShareDto
   */
  percentage?: number;
}
/**
 *
 * @export
 * @interface CreateInitialBalancesBatchDto
 */
export interface CreateInitialBalancesBatchDto {
  /**
   * Pivot date (ISO 8601), e.g. 2026-01-01
   * @type {string}
   * @memberof CreateInitialBalancesBatchDto
   */
  asOfDate: string;
  /**
   *
   * @type {Array<BatchBalanceItemDto>}
   * @memberof CreateInitialBalancesBatchDto
   */
  balances: Array<BatchBalanceItemDto>;
}
/**
 *
 * @export
 * @interface CreateInstructionDto
 */
export interface CreateInstructionDto {
  /**
   * Titre général de la consigne
   * @type {string}
   * @memberof CreateInstructionDto
   */
  title: string;
  /**
   * A virtual file ID to attach to the isntruction.
   * @type {string}
   * @memberof CreateInstructionDto
   */
  attachmentId?: string;
  /**
   * Sections de la consigne
   * @type {Array<CreateInstructionSectionDto>}
   * @memberof CreateInstructionDto
   */
  sections: Array<CreateInstructionSectionDto>;
}
/**
 *
 * @export
 * @interface CreateInstructionSectionDto
 */
export interface CreateInstructionSectionDto {
  /**
   * Titre de la section
   * @type {string}
   * @memberof CreateInstructionSectionDto
   */
  title: string;
  /**
   * Contenu de la section en markdown
   * @type {string}
   * @memberof CreateInstructionSectionDto
   */
  content: string;
  /**
   * An array of virtual file IDs to attach to the instruction section.
   * @type {Array<string>}
   * @memberof CreateInstructionSectionDto
   */
  attachmentIds?: Array<string>;
}
/**
 *
 * @export
 * @interface CreateInventoryItemDto
 */
export interface CreateInventoryItemDto {
  /**
   *
   * @type {string}
   * @memberof CreateInventoryItemDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateInventoryItemDto
   */
  roomId?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateInventoryItemDto
   */
  brandAndModel?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateInventoryItemDto
   */
  condition?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateInventoryItemDto
   */
  notes?: string | null;
  /**
   *
   * @type {number}
   * @memberof CreateInventoryItemDto
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof CreateInventoryItemDto
   */
  purchaseYear?: number | null;
  /**
   * Prix payé pour le lot. Ignoré si le membre n’est pas gestionnaire.
   * @type {number}
   * @memberof CreateInventoryItemDto
   */
  purchasePrice?: number | null;
  /**
   * Valeur à neuf du lot. Ignorée si le membre n’est pas gestionnaire.
   * @type {number}
   * @memberof CreateInventoryItemDto
   */
  replacementValue?: number | null;
  /**
   *
   * @type {InventoryValueSource}
   * @memberof CreateInventoryItemDto
   */
  replacementValueSource?: InventoryValueSource | null;
  /**
   *
   * @type {string}
   * @memberof CreateInventoryItemDto
   */
  replacementValueSourceLabel?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateInventoryItemDto
   */
  replacementValueSourceUrl?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CreateInventoryItemDto
   */
  depreciationEnabled?: boolean;
  /**
   * Photos téléversées via la route de fichiers du mur (1 à 5)
   * @type {Array<string>}
   * @memberof CreateInventoryItemDto
   */
  photoIds?: Array<string>;
  /**
   * Factures rangées dans Documents
   * @type {Array<string>}
   * @memberof CreateInventoryItemDto
   */
  invoiceFileIds?: Array<string>;
  /**
   * Liens cochés par le membre
   * @type {Array<InventoryLinkInputDto>}
   * @memberof CreateInventoryItemDto
   */
  links?: Array<InventoryLinkInputDto>;
  /**
   * Action à créer et relier
   * @type {InventoryTaskInputDto}
   * @memberof CreateInventoryItemDto
   */
  task?: InventoryTaskInputDto;
  /**
   * Souvenir à créer et relier ; le récit se dépose ensuite sur le souvenir
   * @type {InventoryMemoryInputDto}
   * @memberof CreateInventoryItemDto
   */
  memory?: InventoryMemoryInputDto;
}

/**
 *
 * @export
 * @interface CreateInvitationsDto
 */
export interface CreateInvitationsDto {
  /**
   *
   * @type {Array<string>}
   * @memberof CreateInvitationsDto
   */
  emails: Array<string>;
  /**
   * Role preset applied to the member at acceptance. Defaults to the restrictive viewer preset.
   * @type {string}
   * @memberof CreateInvitationsDto
   */
  preset?: CreateInvitationsDtoPresetEnum;
  /**
   * Subject-by-subject overrides applied on top of the preset.
   * @type {Array<PermissionEntry>}
   * @memberof CreateInvitationsDto
   */
  permissions?: Array<PermissionEntry>;
}

export const CreateInvitationsDtoPresetEnum = {
  Viewer: 'viewer',
  Contributor: 'contributor',
  Manager: 'manager',
} as const;

export type CreateInvitationsDtoPresetEnum =
  (typeof CreateInvitationsDtoPresetEnum)[keyof typeof CreateInvitationsDtoPresetEnum];

/**
 *
 * @export
 * @interface CreateMemberReminderDto
 */
export interface CreateMemberReminderDto {
  /**
   *
   * @type {string}
   * @memberof CreateMemberReminderDto
   */
  targetMemberId: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberReminderDto
   */
  tone: CreateMemberReminderDtoToneEnum;
  /**
   *
   * @type {string}
   * @memberof CreateMemberReminderDto
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberReminderDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemberReminderDto
   */
  schedule: CreateMemberReminderDtoScheduleEnum;
  /**
   * Required unless schedule is IMMEDIATE
   * @type {string}
   * @memberof CreateMemberReminderDto
   */
  scheduledAt?: string;
  /**
   * Required if RECURRING
   * @type {string}
   * @memberof CreateMemberReminderDto
   */
  recurrence?: CreateMemberReminderDtoRecurrenceEnum;
  /**
   *
   * @type {MemberReminderChannelsDto}
   * @memberof CreateMemberReminderDto
   */
  channels: MemberReminderChannelsDto;
  /**
   * Bypass the 1-reminder-per-7-days anti-spam guard
   * @type {boolean}
   * @memberof CreateMemberReminderDto
   */
  force?: boolean;
}

export const CreateMemberReminderDtoToneEnum = {
  Amical: 'AMICAL',
  Neutre: 'NEUTRE',
  Ferme: 'FERME',
} as const;

export type CreateMemberReminderDtoToneEnum =
  (typeof CreateMemberReminderDtoToneEnum)[keyof typeof CreateMemberReminderDtoToneEnum];
export const CreateMemberReminderDtoScheduleEnum = {
  Immediate: 'IMMEDIATE',
  Scheduled: 'SCHEDULED',
  Recurring: 'RECURRING',
} as const;

export type CreateMemberReminderDtoScheduleEnum =
  (typeof CreateMemberReminderDtoScheduleEnum)[keyof typeof CreateMemberReminderDtoScheduleEnum];
export const CreateMemberReminderDtoRecurrenceEnum = {
  Monthly: 'MONTHLY',
  Quarterly: 'QUARTERLY',
} as const;

export type CreateMemberReminderDtoRecurrenceEnum =
  (typeof CreateMemberReminderDtoRecurrenceEnum)[keyof typeof CreateMemberReminderDtoRecurrenceEnum];

/**
 *
 * @export
 * @interface CreateMemoryDto
 */
export interface CreateMemoryDto {
  /**
   *
   * @type {string}
   * @memberof CreateMemoryDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemoryDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemoryDto
   */
  memoryKind?: CreateMemoryDtoMemoryKindEnum | null;
  /**
   * Normalised by the server according to the precision
   * @type {string}
   * @memberof CreateMemoryDto
   */
  takenAt?: string;
  /**
   *
   * @type {string}
   * @memberof CreateMemoryDto
   */
  takenAtPrecision?: CreateMemoryDtoTakenAtPrecisionEnum;
  /**
   *
   * @type {boolean}
   * @memberof CreateMemoryDto
   */
  takenAtApproximate?: boolean;
  /**
   * Photos uploaded via the feed item file route
   * @type {Array<string>}
   * @memberof CreateMemoryDto
   */
  fileIds?: Array<string>;
  /**
   * Rooms of the asset, stored as links
   * @type {Array<string>}
   * @memberof CreateMemoryDto
   */
  roomIds?: Array<string>;
  /**
   *
   * @type {Array<MemoryPersonInputDto>}
   * @memberof CreateMemoryDto
   */
  people?: Array<MemoryPersonInputDto>;
  /**
   *
   * @type {string}
   * @memberof CreateMemoryDto
   */
  place?: string;
}

export const CreateMemoryDtoMemoryKindEnum = {
  Family: 'FAMILY',
  Celebration: 'CELEBRATION',
  House: 'HOUSE',
  Works: 'WORKS',
  InMemory: 'IN_MEMORY',
} as const;

export type CreateMemoryDtoMemoryKindEnum =
  (typeof CreateMemoryDtoMemoryKindEnum)[keyof typeof CreateMemoryDtoMemoryKindEnum];
export const CreateMemoryDtoTakenAtPrecisionEnum = {
  Day: 'DAY',
  Month: 'MONTH',
  Season: 'SEASON',
  Year: 'YEAR',
  Decade: 'DECADE',
} as const;

export type CreateMemoryDtoTakenAtPrecisionEnum =
  (typeof CreateMemoryDtoTakenAtPrecisionEnum)[keyof typeof CreateMemoryDtoTakenAtPrecisionEnum];

/**
 *
 * @export
 * @interface CreateMessagingChannelDto
 */
export interface CreateMessagingChannelDto {
  /**
   * Type du canal de messagerie
   * @type {string}
   * @memberof CreateMessagingChannelDto
   */
  type: CreateMessagingChannelDtoTypeEnum;
  /**
   * Valeur eclusivement pour le canal de type messenger
   * @type {string}
   * @memberof CreateMessagingChannelDto
   */
  identifier?: string | null;
}

export const CreateMessagingChannelDtoTypeEnum = {
  Sms: 'SMS',
  Whatsapp: 'WHATSAPP',
  Signal: 'SIGNAL',
  Messenger: 'MESSENGER',
  Email: 'EMAIL',
} as const;

export type CreateMessagingChannelDtoTypeEnum =
  (typeof CreateMessagingChannelDtoTypeEnum)[keyof typeof CreateMessagingChannelDtoTypeEnum];

/**
 *
 * @export
 * @interface CreateMoneyTransferDto
 */
export interface CreateMoneyTransferDto {
  /**
   * Ligne d\'appel de fonds que ce versement règle. Le montant s\'impute sur la ligne, qui passe à SETTLED dès que le cumulé atteint le montant appelé.
   * @type {string}
   * @memberof CreateMoneyTransferDto
   */
  fundCallLineId?: string;
}
/**
 *
 * @export
 * @interface CreatePaymentMethodDto
 */
export interface CreatePaymentMethodDto {
  /**
   * Type de moyen de paiement
   * @type {string}
   * @memberof CreatePaymentMethodDto
   */
  type: CreatePaymentMethodDtoTypeEnum;
  /**
   * Valeur du moyen de paiement
   * @type {string}
   * @memberof CreatePaymentMethodDto
   */
  identifier: string;
  /**
   * Est-ce un favori
   * @type {boolean}
   * @memberof CreatePaymentMethodDto
   */
  isFavorite: boolean;
}

export const CreatePaymentMethodDtoTypeEnum = {
  Iban: 'IBAN',
  Paypal: 'PAYPAL',
  Lydia: 'LYDIA',
  Wero: 'WERO',
} as const;

export type CreatePaymentMethodDtoTypeEnum =
  (typeof CreatePaymentMethodDtoTypeEnum)[keyof typeof CreatePaymentMethodDtoTypeEnum];

/**
 *
 * @export
 * @interface CreatePhotoTagDto
 */
export interface CreatePhotoTagDto {
  /**
   * ID of the storage file (photo) to tag
   * @type {string}
   * @memberof CreatePhotoTagDto
   */
  storageFileId: string;
  /**
   * ID of the member to tag
   * @type {string}
   * @memberof CreatePhotoTagDto
   */
  memberId: string;
}
/**
 *
 * @export
 * @interface CreatePlaceholderMemberDto
 */
export interface CreatePlaceholderMemberDto {
  /**
   *
   * @type {string}
   * @memberof CreatePlaceholderMemberDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof CreatePlaceholderMemberDto
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof CreatePlaceholderMemberDto
   */
  estimatedEmail?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePlaceholderMemberDto
   */
  operationalRole?: CreatePlaceholderMemberDtoOperationalRoleEnum;
  /**
   *
   * @type {number}
   * @memberof CreatePlaceholderMemberDto
   */
  shares?: number;
  /**
   *
   * @type {string}
   * @memberof CreatePlaceholderMemberDto
   */
  ownershipNature?: CreatePlaceholderMemberDtoOwnershipNatureEnum;
  /**
   * Household id to attach this placeholder to.
   * @type {string}
   * @memberof CreatePlaceholderMemberDto
   */
  householdId?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePlaceholderMemberDto
   */
  isMandate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatePlaceholderMemberDto
   */
  hasVotingRights?: boolean;
}

export const CreatePlaceholderMemberDtoOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type CreatePlaceholderMemberDtoOperationalRoleEnum =
  (typeof CreatePlaceholderMemberDtoOperationalRoleEnum)[keyof typeof CreatePlaceholderMemberDtoOperationalRoleEnum];
export const CreatePlaceholderMemberDtoOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type CreatePlaceholderMemberDtoOwnershipNatureEnum =
  (typeof CreatePlaceholderMemberDtoOwnershipNatureEnum)[keyof typeof CreatePlaceholderMemberDtoOwnershipNatureEnum];

/**
 *
 * @export
 * @interface CreatePracticalInformationDto
 */
export interface CreatePracticalInformationDto {
  /**
   * Info title
   * @type {string}
   * @memberof CreatePracticalInformationDto
   */
  title?: string;
  /**
   * Info type
   * @type {string}
   * @memberof CreatePracticalInformationDto
   */
  type: CreatePracticalInformationDtoTypeEnum;
  /**
   * Info subtype
   * @type {string}
   * @memberof CreatePracticalInformationDto
   */
  subtype?: CreatePracticalInformationDtoSubtypeEnum;
  /**
   * Custom icon
   * @type {string}
   * @memberof CreatePracticalInformationDto
   */
  icon?: string;
  /**
   * Info fields
   * @type {Array<CreatePracticalInformationFieldDto>}
   * @memberof CreatePracticalInformationDto
   */
  fields: Array<CreatePracticalInformationFieldDto>;
  /**
   * Key of the DATE or SCHEDULE field that triggers the reminder
   * @type {string}
   * @memberof CreatePracticalInformationDto
   */
  reminderFieldKey?: string;
  /**
   * Reminder duration in seconds before the target date (e.g., 86400 for 1 day)
   * @type {number}
   * @memberof CreatePracticalInformationDto
   */
  reminderDurationSeconds?: number;
  /**
   * Time of day for the reminder, format HH:mm (24h)
   * @type {string}
   * @memberof CreatePracticalInformationDto
   */
  reminderTimeOfDay?: string;
}

export const CreatePracticalInformationDtoTypeEnum = {
  GeneralInformation: 'GENERAL_INFORMATION',
  SecurityAndAccess: 'SECURITY_AND_ACCESS',
  ElectricityAndLighting: 'ELECTRICITY_AND_LIGHTING',
  WaterAndSanitation: 'WATER_AND_SANITATION',
  HeatingAndAirConditioning: 'HEATING_AND_AIR_CONDITIONING',
  InternetAndMultimedia: 'INTERNET_AND_MULTIMEDIA',
  MaintenanceAndStorage: 'MAINTENANCE_AND_STORAGE',
  LeisureAndSpecificEquipment: 'LEISURE_AND_SPECIFIC_EQUIPMENT',
  Custom: 'CUSTOM',
} as const;

export type CreatePracticalInformationDtoTypeEnum =
  (typeof CreatePracticalInformationDtoTypeEnum)[keyof typeof CreatePracticalInformationDtoTypeEnum];
export const CreatePracticalInformationDtoSubtypeEnum = {
  HomeBoatCamperInsurance: 'HOME_BOAT_CAMPER_INSURANCE',
  GarbageCollection: 'GARBAGE_COLLECTION',
  WasteCollectionPoints: 'WASTE_COLLECTION_POINTS',
  WasteDisposalFacility: 'WASTE_DISPOSAL_FACILITY',
  EmergencyContacts: 'EMERGENCY_CONTACTS',
  KeysBadgesAccessCodes: 'KEYS_BADGES_ACCESS_CODES',
  AlarmAndSurveillanceSystem: 'ALARM_AND_SURVEILLANCE_SYSTEM',
  EmergencyExitsAndEvacuationPlan: 'EMERGENCY_EXITS_AND_EVACUATION_PLAN',
  FireExtinguishersAndDetectors: 'FIRE_EXTINGUISHERS_AND_DETECTORS',
  FirstAidKitLocation: 'FIRST_AID_KIT_LOCATION',
  UtilityMetersAndValvesLocation: 'UTILITY_METERS_AND_VALVES_LOCATION',
  EmergencyInstructions: 'EMERGENCY_INSTRUCTIONS',
  ManualsAndWarrantyLocation: 'MANUALS_AND_WARRANTY_LOCATION',
  ElectricalInstallationType: 'ELECTRICAL_INSTALLATION_TYPE',
  TroubleshootingInstructions: 'TROUBLESHOOTING_INSTRUCTIONS',
  WaterSupplyType: 'WATER_SUPPLY_TYPE',
  WaterFiltrationSoftener: 'WATER_FILTRATION_SOFTENER',
  WastewaterTankMaintenance: 'WASTEWATER_TANK_MAINTENANCE',
  WaterHeaterBoilerOperation: 'WATER_HEATER_BOILER_OPERATION',
  MainPipingLayout: 'MAIN_PIPING_LAYOUT',
  HeatingType: 'HEATING_TYPE',
  ThermostatAndTemperatureControl: 'THERMOSTAT_AND_TEMPERATURE_CONTROL',
  AirConditioningAndVentilation: 'AIR_CONDITIONING_AND_VENTILATION',
  EquipmentMaintenance: 'EQUIPMENT_MAINTENANCE',
  GasBottleLocation: 'GAS_BOTTLE_LOCATION',
  InternetProvider: 'INTERNET_PROVIDER',
  CustomerReferenceContract: 'CUSTOMER_REFERENCE_CONTRACT',
  WifiCodeAndRouterSetup: 'WIFI_CODE_AND_ROUTER_SETUP',
  AudioSystemConnectedSpeakers: 'AUDIO_SYSTEM_CONNECTED_SPEAKERS',
  CleaningProductsAndUsage: 'CLEANING_PRODUCTS_AND_USAGE',
  VacuumBroomsMop: 'VACUUM_BROOMS_MOP',
  SensitiveAreasRequiringSpecificMaintenance: 'SENSITIVE_AREAS_REQUIRING_SPECIFIC_MAINTENANCE',
  GardenEquipment: 'GARDEN_EQUIPMENT',
  SwimmingPool: 'SWIMMING_POOL',
  SpaSauna: 'SPA_SAUNA',
  TennisCourt: 'TENNIS_COURT',
  SportsEquipment: 'SPORTS_EQUIPMENT',
  FishingOrDivingEquipment: 'FISHING_OR_DIVING_EQUIPMENT',
  BooksBoardGamesAudiovisualEquipment: 'BOOKS_BOARD_GAMES_AUDIOVISUAL_EQUIPMENT',
} as const;

export type CreatePracticalInformationDtoSubtypeEnum =
  (typeof CreatePracticalInformationDtoSubtypeEnum)[keyof typeof CreatePracticalInformationDtoSubtypeEnum];

/**
 *
 * @export
 * @interface CreatePracticalInformationFieldDto
 */
export interface CreatePracticalInformationFieldDto {
  /**
   * Field type
   * @type {string}
   * @memberof CreatePracticalInformationFieldDto
   */
  fieldType: CreatePracticalInformationFieldDtoFieldTypeEnum;
  /**
   * Field key (used for label-value association)
   * @type {string}
   * @memberof CreatePracticalInformationFieldDto
   */
  key: string;
  /**
   *
   * @type {CreatePracticalInformationFieldDtoValue}
   * @memberof CreatePracticalInformationFieldDto
   */
  value: CreatePracticalInformationFieldDtoValue | null;
}

export const CreatePracticalInformationFieldDtoFieldTypeEnum = {
  Text: 'TEXT',
  Date: 'DATE',
  Schedule: 'SCHEDULE',
  Location: 'LOCATION',
  Password: 'PASSWORD',
  List: 'LIST',
} as const;

export type CreatePracticalInformationFieldDtoFieldTypeEnum =
  (typeof CreatePracticalInformationFieldDtoFieldTypeEnum)[keyof typeof CreatePracticalInformationFieldDtoFieldTypeEnum];

/**
 * @type CreatePracticalInformationFieldDtoValue
 * Field value
 * @export
 */
export type CreatePracticalInformationFieldDtoValue =
  | Array<string>
  | CreatePracticalInformationFieldDtoValueOneOf
  | Dayjs
  | string;

/**
 *
 * @export
 * @interface CreatePracticalInformationFieldDtoValueOneOf
 */
export interface CreatePracticalInformationFieldDtoValueOneOf {
  /**
   *
   * @type {string}
   * @memberof CreatePracticalInformationFieldDtoValueOneOf
   */
  frequency?: string;
  /**
   *
   * @type {number}
   * @memberof CreatePracticalInformationFieldDtoValueOneOf
   */
  interval?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof CreatePracticalInformationFieldDtoValueOneOf
   */
  byMonthDay?: Array<number> | null;
  /**
   *
   * @type {Array<number>}
   * @memberof CreatePracticalInformationFieldDtoValueOneOf
   */
  byMonth?: Array<number> | null;
  /**
   *
   * @type {Array<number>}
   * @memberof CreatePracticalInformationFieldDtoValueOneOf
   */
  byWeekDay?: Array<number> | null;
  /**
   *
   * @type {number}
   * @memberof CreatePracticalInformationFieldDtoValueOneOf
   */
  bySetPos?: number | null;
  /**
   *
   * @type {string}
   * @memberof CreatePracticalInformationFieldDtoValueOneOf
   */
  timezone?: string;
}
/**
 *
 * @export
 * @interface CreateProjectDto
 */
export interface CreateProjectDto {
  /**
   *
   * @type {string}
   * @memberof CreateProjectDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateProjectDto
   */
  status?: CreateProjectDtoStatusEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof CreateProjectDto
   */
  deadline?: Dayjs;
  /**
   *
   * @type {number}
   * @memberof CreateProjectDto
   */
  estimatedDuration?: number;
  /**
   *
   * @type {string}
   * @memberof CreateProjectDto
   */
  estimatedDurationUnit?: CreateProjectDtoEstimatedDurationUnitEnum;
  /**
   *
   * @type {number}
   * @memberof CreateProjectDto
   */
  estimatedCost?: number;
  /**
   *
   * @type {string}
   * @memberof CreateProjectDto
   */
  description?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof CreateProjectDto
   */
  completionDate?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof CreateProjectDto
   */
  label?: CreateProjectDtoLabelEnum | null;
  /**
   *
   * @type {string}
   * @memberof CreateProjectDto
   */
  priority?: CreateProjectDtoPriorityEnum | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateProjectDto
   */
  memberIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateProjectDto
   */
  participantIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateProjectDto
   */
  attachmentIds?: Array<string>;
}

export const CreateProjectDtoStatusEnum = {
  IdeaBox: 'IDEA_BOX',
  IdeaToVote: 'IDEA_TO_VOTE',
  ProjectValidated: 'PROJECT_VALIDATED',
  ProjectInProgress: 'PROJECT_IN_PROGRESS',
  ProjectCompleted: 'PROJECT_COMPLETED',
} as const;

export type CreateProjectDtoStatusEnum =
  (typeof CreateProjectDtoStatusEnum)[keyof typeof CreateProjectDtoStatusEnum];
export const CreateProjectDtoEstimatedDurationUnitEnum = {
  Days: 'DAYS',
  Weeks: 'WEEKS',
  Months: 'MONTHS',
  Years: 'YEARS',
} as const;

export type CreateProjectDtoEstimatedDurationUnitEnum =
  (typeof CreateProjectDtoEstimatedDurationUnitEnum)[keyof typeof CreateProjectDtoEstimatedDurationUnitEnum];
export const CreateProjectDtoLabelEnum = {
  Red: 'RED',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Green: 'GREEN',
  Blue: 'BLUE',
  Purple: 'PURPLE',
  Gray: 'GRAY',
} as const;

export type CreateProjectDtoLabelEnum =
  (typeof CreateProjectDtoLabelEnum)[keyof typeof CreateProjectDtoLabelEnum];
export const CreateProjectDtoPriorityEnum = {
  High: 'HIGH',
  Medium: 'MEDIUM',
  Low: 'LOW',
} as const;

export type CreateProjectDtoPriorityEnum =
  (typeof CreateProjectDtoPriorityEnum)[keyof typeof CreateProjectDtoPriorityEnum];

/**
 *
 * @export
 * @interface CreatePushSubscriptionDto
 */
export interface CreatePushSubscriptionDto {
  /**
   *
   * @type {string}
   * @memberof CreatePushSubscriptionDto
   */
  endpoint: string;
  /**
   *
   * @type {PushSubscriptionKeysDto}
   * @memberof CreatePushSubscriptionDto
   */
  keys: PushSubscriptionKeysDto;
}
/**
 *
 * @export
 * @interface CreateReimbursementDto
 */
export interface CreateReimbursementDto {
  /**
   * The amount of the reimbursement.
   * @type {number}
   * @memberof CreateReimbursementDto
   */
  amount: number;
  /**
   * The ID of the user sending the money. Required if fromBankAccountId is not set.
   * @type {string}
   * @memberof CreateReimbursementDto
   */
  fromUserId?: string;
  /**
   * The ID of the bank account sending the money. Required if fromUserId is not set.
   * @type {string}
   * @memberof CreateReimbursementDto
   */
  fromBankAccountId?: string;
  /**
   * The ID of the user receiving the money. Required if toBankAccountId is not set.
   * @type {string}
   * @memberof CreateReimbursementDto
   */
  toUserId?: string;
  /**
   * The ID of the bank account receiving the money. Required if toUserId is not set.
   * @type {string}
   * @memberof CreateReimbursementDto
   */
  toBankAccountId?: string;
}
/**
 *
 * @export
 * @interface CreateRoomDto
 */
export interface CreateRoomDto {
  /**
   * ID du bâtiment auquel rattacher la pièce
   * @type {string}
   * @memberof CreateRoomDto
   */
  buildingId: string;
  /**
   * ID du niveau (optionnel)
   * @type {string}
   * @memberof CreateRoomDto
   */
  floorId?: string | null;
  /**
   * Nom de la pièce
   * @type {string}
   * @memberof CreateRoomDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateRoomDto
   */
  type: CreateRoomDtoTypeEnum;
  /**
   * Équipements sanitaires présents dans la pièce
   * @type {Array<string>}
   * @memberof CreateRoomDto
   */
  features?: Array<CreateRoomDtoFeaturesEnum>;
  /**
   * Chambre desservie par cette pièce d\'eau (« en suite »)
   * @type {string}
   * @memberof CreateRoomDto
   */
  servedRoomId?: string | null;
  /**
   * Surface en m²
   * @type {number}
   * @memberof CreateRoomDto
   */
  areaSqm?: number;
  /**
   *
   * @type {boolean}
   * @memberof CreateRoomDto
   */
  isOutOfService?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreateRoomDto
   */
  position?: number;
}

export const CreateRoomDtoTypeEnum = {
  Bedroom: 'BEDROOM',
  MasterBedroom: 'MASTER_BEDROOM',
  Dormitory: 'DORMITORY',
  StudioApartment: 'STUDIO_APARTMENT',
  DressingRoom: 'DRESSING_ROOM',
  StorageRoom: 'STORAGE_ROOM',
  LivingRoom: 'LIVING_ROOM',
  DiningRoom: 'DINING_ROOM',
  Office: 'OFFICE',
  Library: 'LIBRARY',
  Playroom: 'PLAYROOM',
  Gym: 'GYM',
  HomeCinema: 'HOME_CINEMA',
  Veranda: 'VERANDA',
  ReceptionRoom: 'RECEPTION_ROOM',
  Kitchen: 'KITCHEN',
  Pantry: 'PANTRY',
  Laundry: 'LAUNDRY',
  Larder: 'LARDER',
  Bathroom: 'BATHROOM',
  ShowerRoom: 'SHOWER_ROOM',
  PowderRoom: 'POWDER_ROOM',
  Toilet: 'TOILET',
  Entrance: 'ENTRANCE',
  Hallway: 'HALLWAY',
  Landing: 'LANDING',
  Stairwell: 'STAIRWELL',
  Mezzanine: 'MEZZANINE',
  Attic: 'ATTIC',
  Basement: 'BASEMENT',
  Cellar: 'CELLAR',
  WineCellar: 'WINE_CELLAR',
  BoilerRoom: 'BOILER_ROOM',
  Outdoor: 'OUTDOOR',
  Garden: 'GARDEN',
  Terrace: 'TERRACE',
  Balcony: 'BALCONY',
  Loggia: 'LOGGIA',
  Courtyard: 'COURTYARD',
  Pool: 'POOL',
  PoolHouse: 'POOL_HOUSE',
  Garage: 'GARAGE',
  Carport: 'CARPORT',
  ParkingSpace: 'PARKING_SPACE',
  Workshop: 'WORKSHOP',
  Shed: 'SHED',
  Outbuilding: 'OUTBUILDING',
  Barn: 'BARN',
  Stable: 'STABLE',
  CommonArea: 'COMMON_AREA',
  Lobby: 'LOBBY',
  BikeRoom: 'BIKE_ROOM',
  BinRoom: 'BIN_ROOM',
  Other: 'OTHER',
} as const;

export type CreateRoomDtoTypeEnum =
  (typeof CreateRoomDtoTypeEnum)[keyof typeof CreateRoomDtoTypeEnum];
export const CreateRoomDtoFeaturesEnum = {
  Bathtub: 'BATHTUB',
  Shower: 'SHOWER',
  Washbasin: 'WASHBASIN',
  DoubleWashbasin: 'DOUBLE_WASHBASIN',
  Toilet: 'TOILET',
  HandBasin: 'HAND_BASIN',
  Bidet: 'BIDET',
} as const;

export type CreateRoomDtoFeaturesEnum =
  (typeof CreateRoomDtoFeaturesEnum)[keyof typeof CreateRoomDtoFeaturesEnum];

/**
 *
 * @export
 * @interface CreateTaskDto
 */
export interface CreateTaskDto {
  /**
   *
   * @type {string}
   * @memberof CreateTaskDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof CreateTaskDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTaskDto
   */
  status?: CreateTaskDtoStatusEnum;
  /**
   *
   * @type {string}
   * @memberof CreateTaskDto
   */
  category?: CreateTaskDtoCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof CreateTaskDto
   */
  subCategory?: CreateTaskDtoSubCategoryEnum | null;
  /**
   *
   * @type {Dayjs}
   * @memberof CreateTaskDto
   */
  dueDate?: Dayjs;
  /**
   * Time spent in minutes
   * @type {number}
   * @memberof CreateTaskDto
   */
  timeSpentMinutes?: number;
  /**
   * Whether the task requires being physically on site
   * @type {boolean}
   * @memberof CreateTaskDto
   */
  requiresOnSite?: boolean;
  /**
   * User ID to assign the task to
   * @type {string}
   * @memberof CreateTaskDto
   */
  assignedToId?: string;
  /**
   *
   * @type {Array<RelatedEntityInputDto>}
   * @memberof CreateTaskDto
   */
  relatedEntities?: Array<RelatedEntityInputDto>;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateTaskDto
   */
  attachmentIds?: Array<string>;
}

export const CreateTaskDtoStatusEnum = {
  Todo: 'TODO',
  InProgress: 'IN_PROGRESS',
  Done: 'DONE',
} as const;

export type CreateTaskDtoStatusEnum =
  (typeof CreateTaskDtoStatusEnum)[keyof typeof CreateTaskDtoStatusEnum];
export const CreateTaskDtoCategoryEnum = {
  Technique: 'TECHNIQUE',
  VieMaison: 'VIE_MAISON',
  Gestion: 'GESTION',
} as const;

export type CreateTaskDtoCategoryEnum =
  (typeof CreateTaskDtoCategoryEnum)[keyof typeof CreateTaskDtoCategoryEnum];
export const CreateTaskDtoSubCategoryEnum = {
  Plomberie: 'PLOMBERIE',
  Electricite: 'ELECTRICITE',
  Menuiseries: 'MENUISERIES',
  PeintureEnduits: 'PEINTURE_ENDUITS',
  ReparationsDiverses: 'REPARATIONS_DIVERSES',
  Jardinage: 'JARDINAGE',
  MenageRangement: 'MENAGE_RANGEMENT',
  Decoration: 'DECORATION',
  CoursesApprovisionnement: 'COURSES_APPROVISIONNEMENT',
  Administratif: 'ADMINISTRATIF',
  Comptabilite: 'COMPTABILITE',
  Juridique: 'JURIDIQUE',
  SourcingAchats: 'SOURCING_ACHATS',
  GestionSinistres: 'GESTION_SINISTRES',
  RelationsExterieures: 'RELATIONS_EXTERIEURES',
} as const;

export type CreateTaskDtoSubCategoryEnum =
  (typeof CreateTaskDtoSubCategoryEnum)[keyof typeof CreateTaskDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface DashboardAlbumDto
 */
export interface DashboardAlbumDto {
  /**
   *
   * @type {string}
   * @memberof DashboardAlbumDto
   */
  id: string;
  /**
   * Titre de l\'album. Il vit aujourd\'hui dans `content` ; les albums antérieurs à sa généralisation retombent sur « Album du JJ/MM/AAAA », même règle que le front.
   * @type {string}
   * @memberof DashboardAlbumDto
   */
  title: string;
  /**
   * URL signée de la première photo de l’album.
   * @type {string}
   * @memberof DashboardAlbumDto
   */
  coverUrl?: string | null;
  /**
   *
   * @type {number}
   * @memberof DashboardAlbumDto
   */
  photosCount: number;
  /**
   *
   * @type {string}
   * @memberof DashboardAlbumDto
   */
  authorName: string;
  /**
   *
   * @type {string}
   * @memberof DashboardAlbumDto
   */
  createdAt: string;
}
/**
 *
 * @export
 * @interface DashboardAlertDto
 */
export interface DashboardAlertDto {
  /**
   *
   * @type {string}
   * @memberof DashboardAlertDto
   */
  level: DashboardAlertDtoLevelEnum;
  /**
   *
   * @type {string}
   * @memberof DashboardAlertDto
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof DashboardAlertDto
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof DashboardAlertDto
   */
  linkTo?: string | null;
}

export const DashboardAlertDtoLevelEnum = {
  Red: 'red',
  Orange: 'orange',
  Green: 'green',
} as const;

export type DashboardAlertDtoLevelEnum =
  (typeof DashboardAlertDtoLevelEnum)[keyof typeof DashboardAlertDtoLevelEnum];

/**
 *
 * @export
 * @interface DashboardCommunityPostDto
 */
export interface DashboardCommunityPostDto {
  /**
   *
   * @type {string}
   * @memberof DashboardCommunityPostDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DashboardCommunityPostDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof DashboardCommunityPostDto
   */
  content?: string | null;
  /**
   *
   * @type {string}
   * @memberof DashboardCommunityPostDto
   */
  authorName: string;
  /**
   *
   * @type {string}
   * @memberof DashboardCommunityPostDto
   */
  authorPictureUrl?: string | null;
  /**
   *
   * @type {number}
   * @memberof DashboardCommunityPostDto
   */
  commentsCount: number;
  /**
   *
   * @type {string}
   * @memberof DashboardCommunityPostDto
   */
  createdAt: string;
}
/**
 *
 * @export
 * @interface DashboardDto
 */
export interface DashboardDto {
  /**
   *
   * @type {DashboardExpenseStatsDto}
   * @memberof DashboardDto
   */
  finances: DashboardExpenseStatsDto;
  /**
   *
   * @type {Array<DashboardMonthlyExpenseDto>}
   * @memberof DashboardDto
   */
  monthlyExpenses: Array<DashboardMonthlyExpenseDto>;
  /**
   *
   * @type {Array<DashboardTaskDto>}
   * @memberof DashboardDto
   */
  urgentTasks: Array<DashboardTaskDto>;
  /**
   *
   * @type {Array<DashboardEventDto>}
   * @memberof DashboardDto
   */
  upcomingEvents: Array<DashboardEventDto>;
  /**
   * Séjours (OCCUPATION) à venir, servis à part car `upcomingEvents` est tronqué
   * @type {Array<DashboardEventDto>}
   * @memberof DashboardDto
   */
  upcomingStays: Array<DashboardEventDto>;
  /**
   * Nombre d\'événements à venir sur 30 jours qui ne sont pas des séjours
   * @type {number}
   * @memberof DashboardDto
   */
  otherUpcomingEventsCount: number;
  /**
   * Événements à venir sur 30 jours hors séjours, rappels d’informations pratiques inclus.
   * @type {Array<DashboardEventDto>}
   * @memberof DashboardDto
   */
  upcomingOtherEvents: Array<DashboardEventDto>;
  /**
   *
   * @type {Array<DashboardProjectDto>}
   * @memberof DashboardDto
   */
  activeProjects: Array<DashboardProjectDto>;
  /**
   *
   * @type {Array<DashboardCommunityPostDto>}
   * @memberof DashboardDto
   */
  recentPosts: Array<DashboardCommunityPostDto>;
  /**
   *
   * @type {Array<DashboardAlbumDto>}
   * @memberof DashboardDto
   */
  recentAlbums: Array<DashboardAlbumDto>;
  /**
   *
   * @type {Array<DashboardAlertDto>}
   * @memberof DashboardDto
   */
  alerts: Array<DashboardAlertDto>;
  /**
   *
   * @type {number}
   * @memberof DashboardDto
   */
  totalAlerts: number;
  /**
   *
   * @type {Array<OnboardingStepDto>}
   * @memberof DashboardDto
   */
  onboarding: Array<OnboardingStepDto>;
  /**
   * Onboarding completion percentage (0-100)
   * @type {number}
   * @memberof DashboardDto
   */
  onboardingCompletionPercent: number;
}
/**
 *
 * @export
 * @interface DashboardEventDto
 */
export interface DashboardEventDto {
  /**
   *
   * @type {string}
   * @memberof DashboardEventDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DashboardEventDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof DashboardEventDto
   */
  startTime: string;
  /**
   *
   * @type {string}
   * @memberof DashboardEventDto
   */
  endTime: string;
  /**
   *
   * @type {string}
   * @memberof DashboardEventDto
   */
  type: string;
  /**
   *
   * @type {boolean}
   * @memberof DashboardEventDto
   */
  allDay: boolean;
  /**
   * Provenance de la ligne : un vrai événement, un rappel d\'info pratique, etc.
   * @type {string}
   * @memberof DashboardEventDto
   */
  origin?: DashboardEventDtoOriginEnum | null;
  /**
   * Nom du foyer rattaché, pour écrire « Foyer Gautier » plutôt que le titre brut.
   * @type {string}
   * @memberof DashboardEventDto
   */
  householdName?: string | null;
  /**
   * Couleur du foyer rattaché.
   * @type {string}
   * @memberof DashboardEventDto
   */
  householdColor?: string | null;
}

export const DashboardEventDtoOriginEnum = {
  Event: 'EVENT',
  PracticalInformation: 'PRACTICAL_INFORMATION',
  Project: 'PROJECT',
  Task: 'TASK',
  External: 'EXTERNAL',
} as const;

export type DashboardEventDtoOriginEnum =
  (typeof DashboardEventDtoOriginEnum)[keyof typeof DashboardEventDtoOriginEnum];

/**
 *
 * @export
 * @interface DashboardExpenseStatsDto
 */
export interface DashboardExpenseStatsDto {
  /**
   *
   * @type {number}
   * @memberof DashboardExpenseStatsDto
   */
  totalBalance: number;
  /**
   *
   * @type {number}
   * @memberof DashboardExpenseStatsDto
   */
  totalExpenses: number;
  /**
   *
   * @type {number}
   * @memberof DashboardExpenseStatsDto
   */
  totalRevenues: number;
  /**
   *
   * @type {number}
   * @memberof DashboardExpenseStatsDto
   */
  yearlyExpenseTotal: number;
  /**
   *
   * @type {number}
   * @memberof DashboardExpenseStatsDto
   */
  annualBudgetCap?: number | null;
  /**
   * Budget usage percentage (0-100)
   * @type {number}
   * @memberof DashboardExpenseStatsDto
   */
  budgetUsagePercent: number;
}
/**
 *
 * @export
 * @interface DashboardMonthlyExpenseDto
 */
export interface DashboardMonthlyExpenseDto {
  /**
   *
   * @type {string}
   * @memberof DashboardMonthlyExpenseDto
   */
  month: string;
  /**
   *
   * @type {number}
   * @memberof DashboardMonthlyExpenseDto
   */
  expenses: number;
  /**
   *
   * @type {number}
   * @memberof DashboardMonthlyExpenseDto
   */
  revenues: number;
}
/**
 *
 * @export
 * @interface DashboardProjectDto
 */
export interface DashboardProjectDto {
  /**
   *
   * @type {string}
   * @memberof DashboardProjectDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DashboardProjectDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof DashboardProjectDto
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof DashboardProjectDto
   */
  deadline?: string | null;
  /**
   *
   * @type {string}
   * @memberof DashboardProjectDto
   */
  label?: string | null;
  /**
   *
   * @type {string}
   * @memberof DashboardProjectDto
   */
  priority?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DashboardProjectDto
   */
  hasActiveVote: boolean;
  /**
   *
   * @type {number}
   * @memberof DashboardProjectDto
   */
  votesCount: number;
  /**
   * Signed URL of the project\'s first image attachment, if any.
   * @type {string}
   * @memberof DashboardProjectDto
   */
  imageUrl?: string | null;
  /**
   * Deadline of the running vote. Always null for now: no vote deadline is stored yet, the field is here so the home tile stops guessing.
   * @type {string}
   * @memberof DashboardProjectDto
   */
  voteDeadline?: string | null;
  /**
   * Households of the asset, i.e. how many are called to vote.
   * @type {number}
   * @memberof DashboardProjectDto
   */
  totalHouseholdsCount: number;
  /**
   * Households with at least one vote on this project.
   * @type {number}
   * @memberof DashboardProjectDto
   */
  votedHouseholdsCount: number;
  /**
   * Whether the caller\'s household has voted on this project.
   * @type {boolean}
   * @memberof DashboardProjectDto
   */
  hasCurrentUserVoted: boolean;
  /**
   *
   * @type {number}
   * @memberof DashboardProjectDto
   */
  estimatedCost?: number | null;
}
/**
 *
 * @export
 * @interface DashboardTaskDto
 */
export interface DashboardTaskDto {
  /**
   *
   * @type {string}
   * @memberof DashboardTaskDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DashboardTaskDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof DashboardTaskDto
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof DashboardTaskDto
   */
  dueDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof DashboardTaskDto
   */
  assignedToName?: string | null;
  /**
   *
   * @type {string}
   * @memberof DashboardTaskDto
   */
  assignedToPictureUrl?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DashboardTaskDto
   */
  isOverdue: boolean;
  /**
   * Catégorie de la tâche (`TaskCategory`), pour la sous-ligne « Xavier · entretien ».
   * @type {string}
   * @memberof DashboardTaskDto
   */
  type?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const DebtDirection = {
  Owes: 'OWES',
  Owed: 'OWED',
} as const;

export type DebtDirection = (typeof DebtDirection)[keyof typeof DebtDirection];

/**
 *
 * @export
 * @interface DebtItemDto
 */
export interface DebtItemDto {
  /**
   * Euros, rounded to the cent. Negative only on an adjustment.
   * @type {number}
   * @memberof DebtItemDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof DebtItemDto
   */
  label: string;
  /**
   *
   * @type {Dayjs}
   * @memberof DebtItemDto
   */
  date: Dayjs | null;
  /**
   *
   * @type {DebtItemKind}
   * @memberof DebtItemDto
   */
  kind: DebtItemKind;
  /**
   *
   * @type {DebtDirection}
   * @memberof DebtItemDto
   */
  direction: DebtDirection;
  /**
   *
   * @type {PartyDto}
   * @memberof DebtItemDto
   */
  counterparty: PartyDto;
  /**
   * Expense id for a share.
   * @type {string}
   * @memberof DebtItemDto
   */
  sourceId: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const DebtItemKind = {
  ExpenseShare: 'EXPENSE_SHARE',
  Adjustment: 'ADJUSTMENT',
} as const;

export type DebtItemKind = (typeof DebtItemKind)[keyof typeof DebtItemKind];

/**
 *
 * @export
 * @interface DeductibleChargesAssetDto
 */
export interface DeductibleChargesAssetDto {
  /**
   *
   * @type {string}
   * @memberof DeductibleChargesAssetDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof DeductibleChargesAssetDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof DeductibleChargesAssetDto
   */
  rentalDeclarationRegime: DeductibleChargesAssetDtoRentalDeclarationRegimeEnum;
}

export const DeductibleChargesAssetDtoRentalDeclarationRegimeEnum = {
  Reel: 'REEL',
  MicroFoncier: 'MICRO_FONCIER',
} as const;

export type DeductibleChargesAssetDtoRentalDeclarationRegimeEnum =
  (typeof DeductibleChargesAssetDtoRentalDeclarationRegimeEnum)[keyof typeof DeductibleChargesAssetDtoRentalDeclarationRegimeEnum];

/**
 *
 * @export
 * @interface DeductibleChargesDto
 */
export interface DeductibleChargesDto {
  /**
   *
   * @type {number}
   * @memberof DeductibleChargesDto
   */
  year: number;
  /**
   *
   * @type {DeductibleChargesAssetDto}
   * @memberof DeductibleChargesDto
   */
  asset: DeductibleChargesAssetDto;
  /**
   *
   * @type {number}
   * @memberof DeductibleChargesDto
   */
  totalLocativeAmount: number;
  /**
   *
   * @type {number}
   * @memberof DeductibleChargesDto
   */
  userQuotePart: number;
  /**
   *
   * @type {Array<DeductibleExpenseLineDto>}
   * @memberof DeductibleChargesDto
   */
  expenses: Array<DeductibleExpenseLineDto>;
}
/**
 *
 * @export
 * @interface DeductibleExpenseLineDto
 */
export interface DeductibleExpenseLineDto {
  /**
   *
   * @type {string}
   * @memberof DeductibleExpenseLineDto
   */
  expenseId: string;
  /**
   *
   * @type {string}
   * @memberof DeductibleExpenseLineDto
   */
  title: string;
  /**
   *
   * @type {Dayjs}
   * @memberof DeductibleExpenseLineDto
   */
  paidAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof DeductibleExpenseLineDto
   */
  type: DeductibleExpenseLineDtoTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DeductibleExpenseLineDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof DeductibleExpenseLineDto
   */
  locativeShare: number;
  /**
   *
   * @type {number}
   * @memberof DeductibleExpenseLineDto
   */
  locativeAmount: number;
  /**
   *
   * @type {number}
   * @memberof DeductibleExpenseLineDto
   */
  userQuotePart: number;
}

export const DeductibleExpenseLineDtoTypeEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type DeductibleExpenseLineDtoTypeEnum =
  (typeof DeductibleExpenseLineDtoTypeEnum)[keyof typeof DeductibleExpenseLineDtoTypeEnum];

/**
 *
 * @export
 * @interface DeletePushSubscriptionDto
 */
export interface DeletePushSubscriptionDto {
  /**
   *
   * @type {string}
   * @memberof DeletePushSubscriptionDto
   */
  endpoint: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const DocumentAnalysisStatus = {
  Analyzing: 'ANALYZING',
  Pending: 'PENDING',
  Accepted: 'ACCEPTED',
  Rejected: 'REJECTED',
  Obsolete: 'OBSOLETE',
  NoSuggestion: 'NO_SUGGESTION',
  Failed: 'FAILED',
} as const;

export type DocumentAnalysisStatus =
  (typeof DocumentAnalysisStatus)[keyof typeof DocumentAnalysisStatus];

/**
 *
 * @export
 * @interface DocumentSuggestionDto
 */
export interface DocumentSuggestionDto {
  /**
   *
   * @type {string}
   * @memberof DocumentSuggestionDto
   */
  id: string;
  /**
   * Id of the analyzed virtual file
   * @type {string}
   * @memberof DocumentSuggestionDto
   */
  fileId: string;
  /**
   *
   * @type {DocumentAnalysisStatus}
   * @memberof DocumentSuggestionDto
   */
  status: DocumentAnalysisStatus;
  /**
   *
   * @type {string}
   * @memberof DocumentSuggestionDto
   */
  originalName: string;
  /**
   *
   * @type {string}
   * @memberof DocumentSuggestionDto
   */
  originalPath: string;
  /**
   *
   * @type {string}
   * @memberof DocumentSuggestionDto
   */
  proposedName?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentSuggestionDto
   */
  proposedPath?: string;
  /**
   *
   * @type {DocumentType}
   * @memberof DocumentSuggestionDto
   */
  documentType?: DocumentType;
  /**
   *
   * @type {string}
   * @memberof DocumentSuggestionDto
   */
  documentTypeLabel?: string;
  /**
   *
   * @type {number}
   * @memberof DocumentSuggestionDto
   */
  confidence?: number;
  /**
   *
   * @type {Dayjs}
   * @memberof DocumentSuggestionDto
   */
  createdAt: Dayjs;
}

/**
 *
 * @export
 * @enum {string}
 */

export const DocumentType = {
  PropertyDeed: 'PROPERTY_DEED',
  CompanyStatutes: 'COMPANY_STATUTES',
  IndivisionAgreement: 'INDIVISION_AGREEMENT',
  Succession: 'SUCCESSION',
  Cadastre: 'CADASTRE',
  CondoRules: 'CONDO_RULES',
  InsuranceContract: 'INSURANCE_CONTRACT',
  InsuranceCertificate: 'INSURANCE_CERTIFICATE',
  InsuranceClaim: 'INSURANCE_CLAIM',
  PropertyTax: 'PROPERTY_TAX',
  HousingTax: 'HOUSING_TAX',
  TaxNotice: 'TAX_NOTICE',
  Invoice: 'INVOICE',
  Receipt: 'RECEIPT',
  Quote: 'QUOTE',
  MaintenanceContract: 'MAINTENANCE_CONTRACT',
  InterventionReport: 'INTERVENTION_REPORT',
  Warranty: 'WARRANTY',
  Diagnostic: 'DIAGNOSTIC',
  Plan: 'PLAN',
  PlanningPermission: 'PLANNING_PERMISSION',
  UtilityContract: 'UTILITY_CONTRACT',
  MeterReading: 'METER_READING',
  Loan: 'LOAN',
  BankStatement: 'BANK_STATEMENT',
  BankDetails: 'BANK_DETAILS',
  MeetingMinutes: 'MEETING_MINUTES',
  MeetingNotice: 'MEETING_NOTICE',
  UserManual: 'USER_MANUAL',
  Lease: 'LEASE',
  RentReceipt: 'RENT_RECEIPT',
  Letter: 'LETTER',
  Photo: 'PHOTO',
  Other: 'OTHER',
} as const;

export type DocumentType = (typeof DocumentType)[keyof typeof DocumentType];

/**
 *
 * @export
 * @interface DuplicateContactDto
 */
export interface DuplicateContactDto {
  /**
   *
   * @type {Array<string>}
   * @memberof DuplicateContactDto
   */
  targetAssetIds: Array<string>;
}
/**
 *
 * @export
 * @interface DuplicateContactResultDto
 */
export interface DuplicateContactResultDto {
  /**
   *
   * @type {Array<ContactDto>}
   * @memberof DuplicateContactResultDto
   */
  contacts: Array<ContactDto>;
  /**
   * Biens ignorés car une entreprise avec le même SIRET y existe déjà
   * @type {Array<string>}
   * @memberof DuplicateContactResultDto
   */
  skippedAssetIds: Array<string>;
}
/**
 *
 * @export
 * @interface EditCommunityFeedItemDto
 */
export interface EditCommunityFeedItemDto {
  /**
   *
   * @type {string}
   * @memberof EditCommunityFeedItemDto
   */
  message: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof EditCommunityFeedItemDto
   */
  files: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof EditCommunityFeedItemDto
   */
  description?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof EditCommunityFeedItemDto
   */
  attachmentIds?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof EditCommunityFeedItemDto
   */
  inGuestbook?: boolean;
  /**
   * Où les photos ont été prises. Propre à un album (POST_MEMORY).
   * @type {string}
   * @memberof EditCommunityFeedItemDto
   */
  place?: string;
  /**
   * Quand les photos ont été prises (ISO 8601), pas quand l\'album est publié. Le front le pré-remplit depuis l\'EXIF de la première photo, sinon aujourd\'hui.
   * @type {string}
   * @memberof EditCommunityFeedItemDto
   */
  takenAt?: string;
}
/**
 *
 * @export
 * @interface EmailStatusDto
 */
export interface EmailStatusDto {
  /**
   *
   * @type {string}
   * @memberof EmailStatusDto
   */
  loginMethod: EmailStatusDtoLoginMethodEnum;
  /**
   * SSO provider name (google, facebook, apple)
   * @type {string}
   * @memberof EmailStatusDto
   */
  ssoProvider?: string;
}

export const EmailStatusDtoLoginMethodEnum = {
  EmailPassword: 'email_password',
  SsoOnly: 'sso_only',
  NotFound: 'not_found',
} as const;

export type EmailStatusDtoLoginMethodEnum =
  (typeof EmailStatusDtoLoginMethodEnum)[keyof typeof EmailStatusDtoLoginMethodEnum];

/**
 *
 * @export
 * @interface EntityExportDto
 */
export interface EntityExportDto {
  /**
   *
   * @type {string}
   * @memberof EntityExportDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EntityExportDto
   */
  entityType: EntityExportDtoEntityTypeEnum;
  /**
   *
   * @type {string}
   * @memberof EntityExportDto
   */
  type: EntityExportDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof EntityExportDto
   */
  rule: EntityExportDtoRuleEnum;
  /**
   *
   * @type {object}
   * @memberof EntityExportDto
   */
  customRuleConfig: object;
  /**
   *
   * @type {string}
   * @memberof EntityExportDto
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof EntityExportDto
   */
  assetName?: string;
  /**
   *
   * @type {boolean}
   * @memberof EntityExportDto
   */
  isPublic: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityExportDto
   */
  publicUrl: string;
  /**
   *
   * @type {Array<string>}
   * @memberof EntityExportDto
   */
  entityIds?: Array<string>;
  /**
   *
   * @type {Dayjs}
   * @memberof EntityExportDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof EntityExportDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof EntityExportDto
   */
  expiresAt: Dayjs;
}

export const EntityExportDtoEntityTypeEnum = {
  Contact: 'CONTACT',
  Checklist: 'CHECKLIST',
  Instruction: 'INSTRUCTION',
  Event: 'EVENT',
  AssetStorageItem: 'ASSET_STORAGE_ITEM',
  PracticalInformation: 'PRACTICAL_INFORMATION',
} as const;

export type EntityExportDtoEntityTypeEnum =
  (typeof EntityExportDtoEntityTypeEnum)[keyof typeof EntityExportDtoEntityTypeEnum];
export const EntityExportDtoTypeEnum = {
  Static: 'STATIC',
  Dynamic: 'DYNAMIC',
  Single: 'SINGLE',
} as const;

export type EntityExportDtoTypeEnum =
  (typeof EntityExportDtoTypeEnum)[keyof typeof EntityExportDtoTypeEnum];
export const EntityExportDtoRuleEnum = {
  All: 'ALL',
  Emergency: 'EMERGENCY',
  DateRange: 'DATE_RANGE',
} as const;

export type EntityExportDtoRuleEnum =
  (typeof EntityExportDtoRuleEnum)[keyof typeof EntityExportDtoRuleEnum];

/**
 *
 * @export
 * @interface ErrorDto
 */
export interface ErrorDto {
  /**
   *
   * @type {string}
   * @memberof ErrorDto
   */
  code: ErrorDtoCodeEnum;
  /**
   *
   * @type {string}
   * @memberof ErrorDto
   */
  message: string | null;
}

export const ErrorDtoCodeEnum = {
  ReimbursementAmountMismatch: 'REIMBURSEMENT_AMOUNT_MISMATCH',
  ReimbursementMixedCase: 'REIMBURSEMENT_MIXED_CASE',
  ReimbursementByParticipantUnsupported: 'REIMBURSEMENT_BY_PARTICIPANT_UNSUPPORTED',
  ReimbursementExpenseNotEligible: 'REIMBURSEMENT_EXPENSE_NOT_ELIGIBLE',
  ContactPayerCannotBeReimbursed: 'CONTACT_PAYER_CANNOT_BE_REIMBURSED',
  EventOverlap: 'EVENT_OVERLAP',
  EventRoomInvalid: 'EVENT_ROOM_INVALID',
  EventRoomConflict: 'EVENT_ROOM_CONFLICT',
  EventHouseholdInvalid: 'EVENT_HOUSEHOLD_INVALID',
  EmailNotLinkedToToken: 'EMAIL_NOT_LINKED_TO_TOKEN',
  InvitationForEmailExists: 'INVITATION_FOR_EMAIL_EXISTS',
  InvalidToken: 'INVALID_TOKEN',
  TokenAlreadyUsed: 'TOKEN_ALREADY_USED',
  ExpiredInvitation: 'EXPIRED_INVITATION',
  NotTheOwner: 'NOT_THE_OWNER',
  AlreadyMember: 'ALREADY_MEMBER',
  EmailNotAllowed: 'EMAIL_NOT_ALLOWED',
  ExpiredOrNonExistingExport: 'EXPIRED_OR_NON_EXISTING_EXPORT',
  UnauthorizedFiletype: 'UNAUTHORIZED_FILETYPE',
  FileInUse: 'FILE_IN_USE',
  InvalidResetPasswordToken: 'INVALID_RESET_PASSWORD_TOKEN',
  EmailAlreadyExists: 'EMAIL_ALREADY_EXISTS',
  MissingPermissions: 'MISSING_PERMISSIONS',
  PasswordPolicyViolated: 'PASSWORD_POLICY_VIOLATED',
  InvalidFileName: 'INVALID_FILE_NAME',
  FileNotFound: 'FILE_NOT_FOUND',
  InvalidDirectoryPath: 'INVALID_DIRECTORY_PATH',
  FolderMoveIntoSelf: 'FOLDER_MOVE_INTO_SELF',
  ItemAlreadyExistsAtDestination: 'ITEM_ALREADY_EXISTS_AT_DESTINATION',
  InvalidFolderName: 'INVALID_FOLDER_NAME',
  ItemAlreadyExists: 'ITEM_ALREADY_EXISTS',
  InvalidFileOrFolderName: 'INVALID_FILE_OR_FOLDER_NAME',
  ItemNotFound: 'ITEM_NOT_FOUND',
  ItemNewNameAlreadyExists: 'ITEM_NEW_NAME_ALREADY_EXISTS',
  ChildItemHasReferences: 'CHILD_ITEM_HAS_REFERENCES',
  NotAFile: 'NOT_A_FILE',
  S3KeyMissing: 'S3_KEY_MISSING',
  ParentDirectoryNotFound: 'PARENT_DIRECTORY_NOT_FOUND',
  DestinationDirectoryNotFound: 'DESTINATION_DIRECTORY_NOT_FOUND',
  FileAlreadyExists: 'FILE_ALREADY_EXISTS',
  TermsNotAccepted: 'TERMS_NOT_ACCEPTED',
  AssetArchived: 'ASSET_ARCHIVED',
  QuotaExceededStorage: 'QUOTA_EXCEEDED_STORAGE',
  QuotaExceededVideoMinutes: 'QUOTA_EXCEEDED_VIDEO_MINUTES',
  AssetReadonlyBecauseQuotaReached: 'ASSET_READONLY_BECAUSE_QUOTA_REACHED',
  BankAccountInUse: 'BANK_ACCOUNT_IN_USE',
  InvitationResendCooldown: 'INVITATION_RESEND_COOLDOWN',
  InvitationNotFoundOrAccepted: 'INVITATION_NOT_FOUND_OR_ACCEPTED',
  InvitationPermissionsTooHigh: 'INVITATION_PERMISSIONS_TOO_HIGH',
  InvalidInviteCode: 'INVALID_INVITE_CODE',
  InviteCodeGenerationFailed: 'INVITE_CODE_GENERATION_FAILED',
  WrongPassword: 'WRONG_PASSWORD',
  NoEmailPasswordLogin: 'NO_EMAIL_PASSWORD_LOGIN',
  ExpenseReimbursedLocked: 'EXPENSE_REIMBURSED_LOCKED',
  ExpensePayerRequired: 'EXPENSE_PAYER_REQUIRED',
  DeductibleChargesNotReelRegime: 'DEDUCTIBLE_CHARGES_NOT_REEL_REGIME',
  DeductibleChargesDismemberedAsset: 'DEDUCTIBLE_CHARGES_DISMEMBERED_ASSET',
  GestionnaireOnly: 'GESTIONNAIRE_ONLY',
  MemberReminderRateLimited: 'MEMBER_REMINDER_RATE_LIMITED',
  InvalidPivotDate: 'INVALID_PIVOT_DATE',
  BudgetForecastDuplicateLine: 'BUDGET_FORECAST_DUPLICATE_LINE',
  BudgetForecastInvalidSubCategoryEntry: 'BUDGET_FORECAST_INVALID_SUB_CATEGORY_ENTRY',
  DocumentSuggestionNotFound: 'DOCUMENT_SUGGESTION_NOT_FOUND',
  DocumentSuggestionOutdated: 'DOCUMENT_SUGGESTION_OUTDATED',
  UnsupportedAudioFormat: 'UNSUPPORTED_AUDIO_FORMAT',
  EmptyDictation: 'EMPTY_DICTATION',
  AudioTooLarge: 'AUDIO_TOO_LARGE',
  InventoryPhotoRequired: 'INVENTORY_PHOTO_REQUIRED',
  InventoryForbidden: 'INVENTORY_FORBIDDEN',
} as const;

export type ErrorDtoCodeEnum = (typeof ErrorDtoCodeEnum)[keyof typeof ErrorDtoCodeEnum];

/**
 *
 * @export
 * @interface EventDetailsDto
 */
export interface EventDetailsDto {
  /**
   *
   * @type {string}
   * @memberof EventDetailsDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventDetailsDto
   */
  name: string;
  /**
   *
   * @type {boolean}
   * @memberof EventDetailsDto
   */
  allDay: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof EventDetailsDto
   */
  startTime: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof EventDetailsDto
   */
  endTime?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof EventDetailsDto
   */
  type: EventDetailsDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof EventDetailsDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EventDetailsDto
   */
  videoConferenceUrl?: string;
  /**
   *
   * @type {string}
   * @memberof EventDetailsDto
   */
  origin: EventDetailsDtoOriginEnum;
  /**
   * Reminder duration in seconds before the event starts
   * @type {number}
   * @memberof EventDetailsDto
   */
  reminderDurationSeconds?: number;
  /**
   *
   * @type {boolean}
   * @memberof EventDetailsDto
   */
  isOccurrence: boolean;
  /**
   * Deprecated: first entry of `households`, kept for older clients.
   * @type {EventHouseholdSummaryDto}
   * @memberof EventDetailsDto
   * @deprecated
   */
  household: EventHouseholdSummaryDto | null;
  /**
   * Households concerned by the event (soft-deleted ones are omitted).
   * @type {Array<EventHouseholdSummaryDto>}
   * @memberof EventDetailsDto
   */
  households: Array<EventHouseholdSummaryDto>;
  /**
   * Chambres occupées par ce séjour, avec leur bâtiment.
   * @type {Array<EventRoomSummaryDto>}
   * @memberof EventDetailsDto
   */
  rooms: Array<EventRoomSummaryDto>;
  /**
   * Is null if the event is automated (ex: holidays)
   * @type {UserDto}
   * @memberof EventDetailsDto
   */
  createdBy: UserDto | null;
  /**
   *
   * @type {AssetPreviewDto}
   * @memberof EventDetailsDto
   */
  asset: AssetPreviewDto;
  /**
   *
   * @type {boolean}
   * @memberof EventDetailsDto
   */
  isRecurring: boolean;
  /**
   *
   * @type {RecurrenceDto}
   * @memberof EventDetailsDto
   */
  recurrence?: RecurrenceDto;
  /**
   *
   * @type {boolean}
   * @memberof EventDetailsDto
   */
  isExclusiveOccupation: boolean;
  /**
   *
   * @type {Array<UserDto>}
   * @memberof EventDetailsDto
   */
  participants: Array<UserDto>;
  /**
   *
   * @type {Dayjs}
   * @memberof EventDetailsDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {AddressResponseDto}
   * @memberof EventDetailsDto
   */
  address: AddressResponseDto | null;
}

export const EventDetailsDtoTypeEnum = {
  Occupation: 'OCCUPATION',
  Entretien: 'ENTRETIEN',
  Location: 'LOCATION',
  EndOfContract: 'END_OF_CONTRACT',
  Work: 'WORK',
  Activities: 'ACTIVITIES',
  Other: 'OTHER',
  PublicHoliday: 'PUBLIC_HOLIDAY',
  SchoolHolidayZoneA: 'SCHOOL_HOLIDAY_ZONE_A',
  SchoolHolidayZoneB: 'SCHOOL_HOLIDAY_ZONE_B',
  SchoolHolidayZoneC: 'SCHOOL_HOLIDAY_ZONE_C',
} as const;

export type EventDetailsDtoTypeEnum =
  (typeof EventDetailsDtoTypeEnum)[keyof typeof EventDetailsDtoTypeEnum];
export const EventDetailsDtoOriginEnum = {
  Event: 'EVENT',
  PracticalInformation: 'PRACTICAL_INFORMATION',
  Project: 'PROJECT',
  Task: 'TASK',
  External: 'EXTERNAL',
} as const;

export type EventDetailsDtoOriginEnum =
  (typeof EventDetailsDtoOriginEnum)[keyof typeof EventDetailsDtoOriginEnum];

/**
 *
 * @export
 * @interface EventDto
 */
export interface EventDto {
  /**
   *
   * @type {string}
   * @memberof EventDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventDto
   */
  name: string;
  /**
   *
   * @type {boolean}
   * @memberof EventDto
   */
  allDay: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof EventDto
   */
  startTime: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof EventDto
   */
  endTime?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof EventDto
   */
  type: EventDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof EventDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof EventDto
   */
  videoConferenceUrl?: string;
  /**
   *
   * @type {string}
   * @memberof EventDto
   */
  origin: EventDtoOriginEnum;
  /**
   * Reminder duration in seconds before the event starts
   * @type {number}
   * @memberof EventDto
   */
  reminderDurationSeconds?: number;
  /**
   *
   * @type {boolean}
   * @memberof EventDto
   */
  isOccurrence: boolean;
  /**
   * Deprecated: first entry of `households`, kept for older clients.
   * @type {EventHouseholdSummaryDto}
   * @memberof EventDto
   * @deprecated
   */
  household: EventHouseholdSummaryDto | null;
  /**
   * Households concerned by the event (soft-deleted ones are omitted).
   * @type {Array<EventHouseholdSummaryDto>}
   * @memberof EventDto
   */
  households: Array<EventHouseholdSummaryDto>;
  /**
   * Chambres occupées par ce séjour, avec leur bâtiment.
   * @type {Array<EventRoomSummaryDto>}
   * @memberof EventDto
   */
  rooms: Array<EventRoomSummaryDto>;
}

export const EventDtoTypeEnum = {
  Occupation: 'OCCUPATION',
  Entretien: 'ENTRETIEN',
  Location: 'LOCATION',
  EndOfContract: 'END_OF_CONTRACT',
  Work: 'WORK',
  Activities: 'ACTIVITIES',
  Other: 'OTHER',
  PublicHoliday: 'PUBLIC_HOLIDAY',
  SchoolHolidayZoneA: 'SCHOOL_HOLIDAY_ZONE_A',
  SchoolHolidayZoneB: 'SCHOOL_HOLIDAY_ZONE_B',
  SchoolHolidayZoneC: 'SCHOOL_HOLIDAY_ZONE_C',
} as const;

export type EventDtoTypeEnum = (typeof EventDtoTypeEnum)[keyof typeof EventDtoTypeEnum];
export const EventDtoOriginEnum = {
  Event: 'EVENT',
  PracticalInformation: 'PRACTICAL_INFORMATION',
  Project: 'PROJECT',
  Task: 'TASK',
  External: 'EXTERNAL',
} as const;

export type EventDtoOriginEnum = (typeof EventDtoOriginEnum)[keyof typeof EventDtoOriginEnum];

/**
 *
 * @export
 * @interface EventHouseholdSummaryDto
 */
export interface EventHouseholdSummaryDto {
  /**
   *
   * @type {string}
   * @memberof EventHouseholdSummaryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventHouseholdSummaryDto
   */
  name: string;
  /**
   * Hex color used to render the occupation banner.
   * @type {string}
   * @memberof EventHouseholdSummaryDto
   */
  color: string;
}
/**
 *
 * @export
 * @interface EventRoomBuildingSummaryDto
 */
export interface EventRoomBuildingSummaryDto {
  /**
   *
   * @type {string}
   * @memberof EventRoomBuildingSummaryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventRoomBuildingSummaryDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface EventRoomSummaryDto
 */
export interface EventRoomSummaryDto {
  /**
   *
   * @type {string}
   * @memberof EventRoomSummaryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventRoomSummaryDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EventRoomSummaryDto
   */
  type: EventRoomSummaryDtoTypeEnum;
  /**
   *
   * @type {EventRoomBuildingSummaryDto}
   * @memberof EventRoomSummaryDto
   */
  building?: EventRoomBuildingSummaryDto | null;
}

export const EventRoomSummaryDtoTypeEnum = {
  Bedroom: 'BEDROOM',
  MasterBedroom: 'MASTER_BEDROOM',
  Dormitory: 'DORMITORY',
  StudioApartment: 'STUDIO_APARTMENT',
  DressingRoom: 'DRESSING_ROOM',
  StorageRoom: 'STORAGE_ROOM',
  LivingRoom: 'LIVING_ROOM',
  DiningRoom: 'DINING_ROOM',
  Office: 'OFFICE',
  Library: 'LIBRARY',
  Playroom: 'PLAYROOM',
  Gym: 'GYM',
  HomeCinema: 'HOME_CINEMA',
  Veranda: 'VERANDA',
  ReceptionRoom: 'RECEPTION_ROOM',
  Kitchen: 'KITCHEN',
  Pantry: 'PANTRY',
  Laundry: 'LAUNDRY',
  Larder: 'LARDER',
  Bathroom: 'BATHROOM',
  ShowerRoom: 'SHOWER_ROOM',
  PowderRoom: 'POWDER_ROOM',
  Toilet: 'TOILET',
  Entrance: 'ENTRANCE',
  Hallway: 'HALLWAY',
  Landing: 'LANDING',
  Stairwell: 'STAIRWELL',
  Mezzanine: 'MEZZANINE',
  Attic: 'ATTIC',
  Basement: 'BASEMENT',
  Cellar: 'CELLAR',
  WineCellar: 'WINE_CELLAR',
  BoilerRoom: 'BOILER_ROOM',
  Outdoor: 'OUTDOOR',
  Garden: 'GARDEN',
  Terrace: 'TERRACE',
  Balcony: 'BALCONY',
  Loggia: 'LOGGIA',
  Courtyard: 'COURTYARD',
  Pool: 'POOL',
  PoolHouse: 'POOL_HOUSE',
  Garage: 'GARAGE',
  Carport: 'CARPORT',
  ParkingSpace: 'PARKING_SPACE',
  Workshop: 'WORKSHOP',
  Shed: 'SHED',
  Outbuilding: 'OUTBUILDING',
  Barn: 'BARN',
  Stable: 'STABLE',
  CommonArea: 'COMMON_AREA',
  Lobby: 'LOBBY',
  BikeRoom: 'BIKE_ROOM',
  BinRoom: 'BIN_ROOM',
  Other: 'OTHER',
} as const;

export type EventRoomSummaryDtoTypeEnum =
  (typeof EventRoomSummaryDtoTypeEnum)[keyof typeof EventRoomSummaryDtoTypeEnum];

/**
 *
 * @export
 * @interface EventSummaryDto
 */
export interface EventSummaryDto {
  /**
   *
   * @type {string}
   * @memberof EventSummaryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventSummaryDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface ExitInventoryItemDto
 */
export interface ExitInventoryItemDto {
  /**
   *
   * @type {InventoryExitReason}
   * @memberof ExitInventoryItemDto
   */
  reason: InventoryExitReason;
  /**
   * Jour de la sortie (défaut : aujourd’hui)
   * @type {string}
   * @memberof ExitInventoryItemDto
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof ExitInventoryItemDto
   */
  note?: string;
}

/**
 *
 * @export
 * @interface ExpensePreviewBankAccountDto
 */
export interface ExpensePreviewBankAccountDto {
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewBankAccountDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewBankAccountDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface ExpensePreviewContactDto
 */
export interface ExpensePreviewContactDto {
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewContactDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewContactDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewContactDto
   */
  lastName?: string;
  /**
   * Nom de l\'entreprise, ou prénom + nom
   * @type {string}
   * @memberof ExpensePreviewContactDto
   */
  displayName: string;
}
/**
 *
 * @export
 * @interface ExpensePreviewDto
 */
export interface ExpensePreviewDto {
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewDto
   */
  id: string;
  /**
   *
   * @type {Dayjs}
   * @memberof ExpensePreviewDto
   */
  date: Dayjs;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewDto
   */
  note?: string;
  /**
   *
   * @type {number}
   * @memberof ExpensePreviewDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewDto
   */
  currency: string;
  /**
   *
   * @type {boolean}
   * @memberof ExpensePreviewDto
   */
  isIncome: boolean;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewDto
   */
  type: ExpensePreviewDtoTypeEnum;
  /**
   *
   * @type {UserDto}
   * @memberof ExpensePreviewDto
   */
  paidBy?: UserDto;
  /**
   *
   * @type {ExpensePreviewBankAccountDto}
   * @memberof ExpensePreviewDto
   */
  paidByBankAccount?: ExpensePreviewBankAccountDto;
  /**
   *
   * @type {ExpensePreviewContactDto}
   * @memberof ExpensePreviewDto
   */
  paidByContact?: ExpensePreviewContactDto;
  /**
   *
   * @type {ExpensePreviewPlaceholderMemberDto}
   * @memberof ExpensePreviewDto
   */
  paidByPlaceholderMember?: ExpensePreviewPlaceholderMemberDto;
  /**
   *
   * @type {Array<PreviewShareDto>}
   * @memberof ExpensePreviewDto
   */
  shares: Array<PreviewShareDto>;
  /**
   * Whether this expense has been marked as reimbursed (only set for non-income, non-settlement expenses)
   * @type {boolean}
   * @memberof ExpensePreviewDto
   */
  isReimbursed?: boolean;
  /**
   * Participants who already settled their own share. Absent on an income.
   * @type {number}
   * @memberof ExpensePreviewDto
   */
  settledSharesCount?: number;
  /**
   * Total number of participants carrying a share. Absent on an income.
   * @type {number}
   * @memberof ExpensePreviewDto
   */
  totalSharesCount?: number;
  /**
   * How many receipts are attached. 0 when there is none — the list shows a paperclip on anything above zero, so it is always a number, never absent.
   * @type {number}
   * @memberof ExpensePreviewDto
   */
  attachmentsCount: number;
  /**
   *
   * @type {boolean}
   * @memberof ExpensePreviewDto
   */
  isRecurring: boolean;
  /**
   *
   * @type {RecurrenceDto}
   * @memberof ExpensePreviewDto
   */
  recurrenceOptions?: RecurrenceDto;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewDto
   */
  recurrenceSeriesId?: string;
}

export const ExpensePreviewDtoTypeEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type ExpensePreviewDtoTypeEnum =
  (typeof ExpensePreviewDtoTypeEnum)[keyof typeof ExpensePreviewDtoTypeEnum];

/**
 *
 * @export
 * @interface ExpensePreviewPlaceholderMemberDto
 */
export interface ExpensePreviewPlaceholderMemberDto {
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewPlaceholderMemberDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewPlaceholderMemberDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof ExpensePreviewPlaceholderMemberDto
   */
  lastName: string;
}
/**
 *
 * @export
 * @interface ExpenseShareDetailsDto
 */
export interface ExpenseShareDetailsDto {
  /**
   *
   * @type {string}
   * @memberof ExpenseShareDetailsDto
   */
  id: string;
  /**
   *
   * @type {UserDto}
   * @memberof ExpenseShareDetailsDto
   */
  user?: UserDto;
  /**
   *
   * @type {ExpenseWithSharesPlaceholderMemberDto}
   * @memberof ExpenseShareDetailsDto
   */
  placeholderMember?: ExpenseWithSharesPlaceholderMemberDto;
  /**
   *
   * @type {number}
   * @memberof ExpenseShareDetailsDto
   */
  amount: number;
  /**
   *
   * @type {number}
   * @memberof ExpenseShareDetailsDto
   */
  percentage?: number;
  /**
   * Date de règlement de la part. `null` tant qu’elle est due.
   * @type {Dayjs}
   * @memberof ExpenseShareDetailsDto
   */
  settledAt?: Dayjs | null;
  /**
   *
   * @type {ExpenseShareSettlingTransferDto}
   * @memberof ExpenseShareDetailsDto
   */
  settledByTransfer?: ExpenseShareSettlingTransferDto | null;
  /**
   * Créancier de la part quand un remboursement lié la lui a transférée.
   * @type {UserDto}
   * @memberof ExpenseShareDetailsDto
   */
  owedToUser?: UserDto | null;
  /**
   *
   * @type {ExpenseWithSharesPlaceholderMemberDto}
   * @memberof ExpenseShareDetailsDto
   */
  owedToPlaceholderMember?: ExpenseWithSharesPlaceholderMemberDto | null;
  /**
   *
   * @type {BankAccountDto}
   * @memberof ExpenseShareDetailsDto
   */
  owedToBankAccount?: BankAccountDto | null;
}
/**
 *
 * @export
 * @interface ExpenseShareSettlingTransferDto
 */
export interface ExpenseShareSettlingTransferDto {
  /**
   *
   * @type {string}
   * @memberof ExpenseShareSettlingTransferDto
   */
  id: string;
  /**
   *
   * @type {Dayjs}
   * @memberof ExpenseShareSettlingTransferDto
   */
  date: Dayjs;
  /**
   *
   * @type {number}
   * @memberof ExpenseShareSettlingTransferDto
   */
  amount: number;
  /**
   * Qui a émis le remboursement : un membre, un non-inscrit, ou un compte.
   * @type {string}
   * @memberof ExpenseShareSettlingTransferDto
   */
  fromName?: string | null;
}
/**
 *
 * @export
 * @interface ExpenseSubCategoryDto
 */
export interface ExpenseSubCategoryDto {
  /**
   *
   * @type {string}
   * @memberof ExpenseSubCategoryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseSubCategoryDto
   */
  mainCategory: ExpenseSubCategoryDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof ExpenseSubCategoryDto
   */
  subCategory: ExpenseSubCategoryDtoSubCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof ExpenseSubCategoryDto
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof ExpenseSubCategoryDto
   */
  position: number;
}

export const ExpenseSubCategoryDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type ExpenseSubCategoryDtoMainCategoryEnum =
  (typeof ExpenseSubCategoryDtoMainCategoryEnum)[keyof typeof ExpenseSubCategoryDtoMainCategoryEnum];
export const ExpenseSubCategoryDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type ExpenseSubCategoryDtoSubCategoryEnum =
  (typeof ExpenseSubCategoryDtoSubCategoryEnum)[keyof typeof ExpenseSubCategoryDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface ExpenseWithSharesDto
 */
export interface ExpenseWithSharesDto {
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  merchant?: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  note?: string;
  /**
   *
   * @type {number}
   * @memberof ExpenseWithSharesDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  currency: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  type: string;
  /**
   *
   * @type {UserDto}
   * @memberof ExpenseWithSharesDto
   */
  createdBy: UserDto;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  assetId: string;
  /**
   *
   * @type {UserDto}
   * @memberof ExpenseWithSharesDto
   */
  paidBy?: UserDto;
  /**
   *
   * @type {BankAccountDto}
   * @memberof ExpenseWithSharesDto
   */
  paidByBankAccount?: BankAccountDto;
  /**
   *
   * @type {ContactPreviewDto}
   * @memberof ExpenseWithSharesDto
   */
  paidByContact?: ContactPreviewDto;
  /**
   *
   * @type {ExpenseWithSharesPlaceholderMemberDto}
   * @memberof ExpenseWithSharesDto
   */
  paidByPlaceholderMember?: ExpenseWithSharesPlaceholderMemberDto;
  /**
   *
   * @type {BankAccountDto}
   * @memberof ExpenseWithSharesDto
   */
  reimburseToBankAccount?: BankAccountDto;
  /**
   *
   * @type {boolean}
   * @memberof ExpenseWithSharesDto
   */
  isIncome: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof ExpenseWithSharesDto
   */
  paidAt: Dayjs;
  /**
   *
   * @type {Array<ExpenseShareDetailsDto>}
   * @memberof ExpenseWithSharesDto
   */
  shares: Array<ExpenseShareDetailsDto>;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  receiptImageUrl: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  receiptImagePath: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  splitType: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  splitScope: ExpenseWithSharesDtoSplitScopeEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof ExpenseWithSharesDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ExpenseWithSharesDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {Array<AttachmentDto>}
   * @memberof ExpenseWithSharesDto
   */
  attachments: Array<AttachmentDto>;
  /**
   * Whether this expense has been marked as reimbursed (only set for non-income, non-settlement expenses)
   * @type {boolean}
   * @memberof ExpenseWithSharesDto
   */
  isReimbursed?: boolean;
  /**
   * Participants who already settled their own share. Absent on an income.
   * @type {number}
   * @memberof ExpenseWithSharesDto
   */
  settledSharesCount?: number;
  /**
   * Total number of participants carrying a share. Absent on an income.
   * @type {number}
   * @memberof ExpenseWithSharesDto
   */
  totalSharesCount?: number;
  /**
   *
   * @type {boolean}
   * @memberof ExpenseWithSharesDto
   */
  isRecurring: boolean;
  /**
   *
   * @type {RecurrenceDto}
   * @memberof ExpenseWithSharesDto
   */
  recurrenceOptions?: RecurrenceDto;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesDto
   */
  recurrenceSeriesId?: string;
  /**
   * Share (0-100) of this expense attributable to rental use.
   * @type {number}
   * @memberof ExpenseWithSharesDto
   */
  locativeShare?: number;
}

export const ExpenseWithSharesDtoSplitScopeEnum = {
  Individual: 'INDIVIDUAL',
  Household: 'HOUSEHOLD',
} as const;

export type ExpenseWithSharesDtoSplitScopeEnum =
  (typeof ExpenseWithSharesDtoSplitScopeEnum)[keyof typeof ExpenseWithSharesDtoSplitScopeEnum];

/**
 *
 * @export
 * @interface ExpenseWithSharesPlaceholderMemberDto
 */
export interface ExpenseWithSharesPlaceholderMemberDto {
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesPlaceholderMemberDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesPlaceholderMemberDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof ExpenseWithSharesPlaceholderMemberDto
   */
  lastName: string;
}
/**
 *
 * @export
 * @interface ExportWithEntitiesDto
 */
export interface ExportWithEntitiesDto {
  /**
   *
   * @type {string}
   * @memberof ExportWithEntitiesDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ExportWithEntitiesDto
   */
  entityType: ExportWithEntitiesDtoEntityTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ExportWithEntitiesDto
   */
  type: ExportWithEntitiesDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ExportWithEntitiesDto
   */
  rule: ExportWithEntitiesDtoRuleEnum;
  /**
   *
   * @type {object}
   * @memberof ExportWithEntitiesDto
   */
  customRuleConfig: object;
  /**
   *
   * @type {string}
   * @memberof ExportWithEntitiesDto
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof ExportWithEntitiesDto
   */
  assetName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ExportWithEntitiesDto
   */
  isPublic: boolean;
  /**
   *
   * @type {string}
   * @memberof ExportWithEntitiesDto
   */
  publicUrl: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportWithEntitiesDto
   */
  entityIds?: Array<string>;
  /**
   *
   * @type {Dayjs}
   * @memberof ExportWithEntitiesDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ExportWithEntitiesDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ExportWithEntitiesDto
   */
  expiresAt: Dayjs;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportWithEntitiesDto
   */
  entities: Array<string>;
}

export const ExportWithEntitiesDtoEntityTypeEnum = {
  Contact: 'CONTACT',
  Checklist: 'CHECKLIST',
  Instruction: 'INSTRUCTION',
  Event: 'EVENT',
  AssetStorageItem: 'ASSET_STORAGE_ITEM',
  PracticalInformation: 'PRACTICAL_INFORMATION',
} as const;

export type ExportWithEntitiesDtoEntityTypeEnum =
  (typeof ExportWithEntitiesDtoEntityTypeEnum)[keyof typeof ExportWithEntitiesDtoEntityTypeEnum];
export const ExportWithEntitiesDtoTypeEnum = {
  Static: 'STATIC',
  Dynamic: 'DYNAMIC',
  Single: 'SINGLE',
} as const;

export type ExportWithEntitiesDtoTypeEnum =
  (typeof ExportWithEntitiesDtoTypeEnum)[keyof typeof ExportWithEntitiesDtoTypeEnum];
export const ExportWithEntitiesDtoRuleEnum = {
  All: 'ALL',
  Emergency: 'EMERGENCY',
  DateRange: 'DATE_RANGE',
} as const;

export type ExportWithEntitiesDtoRuleEnum =
  (typeof ExportWithEntitiesDtoRuleEnum)[keyof typeof ExportWithEntitiesDtoRuleEnum];

/**
 *
 * @export
 * @interface FailureDto
 */
export interface FailureDto {
  /**
   *
   * @type {string}
   * @memberof FailureDto
   */
  filename: string;
  /**
   *
   * @type {string}
   * @memberof FailureDto
   */
  error: string;
}
/**
 *
 * @export
 * @interface FileInfoDto
 */
export interface FileInfoDto {
  /**
   *
   * @type {string}
   * @memberof FileInfoDto
   */
  path: string;
  /**
   *
   * @type {string}
   * @memberof FileInfoDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FileInfoDto
   */
  id: string;
  /**
   *
   * @type {SignedUrlsDto}
   * @memberof FileInfoDto
   */
  urls?: SignedUrlsDto;
  /**
   *
   * @type {string}
   * @memberof FileInfoDto
   */
  type: FileInfoDtoTypeEnum;
  /**
   *
   * @type {VideoDto}
   * @memberof FileInfoDto
   */
  video?: VideoDto;
  /**
   *
   * @type {string}
   * @memberof FileInfoDto
   */
  externalUrl?: string;
}

export const FileInfoDtoTypeEnum = {
  File: 'file',
  Folder: 'folder',
  Video: 'video',
  ExternalLink: 'external_link',
} as const;

export type FileInfoDtoTypeEnum = (typeof FileInfoDtoTypeEnum)[keyof typeof FileInfoDtoTypeEnum];

/**
 *
 * @export
 * @interface FileUploaderDto
 */
export interface FileUploaderDto {
  /**
   * ID of the user who uploaded the file
   * @type {string}
   * @memberof FileUploaderDto
   */
  id: string;
  /**
   * First name of the user who uploaded the file
   * @type {string}
   * @memberof FileUploaderDto
   */
  firstName: string;
  /**
   * Last name of the user who uploaded the file
   * @type {string}
   * @memberof FileUploaderDto
   */
  lastName: string;
}
/**
 *
 * @export
 * @interface FloorDto
 */
export interface FloorDto {
  /**
   *
   * @type {string}
   * @memberof FloorDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FloorDto
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof FloorDto
   */
  level: number;
  /**
   *
   * @type {number}
   * @memberof FloorDto
   */
  position: number;
  /**
   *
   * @type {Dayjs}
   * @memberof FloorDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof FloorDto
   */
  updatedAt: Dayjs;
}
/**
 *
 * @export
 * @interface ForecastExcludedLineDto
 */
export interface ForecastExcludedLineDto {
  /**
   * Id of the excluded expense
   * @type {string}
   * @memberof ForecastExcludedLineDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ForecastExcludedLineDto
   */
  exclusionId: string;
  /**
   *
   * @type {string}
   * @memberof ForecastExcludedLineDto
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof ForecastExcludedLineDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof ForecastExcludedLineDto
   */
  mainCategory: ForecastExcludedLineDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof ForecastExcludedLineDto
   */
  subCategory?: ForecastExcludedLineDtoSubCategoryEnum | null;
  /**
   *
   * @type {Dayjs}
   * @memberof ForecastExcludedLineDto
   */
  date: Dayjs;
}

export const ForecastExcludedLineDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type ForecastExcludedLineDtoMainCategoryEnum =
  (typeof ForecastExcludedLineDtoMainCategoryEnum)[keyof typeof ForecastExcludedLineDtoMainCategoryEnum];
export const ForecastExcludedLineDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type ForecastExcludedLineDtoSubCategoryEnum =
  (typeof ForecastExcludedLineDtoSubCategoryEnum)[keyof typeof ForecastExcludedLineDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface ForecastViewLineDto
 */
export interface ForecastViewLineDto {
  /**
   * Stable identifier for the line: recurrenceSeriesId for AUTO, expense id for MANUAL_REAL, forecast line id for MANUAL_FORECAST
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  source: ForecastViewLineDtoSourceEnum;
  /**
   *
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  mainCategory: ForecastViewLineDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  subCategory?: ForecastViewLineDtoSubCategoryEnum | null;
  /**
   * Whether this line belongs to the CHARGE or PRODUCT budget block
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  nature: ForecastViewLineDtoNatureEnum;
  /**
   * MANUAL_FORECAST only: id of the named sub-line this amount belongs to
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  subCategoryEntryId?: string | null;
  /**
   *
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  subCategoryEntryLabel?: string | null;
  /**
   *
   * @type {string}
   * @memberof ForecastViewLineDto
   */
  expenseType?: ForecastViewLineDtoExpenseTypeEnum | null;
  /**
   *
   * @type {boolean}
   * @memberof ForecastViewLineDto
   */
  isIncome: boolean;
  /**
   *
   * @type {object}
   * @memberof ForecastViewLineDto
   */
  paidBy?: object | null;
  /**
   *
   * @type {object}
   * @memberof ForecastViewLineDto
   */
  paidByBankAccount?: object | null;
  /**
   *
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  occurrenceCount: number;
  /**
   * Per-occurrence unit amount when consistent across occurrences (AUTO lines)
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  unitAmount?: number | null;
  /**
   *
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  totalAmount: number;
  /**
   *
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  paidAmount: number;
  /**
   *
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  pendingAmount: number;
  /**
   * MANUAL_FORECAST only: portion of this budget line already covered by realized expenses (MANUAL_REAL) in the same category, deducted from pendingAmount. Not included in realizedPaid.
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  budgetRealizedAmount?: number | null;
  /**
   * MANUAL_FORECAST only: amount by which realized expenses of the same category exceed this budget line (true overrun, as opposed to the fixed false-overrun bug).
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  budgetOverrunAmount?: number | null;
  /**
   *
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  paidOccurrenceCount: number;
  /**
   *
   * @type {number}
   * @memberof ForecastViewLineDto
   */
  pendingOccurrenceCount: number;
  /**
   *
   * @type {Array<ForecastViewOccurrenceDto>}
   * @memberof ForecastViewLineDto
   */
  occurrences: Array<ForecastViewOccurrenceDto>;
  /**
   * true when this line can be excluded from the budget (MANUAL_REAL lines only: its id is a real expense id). AUTO series and MANUAL_FORECAST lines are never excludable.
   * @type {boolean}
   * @memberof ForecastViewLineDto
   */
  isExcludable: boolean;
}

export const ForecastViewLineDtoSourceEnum = {
  Auto: 'AUTO',
  ManualReal: 'MANUAL_REAL',
  ManualForecast: 'MANUAL_FORECAST',
} as const;

export type ForecastViewLineDtoSourceEnum =
  (typeof ForecastViewLineDtoSourceEnum)[keyof typeof ForecastViewLineDtoSourceEnum];
export const ForecastViewLineDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type ForecastViewLineDtoMainCategoryEnum =
  (typeof ForecastViewLineDtoMainCategoryEnum)[keyof typeof ForecastViewLineDtoMainCategoryEnum];
export const ForecastViewLineDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type ForecastViewLineDtoSubCategoryEnum =
  (typeof ForecastViewLineDtoSubCategoryEnum)[keyof typeof ForecastViewLineDtoSubCategoryEnum];
export const ForecastViewLineDtoNatureEnum = {
  Charge: 'CHARGE',
  Product: 'PRODUCT',
} as const;

export type ForecastViewLineDtoNatureEnum =
  (typeof ForecastViewLineDtoNatureEnum)[keyof typeof ForecastViewLineDtoNatureEnum];
export const ForecastViewLineDtoExpenseTypeEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type ForecastViewLineDtoExpenseTypeEnum =
  (typeof ForecastViewLineDtoExpenseTypeEnum)[keyof typeof ForecastViewLineDtoExpenseTypeEnum];

/**
 *
 * @export
 * @interface ForecastViewOccurrenceDto
 */
export interface ForecastViewOccurrenceDto {
  /**
   *
   * @type {Dayjs}
   * @memberof ForecastViewOccurrenceDto
   */
  date: Dayjs;
  /**
   *
   * @type {number}
   * @memberof ForecastViewOccurrenceDto
   */
  amount: number;
  /**
   * true if this occurrence has been materialized as a real expense (treated as paid)
   * @type {boolean}
   * @memberof ForecastViewOccurrenceDto
   */
  isMaterialized: boolean;
  /**
   * AUTO, not-yet-materialized occurrences only: id of the recurring template expense, used to set a custom amount for this occurrence before it gets materialized
   * @type {string}
   * @memberof ForecastViewOccurrenceDto
   */
  templateExpenseId?: string | null;
  /**
   * true if this not-yet-materialized occurrence already has a custom amount set
   * @type {boolean}
   * @memberof ForecastViewOccurrenceDto
   */
  hasCustomAmount?: boolean;
}
/**
 *
 * @export
 * @interface FundCallBankDetailsDto
 */
export interface FundCallBankDetailsDto {
  /**
   * Pré-remplit « Vers » quand on enregistre le versement d’une ligne.
   * @type {string}
   * @memberof FundCallBankDetailsDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FundCallBankDetailsDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof FundCallBankDetailsDto
   */
  bankName?: string | null;
  /**
   * Agence / caisse régionale (« Île-de-France »). Pas des coordonnées de paiement.
   * @type {string}
   * @memberof FundCallBankDetailsDto
   */
  bankDetail?: string | null;
  /**
   * Bénéficiaire du virement.
   * @type {string}
   * @memberof FundCallBankDetailsDto
   */
  holderName?: string | null;
  /**
   * IBAN sans espaces.
   * @type {string}
   * @memberof FundCallBankDetailsDto
   */
  iban?: string | null;
  /**
   *
   * @type {string}
   * @memberof FundCallBankDetailsDto
   */
  bic?: string | null;
}
/**
 *
 * @export
 * @interface FundCallDto
 */
export interface FundCallDto {
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  type: FundCallDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  scope: FundCallDtoScopeEnum;
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  status: FundCallDtoStatusEnum;
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  periodLabel: string;
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  fraction: FundCallDtoFractionEnum;
  /**
   *
   * @type {boolean}
   * @memberof FundCallDto
   */
  includeCurrentBalance: boolean;
  /**
   * Joindre, après le relevé individuel, l’état des comptes de tous les membres. Défaut à la création : le choix du dernier appel du bien.
   * @type {boolean}
   * @memberof FundCallDto
   */
  includeStatement: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof FundCallDto
   */
  dueDate?: Dayjs | null;
  /**
   *
   * @type {Dayjs}
   * @memberof FundCallDto
   */
  nextStatementDate?: Dayjs | null;
  /**
   *
   * @type {string}
   * @memberof FundCallDto
   */
  message?: string | null;
  /**
   *
   * @type {Dayjs}
   * @memberof FundCallDto
   */
  sentAt?: Dayjs | null;
  /**
   *
   * @type {SettlementTargetDto}
   * @memberof FundCallDto
   */
  createdBy: SettlementTargetDto;
  /**
   *
   * @type {Array<FundCallLineDto>}
   * @memberof FundCallDto
   */
  lines: Array<FundCallLineDto>;
  /**
   *
   * @type {FundCallBankDetailsDto}
   * @memberof FundCallDto
   */
  bankAccount?: FundCallBankDetailsDto | null;
  /**
   * Nombre de lignes réglées sur le nombre de lignes appelées.
   * @type {number}
   * @memberof FundCallDto
   */
  settledCount: number;
  /**
   *
   * @type {number}
   * @memberof FundCallDto
   */
  calledCount: number;
}

export const FundCallDtoTypeEnum = {
  Statement: 'STATEMENT',
  FundCall: 'FUND_CALL',
} as const;

export type FundCallDtoTypeEnum = (typeof FundCallDtoTypeEnum)[keyof typeof FundCallDtoTypeEnum];
export const FundCallDtoScopeEnum = {
  Self: 'SELF',
  All: 'ALL',
} as const;

export type FundCallDtoScopeEnum = (typeof FundCallDtoScopeEnum)[keyof typeof FundCallDtoScopeEnum];
export const FundCallDtoStatusEnum = {
  Draft: 'DRAFT',
  Sent: 'SENT',
} as const;

export type FundCallDtoStatusEnum =
  (typeof FundCallDtoStatusEnum)[keyof typeof FundCallDtoStatusEnum];
export const FundCallDtoFractionEnum = {
  Year: 'YEAR',
  Half: 'HALF',
  Quarter: 'QUARTER',
  Month: 'MONTH',
} as const;

export type FundCallDtoFractionEnum =
  (typeof FundCallDtoFractionEnum)[keyof typeof FundCallDtoFractionEnum];

/**
 *
 * @export
 * @interface FundCallLineDto
 */
export interface FundCallLineDto {
  /**
   *
   * @type {string}
   * @memberof FundCallLineDto
   */
  id: string;
  /**
   *
   * @type {SettlementTargetDto}
   * @memberof FundCallLineDto
   */
  party: SettlementTargetDto;
  /**
   * Nom du foyer du membre sur ce bien, null si non rattaché.
   * @type {string}
   * @memberof FundCallLineDto
   */
  householdName?: string | null;
  /**
   *
   * @type {number}
   * @memberof FundCallLineDto
   */
  currentBalance: number;
  /**
   *
   * @type {number}
   * @memberof FundCallLineDto
   */
  forecastShare: number;
  /**
   *
   * @type {number}
   * @memberof FundCallLineDto
   */
  amountCalled: number;
  /**
   *
   * @type {number}
   * @memberof FundCallLineDto
   */
  amountPaid: number;
  /**
   *
   * @type {string}
   * @memberof FundCallLineDto
   */
  status: FundCallLineDtoStatusEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof FundCallLineDto
   */
  settledAt?: Dayjs | null;
  /**
   *
   * @type {string}
   * @memberof FundCallLineDto
   */
  settledByTransferId?: string | null;
  /**
   *
   * @type {object}
   * @memberof FundCallLineDto
   */
  detail: object;
  /**
   *
   * @type {Dayjs}
   * @memberof FundCallLineDto
   */
  emailSentAt?: Dayjs | null;
  /**
   * Sort de l\'e-mail de la ligne. Null tant que l\'appel n\'est pas envoyé.
   * @type {string}
   * @memberof FundCallLineDto
   */
  sendStatus?: FundCallLineDtoSendStatusEnum | null;
  /**
   * Adresse utilisée pour le dernier envoi.
   * @type {string}
   * @memberof FundCallLineDto
   */
  sentTo?: string | null;
  /**
   * false ⇒ le front propose « Copier le message » à la place.
   * @type {boolean}
   * @memberof FundCallLineDto
   */
  hasEmail: boolean;
  /**
   * Référence de virement `{BIEN}-{PÉRIODE}-{NOM}`, posée à l’envoi.
   * @type {string}
   * @memberof FundCallLineDto
   */
  transferReference?: string | null;
  /**
   * Message de relance prêt à copier, composé côté API.
   * @type {string}
   * @memberof FundCallLineDto
   */
  reminderText: string;
}

export const FundCallLineDtoStatusEnum = {
  Pending: 'PENDING',
  Settled: 'SETTLED',
  NotSent: 'NOT_SENT',
  Excluded: 'EXCLUDED',
} as const;

export type FundCallLineDtoStatusEnum =
  (typeof FundCallLineDtoStatusEnum)[keyof typeof FundCallLineDtoStatusEnum];
export const FundCallLineDtoSendStatusEnum = {
  Sent: 'SENT',
  Failed: 'FAILED',
  NotSent: 'NOT_SENT',
} as const;

export type FundCallLineDtoSendStatusEnum =
  (typeof FundCallLineDtoSendStatusEnum)[keyof typeof FundCallLineDtoSendStatusEnum];

/**
 *
 * @export
 * @interface FundCallPdfUrlDto
 */
export interface FundCallPdfUrlDto {
  /**
   *
   * @type {string}
   * @memberof FundCallPdfUrlDto
   */
  url: string;
}
/**
 *
 * @export
 * @interface GenerateInstructionDto
 */
export interface GenerateInstructionDto {
  /**
   * Titre général de la consigne
   * @type {string}
   * @memberof GenerateInstructionDto
   */
  title: string;
  /**
   * Langue de génération (par défaut: fr)
   * @type {string}
   * @memberof GenerateInstructionDto
   */
  language?: GenerateInstructionDtoLanguageEnum;
}

export const GenerateInstructionDtoLanguageEnum = {
  Fr: 'fr',
  En: 'en',
} as const;

export type GenerateInstructionDtoLanguageEnum =
  (typeof GenerateInstructionDtoLanguageEnum)[keyof typeof GenerateInstructionDtoLanguageEnum];

/**
 *
 * @export
 * @interface GlobalSettlementDto
 */
export interface GlobalSettlementDto {
  /**
   *
   * @type {SettlementTargetDto}
   * @memberof GlobalSettlementDto
   */
  from: SettlementTargetDto;
  /**
   *
   * @type {SettlementTargetDto}
   * @memberof GlobalSettlementDto
   */
  to: SettlementTargetDto;
  /**
   *
   * @type {number}
   * @memberof GlobalSettlementDto
   */
  amount: number;
  /**
   * Expense shares still owed in the direction of the settlement, to pre-select them in the reimbursement form. Their sum equals `amount` unless both parties owe each other something, in which case the shares of the dominant direction are returned and `amount` stays the net. Only set on the per-asset, non-simplified equilibrium: a simplified or cross-asset line nets several debts together and maps to no share.
   * @type {Array<SettlementShareDto>}
   * @memberof GlobalSettlementDto
   */
  shares?: Array<SettlementShareDto>;
  /**
   * L\'ID du bien auquel ce règlement appartient.
   * @type {string}
   * @memberof GlobalSettlementDto
   */
  assetId: string;
  /**
   * Le nom du bien auquel ce règlement appartient.
   * @type {string}
   * @memberof GlobalSettlementDto
   */
  assetName: string;
}
/**
 *
 * @export
 * @interface GlobalWalletDto
 */
export interface GlobalWalletDto {
  /**
   * The total amount owed to the user across all assets and people.
   * @type {number}
   * @memberof GlobalWalletDto
   */
  myTotalNetBalance: number;
  /**
   * The total amount the user owes across all assets and people.
   * @type {Array<GlobalSettlementDto>}
   * @memberof GlobalWalletDto
   */
  owedToMe: Array<GlobalSettlementDto>;
  /**
   * A detailed list of balances.
   * @type {Array<GlobalSettlementDto>}
   * @memberof GlobalWalletDto
   */
  iOwe: Array<GlobalSettlementDto>;
}
/**
 *
 * @export
 * @interface HouseSummaryDto
 */
export interface HouseSummaryDto {
  /**
   * Main account: the first one created on the asset.
   * @type {string}
   * @memberof HouseSummaryDto
   */
  bankAccountId: string;
  /**
   *
   * @type {string}
   * @memberof HouseSummaryDto
   */
  label: string;
  /**
   * Last balance entered on the main account; null when none was ever entered.
   * @type {KnownBalanceDto}
   * @memberof HouseSummaryDto
   */
  knownBalance: KnownBalanceDto | null;
  /**
   * What members owe the house accounts.
   * @type {number}
   * @memberof HouseSummaryDto
   */
  dueToAccount: number;
  /**
   * What the house accounts owe members.
   * @type {number}
   * @memberof HouseSummaryDto
   */
  dueByAccount: number;
  /**
   * knownBalance + dueToAccount − dueByAccount; null without a known balance.
   * @type {number}
   * @memberof HouseSummaryDto
   */
  available: number | null;
  /**
   *
   * @type {Array<DebtItemDto>}
   * @memberof HouseSummaryDto
   */
  dueToAccountItems: Array<DebtItemDto>;
  /**
   *
   * @type {Array<DebtItemDto>}
   * @memberof HouseSummaryDto
   */
  dueByAccountItems: Array<DebtItemDto>;
}
/**
 *
 * @export
 * @interface HouseholdBalanceDto
 */
export interface HouseholdBalanceDto {
  /**
   *
   * @type {string}
   * @memberof HouseholdBalanceDto
   */
  householdId: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdBalanceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdBalanceDto
   */
  color: string;
  /**
   * Net balance of the household, in euros. Positive = the household is owed; negative = the household owes.
   * @type {number}
   * @memberof HouseholdBalanceDto
   */
  netBalance: number;
}
/**
 *
 * @export
 * @interface HouseholdDto
 */
export interface HouseholdDto {
  /**
   *
   * @type {string}
   * @memberof HouseholdDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdDto
   */
  color: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdDto
   */
  costBearerMode: HouseholdDtoCostBearerModeEnum;
  /**
   *
   * @type {HouseholdMemberDto}
   * @memberof HouseholdDto
   */
  head?: HouseholdMemberDto;
  /**
   *
   * @type {Array<HouseholdMemberDto>}
   * @memberof HouseholdDto
   */
  members: Array<HouseholdMemberDto>;
  /**
   *
   * @type {OwnershipSummaryDto}
   * @memberof HouseholdDto
   */
  ownershipSummary: OwnershipSummaryDto;
  /**
   *
   * @type {Dayjs}
   * @memberof HouseholdDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof HouseholdDto
   */
  updatedAt: Dayjs;
}

export const HouseholdDtoCostBearerModeEnum = {
  Representative: 'REPRESENTATIVE',
  OwnersSplit: 'OWNERS_SPLIT',
} as const;

export type HouseholdDtoCostBearerModeEnum =
  (typeof HouseholdDtoCostBearerModeEnum)[keyof typeof HouseholdDtoCostBearerModeEnum];

/**
 *
 * @export
 * @interface HouseholdMemberDto
 */
export interface HouseholdMemberDto {
  /**
   * AssetMember id.
   * @type {string}
   * @memberof HouseholdMemberDto
   */
  id: string;
  /**
   * Absent when this member is a placeholder.
   * @type {string}
   * @memberof HouseholdMemberDto
   */
  userId?: string;
  /**
   * True if this member is a non-registered placeholder.
   * @type {boolean}
   * @memberof HouseholdMemberDto
   */
  isPlaceholder: boolean;
  /**
   * Set when this member is a placeholder.
   * @type {string}
   * @memberof HouseholdMemberDto
   */
  placeholderMemberId?: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdMemberDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdMemberDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof HouseholdMemberDto
   */
  operationalRole?: HouseholdMemberDtoOperationalRoleEnum;
  /**
   * True if this member is the asset owner.
   * @type {boolean}
   * @memberof HouseholdMemberDto
   */
  isAssetOwner: boolean;
  /**
   * Absolute number of shares held by this member.
   * @type {number}
   * @memberof HouseholdMemberDto
   */
  shares?: number;
  /**
   * Percentage of asset total shares held by this member.
   * @type {number}
   * @memberof HouseholdMemberDto
   */
  sharesPct: number;
  /**
   *
   * @type {string}
   * @memberof HouseholdMemberDto
   */
  ownershipNature?: HouseholdMemberDtoOwnershipNatureEnum;
}

export const HouseholdMemberDtoOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type HouseholdMemberDtoOperationalRoleEnum =
  (typeof HouseholdMemberDtoOperationalRoleEnum)[keyof typeof HouseholdMemberDtoOperationalRoleEnum];
export const HouseholdMemberDtoOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type HouseholdMemberDtoOwnershipNatureEnum =
  (typeof HouseholdMemberDtoOwnershipNatureEnum)[keyof typeof HouseholdMemberDtoOwnershipNatureEnum];

/**
 *
 * @export
 * @interface InitialBalanceAuditDto
 */
export interface InitialBalanceAuditDto {
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  initialBalanceId: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  assetMemberId: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  lastName?: string;
  /**
   *
   * @type {number}
   * @memberof InitialBalanceAuditDto
   */
  previousAmount: number;
  /**
   *
   * @type {number}
   * @memberof InitialBalanceAuditDto
   */
  newAmount: number;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  previousLabel?: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  newLabel?: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  reason: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  modifiedById: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  modifiedByFirstName?: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceAuditDto
   */
  modifiedByLastName?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof InitialBalanceAuditDto
   */
  modifiedAt: Dayjs;
}
/**
 *
 * @export
 * @interface InitialBalanceDto
 */
export interface InitialBalanceDto {
  /**
   *
   * @type {string}
   * @memberof InitialBalanceDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceDto
   */
  assetMemberId: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceDto
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceDto
   */
  lastName?: string;
  /**
   *
   * @type {number}
   * @memberof InitialBalanceDto
   */
  amount: number;
  /**
   *
   * @type {Dayjs}
   * @memberof InitialBalanceDto
   */
  asOfDate: Dayjs;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceDto
   */
  pivotPeriod: InitialBalanceDtoPivotPeriodEnum;
  /**
   *
   * @type {string}
   * @memberof InitialBalanceDto
   */
  label?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof InitialBalanceDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof InitialBalanceDto
   */
  updatedAt: Dayjs;
}

export const InitialBalanceDtoPivotPeriodEnum = {
  H12024: 'H1_2024',
  H22024: 'H2_2024',
  H12025: 'H1_2025',
  H22025: 'H2_2025',
  H12026: 'H1_2026',
  H22026: 'H2_2026',
  H12027: 'H1_2027',
  H22027: 'H2_2027',
} as const;

export type InitialBalanceDtoPivotPeriodEnum =
  (typeof InitialBalanceDtoPivotPeriodEnum)[keyof typeof InitialBalanceDtoPivotPeriodEnum];

/**
 *
 * @export
 * @interface InstructionDto
 */
export interface InstructionDto {
  /**
   *
   * @type {string}
   * @memberof InstructionDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InstructionDto
   */
  title: string;
  /**
   *
   * @type {Array<SectionDto>}
   * @memberof InstructionDto
   */
  sections: Array<SectionDto>;
  /**
   *
   * @type {AttachmentDto}
   * @memberof InstructionDto
   */
  attachment: AttachmentDto;
  /**
   *
   * @type {Dayjs}
   * @memberof InstructionDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof InstructionDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof InstructionDto
   */
  createdBy: string;
}
/**
 *
 * @export
 * @interface InstructionPreviewDto
 */
export interface InstructionPreviewDto {
  /**
   *
   * @type {string}
   * @memberof InstructionPreviewDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InstructionPreviewDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof InstructionPreviewDto
   */
  content: string;
  /**
   *
   * @type {AttachmentDto}
   * @memberof InstructionPreviewDto
   */
  attachment: AttachmentDto;
}
/**
 *
 * @export
 * @interface InstructionVoiceDraftDto
 */
export interface InstructionVoiceDraftDto {
  /**
   *
   * @type {string}
   * @memberof InstructionVoiceDraftDto
   */
  title: string;
  /**
   *
   * @type {Array<SectionDto>}
   * @memberof InstructionVoiceDraftDto
   */
  sections: Array<SectionDto>;
  /**
   * Transcription brute de la dictée, à afficher dans « Voir ce que j\'ai dit ».
   * @type {string}
   * @memberof InstructionVoiceDraftDto
   */
  transcript: string;
}
/**
 *
 * @export
 * @interface InterlocutorDto
 */
export interface InterlocutorDto {
  /**
   *
   * @type {string}
   * @memberof InterlocutorDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InterlocutorDto
   */
  title?: InterlocutorDtoTitleEnum;
  /**
   *
   * @type {string}
   * @memberof InterlocutorDto
   */
  firstName?: string;
  /**
   * Nom ou service
   * @type {string}
   * @memberof InterlocutorDto
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof InterlocutorDto
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof InterlocutorDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InterlocutorDto
   */
  phoneNumber?: string;
  /**
   *
   * @type {CompanyContactRole}
   * @memberof InterlocutorDto
   */
  companyRole: CompanyContactRole;
  /**
   *
   * @type {string}
   * @memberof InterlocutorDto
   */
  companyRoleLabel?: string;
}

export const InterlocutorDtoTitleEnum = {
  Mr: 'mr',
  Ms: 'ms',
  Other: 'other',
} as const;

export type InterlocutorDtoTitleEnum =
  (typeof InterlocutorDtoTitleEnum)[keyof typeof InterlocutorDtoTitleEnum];

/**
 *
 * @export
 * @interface InventoryCreatedDto
 */
export interface InventoryCreatedDto {
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  name: string;
  /**
   *
   * @type {InventoryRoomDto}
   * @memberof InventoryCreatedDto
   */
  room?: InventoryRoomDto | null;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  brandAndModel?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  condition?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  notes?: string | null;
  /**
   *
   * @type {number}
   * @memberof InventoryCreatedDto
   */
  quantity: number;
  /**
   *
   * @type {number}
   * @memberof InventoryCreatedDto
   */
  purchaseYear?: number | null;
  /**
   * Vrai pour les gestionnaires et pour la personne qui a ajouté l’objet ; sinon montants masqués
   * @type {boolean}
   * @memberof InventoryCreatedDto
   */
  valuesVisible: boolean;
  /**
   *
   * @type {number}
   * @memberof InventoryCreatedDto
   */
  purchasePrice?: number | null;
  /**
   * Valeur à neuf du lot
   * @type {number}
   * @memberof InventoryCreatedDto
   */
  replacementValue?: number | null;
  /**
   *
   * @type {InventoryValueSource}
   * @memberof InventoryCreatedDto
   */
  replacementValueSource?: InventoryValueSource | null;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  replacementValueSourceLabel?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  replacementValueSourceUrl?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InventoryCreatedDto
   */
  depreciationEnabled: boolean;
  /**
   * Valeur à neuf moins l’usure ; null si non calculable ou masquée
   * @type {number}
   * @memberof InventoryCreatedDto
   */
  currentValue?: number | null;
  /**
   * Gestionnaire seulement : valeur à neuf ou année d’achat manquante
   * @type {boolean}
   * @memberof InventoryCreatedDto
   */
  valueToComplete: boolean;
  /**
   *
   * @type {Array<StorageFileDto>}
   * @memberof InventoryCreatedDto
   */
  photos: Array<StorageFileDto>;
  /**
   *
   * @type {Array<InventoryInvoiceDto>}
   * @memberof InventoryCreatedDto
   */
  invoices: Array<InventoryInvoiceDto>;
  /**
   *
   * @type {InventoryExitReason}
   * @memberof InventoryCreatedDto
   */
  exitReason?: InventoryExitReason | null;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  exitDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  exitNote?: string | null;
  /**
   *
   * @type {InventoryPersonDto}
   * @memberof InventoryCreatedDto
   */
  createdBy: InventoryPersonDto;
  /**
   *
   * @type {Dayjs}
   * @memberof InventoryCreatedDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {boolean}
   * @memberof InventoryCreatedDto
   */
  canEdit: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InventoryCreatedDto
   */
  canDelete: boolean;
  /**
   * Action créée, le cas échéant
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  createdTaskId?: string | null;
  /**
   * Souvenir créé, le cas échéant : le récit s’y dépose ensuite
   * @type {string}
   * @memberof InventoryCreatedDto
   */
  createdMemoryId?: string | null;
  /**
   * Ce qui n’a pas pu être fait après l’enregistrement (TASK, MEMORY, LINK)
   * @type {Array<string>}
   * @memberof InventoryCreatedDto
   */
  warnings: Array<string>;
}

/**
 *
 * @export
 * @interface InventoryDraftDto
 */
export interface InventoryDraftDto {
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  transcript?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  brandAndModel?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  condition?: string | null;
  /**
   *
   * @type {number}
   * @memberof InventoryDraftDto
   */
  quantity: number;
  /**
   *
   * @type {number}
   * @memberof InventoryDraftDto
   */
  purchaseYear?: number | null;
  /**
   * Gestionnaires seulement
   * @type {number}
   * @memberof InventoryDraftDto
   */
  purchasePrice?: number | null;
  /**
   * Dite à la voix ; gestionnaires seulement
   * @type {number}
   * @memberof InventoryDraftDto
   */
  replacementValue?: number | null;
  /**
   * Prix neuf trouvé sur internet quand la valeur n’est pas connue ; gestionnaires seulement
   * @type {number}
   * @memberof InventoryDraftDto
   */
  suggestedReplacementValue?: number | null;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  suggestedReplacementValueLabel?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  suggestedReplacementValueUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  roomId?: string | null;
  /**
   * Pièce dite mais absente de la maison
   * @type {string}
   * @memberof InventoryDraftDto
   */
  unknownRoomName?: string | null;
  /**
   *
   * @type {InventoryDraftFieldSourcesDto}
   * @memberof InventoryDraftDto
   */
  sources: InventoryDraftFieldSourcesDto;
  /**
   * Action proposée (« Faire resserrer le pied »)
   * @type {string}
   * @memberof InventoryDraftDto
   */
  suggestedTaskTitle?: string | null;
  /**
   * Titre de souvenir proposé si la personne a raconté une histoire
   * @type {string}
   * @memberof InventoryDraftDto
   */
  suggestedMemoryTitle?: string | null;
  /**
   * Date du souvenir entendue dans le récit (« offert en 1950 »), sinon null
   * @type {string}
   * @memberof InventoryDraftDto
   */
  suggestedMemoryTakenAt?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftDto
   */
  suggestedMemoryTakenAtPrecision: InventoryDraftDtoSuggestedMemoryTakenAtPrecisionEnum;
  /**
   * « Vers 1950 » : la famille n’est pas sûre de la date
   * @type {boolean}
   * @memberof InventoryDraftDto
   */
  suggestedMemoryTakenAtApproximate: boolean;
  /**
   *
   * @type {Array<InventoryDraftSuggestionDto>}
   * @memberof InventoryDraftDto
   */
  suggestedLinks: Array<InventoryDraftSuggestionDto>;
  /**
   * Faux si Lucien n’a pas pu préparer la fiche : à remplir à la main
   * @type {boolean}
   * @memberof InventoryDraftDto
   */
  drafted: boolean;
}

export const InventoryDraftDtoSuggestedMemoryTakenAtPrecisionEnum = {
  Day: 'DAY',
  Month: 'MONTH',
  Season: 'SEASON',
  Year: 'YEAR',
  Decade: 'DECADE',
} as const;

export type InventoryDraftDtoSuggestedMemoryTakenAtPrecisionEnum =
  (typeof InventoryDraftDtoSuggestedMemoryTakenAtPrecisionEnum)[keyof typeof InventoryDraftDtoSuggestedMemoryTakenAtPrecisionEnum];

/**
 *
 * @export
 * @interface InventoryDraftFieldSourcesDto
 */
export interface InventoryDraftFieldSourcesDto {
  /**
   * PHOTO | LABEL | VOICE | INVOICE | WEB
   * @type {string}
   * @memberof InventoryDraftFieldSourcesDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftFieldSourcesDto
   */
  brandAndModel?: string;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftFieldSourcesDto
   */
  purchase?: string;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftFieldSourcesDto
   */
  condition?: string;
}
/**
 *
 * @export
 * @interface InventoryDraftSuggestionDto
 */
export interface InventoryDraftSuggestionDto {
  /**
   *
   * @type {LinkableEntityType}
   * @memberof InventoryDraftSuggestionDto
   */
  type: LinkableEntityType;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftSuggestionDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InventoryDraftSuggestionDto
   */
  title: string;
  /**
   * Pourquoi Lucien le propose (mots retrouvés…)
   * @type {string}
   * @memberof InventoryDraftSuggestionDto
   */
  reason?: string;
  /**
   * Coché d’office (facture très proche)
   * @type {boolean}
   * @memberof InventoryDraftSuggestionDto
   */
  preselected: boolean;
}

/**
 *
 * @export
 * @enum {string}
 */

export const InventoryExitReason = {
  Broken: 'BROKEN',
  Given: 'GIVEN',
  Sold: 'SOLD',
  ThrownAway: 'THROWN_AWAY',
  LostOrStolen: 'LOST_OR_STOLEN',
  Other: 'OTHER',
} as const;

export type InventoryExitReason = (typeof InventoryExitReason)[keyof typeof InventoryExitReason];

/**
 *
 * @export
 * @interface InventoryInvoiceDto
 */
export interface InventoryInvoiceDto {
  /**
   * Document (VirtualFile)
   * @type {string}
   * @memberof InventoryInvoiceDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InventoryInvoiceDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof InventoryInvoiceDto
   */
  mimeType: string;
  /**
   * Lien signé (1 h) pour ouvrir le document
   * @type {string}
   * @memberof InventoryInvoiceDto
   */
  url?: string;
}
/**
 *
 * @export
 * @interface InventoryItemDto
 */
export interface InventoryItemDto {
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  name: string;
  /**
   *
   * @type {InventoryRoomDto}
   * @memberof InventoryItemDto
   */
  room?: InventoryRoomDto | null;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  brandAndModel?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  condition?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  notes?: string | null;
  /**
   *
   * @type {number}
   * @memberof InventoryItemDto
   */
  quantity: number;
  /**
   *
   * @type {number}
   * @memberof InventoryItemDto
   */
  purchaseYear?: number | null;
  /**
   * Vrai pour les gestionnaires et pour la personne qui a ajouté l’objet ; sinon montants masqués
   * @type {boolean}
   * @memberof InventoryItemDto
   */
  valuesVisible: boolean;
  /**
   *
   * @type {number}
   * @memberof InventoryItemDto
   */
  purchasePrice?: number | null;
  /**
   * Valeur à neuf du lot
   * @type {number}
   * @memberof InventoryItemDto
   */
  replacementValue?: number | null;
  /**
   *
   * @type {InventoryValueSource}
   * @memberof InventoryItemDto
   */
  replacementValueSource?: InventoryValueSource | null;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  replacementValueSourceLabel?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  replacementValueSourceUrl?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InventoryItemDto
   */
  depreciationEnabled: boolean;
  /**
   * Valeur à neuf moins l’usure ; null si non calculable ou masquée
   * @type {number}
   * @memberof InventoryItemDto
   */
  currentValue?: number | null;
  /**
   * Gestionnaire seulement : valeur à neuf ou année d’achat manquante
   * @type {boolean}
   * @memberof InventoryItemDto
   */
  valueToComplete: boolean;
  /**
   *
   * @type {Array<StorageFileDto>}
   * @memberof InventoryItemDto
   */
  photos: Array<StorageFileDto>;
  /**
   *
   * @type {Array<InventoryInvoiceDto>}
   * @memberof InventoryItemDto
   */
  invoices: Array<InventoryInvoiceDto>;
  /**
   *
   * @type {InventoryExitReason}
   * @memberof InventoryItemDto
   */
  exitReason?: InventoryExitReason | null;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  exitDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof InventoryItemDto
   */
  exitNote?: string | null;
  /**
   *
   * @type {InventoryPersonDto}
   * @memberof InventoryItemDto
   */
  createdBy: InventoryPersonDto;
  /**
   *
   * @type {Dayjs}
   * @memberof InventoryItemDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {boolean}
   * @memberof InventoryItemDto
   */
  canEdit: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InventoryItemDto
   */
  canDelete: boolean;
}

/**
 *
 * @export
 * @interface InventoryLinkInputDto
 */
export interface InventoryLinkInputDto {
  /**
   *
   * @type {LinkableEntityType}
   * @memberof InventoryLinkInputDto
   */
  type: LinkableEntityType;
  /**
   *
   * @type {string}
   * @memberof InventoryLinkInputDto
   */
  id: string;
}

/**
 *
 * @export
 * @interface InventoryMemoryInputDto
 */
export interface InventoryMemoryInputDto {
  /**
   *
   * @type {string}
   * @memberof InventoryMemoryInputDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof InventoryMemoryInputDto
   */
  description?: string;
  /**
   * Date racontée (« offert en 1950 ») ; absente : date des photos ou du jour
   * @type {string}
   * @memberof InventoryMemoryInputDto
   */
  takenAt?: string;
  /**
   *
   * @type {string}
   * @memberof InventoryMemoryInputDto
   */
  takenAtPrecision?: InventoryMemoryInputDtoTakenAtPrecisionEnum;
  /**
   *
   * @type {boolean}
   * @memberof InventoryMemoryInputDto
   */
  takenAtApproximate?: boolean;
}

export const InventoryMemoryInputDtoTakenAtPrecisionEnum = {
  Day: 'DAY',
  Month: 'MONTH',
  Season: 'SEASON',
  Year: 'YEAR',
  Decade: 'DECADE',
} as const;

export type InventoryMemoryInputDtoTakenAtPrecisionEnum =
  (typeof InventoryMemoryInputDtoTakenAtPrecisionEnum)[keyof typeof InventoryMemoryInputDtoTakenAtPrecisionEnum];

/**
 *
 * @export
 * @interface InventoryOverviewDto
 */
export interface InventoryOverviewDto {
  /**
   * Objets présents (hors sortis)
   * @type {Array<InventoryItemDto>}
   * @memberof InventoryOverviewDto
   */
  items: Array<InventoryItemDto>;
  /**
   *
   * @type {number}
   * @memberof InventoryOverviewDto
   */
  exitedCount: number;
  /**
   * Gestionnaire : voit toutes les valeurs, les totaux et l’export
   * @type {boolean}
   * @memberof InventoryOverviewDto
   */
  valuesVisible: boolean;
  /**
   * Gestionnaires seulement
   * @type {number}
   * @memberof InventoryOverviewDto
   */
  totalReplacementValue?: number | null;
  /**
   * Gestionnaires seulement
   * @type {number}
   * @memberof InventoryOverviewDto
   */
  totalCurrentValue?: number | null;
  /**
   * Gestionnaires seulement : objets dont la valeur est à compléter
   * @type {number}
   * @memberof InventoryOverviewDto
   */
  valueToCompleteCount: number;
  /**
   *
   * @type {InventorySettingsDto}
   * @memberof InventoryOverviewDto
   */
  settings: InventorySettingsDto;
}
/**
 *
 * @export
 * @interface InventoryPdfDto
 */
export interface InventoryPdfDto {
  /**
   * Lien signé (1 h) vers le PDF
   * @type {string}
   * @memberof InventoryPdfDto
   */
  url: string;
  /**
   * Objets sans valeur, signalés sans bloquer
   * @type {number}
   * @memberof InventoryPdfDto
   */
  valueToCompleteCount: number;
  /**
   * Action de rappel annuelle
   * @type {string}
   * @memberof InventoryPdfDto
   */
  reminderTaskId?: string | null;
}
/**
 *
 * @export
 * @interface InventoryPersonDto
 */
export interface InventoryPersonDto {
  /**
   *
   * @type {string}
   * @memberof InventoryPersonDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InventoryPersonDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface InventoryRoomDto
 */
export interface InventoryRoomDto {
  /**
   *
   * @type {string}
   * @memberof InventoryRoomDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InventoryRoomDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface InventorySettingsDto
 */
export interface InventorySettingsDto {
  /**
   *
   * @type {number}
   * @memberof InventorySettingsDto
   */
  depreciationRatePercent: number;
  /**
   *
   * @type {number}
   * @memberof InventorySettingsDto
   */
  depreciationMaxPercent: number;
  /**
   *
   * @type {Dayjs}
   * @memberof InventorySettingsDto
   */
  lastExportedAt?: Dayjs | null;
}
/**
 *
 * @export
 * @interface InventoryTaskInputDto
 */
export interface InventoryTaskInputDto {
  /**
   *
   * @type {string}
   * @memberof InventoryTaskInputDto
   */
  title: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const InventoryValueSource = {
  Manual: 'MANUAL',
  Lucien: 'LUCIEN',
} as const;

export type InventoryValueSource = (typeof InventoryValueSource)[keyof typeof InventoryValueSource];

/**
 *
 * @export
 * @interface InvitationDto
 */
export interface InvitationDto {
  /**
   *
   * @type {string}
   * @memberof InvitationDto
   */
  token: string;
  /**
   *
   * @type {AssetDto}
   * @memberof InvitationDto
   */
  asset: AssetDto;
  /**
   *
   * @type {UserWithPrivateInfoDto}
   * @memberof InvitationDto
   */
  invitedBy: UserWithPrivateInfoDto;
  /**
   *
   * @type {string}
   * @memberof InvitationDto
   */
  role?: InvitationDtoRoleEnum;
}

export const InvitationDtoRoleEnum = {
  Viewer: 'viewer',
  Contributor: 'contributor',
  Manager: 'manager',
} as const;

export type InvitationDtoRoleEnum =
  (typeof InvitationDtoRoleEnum)[keyof typeof InvitationDtoRoleEnum];

/**
 *
 * @export
 * @interface InviteCodeDto
 */
export interface InviteCodeDto {
  /**
   *
   * @type {string}
   * @memberof InviteCodeDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof InviteCodeDto
   */
  code: string;
  /**
   *
   * @type {AssetDto}
   * @memberof InviteCodeDto
   */
  asset: AssetDto;
  /**
   *
   * @type {Dayjs}
   * @memberof InviteCodeDto
   */
  createdAt: Dayjs;
}
/**
 *
 * @export
 * @interface InviteCodeValidationDto
 */
export interface InviteCodeValidationDto {
  /**
   *
   * @type {string}
   * @memberof InviteCodeValidationDto
   */
  code: string;
  /**
   *
   * @type {AssetDto}
   * @memberof InviteCodeValidationDto
   */
  asset: AssetDto;
  /**
   *
   * @type {string}
   * @memberof InviteCodeValidationDto
   */
  createdByFirstName: string;
  /**
   *
   * @type {string}
   * @memberof InviteCodeValidationDto
   */
  createdByLastName: string;
}
/**
 *
 * @export
 * @interface KnownBalanceDto
 */
export interface KnownBalanceDto {
  /**
   *
   * @type {number}
   * @memberof KnownBalanceDto
   */
  amount: number;
  /**
   *
   * @type {Dayjs}
   * @memberof KnownBalanceDto
   */
  date: Dayjs;
  /**
   *
   * @type {PartyDto}
   * @memberof KnownBalanceDto
   */
  enteredBy: PartyDto | null;
}
/**
 *
 * @export
 * @interface LikeDto
 */
export interface LikeDto {
  /**
   *
   * @type {string}
   * @memberof LikeDto
   */
  id: string;
  /**
   *
   * @type {UserDto}
   * @memberof LikeDto
   */
  from: UserDto;
  /**
   *
   * @type {Dayjs}
   * @memberof LikeDto
   */
  createdAt: Dayjs;
}
/**
 *
 * @export
 * @interface LikesSummaryDto
 */
export interface LikesSummaryDto {
  /**
   *
   * @type {number}
   * @memberof LikesSummaryDto
   */
  count: number;
  /**
   * The five first likes.
   * @type {Array<LikeDto>}
   * @memberof LikesSummaryDto
   */
  firstFive: Array<LikeDto>;
  /**
   * Wether you liked this.
   * @type {boolean}
   * @memberof LikesSummaryDto
   */
  didILike: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const LinkableEntityType = {
  Task: 'task',
  Project: 'project',
  Contact: 'contact',
  VirtualFile: 'virtualFile',
  Expense: 'expense',
  CommunityFeedItem: 'communityFeedItem',
  Room: 'room',
  Event: 'event',
  InventoryItem: 'inventoryItem',
} as const;

export type LinkableEntityType = (typeof LinkableEntityType)[keyof typeof LinkableEntityType];

/**
 *
 * @export
 * @interface LinkedEntityDto
 */
export interface LinkedEntityDto {
  /**
   * Present only for GENERIC links (deletable via the API)
   * @type {string}
   * @memberof LinkedEntityDto
   */
  linkId?: string;
  /**
   *
   * @type {string}
   * @memberof LinkedEntityDto
   */
  entityType: LinkedEntityDtoEntityTypeEnum;
  /**
   *
   * @type {string}
   * @memberof LinkedEntityDto
   */
  entityId: string;
  /**
   *
   * @type {string}
   * @memberof LinkedEntityDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof LinkedEntityDto
   */
  subtitle?: string;
  /**
   *
   * @type {string}
   * @memberof LinkedEntityDto
   */
  linkOrigin: LinkedEntityDtoLinkOriginEnum;
  /**
   * For BUSINESS links, which relation produced it (e.g. \'paidByContact\')
   * @type {string}
   * @memberof LinkedEntityDto
   */
  businessRelationKind?: string;
  /**
   * Type-specific display attributes (e.g. status/dueDate for a task, amount/currency for an expense)
   * @type {object}
   * @memberof LinkedEntityDto
   */
  metadata?: object;
  /**
   * True if this entry is part of a business-relation batch that hit the 100-item cap — there may be more, not all were returned
   * @type {boolean}
   * @memberof LinkedEntityDto
   */
  truncated?: boolean;
}

export const LinkedEntityDtoEntityTypeEnum = {
  Task: 'task',
  Project: 'project',
  Contact: 'contact',
  VirtualFile: 'virtualFile',
  Expense: 'expense',
  CommunityFeedItem: 'communityFeedItem',
  Room: 'room',
  Event: 'event',
  InventoryItem: 'inventoryItem',
} as const;

export type LinkedEntityDtoEntityTypeEnum =
  (typeof LinkedEntityDtoEntityTypeEnum)[keyof typeof LinkedEntityDtoEntityTypeEnum];
export const LinkedEntityDtoLinkOriginEnum = {
  Generic: 'GENERIC',
  Business: 'BUSINESS',
} as const;

export type LinkedEntityDtoLinkOriginEnum =
  (typeof LinkedEntityDtoLinkOriginEnum)[keyof typeof LinkedEntityDtoLinkOriginEnum];

/**
 *
 * @export
 * @interface MainInterlocutorDto
 */
export interface MainInterlocutorDto {
  /**
   *
   * @type {string}
   * @memberof MainInterlocutorDto
   */
  displayName: string;
  /**
   *
   * @type {CompanyContactRole}
   * @memberof MainInterlocutorDto
   */
  companyRole: CompanyContactRole;
  /**
   *
   * @type {string}
   * @memberof MainInterlocutorDto
   */
  companyRoleLabel?: string;
}

/**
 *
 * @export
 * @interface ManagerDashboardCategoryDto
 */
export interface ManagerDashboardCategoryDto {
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardCategoryDto
   */
  mainCategory: string;
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardCategoryDto
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardCategoryDto
   */
  actualAmount: number;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardCategoryDto
   */
  forecastAmount: number;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardCategoryDto
   */
  percentage: number;
  /**
   *
   * @type {boolean}
   * @memberof ManagerDashboardCategoryDto
   */
  hasForecasts: boolean;
}
/**
 *
 * @export
 * @interface ManagerDashboardDto
 */
export interface ManagerDashboardDto {
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardDto
   */
  assetName: string;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardDto
   */
  yearlyExpenseTotal: number;
  /**
   *
   * @type {boolean}
   * @memberof ManagerDashboardDto
   */
  hasForecasts: boolean;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardDto
   */
  totalForecastAmount?: number | null;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardDto
   */
  remainingBudget?: number | null;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardDto
   */
  projectedOverrun?: number | null;
  /**
   *
   * @type {Array<ManagerDashboardCategoryDto>}
   * @memberof ManagerDashboardDto
   */
  categoryBreakdown: Array<ManagerDashboardCategoryDto>;
  /**
   *
   * @type {Array<ManagerDashboardMemberDto>}
   * @memberof ManagerDashboardDto
   */
  memberStatuses: Array<ManagerDashboardMemberDto>;
}
/**
 *
 * @export
 * @interface ManagerDashboardMemberDto
 */
export interface ManagerDashboardMemberDto {
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardMemberDto
   */
  userId: string;
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardMemberDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardMemberDto
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardMemberDto
   */
  profilePictureUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof ManagerDashboardMemberDto
   */
  status: ManagerDashboardMemberDtoStatusEnum;
  /**
   *
   * @type {number}
   * @memberof ManagerDashboardMemberDto
   */
  amountDue: number;
}

export const ManagerDashboardMemberDtoStatusEnum = {
  AJour: 'A_JOUR',
  EnRetard: 'EN_RETARD',
} as const;

export type ManagerDashboardMemberDtoStatusEnum =
  (typeof ManagerDashboardMemberDtoStatusEnum)[keyof typeof ManagerDashboardMemberDtoStatusEnum];

/**
 *
 * @export
 * @interface MarkExpensesReimbursedDto
 */
export interface MarkExpensesReimbursedDto {
  /**
   * The IDs of the expenses to mark as reimbursed.
   * @type {Array<string>}
   * @memberof MarkExpensesReimbursedDto
   */
  expenseIds: Array<string>;
  /**
   * Whether to also create the corresponding money transfers (debtor -> payer, aggregated by pair).
   * @type {boolean}
   * @memberof MarkExpensesReimbursedDto
   */
  createTransfers: boolean;
}
/**
 *
 * @export
 * @interface MemberDeletionBlockerDto
 */
export interface MemberDeletionBlockerDto {
  /**
   *
   * @type {string}
   * @memberof MemberDeletionBlockerDto
   */
  type: MemberDeletionBlockerDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof MemberDeletionBlockerDto
   */
  entityType: MemberDeletionBlockerDtoEntityTypeEnum;
  /**
   *
   * @type {string}
   * @memberof MemberDeletionBlockerDto
   */
  entityId: string;
  /**
   * Short human label for display (e.g. expense title + amount)
   * @type {string}
   * @memberof MemberDeletionBlockerDto
   */
  label: string;
  /**
   * Date associated with the entity, for sorting/display
   * @type {Dayjs}
   * @memberof MemberDeletionBlockerDto
   */
  date?: Dayjs;
}

export const MemberDeletionBlockerDtoTypeEnum = {
  Owner: 'OWNER',
  ExpenseShare: 'EXPENSE_SHARE',
  ExpensePaid: 'EXPENSE_PAID',
  ExpenseSettlement: 'EXPENSE_SETTLEMENT',
  MoneyTransfer: 'MONEY_TRANSFER',
} as const;

export type MemberDeletionBlockerDtoTypeEnum =
  (typeof MemberDeletionBlockerDtoTypeEnum)[keyof typeof MemberDeletionBlockerDtoTypeEnum];
export const MemberDeletionBlockerDtoEntityTypeEnum = {
  Asset: 'ASSET',
  Expense: 'EXPENSE',
  MoneyTransfer: 'MONEY_TRANSFER',
} as const;

export type MemberDeletionBlockerDtoEntityTypeEnum =
  (typeof MemberDeletionBlockerDtoEntityTypeEnum)[keyof typeof MemberDeletionBlockerDtoEntityTypeEnum];

/**
 *
 * @export
 * @interface MemberDeletionCheckDto
 */
export interface MemberDeletionCheckDto {
  /**
   *
   * @type {boolean}
   * @memberof MemberDeletionCheckDto
   */
  canDelete: boolean;
  /**
   *
   * @type {Array<MemberDeletionBlockerDto>}
   * @memberof MemberDeletionCheckDto
   */
  blockers: Array<MemberDeletionBlockerDto>;
}
/**
 *
 * @export
 * @interface MemberForecastSummaryDto
 */
export interface MemberForecastSummaryDto {
  /**
   *
   * @type {number}
   * @memberof MemberForecastSummaryDto
   */
  year: number;
  /**
   * Effective annual budget cap for the asset (null if none configured)
   * @type {number}
   * @memberof MemberForecastSummaryDto
   */
  annualBudget?: number | null;
  /**
   * This member\'s share of the annual budget
   * @type {number}
   * @memberof MemberForecastSummaryDto
   */
  userShare: number;
  /**
   * Sum this member has personally paid this year (real expenses)
   * @type {number}
   * @memberof MemberForecastSummaryDto
   */
  alreadyContributed: number;
  /**
   * userShare - alreadyContributed; can be negative if the member over-contributed
   * @type {number}
   * @memberof MemberForecastSummaryDto
   */
  remainingToProvision: number;
}
/**
 *
 * @export
 * @interface MemberPhotoAlbumDto
 */
export interface MemberPhotoAlbumDto {
  /**
   *
   * @type {Array<AlbumPhotoDto>}
   * @memberof MemberPhotoAlbumDto
   */
  photos: Array<AlbumPhotoDto>;
  /**
   *
   * @type {number}
   * @memberof MemberPhotoAlbumDto
   */
  total: number;
  /**
   *
   * @type {string}
   * @memberof MemberPhotoAlbumDto
   */
  nextCursor?: string;
}
/**
 *
 * @export
 * @interface MemberPositionDto
 */
export interface MemberPositionDto {
  /**
   *
   * @type {PartyDto}
   * @memberof MemberPositionDto
   */
  party: PartyDto;
  /**
   * Towards the house accounts; null when the asset has no account.
   * @type {CircuitDto}
   * @memberof MemberPositionDto
   */
  towardsHouse: CircuitDto | null;
  /**
   *
   * @type {BetweenMembersDto}
   * @memberof MemberPositionDto
   */
  betweenMembers: BetweenMembersDto;
  /**
   * Towards contacts (outside payers); null when there is none.
   * @type {CircuitDto}
   * @memberof MemberPositionDto
   */
  withContacts: CircuitDto | null;
  /**
   * Opening position at the closing date (card I); 0 without one.
   * @type {number}
   * @memberof MemberPositionDto
   */
  initialBalance: number;
  /**
   * owed − owes over every circuit + initialBalance.
   * @type {number}
   * @memberof MemberPositionDto
   */
  position: number;
}
/**
 *
 * @export
 * @interface MemberReminderChannelsDto
 */
export interface MemberReminderChannelsDto {
  /**
   *
   * @type {boolean}
   * @memberof MemberReminderChannelsDto
   */
  email: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MemberReminderChannelsDto
   */
  push: boolean;
}
/**
 *
 * @export
 * @interface MemberReminderDto
 */
export interface MemberReminderDto {
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  targetMemberId: string;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  targetFirstName?: string;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  targetLastName?: string;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  triggeredByFirstName: string;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  triggeredByLastName: string;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  tone: MemberReminderDtoToneEnum;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof MemberReminderDto
   */
  amountAtTime: number;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  schedule: MemberReminderDtoScheduleEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof MemberReminderDto
   */
  scheduledAt?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  recurrence?: MemberReminderDtoRecurrenceEnum;
  /**
   *
   * @type {object}
   * @memberof MemberReminderDto
   */
  channels: object;
  /**
   *
   * @type {string}
   * @memberof MemberReminderDto
   */
  status: MemberReminderDtoStatusEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof MemberReminderDto
   */
  sentAt?: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof MemberReminderDto
   */
  readAt?: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof MemberReminderDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof MemberReminderDto
   */
  updatedAt: Dayjs;
}

export const MemberReminderDtoToneEnum = {
  Amical: 'AMICAL',
  Neutre: 'NEUTRE',
  Ferme: 'FERME',
} as const;

export type MemberReminderDtoToneEnum =
  (typeof MemberReminderDtoToneEnum)[keyof typeof MemberReminderDtoToneEnum];
export const MemberReminderDtoScheduleEnum = {
  Immediate: 'IMMEDIATE',
  Scheduled: 'SCHEDULED',
  Recurring: 'RECURRING',
} as const;

export type MemberReminderDtoScheduleEnum =
  (typeof MemberReminderDtoScheduleEnum)[keyof typeof MemberReminderDtoScheduleEnum];
export const MemberReminderDtoRecurrenceEnum = {
  Monthly: 'MONTHLY',
  Quarterly: 'QUARTERLY',
} as const;

export type MemberReminderDtoRecurrenceEnum =
  (typeof MemberReminderDtoRecurrenceEnum)[keyof typeof MemberReminderDtoRecurrenceEnum];
export const MemberReminderDtoStatusEnum = {
  Draft: 'DRAFT',
  Scheduled: 'SCHEDULED',
  Sent: 'SENT',
  Read: 'READ',
  Cancelled: 'CANCELLED',
  Failed: 'FAILED',
} as const;

export type MemberReminderDtoStatusEnum =
  (typeof MemberReminderDtoStatusEnum)[keyof typeof MemberReminderDtoStatusEnum];

/**
 *
 * @export
 * @interface MemberStatementDetailsDto
 */
export interface MemberStatementDetailsDto {
  /**
   *
   * @type {Dayjs}
   * @memberof MemberStatementDetailsDto
   */
  asOf: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof MemberStatementDetailsDto
   */
  periodStart: Dayjs | null;
  /**
   *
   * @type {MemberPositionDto}
   * @memberof MemberStatementDetailsDto
   */
  member: MemberPositionDto;
  /**
   * Every open item of the member, grouped by counterparty.
   * @type {Array<DebtItemDto>}
   * @memberof MemberStatementDetailsDto
   */
  items: Array<DebtItemDto>;
}
/**
 *
 * @export
 * @interface MemoryAuthorDto
 */
export interface MemoryAuthorDto {
  /**
   *
   * @type {string}
   * @memberof MemoryAuthorDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MemoryAuthorDto
   */
  displayName: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const MemoryDatePrecision = {
  Day: 'DAY',
  Month: 'MONTH',
  Season: 'SEASON',
  Year: 'YEAR',
  Decade: 'DECADE',
} as const;

export type MemoryDatePrecision = (typeof MemoryDatePrecision)[keyof typeof MemoryDatePrecision];

/**
 *
 * @export
 * @interface MemoryDraftDto
 */
export interface MemoryDraftDto {
  /**
   *
   * @type {string}
   * @memberof MemoryDraftDto
   */
  transcript: string;
  /**
   *
   * @type {string}
   * @memberof MemoryDraftDto
   */
  title: string;
  /**
   *
   * @type {MemoryKind}
   * @memberof MemoryDraftDto
   */
  memoryKind?: MemoryKind | null;
  /**
   *
   * @type {string}
   * @memberof MemoryDraftDto
   */
  takenAt?: string | null;
  /**
   *
   * @type {MemoryDatePrecision}
   * @memberof MemoryDraftDto
   */
  takenAtPrecision: MemoryDatePrecision;
  /**
   *
   * @type {boolean}
   * @memberof MemoryDraftDto
   */
  takenAtApproximate: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof MemoryDraftDto
   */
  roomIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof MemoryDraftDto
   */
  memberIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof MemoryDraftDto
   */
  freeNames: Array<string>;
  /**
   *
   * @type {string}
   * @memberof MemoryDraftDto
   */
  description: string;
}

/**
 *
 * @export
 * @interface MemoryDto
 */
export interface MemoryDto {
  /**
   *
   * @type {string}
   * @memberof MemoryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MemoryDto
   */
  title: string;
  /**
   *
   * @type {MemoryKind}
   * @memberof MemoryDto
   */
  memoryKind?: MemoryKind | null;
  /**
   *
   * @type {string}
   * @memberof MemoryDto
   */
  takenAt?: string | null;
  /**
   *
   * @type {MemoryDatePrecision}
   * @memberof MemoryDto
   */
  takenAtPrecision: MemoryDatePrecision;
  /**
   *
   * @type {boolean}
   * @memberof MemoryDto
   */
  takenAtApproximate: boolean;
  /**
   *
   * @type {StorageFileDto}
   * @memberof MemoryDto
   */
  cover?: StorageFileDto | null;
  /**
   *
   * @type {number}
   * @memberof MemoryDto
   */
  photoCount: number;
  /**
   *
   * @type {number}
   * @memberof MemoryDto
   */
  recordingCount: number;
  /**
   *
   * @type {number}
   * @memberof MemoryDto
   */
  voiceSeconds: number;
  /**
   *
   * @type {Array<MemoryRoomDto>}
   * @memberof MemoryDto
   */
  rooms: Array<MemoryRoomDto>;
  /**
   *
   * @type {Array<MemoryStorytellerDto>}
   * @memberof MemoryDto
   */
  storytellers: Array<MemoryStorytellerDto>;
  /**
   *
   * @type {Array<MemoryPersonDto>}
   * @memberof MemoryDto
   */
  people: Array<MemoryPersonDto>;
  /**
   *
   * @type {string}
   * @memberof MemoryDto
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof MemoryDto
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof MemoryDto
   */
  place?: string | null;
  /**
   *
   * @type {Array<StorageFileDto>}
   * @memberof MemoryDto
   */
  files: Array<StorageFileDto>;
  /**
   *
   * @type {Array<MemoryRecordingDto>}
   * @memberof MemoryDto
   */
  recordings: Array<MemoryRecordingDto>;
  /**
   *
   * @type {MemoryAuthorDto}
   * @memberof MemoryDto
   */
  author: MemoryAuthorDto;
  /**
   *
   * @type {boolean}
   * @memberof MemoryDto
   */
  canEdit: boolean;
}

/**
 *
 * @export
 * @enum {string}
 */

export const MemoryKind = {
  Family: 'FAMILY',
  Celebration: 'CELEBRATION',
  House: 'HOUSE',
  Works: 'WORKS',
  InMemory: 'IN_MEMORY',
} as const;

export type MemoryKind = (typeof MemoryKind)[keyof typeof MemoryKind];

/**
 *
 * @export
 * @interface MemoryPersonDto
 */
export interface MemoryPersonDto {
  /**
   *
   * @type {string}
   * @memberof MemoryPersonDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MemoryPersonDto
   */
  memberId?: string | null;
  /**
   *
   * @type {string}
   * @memberof MemoryPersonDto
   */
  displayName: string;
}
/**
 *
 * @export
 * @interface MemoryPersonInputDto
 */
export interface MemoryPersonInputDto {
  /**
   * A member of the asset
   * @type {string}
   * @memberof MemoryPersonInputDto
   */
  memberId?: string;
  /**
   * Free first name when not a member (\"Mamie Odette\")
   * @type {string}
   * @memberof MemoryPersonInputDto
   */
  freeName?: string;
}
/**
 *
 * @export
 * @interface MemoryRecordingDto
 */
export interface MemoryRecordingDto {
  /**
   *
   * @type {string}
   * @memberof MemoryRecordingDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MemoryRecordingDto
   */
  audioUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof MemoryRecordingDto
   */
  audioMimeType?: string | null;
  /**
   *
   * @type {number}
   * @memberof MemoryRecordingDto
   */
  durationSeconds: number;
  /**
   *
   * @type {string}
   * @memberof MemoryRecordingDto
   */
  speakerDisplayName: string;
  /**
   *
   * @type {string}
   * @memberof MemoryRecordingDto
   */
  speakerId?: string | null;
  /**
   *
   * @type {string}
   * @memberof MemoryRecordingDto
   */
  recordedAt: string;
  /**
   *
   * @type {string}
   * @memberof MemoryRecordingDto
   */
  transcript?: string | null;
  /**
   *
   * @type {MemoryTranscriptStatus}
   * @memberof MemoryRecordingDto
   */
  transcriptStatus: MemoryTranscriptStatus;
  /**
   *
   * @type {boolean}
   * @memberof MemoryRecordingDto
   */
  withdrawn: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MemoryRecordingDto
   */
  canDelete: boolean;
}

/**
 *
 * @export
 * @interface MemoryRoomDto
 */
export interface MemoryRoomDto {
  /**
   *
   * @type {string}
   * @memberof MemoryRoomDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MemoryRoomDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface MemoryStatsDto
 */
export interface MemoryStatsDto {
  /**
   *
   * @type {number}
   * @memberof MemoryStatsDto
   */
  firstYear?: number | null;
  /**
   *
   * @type {number}
   * @memberof MemoryStatsDto
   */
  memoryCount: number;
  /**
   *
   * @type {number}
   * @memberof MemoryStatsDto
   */
  photoCount: number;
  /**
   *
   * @type {number}
   * @memberof MemoryStatsDto
   */
  voiceSeconds: number;
  /**
   *
   * @type {number}
   * @memberof MemoryStatsDto
   */
  storytellerCount: number;
}
/**
 *
 * @export
 * @interface MemoryStorytellerDto
 */
export interface MemoryStorytellerDto {
  /**
   *
   * @type {string}
   * @memberof MemoryStorytellerDto
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof MemoryStorytellerDto
   */
  initials: string;
}
/**
 *
 * @export
 * @interface MemoryTimelineDto
 */
export interface MemoryTimelineDto {
  /**
   *
   * @type {MemoryStatsDto}
   * @memberof MemoryTimelineDto
   */
  stats: MemoryStatsDto;
  /**
   *
   * @type {Array<MemoryTimelineItemDto>}
   * @memberof MemoryTimelineDto
   */
  items: Array<MemoryTimelineItemDto>;
}
/**
 *
 * @export
 * @interface MemoryTimelineItemDto
 */
export interface MemoryTimelineItemDto {
  /**
   *
   * @type {string}
   * @memberof MemoryTimelineItemDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MemoryTimelineItemDto
   */
  title: string;
  /**
   *
   * @type {MemoryKind}
   * @memberof MemoryTimelineItemDto
   */
  memoryKind?: MemoryKind | null;
  /**
   *
   * @type {string}
   * @memberof MemoryTimelineItemDto
   */
  takenAt?: string | null;
  /**
   *
   * @type {MemoryDatePrecision}
   * @memberof MemoryTimelineItemDto
   */
  takenAtPrecision: MemoryDatePrecision;
  /**
   *
   * @type {boolean}
   * @memberof MemoryTimelineItemDto
   */
  takenAtApproximate: boolean;
  /**
   *
   * @type {StorageFileDto}
   * @memberof MemoryTimelineItemDto
   */
  cover?: StorageFileDto | null;
  /**
   *
   * @type {number}
   * @memberof MemoryTimelineItemDto
   */
  photoCount: number;
  /**
   *
   * @type {number}
   * @memberof MemoryTimelineItemDto
   */
  recordingCount: number;
  /**
   *
   * @type {number}
   * @memberof MemoryTimelineItemDto
   */
  voiceSeconds: number;
  /**
   *
   * @type {Array<MemoryRoomDto>}
   * @memberof MemoryTimelineItemDto
   */
  rooms: Array<MemoryRoomDto>;
  /**
   *
   * @type {Array<MemoryStorytellerDto>}
   * @memberof MemoryTimelineItemDto
   */
  storytellers: Array<MemoryStorytellerDto>;
  /**
   *
   * @type {Array<MemoryPersonDto>}
   * @memberof MemoryTimelineItemDto
   */
  people: Array<MemoryPersonDto>;
  /**
   *
   * @type {string}
   * @memberof MemoryTimelineItemDto
   */
  createdAt: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const MemoryTranscriptStatus = {
  Pending: 'PENDING',
  Done: 'DONE',
  Failed: 'FAILED',
} as const;

export type MemoryTranscriptStatus =
  (typeof MemoryTranscriptStatus)[keyof typeof MemoryTranscriptStatus];

/**
 *
 * @export
 * @interface MessagingChannelDto
 */
export interface MessagingChannelDto {
  /**
   *
   * @type {string}
   * @memberof MessagingChannelDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MessagingChannelDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof MessagingChannelDto
   */
  identifier: string | null;
}
/**
 *
 * @export
 * @interface MoveItemDto
 */
export interface MoveItemDto {
  /**
   *
   * @type {string}
   * @memberof MoveItemDto
   */
  path: string;
}
/**
 *
 * @export
 * @interface MyTaskSummaryDto
 */
export interface MyTaskSummaryDto {
  /**
   *
   * @type {string}
   * @memberof MyTaskSummaryDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MyTaskSummaryDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof MyTaskSummaryDto
   */
  status: MyTaskSummaryDtoStatusEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof MyTaskSummaryDto
   */
  dueDate?: Dayjs | null;
  /**
   *
   * @type {string}
   * @memberof MyTaskSummaryDto
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof MyTaskSummaryDto
   */
  assetName: string;
}

export const MyTaskSummaryDtoStatusEnum = {
  Todo: 'TODO',
  InProgress: 'IN_PROGRESS',
  Done: 'DONE',
} as const;

export type MyTaskSummaryDtoStatusEnum =
  (typeof MyTaskSummaryDtoStatusEnum)[keyof typeof MyTaskSummaryDtoStatusEnum];

/**
 *
 * @export
 * @interface OnboardingStepDto
 */
export interface OnboardingStepDto {
  /**
   *
   * @type {string}
   * @memberof OnboardingStepDto
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof OnboardingStepDto
   */
  label: string;
  /**
   *
   * @type {boolean}
   * @memberof OnboardingStepDto
   */
  done: boolean;
  /**
   *
   * @type {string}
   * @memberof OnboardingStepDto
   */
  linkTo: string;
}
/**
 *
 * @export
 * @interface OwnershipSummaryDto
 */
export interface OwnershipSummaryDto {
  /**
   * Sum of full-ownership (PP) shares in % of asset total.
   * @type {number}
   * @memberof OwnershipSummaryDto
   */
  fullOwnershipPct: number;
  /**
   * Sum of bare-ownership (NP) shares in % of asset total.
   * @type {number}
   * @memberof OwnershipSummaryDto
   */
  bareOwnershipPct: number;
  /**
   * Sum of usufruct (US) shares in % of asset total. Never counted as capital.
   * @type {number}
   * @memberof OwnershipSummaryDto
   */
  usufructPct: number;
  /**
   * Consolidated capital share = fullOwnershipPct + bareOwnershipPct.
   * @type {number}
   * @memberof OwnershipSummaryDto
   */
  capitalSharePct: number;
  /**
   * Sum of PP+NP shares as absolute units when shareType != PERCENTAGE.
   * @type {number}
   * @memberof OwnershipSummaryDto
   */
  capitalShareTantiemes?: number;
}
/**
 *
 * @export
 * @interface PaginatedCommentsDto
 */
export interface PaginatedCommentsDto {
  /**
   * Use this cursor to paginate
   * @type {string}
   * @memberof PaginatedCommentsDto
   */
  endCursor: string | null;
  /**
   *
   * @type {Array<CommentDto>}
   * @memberof PaginatedCommentsDto
   */
  items: Array<CommentDto>;
}
/**
 *
 * @export
 * @interface PaginatedCommunityFeedItemDto
 */
export interface PaginatedCommunityFeedItemDto {
  /**
   * Use this cursor to paginate
   * @type {string}
   * @memberof PaginatedCommunityFeedItemDto
   */
  endCursor: string | null;
  /**
   *
   * @type {Array<CommunityFeedItemDto>}
   * @memberof PaginatedCommunityFeedItemDto
   */
  items: Array<CommunityFeedItemDto>;
}
/**
 *
 * @export
 * @interface PaginatedContactsDto
 */
export interface PaginatedContactsDto {
  /**
   * The total number of items
   * @type {number}
   * @memberof PaginatedContactsDto
   */
  total: number;
  /**
   * The total number of pages
   * @type {number}
   * @memberof PaginatedContactsDto
   */
  pageCount: number;
  /**
   * The current page
   * @type {number}
   * @memberof PaginatedContactsDto
   */
  currentPage: number;
  /**
   * Array of contacts
   * @type {Array<ContactPreviewDto>}
   * @memberof PaginatedContactsDto
   */
  items: Array<ContactPreviewDto>;
}
/**
 *
 * @export
 * @interface PaginatedExpensesDto
 */
export interface PaginatedExpensesDto {
  /**
   * The total number of items
   * @type {number}
   * @memberof PaginatedExpensesDto
   */
  total: number;
  /**
   * The total number of pages
   * @type {number}
   * @memberof PaginatedExpensesDto
   */
  pageCount: number;
  /**
   * The current page
   * @type {number}
   * @memberof PaginatedExpensesDto
   */
  currentPage: number;
  /**
   * Array of expenses
   * @type {Array<ExpensePreviewDto>}
   * @memberof PaginatedExpensesDto
   */
  items: Array<ExpensePreviewDto>;
}
/**
 *
 * @export
 * @interface PaginatedInstructionsDto
 */
export interface PaginatedInstructionsDto {
  /**
   * The total number of items
   * @type {number}
   * @memberof PaginatedInstructionsDto
   */
  total: number;
  /**
   * The total number of pages
   * @type {number}
   * @memberof PaginatedInstructionsDto
   */
  pageCount: number;
  /**
   * The current page
   * @type {number}
   * @memberof PaginatedInstructionsDto
   */
  currentPage: number;
  /**
   * Array of intructions
   * @type {Array<InstructionPreviewDto>}
   * @memberof PaginatedInstructionsDto
   */
  items: Array<InstructionPreviewDto>;
}
/**
 *
 * @export
 * @interface PaginatedLikesDto
 */
export interface PaginatedLikesDto {
  /**
   * Use this cursor to paginate
   * @type {string}
   * @memberof PaginatedLikesDto
   */
  endCursor: string | null;
  /**
   *
   * @type {Array<LikeDto>}
   * @memberof PaginatedLikesDto
   */
  items: Array<LikeDto>;
}
/**
 *
 * @export
 * @interface PaginatedPracticalInformationDto
 */
export interface PaginatedPracticalInformationDto {
  /**
   * The total number of items
   * @type {number}
   * @memberof PaginatedPracticalInformationDto
   */
  total: number;
  /**
   * The total number of pages
   * @type {number}
   * @memberof PaginatedPracticalInformationDto
   */
  pageCount: number;
  /**
   * The current page
   * @type {number}
   * @memberof PaginatedPracticalInformationDto
   */
  currentPage: number;
  /**
   * Array of information
   * @type {Array<PracticalInformationPreviewDto>}
   * @memberof PaginatedPracticalInformationDto
   */
  items: Array<PracticalInformationPreviewDto>;
}
/**
 *
 * @export
 * @interface PartyDto
 */
export interface PartyDto {
  /**
   *
   * @type {string}
   * @memberof PartyDto
   */
  id: string;
  /**
   *
   * @type {SettlementTargetType}
   * @memberof PartyDto
   */
  type: SettlementTargetType;
  /**
   * Never null: name, else estimated e-mail, else « Membre sans nom ».
   * @type {string}
   * @memberof PartyDto
   */
  displayName: string;
  /**
   * Membership row of a member or unregistered co-owner, to request their details. Null for an account, a contact, or a former member who still carries a debt.
   * @type {string}
   * @memberof PartyDto
   */
  assetMemberId: string | null;
}

/**
 *
 * @export
 * @interface PaymentMethodDto
 */
export interface PaymentMethodDto {
  /**
   *
   * @type {string}
   * @memberof PaymentMethodDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof PaymentMethodDto
   */
  identifier: string;
  /**
   *
   * @type {boolean}
   * @memberof PaymentMethodDto
   */
  isFavorite: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const PaymentMode = {
  DirectDebit: 'DIRECT_DEBIT',
  Transfer: 'TRANSFER',
  Card: 'CARD',
  Check: 'CHECK',
  Cash: 'CASH',
  Cesu: 'CESU',
  Other: 'OTHER',
} as const;

export type PaymentMode = (typeof PaymentMode)[keyof typeof PaymentMode];

/**
 *
 * @export
 * @interface PendingInvitationDto
 */
export interface PendingInvitationDto {
  /**
   *
   * @type {string}
   * @memberof PendingInvitationDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PendingInvitationDto
   */
  email: string;
  /**
   *
   * @type {Dayjs}
   * @memberof PendingInvitationDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof PendingInvitationDto
   */
  expiresAt: Dayjs;
  /**
   *
   * @type {AssetMemberUserDto}
   * @memberof PendingInvitationDto
   */
  invitedBy: AssetMemberUserDto;
  /**
   *
   * @type {string}
   * @memberof PendingInvitationDto
   */
  role?: PendingInvitationDtoRoleEnum;
}

export const PendingInvitationDtoRoleEnum = {
  Viewer: 'viewer',
  Contributor: 'contributor',
  Manager: 'manager',
} as const;

export type PendingInvitationDtoRoleEnum =
  (typeof PendingInvitationDtoRoleEnum)[keyof typeof PendingInvitationDtoRoleEnum];

/**
 *
 * @export
 * @interface PendingPlaceholderMatchDto
 */
export interface PendingPlaceholderMatchDto {
  /**
   * PlaceholderMember id.
   * @type {string}
   * @memberof PendingPlaceholderMatchDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PendingPlaceholderMatchDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof PendingPlaceholderMatchDto
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof PendingPlaceholderMatchDto
   */
  assetId: string;
  /**
   *
   * @type {string}
   * @memberof PendingPlaceholderMatchDto
   */
  assetName: string;
}
/**
 *
 * @export
 * @interface PermissionEntry
 */
export interface PermissionEntry {
  /**
   * The entity type to set permission for
   * @type {string}
   * @memberof PermissionEntry
   */
  subject: PermissionEntrySubjectEnum;
  /**
   * The permission level to set
   * @type {string}
   * @memberof PermissionEntry
   */
  level: PermissionEntryLevelEnum;
}

export const PermissionEntrySubjectEnum = {
  Contact: 'contact',
  Event: 'event',
  Expense: 'expense',
  BankAccount: 'bankAccount',
  MoneyTransfer: 'moneyTransfer',
  Project: 'project',
  Task: 'task',
  Checklist: 'checklist',
  Instruction: 'instruction',
  PracticalInformation: 'practicalInformation',
  AssetStorage: 'assetStorage',
  EntityExport: 'entityExport',
  FinanceAdmin: 'financeAdmin',
  Dashboard: 'dashboard',
  Cartography: 'cartography',
  DeductibleCharges: 'deductibleCharges',
  FundCall: 'fundCall',
} as const;

export type PermissionEntrySubjectEnum =
  (typeof PermissionEntrySubjectEnum)[keyof typeof PermissionEntrySubjectEnum];
export const PermissionEntryLevelEnum = {
  None: 'none',
  Read: 'read',
  Own: 'own',
  Full: 'full',
} as const;

export type PermissionEntryLevelEnum =
  (typeof PermissionEntryLevelEnum)[keyof typeof PermissionEntryLevelEnum];

/**
 *
 * @export
 * @interface PlaceMatchDto
 */
export interface PlaceMatchDto {
  /**
   *
   * @type {number}
   * @memberof PlaceMatchDto
   */
  startOffset: number;
  /**
   *
   * @type {number}
   * @memberof PlaceMatchDto
   */
  endOffset: number;
}
/**
 *
 * @export
 * @interface PlacePredictionDetailsDto
 */
export interface PlacePredictionDetailsDto {
  /**
   *
   * @type {string}
   * @memberof PlacePredictionDetailsDto
   */
  place: string;
  /**
   *
   * @type {string}
   * @memberof PlacePredictionDetailsDto
   */
  placeId: string;
  /**
   *
   * @type {PlacePredictionTextDto}
   * @memberof PlacePredictionDetailsDto
   */
  text: PlacePredictionTextDto;
  /**
   *
   * @type {PlaceStructuredFormatDto}
   * @memberof PlacePredictionDetailsDto
   */
  structuredFormat?: PlaceStructuredFormatDto;
  /**
   *
   * @type {Array<string>}
   * @memberof PlacePredictionDetailsDto
   */
  types?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof PlacePredictionDetailsDto
   */
  distanceMeters?: number;
}
/**
 *
 * @export
 * @interface PlacePredictionTextDto
 */
export interface PlacePredictionTextDto {
  /**
   *
   * @type {string}
   * @memberof PlacePredictionTextDto
   */
  text: string;
  /**
   *
   * @type {Array<PlaceMatchDto>}
   * @memberof PlacePredictionTextDto
   */
  matches: Array<PlaceMatchDto>;
}
/**
 *
 * @export
 * @interface PlaceStructuredFormatDto
 */
export interface PlaceStructuredFormatDto {
  /**
   *
   * @type {PlacePredictionTextDto}
   * @memberof PlaceStructuredFormatDto
   */
  mainText: PlacePredictionTextDto;
  /**
   *
   * @type {PlacePredictionTextDto}
   * @memberof PlaceStructuredFormatDto
   */
  secondaryText?: PlacePredictionTextDto;
}
/**
 *
 * @export
 * @interface PlaceholderMemberDto
 */
export interface PlaceholderMemberDto {
  /**
   * PlaceholderMember id.
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  id: string;
  /**
   * Paired AssetMember id (used for household attachment, etc.).
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  assetMemberId: string;
  /**
   *
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  estimatedEmail?: string;
  /**
   *
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  operationalRole?: PlaceholderMemberDtoOperationalRoleEnum;
  /**
   *
   * @type {number}
   * @memberof PlaceholderMemberDto
   */
  shares?: number;
  /**
   *
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  ownershipNature?: PlaceholderMemberDtoOwnershipNatureEnum;
  /**
   *
   * @type {string}
   * @memberof PlaceholderMemberDto
   */
  householdId?: string;
  /**
   *
   * @type {boolean}
   * @memberof PlaceholderMemberDto
   */
  isMandate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PlaceholderMemberDto
   */
  hasVotingRights?: boolean;
  /**
   *
   * @type {Dayjs}
   * @memberof PlaceholderMemberDto
   */
  createdAt: Dayjs;
}

export const PlaceholderMemberDtoOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type PlaceholderMemberDtoOperationalRoleEnum =
  (typeof PlaceholderMemberDtoOperationalRoleEnum)[keyof typeof PlaceholderMemberDtoOperationalRoleEnum];
export const PlaceholderMemberDtoOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type PlaceholderMemberDtoOwnershipNatureEnum =
  (typeof PlaceholderMemberDtoOwnershipNatureEnum)[keyof typeof PlaceholderMemberDtoOwnershipNatureEnum];

/**
 *
 * @export
 * @interface PracticalInformationDetailDto
 */
export interface PracticalInformationDetailDto {
  /**
   *
   * @type {string}
   * @memberof PracticalInformationDetailDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationDetailDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationDetailDto
   */
  type: PracticalInformationDetailDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationDetailDto
   */
  subtype?: PracticalInformationDetailDtoSubtypeEnum;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationDetailDto
   */
  icon?: string;
  /**
   *
   * @type {Array<PracticalInformationFieldDto>}
   * @memberof PracticalInformationDetailDto
   */
  fields: Array<PracticalInformationFieldDto>;
  /**
   *
   * @type {Array<AttachmentDto>}
   * @memberof PracticalInformationDetailDto
   */
  attachments?: Array<AttachmentDto>;
  /**
   *
   * @type {Dayjs}
   * @memberof PracticalInformationDetailDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof PracticalInformationDetailDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {boolean}
   * @memberof PracticalInformationDetailDto
   */
  isSystem: boolean;
  /**
   * Key of the DATE or SCHEDULE field that drives the reminder
   * @type {string}
   * @memberof PracticalInformationDetailDto
   */
  reminderFieldKey?: string;
  /**
   * Reminder duration in seconds before the target date
   * @type {number}
   * @memberof PracticalInformationDetailDto
   */
  reminderDurationSeconds?: number;
  /**
   * Time of day for the reminder, format HH:mm (24h)
   * @type {string}
   * @memberof PracticalInformationDetailDto
   */
  reminderTimeOfDay?: string;
}

export const PracticalInformationDetailDtoTypeEnum = {
  GeneralInformation: 'GENERAL_INFORMATION',
  SecurityAndAccess: 'SECURITY_AND_ACCESS',
  ElectricityAndLighting: 'ELECTRICITY_AND_LIGHTING',
  WaterAndSanitation: 'WATER_AND_SANITATION',
  HeatingAndAirConditioning: 'HEATING_AND_AIR_CONDITIONING',
  InternetAndMultimedia: 'INTERNET_AND_MULTIMEDIA',
  MaintenanceAndStorage: 'MAINTENANCE_AND_STORAGE',
  LeisureAndSpecificEquipment: 'LEISURE_AND_SPECIFIC_EQUIPMENT',
  Custom: 'CUSTOM',
} as const;

export type PracticalInformationDetailDtoTypeEnum =
  (typeof PracticalInformationDetailDtoTypeEnum)[keyof typeof PracticalInformationDetailDtoTypeEnum];
export const PracticalInformationDetailDtoSubtypeEnum = {
  HomeBoatCamperInsurance: 'HOME_BOAT_CAMPER_INSURANCE',
  GarbageCollection: 'GARBAGE_COLLECTION',
  WasteCollectionPoints: 'WASTE_COLLECTION_POINTS',
  WasteDisposalFacility: 'WASTE_DISPOSAL_FACILITY',
  EmergencyContacts: 'EMERGENCY_CONTACTS',
  KeysBadgesAccessCodes: 'KEYS_BADGES_ACCESS_CODES',
  AlarmAndSurveillanceSystem: 'ALARM_AND_SURVEILLANCE_SYSTEM',
  EmergencyExitsAndEvacuationPlan: 'EMERGENCY_EXITS_AND_EVACUATION_PLAN',
  FireExtinguishersAndDetectors: 'FIRE_EXTINGUISHERS_AND_DETECTORS',
  FirstAidKitLocation: 'FIRST_AID_KIT_LOCATION',
  UtilityMetersAndValvesLocation: 'UTILITY_METERS_AND_VALVES_LOCATION',
  EmergencyInstructions: 'EMERGENCY_INSTRUCTIONS',
  ManualsAndWarrantyLocation: 'MANUALS_AND_WARRANTY_LOCATION',
  ElectricalInstallationType: 'ELECTRICAL_INSTALLATION_TYPE',
  TroubleshootingInstructions: 'TROUBLESHOOTING_INSTRUCTIONS',
  WaterSupplyType: 'WATER_SUPPLY_TYPE',
  WaterFiltrationSoftener: 'WATER_FILTRATION_SOFTENER',
  WastewaterTankMaintenance: 'WASTEWATER_TANK_MAINTENANCE',
  WaterHeaterBoilerOperation: 'WATER_HEATER_BOILER_OPERATION',
  MainPipingLayout: 'MAIN_PIPING_LAYOUT',
  HeatingType: 'HEATING_TYPE',
  ThermostatAndTemperatureControl: 'THERMOSTAT_AND_TEMPERATURE_CONTROL',
  AirConditioningAndVentilation: 'AIR_CONDITIONING_AND_VENTILATION',
  EquipmentMaintenance: 'EQUIPMENT_MAINTENANCE',
  GasBottleLocation: 'GAS_BOTTLE_LOCATION',
  InternetProvider: 'INTERNET_PROVIDER',
  CustomerReferenceContract: 'CUSTOMER_REFERENCE_CONTRACT',
  WifiCodeAndRouterSetup: 'WIFI_CODE_AND_ROUTER_SETUP',
  AudioSystemConnectedSpeakers: 'AUDIO_SYSTEM_CONNECTED_SPEAKERS',
  CleaningProductsAndUsage: 'CLEANING_PRODUCTS_AND_USAGE',
  VacuumBroomsMop: 'VACUUM_BROOMS_MOP',
  SensitiveAreasRequiringSpecificMaintenance: 'SENSITIVE_AREAS_REQUIRING_SPECIFIC_MAINTENANCE',
  GardenEquipment: 'GARDEN_EQUIPMENT',
  SwimmingPool: 'SWIMMING_POOL',
  SpaSauna: 'SPA_SAUNA',
  TennisCourt: 'TENNIS_COURT',
  SportsEquipment: 'SPORTS_EQUIPMENT',
  FishingOrDivingEquipment: 'FISHING_OR_DIVING_EQUIPMENT',
  BooksBoardGamesAudiovisualEquipment: 'BOOKS_BOARD_GAMES_AUDIOVISUAL_EQUIPMENT',
} as const;

export type PracticalInformationDetailDtoSubtypeEnum =
  (typeof PracticalInformationDetailDtoSubtypeEnum)[keyof typeof PracticalInformationDetailDtoSubtypeEnum];

/**
 *
 * @export
 * @interface PracticalInformationFieldDto
 */
export interface PracticalInformationFieldDto {
  /**
   *
   * @type {string}
   * @memberof PracticalInformationFieldDto
   */
  fieldType: PracticalInformationFieldDtoFieldTypeEnum;
  /**
   *
   * @type {object}
   * @memberof PracticalInformationFieldDto
   */
  value: object;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationFieldDto
   */
  key: string;
}

export const PracticalInformationFieldDtoFieldTypeEnum = {
  Text: 'TEXT',
  Date: 'DATE',
  Schedule: 'SCHEDULE',
  Location: 'LOCATION',
  Password: 'PASSWORD',
  List: 'LIST',
} as const;

export type PracticalInformationFieldDtoFieldTypeEnum =
  (typeof PracticalInformationFieldDtoFieldTypeEnum)[keyof typeof PracticalInformationFieldDtoFieldTypeEnum];

/**
 *
 * @export
 * @interface PracticalInformationPreviewDto
 */
export interface PracticalInformationPreviewDto {
  /**
   *
   * @type {string}
   * @memberof PracticalInformationPreviewDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationPreviewDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationPreviewDto
   */
  subtype?: string;
  /**
   *
   * @type {Array<PracticalInformationFieldDto>}
   * @memberof PracticalInformationPreviewDto
   */
  fields: Array<PracticalInformationFieldDto>;
  /**
   *
   * @type {Dayjs}
   * @memberof PracticalInformationPreviewDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationPreviewDto
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof PracticalInformationPreviewDto
   */
  icon: string;
  /**
   *
   * @type {boolean}
   * @memberof PracticalInformationPreviewDto
   */
  isSystem: boolean;
  /**
   * Time of day for the reminder, format HH:mm (24h)
   * @type {string}
   * @memberof PracticalInformationPreviewDto
   */
  reminderTimeOfDay?: string;
  /**
   * Key of the DATE or SCHEDULE field that drives the reminder
   * @type {string}
   * @memberof PracticalInformationPreviewDto
   */
  reminderFieldKey?: string;
}
/**
 *
 * @export
 * @interface PreviewShareDto
 */
export interface PreviewShareDto {
  /**
   *
   * @type {string}
   * @memberof PreviewShareDto
   */
  id: string;
  /**
   *
   * @type {UserDto}
   * @memberof PreviewShareDto
   */
  user?: UserDto;
  /**
   *
   * @type {ExpenseWithSharesPlaceholderMemberDto}
   * @memberof PreviewShareDto
   */
  placeholderMember?: ExpenseWithSharesPlaceholderMemberDto;
  /**
   *
   * @type {number}
   * @memberof PreviewShareDto
   */
  amount: number;
}
/**
 *
 * @export
 * @interface ProfilePictureDto
 */
export interface ProfilePictureDto {
  /**
   *
   * @type {string}
   * @memberof ProfilePictureDto
   */
  profilePictureUrl: string;
}
/**
 *
 * @export
 * @interface ProjectDto
 */
export interface ProjectDto {
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  status: ProjectDtoStatusEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof ProjectDto
   */
  deadline?: Dayjs | null;
  /**
   *
   * @type {number}
   * @memberof ProjectDto
   */
  estimatedDuration?: number | null;
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  estimatedDurationUnit?: ProjectDtoEstimatedDurationUnitEnum | null;
  /**
   *
   * @type {number}
   * @memberof ProjectDto
   */
  estimatedCost?: number | null;
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  description?: string | null;
  /**
   *
   * @type {Dayjs}
   * @memberof ProjectDto
   */
  completionDate?: Dayjs | null;
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  label?: ProjectDtoLabelEnum | null;
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  priority?: ProjectDtoPriorityEnum | null;
  /**
   *
   * @type {string}
   * @memberof ProjectDto
   */
  assetId: string;
  /**
   *
   * @type {UserDto}
   * @memberof ProjectDto
   */
  createdBy: UserDto;
  /**
   *
   * @type {Dayjs}
   * @memberof ProjectDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof ProjectDto
   */
  updatedAt: Dayjs;
  /**
   *
   * @type {Array<UserDto>}
   * @memberof ProjectDto
   */
  members: Array<UserDto>;
  /**
   *
   * @type {Array<UserDto>}
   * @memberof ProjectDto
   */
  participants: Array<UserDto>;
  /**
   *
   * @type {Array<AttachmentDto>}
   * @memberof ProjectDto
   */
  attachments: Array<AttachmentDto>;
  /**
   *
   * @type {Array<ProjectVoteDto>}
   * @memberof ProjectDto
   */
  votes: Array<ProjectVoteDto>;
  /**
   *
   * @type {LikesSummaryDto}
   * @memberof ProjectDto
   */
  likesSummary: LikesSummaryDto;
}

export const ProjectDtoStatusEnum = {
  IdeaBox: 'IDEA_BOX',
  IdeaToVote: 'IDEA_TO_VOTE',
  ProjectValidated: 'PROJECT_VALIDATED',
  ProjectInProgress: 'PROJECT_IN_PROGRESS',
  ProjectCompleted: 'PROJECT_COMPLETED',
} as const;

export type ProjectDtoStatusEnum = (typeof ProjectDtoStatusEnum)[keyof typeof ProjectDtoStatusEnum];
export const ProjectDtoEstimatedDurationUnitEnum = {
  Days: 'DAYS',
  Weeks: 'WEEKS',
  Months: 'MONTHS',
  Years: 'YEARS',
} as const;

export type ProjectDtoEstimatedDurationUnitEnum =
  (typeof ProjectDtoEstimatedDurationUnitEnum)[keyof typeof ProjectDtoEstimatedDurationUnitEnum];
export const ProjectDtoLabelEnum = {
  Red: 'RED',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Green: 'GREEN',
  Blue: 'BLUE',
  Purple: 'PURPLE',
  Gray: 'GRAY',
} as const;

export type ProjectDtoLabelEnum = (typeof ProjectDtoLabelEnum)[keyof typeof ProjectDtoLabelEnum];
export const ProjectDtoPriorityEnum = {
  High: 'HIGH',
  Medium: 'MEDIUM',
  Low: 'LOW',
} as const;

export type ProjectDtoPriorityEnum =
  (typeof ProjectDtoPriorityEnum)[keyof typeof ProjectDtoPriorityEnum];

/**
 *
 * @export
 * @interface ProjectVoteDto
 */
export interface ProjectVoteDto {
  /**
   *
   * @type {string}
   * @memberof ProjectVoteDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ProjectVoteDto
   */
  vote: ProjectVoteDtoVoteEnum;
  /**
   *
   * @type {UserDto}
   * @memberof ProjectVoteDto
   */
  user: UserDto;
  /**
   *
   * @type {Dayjs}
   * @memberof ProjectVoteDto
   */
  createdAt: Dayjs;
}

export const ProjectVoteDtoVoteEnum = {
  Yes: 'YES',
  No: 'NO',
} as const;

export type ProjectVoteDtoVoteEnum =
  (typeof ProjectVoteDtoVoteEnum)[keyof typeof ProjectVoteDtoVoteEnum];

/**
 *
 * @export
 * @interface PublicAnnouncementDto
 */
export interface PublicAnnouncementDto {
  /**
   *
   * @type {string}
   * @memberof PublicAnnouncementDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PublicAnnouncementDto
   */
  level: PublicAnnouncementDtoLevelEnum;
  /**
   *
   * @type {string}
   * @memberof PublicAnnouncementDto
   */
  message: string;
}

export const PublicAnnouncementDtoLevelEnum = {
  Info: 'INFO',
  Warning: 'WARNING',
  Critical: 'CRITICAL',
} as const;

export type PublicAnnouncementDtoLevelEnum =
  (typeof PublicAnnouncementDtoLevelEnum)[keyof typeof PublicAnnouncementDtoLevelEnum];

/**
 *
 * @export
 * @interface PushSubscriptionDto
 */
export interface PushSubscriptionDto {
  /**
   *
   * @type {boolean}
   * @memberof PushSubscriptionDto
   */
  isSubscribedForCurrentUser: boolean;
}
/**
 *
 * @export
 * @interface PushSubscriptionKeysDto
 */
export interface PushSubscriptionKeysDto {
  /**
   *
   * @type {string}
   * @memberof PushSubscriptionKeysDto
   */
  p256dh: string;
  /**
   *
   * @type {string}
   * @memberof PushSubscriptionKeysDto
   */
  auth: string;
}
/**
 *
 * @export
 * @interface ReceiptDataDto
 */
export interface ReceiptDataDto {
  /**
   * Suggested title for the expense (e.g., Merchant Name)
   * @type {string}
   * @memberof ReceiptDataDto
   */
  title?: string;
  /**
   * Extracted total amount from the receipt
   * @type {number}
   * @memberof ReceiptDataDto
   */
  amount?: number;
  /**
   * Extracted date from the receipt
   * @type {Dayjs}
   * @memberof ReceiptDataDto
   */
  date?: Dayjs;
  /**
   * Extracted merchant or vendor name
   * @type {string}
   * @memberof ReceiptDataDto
   */
  merchantName?: string;
  /**
   * Inferred expense type based on receipt content
   * @type {string}
   * @memberof ReceiptDataDto
   */
  type?: ReceiptDataDtoTypeEnum;
  /**
   * Raw or simplified text lines from the receipt line items
   * @type {Array<string>}
   * @memberof ReceiptDataDto
   */
  lineItems?: Array<string>;
}

export const ReceiptDataDtoTypeEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type ReceiptDataDtoTypeEnum =
  (typeof ReceiptDataDtoTypeEnum)[keyof typeof ReceiptDataDtoTypeEnum];

/**
 *
 * @export
 * @interface RecurrenceDto
 */
export interface RecurrenceDto {
  /**
   * Fréquence de récurrence
   * @type {string}
   * @memberof RecurrenceDto
   */
  frequency: RecurrenceDtoFrequencyEnum;
  /**
   * Intervalle de récurrence (ex: toutes les 2 semaines)
   * @type {number}
   * @memberof RecurrenceDto
   */
  interval?: number;
  /**
   * Jours du mois (1-31)
   * @type {Array<number>}
   * @memberof RecurrenceDto
   */
  byMonthDay?: Array<number>;
  /**
   * Mois de l\'année (1-12)
   * @type {Array<number>}
   * @memberof RecurrenceDto
   */
  byMonth?: Array<number>;
  /**
   * Jours de la semaine (0-6, 0=Lundi)
   * @type {Array<number>}
   * @memberof RecurrenceDto
   */
  byWeekDay?: Array<number>;
  /**
   * La énième occurrence
   * @type {number}
   * @memberof RecurrenceDto
   */
  bySetPos?: number;
  /**
   * Date de fin de la récurrence
   * @type {Dayjs}
   * @memberof RecurrenceDto
   */
  until?: Dayjs;
  /**
   * Timezone of the user
   * @type {string}
   * @memberof RecurrenceDto
   */
  timezone: string;
  /**
   * The recurrence start
   * @type {Dayjs}
   * @memberof RecurrenceDto
   */
  dtstart?: Dayjs;
  /**
   *
   * @type {Array<string>}
   * @memberof RecurrenceDto
   */
  exdates?: Array<string>;
}

export const RecurrenceDtoFrequencyEnum = {
  Yearly: 'YEARLY',
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY',
  Daily: 'DAILY',
} as const;

export type RecurrenceDtoFrequencyEnum =
  (typeof RecurrenceDtoFrequencyEnum)[keyof typeof RecurrenceDtoFrequencyEnum];

/**
 *
 * @export
 * @interface RegisterUserDto
 */
export interface RegisterUserDto {
  /**
   *
   * @type {string}
   * @memberof RegisterUserDto
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof RegisterUserDto
   */
  password: string;
  /**
   *
   * @type {string}
   * @memberof RegisterUserDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof RegisterUserDto
   */
  lastName: string;
  /**
   *
   * @type {boolean}
   * @memberof RegisterUserDto
   */
  acceptedTermsPrivacy: boolean;
  /**
   *
   * @type {string}
   * @memberof RegisterUserDto
   */
  acceptedTermsPrivacyVersion: string;
  /**
   *
   * @type {boolean}
   * @memberof RegisterUserDto
   */
  newsletterOptIn?: boolean;
  /**
   * UTM source
   * @type {string}
   * @memberof RegisterUserDto
   */
  utmSource?: string;
  /**
   * UTM medium
   * @type {string}
   * @memberof RegisterUserDto
   */
  utmMedium?: string;
  /**
   * UTM campaign
   * @type {string}
   * @memberof RegisterUserDto
   */
  utmCampaign?: string;
  /**
   * UTM term
   * @type {string}
   * @memberof RegisterUserDto
   */
  utmTerm?: string;
  /**
   * UTM content
   * @type {string}
   * @memberof RegisterUserDto
   */
  utmContent?: string;
  /**
   * Facebook Click ID (_fbc cookie)
   * @type {string}
   * @memberof RegisterUserDto
   */
  fbc?: string;
  /**
   * Facebook Browser ID (_fbp cookie)
   * @type {string}
   * @memberof RegisterUserDto
   */
  fbp?: string;
}
/**
 *
 * @export
 * @interface RelatedEntityInputDto
 */
export interface RelatedEntityInputDto {
  /**
   * Type of the related entity
   * @type {string}
   * @memberof RelatedEntityInputDto
   */
  type: RelatedEntityInputDtoTypeEnum;
  /**
   * ID of the related entity
   * @type {string}
   * @memberof RelatedEntityInputDto
   */
  id: string;
}

export const RelatedEntityInputDtoTypeEnum = {
  Project: 'project',
  Event: 'event',
  Expense: 'expense',
  Checklist: 'checklist',
  CommunityFeedItem: 'communityFeedItem',
} as const;

export type RelatedEntityInputDtoTypeEnum =
  (typeof RelatedEntityInputDtoTypeEnum)[keyof typeof RelatedEntityInputDtoTypeEnum];

/**
 *
 * @export
 * @interface RenameItemDto
 */
export interface RenameItemDto {
  /**
   *
   * @type {string}
   * @memberof RenameItemDto
   */
  name: string;
}
/**
 *
 * @export
 * @interface RequestPasswordResetDto
 */
export interface RequestPasswordResetDto {
  /**
   *
   * @type {string}
   * @memberof RequestPasswordResetDto
   */
  email: string;
}
/**
 *
 * @export
 * @interface RoomDto
 */
export interface RoomDto {
  /**
   *
   * @type {string}
   * @memberof RoomDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof RoomDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof RoomDto
   */
  type: RoomDtoTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof RoomDto
   */
  features: Array<RoomDtoFeaturesEnum>;
  /**
   * Chambre desservie par cette pièce d\'eau (« en suite »)
   * @type {string}
   * @memberof RoomDto
   */
  servedRoomId?: string | null;
  /**
   *
   * @type {string}
   * @memberof RoomDto
   */
  floorId?: string | null;
  /**
   *
   * @type {number}
   * @memberof RoomDto
   */
  areaSqm?: number;
  /**
   *
   * @type {boolean}
   * @memberof RoomDto
   */
  isOutOfService: boolean;
  /**
   *
   * @type {number}
   * @memberof RoomDto
   */
  position: number;
  /**
   * Capacité totale de la pièce (somme des lits)
   * @type {number}
   * @memberof RoomDto
   */
  capacity: number;
  /**
   *
   * @type {Array<BedDto>}
   * @memberof RoomDto
   */
  beds: Array<BedDto>;
  /**
   *
   * @type {Dayjs}
   * @memberof RoomDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof RoomDto
   */
  updatedAt: Dayjs;
}

export const RoomDtoTypeEnum = {
  Bedroom: 'BEDROOM',
  MasterBedroom: 'MASTER_BEDROOM',
  Dormitory: 'DORMITORY',
  StudioApartment: 'STUDIO_APARTMENT',
  DressingRoom: 'DRESSING_ROOM',
  StorageRoom: 'STORAGE_ROOM',
  LivingRoom: 'LIVING_ROOM',
  DiningRoom: 'DINING_ROOM',
  Office: 'OFFICE',
  Library: 'LIBRARY',
  Playroom: 'PLAYROOM',
  Gym: 'GYM',
  HomeCinema: 'HOME_CINEMA',
  Veranda: 'VERANDA',
  ReceptionRoom: 'RECEPTION_ROOM',
  Kitchen: 'KITCHEN',
  Pantry: 'PANTRY',
  Laundry: 'LAUNDRY',
  Larder: 'LARDER',
  Bathroom: 'BATHROOM',
  ShowerRoom: 'SHOWER_ROOM',
  PowderRoom: 'POWDER_ROOM',
  Toilet: 'TOILET',
  Entrance: 'ENTRANCE',
  Hallway: 'HALLWAY',
  Landing: 'LANDING',
  Stairwell: 'STAIRWELL',
  Mezzanine: 'MEZZANINE',
  Attic: 'ATTIC',
  Basement: 'BASEMENT',
  Cellar: 'CELLAR',
  WineCellar: 'WINE_CELLAR',
  BoilerRoom: 'BOILER_ROOM',
  Outdoor: 'OUTDOOR',
  Garden: 'GARDEN',
  Terrace: 'TERRACE',
  Balcony: 'BALCONY',
  Loggia: 'LOGGIA',
  Courtyard: 'COURTYARD',
  Pool: 'POOL',
  PoolHouse: 'POOL_HOUSE',
  Garage: 'GARAGE',
  Carport: 'CARPORT',
  ParkingSpace: 'PARKING_SPACE',
  Workshop: 'WORKSHOP',
  Shed: 'SHED',
  Outbuilding: 'OUTBUILDING',
  Barn: 'BARN',
  Stable: 'STABLE',
  CommonArea: 'COMMON_AREA',
  Lobby: 'LOBBY',
  BikeRoom: 'BIKE_ROOM',
  BinRoom: 'BIN_ROOM',
  Other: 'OTHER',
} as const;

export type RoomDtoTypeEnum = (typeof RoomDtoTypeEnum)[keyof typeof RoomDtoTypeEnum];
export const RoomDtoFeaturesEnum = {
  Bathtub: 'BATHTUB',
  Shower: 'SHOWER',
  Washbasin: 'WASHBASIN',
  DoubleWashbasin: 'DOUBLE_WASHBASIN',
  Toilet: 'TOILET',
  HandBasin: 'HAND_BASIN',
  Bidet: 'BIDET',
} as const;

export type RoomDtoFeaturesEnum = (typeof RoomDtoFeaturesEnum)[keyof typeof RoomDtoFeaturesEnum];

/**
 *
 * @export
 * @interface SectionDto
 */
export interface SectionDto {
  /**
   *
   * @type {string}
   * @memberof SectionDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SectionDto
   */
  title: string;
  /**
   *
   * @type {object}
   * @memberof SectionDto
   */
  content: object;
  /**
   *
   * @type {Array<AttachmentDto>}
   * @memberof SectionDto
   */
  attachments: Array<AttachmentDto>;
}
/**
 *
 * @export
 * @interface SectionsDto
 */
export interface SectionsDto {
  /**
   *
   * @type {Array<SectionDto>}
   * @memberof SectionsDto
   */
  sections: Array<SectionDto>;
  /**
   *
   * @type {string}
   * @memberof SectionsDto
   */
  title: string;
}
/**
 *
 * @export
 * @interface SendFundCallDto
 */
export interface SendFundCallDto {
  /**
   * Envoyer les e-mails. Défaut : true.
   * @type {boolean}
   * @memberof SendFundCallDto
   */
  sendEmail?: boolean;
  /**
   * Publier un message dans « Entre nous ». Défaut : true.
   * @type {boolean}
   * @memberof SendFundCallDto
   */
  postToFeed?: boolean;
  /**
   * Renvoi ciblé sur une seule ligne, après un échec provider. Absent = envoi complet.
   * @type {string}
   * @memberof SendFundCallDto
   */
  lineId?: string;
  /**
   * Sur un relevé SELF : envoyer aussi aux membres non concernés.
   * @type {boolean}
   * @memberof SendFundCallDto
   */
  alsoSendToOtherMembers?: boolean;
}
/**
 *
 * @export
 * @interface SetFavoriteAssetDto
 */
export interface SetFavoriteAssetDto {
  /**
   * Asset ID to set as favorite, or null to unset
   * @type {string}
   * @memberof SetFavoriteAssetDto
   */
  assetId?: string | null;
}
/**
 *
 * @export
 * @interface SetRecurrenceOccurrenceAmountDto
 */
export interface SetRecurrenceOccurrenceAmountDto {
  /**
   * Date of the not-yet-materialized occurrence, as projected in the budget forecast view
   * @type {string}
   * @memberof SetRecurrenceOccurrenceAmountDto
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof SetRecurrenceOccurrenceAmountDto
   */
  amount: number;
}
/**
 *
 * @export
 * @interface SettlementDto
 */
export interface SettlementDto {
  /**
   *
   * @type {SettlementTargetDto}
   * @memberof SettlementDto
   */
  from: SettlementTargetDto;
  /**
   *
   * @type {SettlementTargetDto}
   * @memberof SettlementDto
   */
  to: SettlementTargetDto;
  /**
   *
   * @type {number}
   * @memberof SettlementDto
   */
  amount: number;
  /**
   * Expense shares still owed in the direction of the settlement, to pre-select them in the reimbursement form. Their sum equals `amount` unless both parties owe each other something, in which case the shares of the dominant direction are returned and `amount` stays the net. Only set on the per-asset, non-simplified equilibrium: a simplified or cross-asset line nets several debts together and maps to no share.
   * @type {Array<SettlementShareDto>}
   * @memberof SettlementDto
   */
  shares?: Array<SettlementShareDto>;
}
/**
 *
 * @export
 * @interface SettlementShareDto
 */
export interface SettlementShareDto {
  /**
   *
   * @type {string}
   * @memberof SettlementShareDto
   */
  expenseId: string;
  /**
   *
   * @type {string}
   * @memberof SettlementShareDto
   */
  expenseShareId: string;
  /**
   *
   * @type {string}
   * @memberof SettlementShareDto
   */
  expenseTitle: string;
  /**
   *
   * @type {Dayjs}
   * @memberof SettlementShareDto
   */
  expenseDate: Dayjs;
  /**
   *
   * @type {number}
   * @memberof SettlementShareDto
   */
  amount: number;
}
/**
 *
 * @export
 * @interface SettlementTargetDto
 */
export interface SettlementTargetDto {
  /**
   *
   * @type {string}
   * @memberof SettlementTargetDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SettlementTargetDto
   */
  type: SettlementTargetDtoTypeEnum;
  /**
   *
   * @type {string}
   * @memberof SettlementTargetDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof SettlementTargetDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof SettlementTargetDto
   */
  lastName?: string;
  /**
   * Nom affichable, toujours rempli quand la cible est une personne : prénom nom, sinon « Membre sans nom ». À préférer à la concaténation de firstName/lastName côté front, qui produisait « null null » sur un profil jamais complété.
   * @type {string}
   * @memberof SettlementTargetDto
   */
  displayName?: string;
  /**
   * URL signée de la photo de profil, pour afficher le visage plutôt que les initiales. Renseignée pour les cibles de type `user` uniquement.
   * @type {string}
   * @memberof SettlementTargetDto
   */
  profilePictureUrl?: string;
}

export const SettlementTargetDtoTypeEnum = {
  User: 'user',
  BankAccount: 'bank_account',
  Contact: 'contact',
  PlaceholderMember: 'placeholder_member',
} as const;

export type SettlementTargetDtoTypeEnum =
  (typeof SettlementTargetDtoTypeEnum)[keyof typeof SettlementTargetDtoTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const SettlementTargetType = {
  User: 'user',
  BankAccount: 'bank_account',
  Contact: 'contact',
  PlaceholderMember: 'placeholder_member',
} as const;

export type SettlementTargetType = (typeof SettlementTargetType)[keyof typeof SettlementTargetType];

/**
 *
 * @export
 * @interface SignedUrlsDto
 */
export interface SignedUrlsDto {
  /**
   * The signed URL for the main file.
   * @type {string}
   * @memberof SignedUrlsDto
   */
  fileUrl: string;
  /**
   * The signed URL for the large preview, if available.
   * @type {string}
   * @memberof SignedUrlsDto
   */
  previewLargeUrl?: string;
  /**
   * The signed URL for the medium preview, if available.
   * @type {string}
   * @memberof SignedUrlsDto
   */
  previewMediumUrl?: string;
  /**
   * The signed URL for the thumbnail preview, if available.
   * @type {string}
   * @memberof SignedUrlsDto
   */
  previewThumbnailUrl?: string;
}
/**
 *
 * @export
 * @interface SleepingRoomsSummaryDto
 */
export interface SleepingRoomsSummaryDto {
  /**
   * Nombre de pièces portant un couchage
   * @type {number}
   * @memberof SleepingRoomsSummaryDto
   */
  total: number;
  /**
   * Pièces dont tous les lits accueillent 2 personnes ou plus
   * @type {number}
   * @memberof SleepingRoomsSummaryDto
   */
  withDoubleBed: number;
  /**
   * Pièces n\'ayant que des lits simples
   * @type {number}
   * @memberof SleepingRoomsSummaryDto
   */
  withSingleBedsOnly: number;
  /**
   * Pièces sans aucun lit renseigné
   * @type {number}
   * @memberof SleepingRoomsSummaryDto
   */
  withoutBed: number;
  /**
   * Répartition par niveau
   * @type {Array<CountByKeyDto>}
   * @memberof SleepingRoomsSummaryDto
   */
  byFloor: Array<CountByKeyDto>;
  /**
   * Répartition par bâtiment
   * @type {Array<CountByKeyDto>}
   * @memberof SleepingRoomsSummaryDto
   */
  byBuilding: Array<CountByKeyDto>;
  /**
   * Répartition par type de pièce
   * @type {Array<string>}
   * @memberof SleepingRoomsSummaryDto
   */
  byType: Array<SleepingRoomsSummaryDtoByTypeEnum>;
}

export const SleepingRoomsSummaryDtoByTypeEnum = {
  Bedroom: 'BEDROOM',
  MasterBedroom: 'MASTER_BEDROOM',
  Dormitory: 'DORMITORY',
  StudioApartment: 'STUDIO_APARTMENT',
  DressingRoom: 'DRESSING_ROOM',
  StorageRoom: 'STORAGE_ROOM',
  LivingRoom: 'LIVING_ROOM',
  DiningRoom: 'DINING_ROOM',
  Office: 'OFFICE',
  Library: 'LIBRARY',
  Playroom: 'PLAYROOM',
  Gym: 'GYM',
  HomeCinema: 'HOME_CINEMA',
  Veranda: 'VERANDA',
  ReceptionRoom: 'RECEPTION_ROOM',
  Kitchen: 'KITCHEN',
  Pantry: 'PANTRY',
  Laundry: 'LAUNDRY',
  Larder: 'LARDER',
  Bathroom: 'BATHROOM',
  ShowerRoom: 'SHOWER_ROOM',
  PowderRoom: 'POWDER_ROOM',
  Toilet: 'TOILET',
  Entrance: 'ENTRANCE',
  Hallway: 'HALLWAY',
  Landing: 'LANDING',
  Stairwell: 'STAIRWELL',
  Mezzanine: 'MEZZANINE',
  Attic: 'ATTIC',
  Basement: 'BASEMENT',
  Cellar: 'CELLAR',
  WineCellar: 'WINE_CELLAR',
  BoilerRoom: 'BOILER_ROOM',
  Outdoor: 'OUTDOOR',
  Garden: 'GARDEN',
  Terrace: 'TERRACE',
  Balcony: 'BALCONY',
  Loggia: 'LOGGIA',
  Courtyard: 'COURTYARD',
  Pool: 'POOL',
  PoolHouse: 'POOL_HOUSE',
  Garage: 'GARAGE',
  Carport: 'CARPORT',
  ParkingSpace: 'PARKING_SPACE',
  Workshop: 'WORKSHOP',
  Shed: 'SHED',
  Outbuilding: 'OUTBUILDING',
  Barn: 'BARN',
  Stable: 'STABLE',
  CommonArea: 'COMMON_AREA',
  Lobby: 'LOBBY',
  BikeRoom: 'BIKE_ROOM',
  BinRoom: 'BIN_ROOM',
  Other: 'OTHER',
} as const;

export type SleepingRoomsSummaryDtoByTypeEnum =
  (typeof SleepingRoomsSummaryDtoByTypeEnum)[keyof typeof SleepingRoomsSummaryDtoByTypeEnum];

/**
 *
 * @export
 * @interface StatementCheckDto
 */
export interface StatementCheckDto {
  /**
   * Σ of what debtors owe: members, house and contacts.
   * @type {number}
   * @memberof StatementCheckDto
   */
  totalOwed: number;
  /**
   * Σ of what creditors expect: members, house and contacts.
   * @type {number}
   * @memberof StatementCheckDto
   */
  totalExpected: number;
  /**
   * totalOwed − totalExpected; 0 on balanced books, never forced.
   * @type {number}
   * @memberof StatementCheckDto
   */
  gap: number;
}
/**
 *
 * @export
 * @interface StorageFileDto
 */
export interface StorageFileDto {
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  originalName: string;
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  mimeType: string;
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  blurhash: string | null;
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  url: string;
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  previewLargeUrl: string | null;
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  previewMediumUrl: string | null;
  /**
   *
   * @type {string}
   * @memberof StorageFileDto
   */
  previewThumbnailUrl: string | null;
  /**
   *
   * @type {Array<TaggedMemberDto>}
   * @memberof StorageFileDto
   */
  taggedMembers?: Array<TaggedMemberDto>;
}
/**
 *
 * @export
 * @interface StorageUsageDto
 */
export interface StorageUsageDto {
  /**
   *
   * @type {number}
   * @memberof StorageUsageDto
   */
  currentMb: number;
  /**
   *
   * @type {number}
   * @memberof StorageUsageDto
   */
  limitMb: number;
}
/**
 *
 * @export
 * @interface SuccessResponseDto
 */
export interface SuccessResponseDto {
  /**
   * Indicates if the operation was successful.
   * @type {boolean}
   * @memberof SuccessResponseDto
   */
  success: boolean;
  /**
   * An optional message providing more context about the success.
   * @type {string}
   * @memberof SuccessResponseDto
   */
  message?: string;
}
/**
 *
 * @export
 * @interface TaggedMemberDto
 */
export interface TaggedMemberDto {
  /**
   *
   * @type {string}
   * @memberof TaggedMemberDto
   */
  tagId: string;
  /**
   *
   * @type {string}
   * @memberof TaggedMemberDto
   */
  memberId: string;
  /**
   *
   * @type {string}
   * @memberof TaggedMemberDto
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof TaggedMemberDto
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof TaggedMemberDto
   */
  imageUrl?: string;
}
/**
 *
 * @export
 * @interface TaskDto
 */
export interface TaskDto {
  /**
   *
   * @type {string}
   * @memberof TaskDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof TaskDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof TaskDto
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof TaskDto
   */
  status: TaskDtoStatusEnum;
  /**
   *
   * @type {string}
   * @memberof TaskDto
   */
  category?: TaskDtoCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof TaskDto
   */
  subCategory?: TaskDtoSubCategoryEnum | null;
  /**
   *
   * @type {Dayjs}
   * @memberof TaskDto
   */
  dueDate?: Dayjs | null;
  /**
   * Time spent in minutes
   * @type {number}
   * @memberof TaskDto
   */
  timeSpentMinutes?: number | null;
  /**
   * Whether the task requires being physically on site
   * @type {boolean}
   * @memberof TaskDto
   */
  requiresOnSite: boolean;
  /**
   *
   * @type {string}
   * @memberof TaskDto
   */
  assetId: string;
  /**
   *
   * @type {UserDto}
   * @memberof TaskDto
   */
  createdBy: UserDto;
  /**
   *
   * @type {UserDto}
   * @memberof TaskDto
   */
  assignedTo?: UserDto | null;
  /**
   *
   * @type {Array<TaskRelatedEntityDto>}
   * @memberof TaskDto
   */
  relatedEntities: Array<TaskRelatedEntityDto>;
  /**
   *
   * @type {Array<AttachmentDto>}
   * @memberof TaskDto
   */
  attachments: Array<AttachmentDto>;
  /**
   *
   * @type {Dayjs}
   * @memberof TaskDto
   */
  createdAt: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof TaskDto
   */
  updatedAt: Dayjs;
}

export const TaskDtoStatusEnum = {
  Todo: 'TODO',
  InProgress: 'IN_PROGRESS',
  Done: 'DONE',
} as const;

export type TaskDtoStatusEnum = (typeof TaskDtoStatusEnum)[keyof typeof TaskDtoStatusEnum];
export const TaskDtoCategoryEnum = {
  Technique: 'TECHNIQUE',
  VieMaison: 'VIE_MAISON',
  Gestion: 'GESTION',
} as const;

export type TaskDtoCategoryEnum = (typeof TaskDtoCategoryEnum)[keyof typeof TaskDtoCategoryEnum];
export const TaskDtoSubCategoryEnum = {
  Plomberie: 'PLOMBERIE',
  Electricite: 'ELECTRICITE',
  Menuiseries: 'MENUISERIES',
  PeintureEnduits: 'PEINTURE_ENDUITS',
  ReparationsDiverses: 'REPARATIONS_DIVERSES',
  Jardinage: 'JARDINAGE',
  MenageRangement: 'MENAGE_RANGEMENT',
  Decoration: 'DECORATION',
  CoursesApprovisionnement: 'COURSES_APPROVISIONNEMENT',
  Administratif: 'ADMINISTRATIF',
  Comptabilite: 'COMPTABILITE',
  Juridique: 'JURIDIQUE',
  SourcingAchats: 'SOURCING_ACHATS',
  GestionSinistres: 'GESTION_SINISTRES',
  RelationsExterieures: 'RELATIONS_EXTERIEURES',
} as const;

export type TaskDtoSubCategoryEnum =
  (typeof TaskDtoSubCategoryEnum)[keyof typeof TaskDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface TaskRelatedEntityDto
 */
export interface TaskRelatedEntityDto {
  /**
   *
   * @type {string}
   * @memberof TaskRelatedEntityDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof TaskRelatedEntityDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof TaskRelatedEntityDto
   */
  type: string;
}
/**
 *
 * @export
 * @interface TempUploadedImageDto
 */
export interface TempUploadedImageDto {
  /**
   * Temp image path
   * @type {string}
   * @memberof TempUploadedImageDto
   */
  imagePath: string;
  /**
   * Signed url to view image
   * @type {string}
   * @memberof TempUploadedImageDto
   */
  imageUrl: string;
  /**
   * Temp image path
   * @type {string}
   * @memberof TempUploadedImageDto
   */
  previewPath: string;
  /**
   * Signed url to view image
   * @type {string}
   * @memberof TempUploadedImageDto
   */
  previewUrl: string;
}
/**
 *
 * @export
 * @interface TranslatedString
 */
export interface TranslatedString {
  /**
   *
   * @type {string}
   * @memberof TranslatedString
   */
  en: string;
  /**
   *
   * @type {string}
   * @memberof TranslatedString
   */
  fr: string | null;
}
/**
 *
 * @export
 * @interface UnifiedUploadResponseDto
 */
export interface UnifiedUploadResponseDto {
  /**
   * Information about the processed file.
   * @type {UploadedFileDto}
   * @memberof UnifiedUploadResponseDto
   */
  file: UploadedFileDto;
  /**
   * OCR data, if requested and available for the context.
   * @type {ReceiptDataDto}
   * @memberof UnifiedUploadResponseDto
   */
  ocrData?: ReceiptDataDto;
}
/**
 *
 * @export
 * @interface UpdateAnnouncementDto
 */
export interface UpdateAnnouncementDto {
  /**
   *
   * @type {string}
   * @memberof UpdateAnnouncementDto
   */
  level?: UpdateAnnouncementDtoLevelEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateAnnouncementDto
   */
  message?: string;
}

export const UpdateAnnouncementDtoLevelEnum = {
  Info: 'INFO',
  Warning: 'WARNING',
  Critical: 'CRITICAL',
} as const;

export type UpdateAnnouncementDtoLevelEnum =
  (typeof UpdateAnnouncementDtoLevelEnum)[keyof typeof UpdateAnnouncementDtoLevelEnum];

/**
 *
 * @export
 * @interface UpdateAssetAnnouncementDto
 */
export interface UpdateAssetAnnouncementDto {
  /**
   *
   * @type {string}
   * @memberof UpdateAssetAnnouncementDto
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateAssetAnnouncementDto
   */
  level?: UpdateAssetAnnouncementDtoLevelEnum;
}

export const UpdateAssetAnnouncementDtoLevelEnum = {
  Info: 'INFO',
  Warning: 'WARNING',
  Critical: 'CRITICAL',
} as const;

export type UpdateAssetAnnouncementDtoLevelEnum =
  (typeof UpdateAssetAnnouncementDtoLevelEnum)[keyof typeof UpdateAssetAnnouncementDtoLevelEnum];

/**
 *
 * @export
 * @interface UpdateAssetDto
 */
export interface UpdateAssetDto {
  /**
   * The new name of the asset
   * @type {string}
   * @memberof UpdateAssetDto
   */
  name?: string;
  /**
   * Google Place ID for the address. Set to null to remove the address.
   * @type {string}
   * @memberof UpdateAssetDto
   */
  placeId?: string | null;
  /**
   * Temporary image path for the asset photo. Set to null to remove the photo. Must be a path from uploadTemporaryPhoto endpoint.
   * @type {string}
   * @memberof UpdateAssetDto
   */
  photoImagePath?: string | null;
  /**
   * Annual budget cap for the asset. Set to null to remove the budget cap.
   * @type {number}
   * @memberof UpdateAssetDto
   */
  annualBudgetCap?: number | null;
}
/**
 *
 * @export
 * @interface UpdateBankAccountDto
 */
export interface UpdateBankAccountDto {
  /**
   * The new name of the bank account.
   * @type {string}
   * @memberof UpdateBankAccountDto
   */
  name: string;
  /**
   * The name of the bank, e.g. \"Crédit Agricole\".
   * @type {string}
   * @memberof UpdateBankAccountDto
   */
  bankName?: string;
  /**
   * The bank logo domain key used by Brandfetch, e.g. \"credit-agricole.fr\".
   * @type {string}
   * @memberof UpdateBankAccountDto
   */
  bankDomain?: string;
  /**
   * Free text detail, e.g. \"Île-de-France\".
   * @type {string}
   * @memberof UpdateBankAccountDto
   */
  bankDetail?: string;
  /**
   * Beneficiary name printed on statements, e.g. \"Indivision Rochette\".
   * @type {string}
   * @memberof UpdateBankAccountDto
   */
  holderName?: string | null;
  /**
   * IBAN, spaces allowed (stored without them).
   * @type {string}
   * @memberof UpdateBankAccountDto
   */
  iban?: string | null;
  /**
   * BIC / SWIFT code.
   * @type {string}
   * @memberof UpdateBankAccountDto
   */
  bic?: string | null;
}
/**
 *
 * @export
 * @interface UpdateBedDto
 */
export interface UpdateBedDto {
  /**
   *
   * @type {string}
   * @memberof UpdateBedDto
   */
  type?: UpdateBedDtoTypeEnum;
  /**
   * Largeur en cm
   * @type {number}
   * @memberof UpdateBedDto
   */
  widthCm?: number;
  /**
   * Longueur en cm
   * @type {number}
   * @memberof UpdateBedDto
   */
  lengthCm?: number;
  /**
   * Libellé personnalisé
   * @type {string}
   * @memberof UpdateBedDto
   */
  label?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateBedDto
   */
  position?: number;
}

export const UpdateBedDtoTypeEnum = {
  Single: 'SINGLE',
  Double: 'DOUBLE',
  Queen: 'QUEEN',
  King: 'KING',
  Bunk: 'BUNK',
  SofaBed: 'SOFA_BED',
  Baby: 'BABY',
  Cot: 'COT',
} as const;

export type UpdateBedDtoTypeEnum = (typeof UpdateBedDtoTypeEnum)[keyof typeof UpdateBedDtoTypeEnum];

/**
 *
 * @export
 * @interface UpdateBudgetCapDto
 */
export interface UpdateBudgetCapDto {
  /**
   * Annual budget cap for the asset. Set to null to remove the budget cap.
   * @type {number}
   * @memberof UpdateBudgetCapDto
   */
  annualBudgetCap?: number | null;
}
/**
 *
 * @export
 * @interface UpdateBudgetLineDto
 */
export interface UpdateBudgetLineDto {
  /**
   *
   * @type {string}
   * @memberof UpdateBudgetLineDto
   */
  mainCategory?: UpdateBudgetLineDtoMainCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateBudgetLineDto
   */
  subCategory?: UpdateBudgetLineDtoSubCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof UpdateBudgetLineDto
   */
  subCategoryEntryId?: string | null;
  /**
   * Final budgeted amount, typed directly or via the « vs N−1 » %.
   * @type {number}
   * @memberof UpdateBudgetLineDto
   */
  amount?: number;
  /**
   * Reconciliation key.
   * @type {string}
   * @memberof UpdateBudgetLineDto
   */
  category?: UpdateBudgetLineDtoCategoryEnum | null;
  /**
   * 1 = yearly, 12 = monthly, 0.5 = biennial.
   * @type {number}
   * @memberof UpdateBudgetLineDto
   */
  frequencyPerYear?: number;
  /**
   * Multiply by the number of households.
   * @type {boolean}
   * @memberof UpdateBudgetLineDto
   */
  perHousehold?: boolean;
  /**
   * Actual N−1 amount. The % is derived from it.
   * @type {number}
   * @memberof UpdateBudgetLineDto
   */
  previousYearAmount?: number | null;
  /**
   * Précision libre sur la ligne. `null` efface la note.
   * @type {string}
   * @memberof UpdateBudgetLineDto
   */
  note?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateBudgetLineDto
   */
  sourceType?: UpdateBudgetLineDtoSourceTypeEnum;
  /**
   * Informative project reference, not a FK.
   * @type {string}
   * @memberof UpdateBudgetLineDto
   */
  sourceProjectId?: string | null;
}

export const UpdateBudgetLineDtoMainCategoryEnum = {
  FixedCosts: 'FIXED_COSTS',
  DailyLife: 'DAILY_LIFE',
  WorksEquipment: 'WORKS_EQUIPMENT',
  FundingCalls: 'FUNDING_CALLS',
  RentalHousing: 'RENTAL_HOUSING',
  EventsTourism: 'EVENTS_TOURISM',
  EstateLands: 'ESTATE_LANDS',
  Operating: 'OPERATING',
  Subsidies: 'SUBSIDIES',
  Reimbursements: 'REIMBURSEMENTS',
} as const;

export type UpdateBudgetLineDtoMainCategoryEnum =
  (typeof UpdateBudgetLineDtoMainCategoryEnum)[keyof typeof UpdateBudgetLineDtoMainCategoryEnum];
export const UpdateBudgetLineDtoSubCategoryEnum = {
  TaxesAndDuties: 'TAXES_AND_DUTIES',
  EnergyAndWater: 'ENERGY_AND_WATER',
  InsuranceAndAdmin: 'INSURANCE_AND_ADMIN',
  ContractsAndSubscriptions: 'CONTRACTS_AND_SUBSCRIPTIONS',
  CondoFees: 'CONDO_FEES',
  Groceries: 'GROCERIES',
  CleaningAndLaundry: 'CLEANING_AND_LAUNDRY',
  Consumables: 'CONSUMABLES',
  Leisure: 'LEISURE',
  Garden: 'GARDEN',
  MajorWorks: 'MAJOR_WORKS',
  Repairs: 'REPAIRS',
  FurnitureDecor: 'FURNITURE_DECOR',
  Equipment: 'EQUIPMENT',
  RegularTransfers: 'REGULAR_TRANSFERS',
  ExceptionalOperations: 'EXCEPTIONAL_OPERATIONS',
  OnlinePlatforms: 'ONLINE_PLATFORMS',
  DirectPrivateCircle: 'DIRECT_PRIVATE_CIRCLE',
  Privatization: 'PRIVATIZATION',
  PublicReception: 'PUBLIC_RECEPTION',
  LeasesAndRentals: 'LEASES_AND_RENTALS',
  DirectOperation: 'DIRECT_OPERATION',
  AdditionalActivities: 'ADDITIONAL_ACTIVITIES',
  PublicFunds: 'PUBLIC_FUNDS',
  PrivateFunds: 'PRIVATE_FUNDS',
  InternalTribe: 'INTERNAL_TRIBE',
  ExternalThirdParty: 'EXTERNAL_THIRD_PARTY',
} as const;

export type UpdateBudgetLineDtoSubCategoryEnum =
  (typeof UpdateBudgetLineDtoSubCategoryEnum)[keyof typeof UpdateBudgetLineDtoSubCategoryEnum];
export const UpdateBudgetLineDtoCategoryEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type UpdateBudgetLineDtoCategoryEnum =
  (typeof UpdateBudgetLineDtoCategoryEnum)[keyof typeof UpdateBudgetLineDtoCategoryEnum];
export const UpdateBudgetLineDtoSourceTypeEnum = {
  SuggestionPreviousYear: 'SUGGESTION_PREVIOUS_YEAR',
  Project: 'PROJECT',
  Manual: 'MANUAL',
} as const;

export type UpdateBudgetLineDtoSourceTypeEnum =
  (typeof UpdateBudgetLineDtoSourceTypeEnum)[keyof typeof UpdateBudgetLineDtoSourceTypeEnum];

/**
 *
 * @export
 * @interface UpdateBuildingDto
 */
export interface UpdateBuildingDto {
  /**
   * Nom du bâtiment
   * @type {string}
   * @memberof UpdateBuildingDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateBuildingDto
   */
  type?: UpdateBuildingDtoTypeEnum | null;
  /**
   * Position dans la liste (ordre)
   * @type {number}
   * @memberof UpdateBuildingDto
   */
  position?: number;
}

export const UpdateBuildingDtoTypeEnum = {
  MainHouse: 'MAIN_HOUSE',
  Apartment: 'APARTMENT',
  Annex: 'ANNEX',
  Garage: 'GARAGE',
  PoolHouse: 'POOL_HOUSE',
  Outbuilding: 'OUTBUILDING',
  Land: 'LAND',
  Other: 'OTHER',
} as const;

export type UpdateBuildingDtoTypeEnum =
  (typeof UpdateBuildingDtoTypeEnum)[keyof typeof UpdateBuildingDtoTypeEnum];

/**
 *
 * @export
 * @interface UpdateEventDto
 */
export interface UpdateEventDto {
  /**
   * Nom du de l\'événement
   * @type {string}
   * @memberof UpdateEventDto
   */
  name?: string;
  /**
   * Type d\'événement
   * @type {string}
   * @memberof UpdateEventDto
   */
  type?: string;
  /**
   * Date de début
   * @type {Dayjs}
   * @memberof UpdateEventDto
   */
  startTime?: Dayjs;
  /**
   * Date de fin
   * @type {Dayjs}
   * @memberof UpdateEventDto
   */
  endTime?: Dayjs;
  /**
   *
   * @type {boolean}
   * @memberof UpdateEventDto
   */
  isExclusiveOccupation?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateEventDto
   */
  description?: string;
  /**
   * Identifiant Google Places de l’adresse de l’événement. Envoyer null pour détacher l’adresse.
   * @type {string}
   * @memberof UpdateEventDto
   */
  placeId?: string | null;
  /**
   * Lien de visioconférence (Meet, Zoom, Teams, etc.). Envoyer une chaîne vide pour supprimer le lien.
   * @type {string}
   * @memberof UpdateEventDto
   */
  videoConferenceUrl?: string;
  /**
   * Règle de récurrence
   * @type {RecurrenceDto}
   * @memberof UpdateEventDto
   */
  recurrence?: RecurrenceDto | null;
  /**
   * Reminder duration in seconds before the event starts (e.g., 3600 for 1 hour)
   * @type {number}
   * @memberof UpdateEventDto
   */
  reminderDurationSeconds?: number;
  /**
   * List of participant user IDs. Replaces the existing list.
   * @type {Array<string>}
   * @memberof UpdateEventDto
   */
  participantIds?: Array<string>;
  /**
   * Households concerned by the event. Replaces the existing list; an empty array detaches them all, an absent key leaves them untouched. Takes precedence over `householdId`.
   * @type {Array<string>}
   * @memberof UpdateEventDto
   */
  householdIds?: Array<string>;
  /**
   * Deprecated: use `householdIds`. Identifier of a single household; null detaches all.
   * @type {string}
   * @memberof UpdateEventDto
   * @deprecated
   */
  householdId?: string | null;
  /**
   * Chambres occupées par ce séjour. Chaque chambre doit appartenir au même bien et porter un couchage. Un tableau vide détache toutes les chambres.
   * @type {Array<string>}
   * @memberof UpdateEventDto
   */
  roomIds?: Array<string>;
}
/**
 *
 * @export
 * @interface UpdateExpenseDto
 */
export interface UpdateExpenseDto {
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  merchant?: string;
  /**
   * Free-text note explaining the operation details.
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  note?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateExpenseDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  currency: UpdateExpenseDtoCurrencyEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  paidBy?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  paidByBankAccountId?: string;
  /**
   * ID of the contact (tiers) who paid.
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  paidByContactId?: string;
  /**
   * ID of the placeholder member (unregistered co-owner) who paid.
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  paidByPlaceholderMemberId?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof UpdateExpenseDto
   */
  paidAt: Dayjs;
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  splitType: UpdateExpenseDtoSplitTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  splitScope?: UpdateExpenseDtoSplitScopeEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  type: UpdateExpenseDtoTypeEnum;
  /**
   * An array of virtual file IDs to attach to the expense.
   * @type {Array<string>}
   * @memberof UpdateExpenseDto
   */
  attachmentIds?: Array<string>;
  /**
   * ID of the bank account to reimburse (intermediary). If null, reimburses the payer.
   * @type {string}
   * @memberof UpdateExpenseDto
   */
  reimburseToBankAccount?: string;
  /**
   * Per-user shares. Required when splitScope is INDIVIDUAL (default).
   * @type {Array<CreateExpenseShareDto>}
   * @memberof UpdateExpenseDto
   */
  shares?: Array<CreateExpenseShareDto>;
  /**
   * Per-household shares. Required when splitScope is HOUSEHOLD.
   * @type {Array<CreateHouseholdShareDto>}
   * @memberof UpdateExpenseDto
   */
  householdShares?: Array<CreateHouseholdShareDto>;
  /**
   *
   * @type {RecurrenceDto}
   * @memberof UpdateExpenseDto
   */
  recurrence?: RecurrenceDto;
  /**
   * Share (0-100) of this expense attributable to rental use, for tax-deductible charges (régime réel).
   * @type {number}
   * @memberof UpdateExpenseDto
   */
  locativeShare?: number;
}

export const UpdateExpenseDtoCurrencyEnum = {
  Eur: 'EUR',
} as const;

export type UpdateExpenseDtoCurrencyEnum =
  (typeof UpdateExpenseDtoCurrencyEnum)[keyof typeof UpdateExpenseDtoCurrencyEnum];
export const UpdateExpenseDtoSplitTypeEnum = {
  Equal: 'EQUAL',
  Amount: 'AMOUNT',
  Percentage: 'PERCENTAGE',
  Prorata: 'PRORATA',
} as const;

export type UpdateExpenseDtoSplitTypeEnum =
  (typeof UpdateExpenseDtoSplitTypeEnum)[keyof typeof UpdateExpenseDtoSplitTypeEnum];
export const UpdateExpenseDtoSplitScopeEnum = {
  Individual: 'INDIVIDUAL',
  Household: 'HOUSEHOLD',
} as const;

export type UpdateExpenseDtoSplitScopeEnum =
  (typeof UpdateExpenseDtoSplitScopeEnum)[keyof typeof UpdateExpenseDtoSplitScopeEnum];
export const UpdateExpenseDtoTypeEnum = {
  HousingTax: 'HOUSING_TAX',
  PropertyTax: 'PROPERTY_TAX',
  WasteCollectionTax: 'WASTE_COLLECTION_TAX',
  OtherTax: 'OTHER_TAX',
  Electricity: 'ELECTRICITY',
  Water: 'WATER',
  Gas: 'GAS',
  HeatingOil: 'HEATING_OIL',
  Wood: 'WOOD',
  WoodPellets: 'WOOD_PELLETS',
  OtherEnergy: 'OTHER_ENERGY',
  HomeInsurance: 'HOME_INSURANCE',
  OtherInsurance: 'OTHER_INSURANCE',
  BankFees: 'BANK_FEES',
  LegalProtection: 'LEGAL_PROTECTION',
  ManagementTravel: 'MANAGEMENT_TRAVEL',
  OtherInsuranceAndAdmin: 'OTHER_INSURANCE_AND_ADMIN',
  InternetAndPhone: 'INTERNET_AND_PHONE',
  Tv: 'TV',
  Alarm: 'ALARM',
  BoilerMaintenance: 'BOILER_MAINTENANCE',
  ChimneySweeping: 'CHIMNEY_SWEEPING',
  GardenMaintenance: 'GARDEN_MAINTENANCE',
  PoolMaintenance: 'POOL_MAINTENANCE',
  TennisMaintenance: 'TENNIS_MAINTENANCE',
  OtherContract: 'OTHER_CONTRACT',
  SyndicFundCalls: 'SYNDIC_FUND_CALLS',
  CommonAreasMaintenance: 'COMMON_AREAS_MAINTENANCE',
  OtherCondoCharges: 'OTHER_CONDO_CHARGES',
  Supermarket: 'SUPERMARKET',
  Market: 'MARKET',
  Catering: 'CATERING',
  Beverages: 'BEVERAGES',
  GroceriesCleaningProducts: 'GROCERIES_CLEANING_PRODUCTS',
  HouseFund: 'HOUSE_FUND',
  OtherGroceries: 'OTHER_GROCERIES',
  HouseholdCleaningProducts: 'HOUSEHOLD_CLEANING_PRODUCTS',
  DryCleaning: 'DRY_CLEANING',
  Laundry: 'LAUNDRY',
  CleaningLady: 'CLEANING_LADY',
  OtherCleaningLaundry: 'OTHER_CLEANING_LAUNDRY',
  LightBulbsBatteries: 'LIGHT_BULBS_BATTERIES',
  ToiletPaper: 'TOILET_PAPER',
  BbqCharcoal: 'BBQ_CHARCOAL',
  LawnMowerFuel: 'LAWN_MOWER_FUEL',
  OtherConsumables: 'OTHER_CONSUMABLES',
  BoardGames: 'BOARD_GAMES',
  Bikes: 'BIKES',
  RacketsAndBalls: 'RACKETS_AND_BALLS',
  OtherLeisure: 'OTHER_LEISURE',
  Plants: 'PLANTS',
  OccasionalGardener: 'OCCASIONAL_GARDENER',
  FertilizersHerbicides: 'FERTILIZERS_HERBICIDES',
  GardenToolsDaily: 'GARDEN_TOOLS_DAILY',
  OtherGarden: 'OTHER_GARDEN',
  Roofing: 'ROOFING',
  FacadeRenovation: 'FACADE_RENOVATION',
  Insulation: 'INSULATION',
  DoorsWindows: 'DOORS_WINDOWS',
  Woodwork: 'WOODWORK',
  Masonry: 'MASONRY',
  PlumbingNetwork: 'PLUMBING_NETWORK',
  ElectricalNetwork: 'ELECTRICAL_NETWORK',
  HeatingAndAc: 'HEATING_AND_AC',
  Earthwork: 'EARTHWORK',
  Sanitation: 'SANITATION',
  Landscaping: 'LANDSCAPING',
  PoolLiner: 'POOL_LINER',
  PoolFiltration: 'POOL_FILTRATION',
  TennisSurface: 'TENNIS_SURFACE',
  OtherMajorWorks: 'OTHER_MAJOR_WORKS',
  PlumberRepair: 'PLUMBER_REPAIR',
  ElectricianRepair: 'ELECTRICIAN_REPAIR',
  Locksmith: 'LOCKSMITH',
  GardenerRepair: 'GARDENER_REPAIR',
  PoolTechnician: 'POOL_TECHNICIAN',
  Mechanic: 'MECHANIC',
  OtherRepair: 'OTHER_REPAIR',
  SofasBeds: 'SOFAS_BEDS',
  Appliances: 'APPLIANCES',
  Dishware: 'DISHWARE',
  Decoration: 'DECORATION',
  Linens: 'LINENS',
  TvHifi: 'TV_HIFI',
  GardenToolsEquipment: 'GARDEN_TOOLS_EQUIPMENT',
  HouseTools: 'HOUSE_TOOLS',
  MonthlyTransfer: 'MONTHLY_TRANSFER',
  QuarterlyTransfer: 'QUARTERLY_TRANSFER',
  SemiAnnualTransfer: 'SEMI_ANNUAL_TRANSFER',
  AnnualTransfer: 'ANNUAL_TRANSFER',
  PeriodEndAdjustment: 'PERIOD_END_ADJUSTMENT',
  ExceptionalWorkContribution: 'EXCEPTIONAL_WORK_CONTRIBUTION',
  AccountReplenishment: 'ACCOUNT_REPLENISHMENT',
  OtherFundCall: 'OTHER_FUND_CALL',
  AirbnbAgency: 'AIRBNB_AGENCY',
  AirbnbDirect: 'AIRBNB_DIRECT',
  Booking: 'BOOKING',
  GensDeConfiance: 'GENS_DE_CONFIANCE',
  OtherOnlineRental: 'OTHER_ONLINE_RENTAL',
  BedAndBreakfast: 'BED_AND_BREAKFAST',
  FriendsAcquaintances: 'FRIENDS_ACQUAINTANCES',
  InternalFamilyRent: 'INTERNAL_FAMILY_RENT',
  WeddingsReceptions: 'WEDDINGS_RECEPTIONS',
  SeminarRental: 'SEMINAR_RENTAL',
  CinemaPhotoRental: 'CINEMA_PHOTO_RENTAL',
  VisitsTicketing: 'VISITS_TICKETING',
  ShopSouvenirs: 'SHOP_SOUVENIRS',
  HuntingLease: 'HUNTING_LEASE',
  FishingLease: 'FISHING_LEASE',
  AgriculturalLease: 'AGRICULTURAL_LEASE',
  HayGrainSale: 'HAY_GRAIN_SALE',
  WoodSale: 'WOOD_SALE',
  WinterStorage: 'WINTER_STORAGE',
  ElectricityResale: 'ELECTRICITY_RESALE',
  AnahRenovAid: 'ANAH_RENOV_AID',
  DracSubsidy: 'DRAC_SUBSIDY',
  PatronageCrowdfunding: 'PATRONAGE_CROWDFUNDING',
  TribeFeesSharing: 'TRIBE_FEES_SHARING',
  InsuranceClaimReimbursement: 'INSURANCE_CLAIM_REIMBURSEMENT',
  TaxOverpayment: 'TAX_OVERPAYMENT',
  OtherReimbursement: 'OTHER_REIMBURSEMENT',
} as const;

export type UpdateExpenseDtoTypeEnum =
  (typeof UpdateExpenseDtoTypeEnum)[keyof typeof UpdateExpenseDtoTypeEnum];

/**
 *
 * @export
 * @interface UpdateExpenseSubCategoryDto
 */
export interface UpdateExpenseSubCategoryDto {
  /**
   *
   * @type {string}
   * @memberof UpdateExpenseSubCategoryDto
   */
  label?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateExpenseSubCategoryDto
   */
  position?: number;
}
/**
 *
 * @export
 * @interface UpdateFavoriteDto
 */
export interface UpdateFavoriteDto {
  /**
   * The new favorite status for the contact.
   * @type {boolean}
   * @memberof UpdateFavoriteDto
   */
  isFavorite: boolean;
}
/**
 *
 * @export
 * @interface UpdateFloorDto
 */
export interface UpdateFloorDto {
  /**
   * Nom du niveau
   * @type {string}
   * @memberof UpdateFloorDto
   */
  name?: string;
  /**
   * Numéro de niveau (0 = rdc, 1 = 1er étage, -1 = sous-sol)
   * @type {number}
   * @memberof UpdateFloorDto
   */
  level?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateFloorDto
   */
  position?: number;
}
/**
 *
 * @export
 * @interface UpdateFundCallDto
 */
export interface UpdateFundCallDto {
  /**
   *
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  type?: UpdateFundCallDtoTypeEnum;
  /**
   * `ALL` (défaut) = état des comptes du gestionnaire. `SELF` = relevé qu’un membre émet sur sa propre position, ouvert à tout membre.
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  scope?: UpdateFundCallDtoScopeEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  periodLabel?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  fraction?: UpdateFundCallDtoFractionEnum;
  /**
   * Ajouter le solde courant à la quote-part appelée.
   * @type {boolean}
   * @memberof UpdateFundCallDto
   */
  includeCurrentBalance?: boolean;
  /**
   * Joindre l’état des comptes de tous les membres au relevé individuel. Défaut : le choix du dernier appel du bien, sinon non.
   * @type {boolean}
   * @memberof UpdateFundCallDto
   */
  includeStatement?: boolean;
  /**
   * Échéance de règlement. Défaut : J+30.
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  dueDate?: string;
  /**
   * Date du prochain état. Défaut : échéance + 10 jours.
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  nextStatementDate?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateFundCallDto
   */
  message?: string;
  /**
   *
   * @type {Array<UpdateFundCallLineDto>}
   * @memberof UpdateFundCallDto
   */
  lines?: Array<UpdateFundCallLineDto>;
}

export const UpdateFundCallDtoTypeEnum = {
  Statement: 'STATEMENT',
  FundCall: 'FUND_CALL',
} as const;

export type UpdateFundCallDtoTypeEnum =
  (typeof UpdateFundCallDtoTypeEnum)[keyof typeof UpdateFundCallDtoTypeEnum];
export const UpdateFundCallDtoScopeEnum = {
  Self: 'SELF',
  All: 'ALL',
} as const;

export type UpdateFundCallDtoScopeEnum =
  (typeof UpdateFundCallDtoScopeEnum)[keyof typeof UpdateFundCallDtoScopeEnum];
export const UpdateFundCallDtoFractionEnum = {
  Year: 'YEAR',
  Half: 'HALF',
  Quarter: 'QUARTER',
  Month: 'MONTH',
} as const;

export type UpdateFundCallDtoFractionEnum =
  (typeof UpdateFundCallDtoFractionEnum)[keyof typeof UpdateFundCallDtoFractionEnum];

/**
 *
 * @export
 * @interface UpdateFundCallLineDto
 */
export interface UpdateFundCallLineDto {
  /**
   *
   * @type {string}
   * @memberof UpdateFundCallLineDto
   */
  id?: string;
  /**
   * Montant appelé, modifiable tant que l’appel est DRAFT.
   * @type {number}
   * @memberof UpdateFundCallLineDto
   */
  amountCalled?: number;
  /**
   * Écarter ce propriétaire de l’appel.
   * @type {boolean}
   * @memberof UpdateFundCallLineDto
   */
  excluded?: boolean;
}
/**
 *
 * @export
 * @interface UpdateGovernanceDto
 */
export interface UpdateGovernanceDto {
  /**
   *
   * @type {string}
   * @memberof UpdateGovernanceDto
   */
  legalStructure: UpdateGovernanceDtoLegalStructureEnum | null;
  /**
   *
   * @type {string}
   * @memberof UpdateGovernanceDto
   */
  taxRegime?: UpdateGovernanceDtoTaxRegimeEnum | null;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateGovernanceDto
   */
  specialStatuses?: Array<UpdateGovernanceDtoSpecialStatusesEnum> | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateGovernanceDto
   */
  hasDismemberment?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateGovernanceDto
   */
  shareType?: UpdateGovernanceDtoShareTypeEnum | null;
  /**
   *
   * @type {number}
   * @memberof UpdateGovernanceDto
   */
  totalShares?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpdateGovernanceDto
   */
  managementMode?: UpdateGovernanceDtoManagementModeEnum | null;
  /**
   *
   * @type {string}
   * @memberof UpdateGovernanceDto
   */
  syndicLibreType?: UpdateGovernanceDtoSyndicLibreTypeEnum | null;
  /**
   *
   * @type {string}
   * @memberof UpdateGovernanceDto
   */
  rentalDeclarationRegime?: UpdateGovernanceDtoRentalDeclarationRegimeEnum | null;
  /**
   *
   * @type {number}
   * @memberof UpdateGovernanceDto
   */
  defaultLocativeShare?: number | null;
}

export const UpdateGovernanceDtoLegalStructureEnum = {
  FullOwnership: 'FULL_OWNERSHIP',
  Indivision: 'INDIVISION',
  Sci: 'SCI',
  SarlFamille: 'SARL_FAMILLE',
} as const;

export type UpdateGovernanceDtoLegalStructureEnum =
  (typeof UpdateGovernanceDtoLegalStructureEnum)[keyof typeof UpdateGovernanceDtoLegalStructureEnum];
export const UpdateGovernanceDtoTaxRegimeEnum = {
  Ir: 'IR',
  Is: 'IS',
} as const;

export type UpdateGovernanceDtoTaxRegimeEnum =
  (typeof UpdateGovernanceDtoTaxRegimeEnum)[keyof typeof UpdateGovernanceDtoTaxRegimeEnum];
export const UpdateGovernanceDtoSpecialStatusesEnum = {
  Lmnp: 'LMNP',
  MonumentHistorique: 'MONUMENT_HISTORIQUE',
} as const;

export type UpdateGovernanceDtoSpecialStatusesEnum =
  (typeof UpdateGovernanceDtoSpecialStatusesEnum)[keyof typeof UpdateGovernanceDtoSpecialStatusesEnum];
export const UpdateGovernanceDtoShareTypeEnum = {
  Percentage: 'PERCENTAGE',
  Tantiemes: 'TANTIEMES',
  PartsSociales: 'PARTS_SOCIALES',
} as const;

export type UpdateGovernanceDtoShareTypeEnum =
  (typeof UpdateGovernanceDtoShareTypeEnum)[keyof typeof UpdateGovernanceDtoShareTypeEnum];
export const UpdateGovernanceDtoManagementModeEnum = {
  SyndicPro: 'SYNDIC_PRO',
  SyndicLibre: 'SYNDIC_LIBRE',
  NoCopro: 'NO_COPRO',
  Unknown: 'UNKNOWN',
} as const;

export type UpdateGovernanceDtoManagementModeEnum =
  (typeof UpdateGovernanceDtoManagementModeEnum)[keyof typeof UpdateGovernanceDtoManagementModeEnum];
export const UpdateGovernanceDtoSyndicLibreTypeEnum = {
  Benevole: 'BENEVOLE',
  Cooperatif: 'COOPERATIF',
  Unknown: 'UNKNOWN',
} as const;

export type UpdateGovernanceDtoSyndicLibreTypeEnum =
  (typeof UpdateGovernanceDtoSyndicLibreTypeEnum)[keyof typeof UpdateGovernanceDtoSyndicLibreTypeEnum];
export const UpdateGovernanceDtoRentalDeclarationRegimeEnum = {
  Reel: 'REEL',
  MicroFoncier: 'MICRO_FONCIER',
} as const;

export type UpdateGovernanceDtoRentalDeclarationRegimeEnum =
  (typeof UpdateGovernanceDtoRentalDeclarationRegimeEnum)[keyof typeof UpdateGovernanceDtoRentalDeclarationRegimeEnum];

/**
 *
 * @export
 * @interface UpdateHouseholdDto
 */
export interface UpdateHouseholdDto {
  /**
   *
   * @type {string}
   * @memberof UpdateHouseholdDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateHouseholdDto
   */
  color?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateHouseholdDto
   */
  costBearerMode?: UpdateHouseholdDtoCostBearerModeEnum;
  /**
   * AssetMember id of the household representative (head).
   * @type {string}
   * @memberof UpdateHouseholdDto
   */
  headMemberId?: string;
  /**
   * AssetMember ids to attach to this household at creation.
   * @type {Array<string>}
   * @memberof UpdateHouseholdDto
   */
  memberIds?: Array<string>;
}

export const UpdateHouseholdDtoCostBearerModeEnum = {
  Representative: 'REPRESENTATIVE',
  OwnersSplit: 'OWNERS_SPLIT',
} as const;

export type UpdateHouseholdDtoCostBearerModeEnum =
  (typeof UpdateHouseholdDtoCostBearerModeEnum)[keyof typeof UpdateHouseholdDtoCostBearerModeEnum];

/**
 *
 * @export
 * @interface UpdateInitialBalanceDto
 */
export interface UpdateInitialBalanceDto {
  /**
   *
   * @type {number}
   * @memberof UpdateInitialBalanceDto
   */
  amount: number;
  /**
   *
   * @type {string}
   * @memberof UpdateInitialBalanceDto
   */
  label?: string;
  /**
   * Mandatory justification, kept in the append-only audit trail.
   * @type {string}
   * @memberof UpdateInitialBalanceDto
   */
  reason: string;
}
/**
 *
 * @export
 * @interface UpdateInventoryItemDto
 */
export interface UpdateInventoryItemDto {
  /**
   *
   * @type {string}
   * @memberof UpdateInventoryItemDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateInventoryItemDto
   */
  roomId?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateInventoryItemDto
   */
  brandAndModel?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateInventoryItemDto
   */
  condition?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateInventoryItemDto
   */
  notes?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpdateInventoryItemDto
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateInventoryItemDto
   */
  purchaseYear?: number | null;
  /**
   * Prix payé pour le lot. Ignoré si le membre n’est pas gestionnaire.
   * @type {number}
   * @memberof UpdateInventoryItemDto
   */
  purchasePrice?: number | null;
  /**
   * Valeur à neuf du lot. Ignorée si le membre n’est pas gestionnaire.
   * @type {number}
   * @memberof UpdateInventoryItemDto
   */
  replacementValue?: number | null;
  /**
   *
   * @type {InventoryValueSource}
   * @memberof UpdateInventoryItemDto
   */
  replacementValueSource?: InventoryValueSource | null;
  /**
   *
   * @type {string}
   * @memberof UpdateInventoryItemDto
   */
  replacementValueSourceLabel?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateInventoryItemDto
   */
  replacementValueSourceUrl?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateInventoryItemDto
   */
  depreciationEnabled?: boolean;
  /**
   * Photos téléversées via la route de fichiers du mur (1 à 5)
   * @type {Array<string>}
   * @memberof UpdateInventoryItemDto
   */
  photoIds?: Array<string>;
  /**
   * Factures rangées dans Documents
   * @type {Array<string>}
   * @memberof UpdateInventoryItemDto
   */
  invoiceFileIds?: Array<string>;
}

/**
 *
 * @export
 * @interface UpdateInventorySettingsDto
 */
export interface UpdateInventorySettingsDto {
  /**
   * Usure par an, en %
   * @type {number}
   * @memberof UpdateInventorySettingsDto
   */
  depreciationRatePercent: number;
  /**
   * Usure maximale, en %
   * @type {number}
   * @memberof UpdateInventorySettingsDto
   */
  depreciationMaxPercent: number;
}
/**
 *
 * @export
 * @interface UpdateMemberGovernanceDto
 */
export interface UpdateMemberGovernanceDto {
  /**
   *
   * @type {string}
   * @memberof UpdateMemberGovernanceDto
   */
  operationalRole?: UpdateMemberGovernanceDtoOperationalRoleEnum | null;
  /**
   *
   * @type {number}
   * @memberof UpdateMemberGovernanceDto
   */
  shares?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberGovernanceDto
   */
  ownershipNature?: UpdateMemberGovernanceDtoOwnershipNatureEnum | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateMemberGovernanceDto
   */
  isMandate?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateMemberGovernanceDto
   */
  hasVotingRights?: boolean | null;
}

export const UpdateMemberGovernanceDtoOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type UpdateMemberGovernanceDtoOperationalRoleEnum =
  (typeof UpdateMemberGovernanceDtoOperationalRoleEnum)[keyof typeof UpdateMemberGovernanceDtoOperationalRoleEnum];
export const UpdateMemberGovernanceDtoOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type UpdateMemberGovernanceDtoOwnershipNatureEnum =
  (typeof UpdateMemberGovernanceDtoOwnershipNatureEnum)[keyof typeof UpdateMemberGovernanceDtoOwnershipNatureEnum];

/**
 *
 * @export
 * @interface UpdateMemberPermissionsDto
 */
export interface UpdateMemberPermissionsDto {
  /**
   * Array of permission entries to update. Only specified subjects will be updated.
   * @type {Array<PermissionEntry>}
   * @memberof UpdateMemberPermissionsDto
   */
  permissions?: Array<PermissionEntry>;
  /**
   * Apply a preset instead of individual permissions. This will override all permissions.
   * @type {string}
   * @memberof UpdateMemberPermissionsDto
   */
  preset?: UpdateMemberPermissionsDtoPresetEnum;
}

export const UpdateMemberPermissionsDtoPresetEnum = {
  Viewer: 'viewer',
  Contributor: 'contributor',
  Manager: 'manager',
} as const;

export type UpdateMemberPermissionsDtoPresetEnum =
  (typeof UpdateMemberPermissionsDtoPresetEnum)[keyof typeof UpdateMemberPermissionsDtoPresetEnum];

/**
 *
 * @export
 * @interface UpdateMemberReminderDto
 */
export interface UpdateMemberReminderDto {
  /**
   *
   * @type {string}
   * @memberof UpdateMemberReminderDto
   */
  tone?: UpdateMemberReminderDtoToneEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberReminderDto
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberReminderDto
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberReminderDto
   */
  scheduledAt?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberReminderDto
   */
  recurrence?: UpdateMemberReminderDtoRecurrenceEnum;
  /**
   *
   * @type {MemberReminderChannelsDto}
   * @memberof UpdateMemberReminderDto
   */
  channels?: MemberReminderChannelsDto;
}

export const UpdateMemberReminderDtoToneEnum = {
  Amical: 'AMICAL',
  Neutre: 'NEUTRE',
  Ferme: 'FERME',
} as const;

export type UpdateMemberReminderDtoToneEnum =
  (typeof UpdateMemberReminderDtoToneEnum)[keyof typeof UpdateMemberReminderDtoToneEnum];
export const UpdateMemberReminderDtoRecurrenceEnum = {
  Monthly: 'MONTHLY',
  Quarterly: 'QUARTERLY',
} as const;

export type UpdateMemberReminderDtoRecurrenceEnum =
  (typeof UpdateMemberReminderDtoRecurrenceEnum)[keyof typeof UpdateMemberReminderDtoRecurrenceEnum];

/**
 *
 * @export
 * @interface UpdateMemberRoleDto
 */
export interface UpdateMemberRoleDto {
  /**
   *
   * @type {string}
   * @memberof UpdateMemberRoleDto
   */
  role: UpdateMemberRoleDtoRoleEnum;
}

export const UpdateMemberRoleDtoRoleEnum = {
  Manager: 'manager',
  Member: 'member',
  Viewer: 'viewer',
} as const;

export type UpdateMemberRoleDtoRoleEnum =
  (typeof UpdateMemberRoleDtoRoleEnum)[keyof typeof UpdateMemberRoleDtoRoleEnum];

/**
 *
 * @export
 * @interface UpdateMemoryDto
 */
export interface UpdateMemoryDto {
  /**
   *
   * @type {string}
   * @memberof UpdateMemoryDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMemoryDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMemoryDto
   */
  memoryKind?: UpdateMemoryDtoMemoryKindEnum | null;
  /**
   * Normalised by the server according to the precision
   * @type {string}
   * @memberof UpdateMemoryDto
   */
  takenAt?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMemoryDto
   */
  takenAtPrecision?: UpdateMemoryDtoTakenAtPrecisionEnum;
  /**
   *
   * @type {boolean}
   * @memberof UpdateMemoryDto
   */
  takenAtApproximate?: boolean;
  /**
   * Photos uploaded via the feed item file route
   * @type {Array<string>}
   * @memberof UpdateMemoryDto
   */
  fileIds?: Array<string>;
  /**
   * Rooms of the asset, stored as links
   * @type {Array<string>}
   * @memberof UpdateMemoryDto
   */
  roomIds?: Array<string>;
  /**
   *
   * @type {Array<MemoryPersonInputDto>}
   * @memberof UpdateMemoryDto
   */
  people?: Array<MemoryPersonInputDto>;
  /**
   *
   * @type {string}
   * @memberof UpdateMemoryDto
   */
  place?: string;
}

export const UpdateMemoryDtoMemoryKindEnum = {
  Family: 'FAMILY',
  Celebration: 'CELEBRATION',
  House: 'HOUSE',
  Works: 'WORKS',
  InMemory: 'IN_MEMORY',
} as const;

export type UpdateMemoryDtoMemoryKindEnum =
  (typeof UpdateMemoryDtoMemoryKindEnum)[keyof typeof UpdateMemoryDtoMemoryKindEnum];
export const UpdateMemoryDtoTakenAtPrecisionEnum = {
  Day: 'DAY',
  Month: 'MONTH',
  Season: 'SEASON',
  Year: 'YEAR',
  Decade: 'DECADE',
} as const;

export type UpdateMemoryDtoTakenAtPrecisionEnum =
  (typeof UpdateMemoryDtoTakenAtPrecisionEnum)[keyof typeof UpdateMemoryDtoTakenAtPrecisionEnum];

/**
 *
 * @export
 * @interface UpdateMoneyTransferDto
 */
export interface UpdateMoneyTransferDto {
  /**
   *
   * @type {number}
   * @memberof UpdateMoneyTransferDto
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateMoneyTransferDto
   */
  date?: string;
  /**
   * Liste complète des dépenses réglées par ce remboursement. Un tableau vide les détache toutes et redevient un transfert libre.
   * @type {Array<string>}
   * @memberof UpdateMoneyTransferDto
   */
  expenseIds?: Array<string>;
}
/**
 *
 * @export
 * @interface UpdateNotificationPreferencesDto
 */
export interface UpdateNotificationPreferencesDto {
  /**
   *
   * @type {string}
   * @memberof UpdateNotificationPreferencesDto
   */
  expenseNotificationPreference?: UpdateNotificationPreferencesDtoExpenseNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateNotificationPreferencesDto
   */
  eventNotificationPreference?: UpdateNotificationPreferencesDtoEventNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateNotificationPreferencesDto
   */
  postNotificationPreference?: UpdateNotificationPreferencesDtoPostNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateNotificationPreferencesDto
   */
  commentNotificationPreference?: UpdateNotificationPreferencesDtoCommentNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateNotificationPreferencesDto
   */
  practicalInformationNotificationPreference?: UpdateNotificationPreferencesDtoPracticalInformationNotificationPreferenceEnum;
}

export const UpdateNotificationPreferencesDtoExpenseNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UpdateNotificationPreferencesDtoExpenseNotificationPreferenceEnum =
  (typeof UpdateNotificationPreferencesDtoExpenseNotificationPreferenceEnum)[keyof typeof UpdateNotificationPreferencesDtoExpenseNotificationPreferenceEnum];
export const UpdateNotificationPreferencesDtoEventNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UpdateNotificationPreferencesDtoEventNotificationPreferenceEnum =
  (typeof UpdateNotificationPreferencesDtoEventNotificationPreferenceEnum)[keyof typeof UpdateNotificationPreferencesDtoEventNotificationPreferenceEnum];
export const UpdateNotificationPreferencesDtoPostNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UpdateNotificationPreferencesDtoPostNotificationPreferenceEnum =
  (typeof UpdateNotificationPreferencesDtoPostNotificationPreferenceEnum)[keyof typeof UpdateNotificationPreferencesDtoPostNotificationPreferenceEnum];
export const UpdateNotificationPreferencesDtoCommentNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UpdateNotificationPreferencesDtoCommentNotificationPreferenceEnum =
  (typeof UpdateNotificationPreferencesDtoCommentNotificationPreferenceEnum)[keyof typeof UpdateNotificationPreferencesDtoCommentNotificationPreferenceEnum];
export const UpdateNotificationPreferencesDtoPracticalInformationNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UpdateNotificationPreferencesDtoPracticalInformationNotificationPreferenceEnum =
  (typeof UpdateNotificationPreferencesDtoPracticalInformationNotificationPreferenceEnum)[keyof typeof UpdateNotificationPreferencesDtoPracticalInformationNotificationPreferenceEnum];

/**
 *
 * @export
 * @interface UpdateOwnerGovernanceDto
 */
export interface UpdateOwnerGovernanceDto {
  /**
   *
   * @type {string}
   * @memberof UpdateOwnerGovernanceDto
   */
  ownerOperationalRole?: UpdateOwnerGovernanceDtoOwnerOperationalRoleEnum | null;
  /**
   *
   * @type {number}
   * @memberof UpdateOwnerGovernanceDto
   */
  ownerShares?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpdateOwnerGovernanceDto
   */
  ownerOwnershipNature?: UpdateOwnerGovernanceDtoOwnerOwnershipNatureEnum | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateOwnerGovernanceDto
   */
  ownerHasVotingRights?: boolean | null;
}

export const UpdateOwnerGovernanceDtoOwnerOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type UpdateOwnerGovernanceDtoOwnerOperationalRoleEnum =
  (typeof UpdateOwnerGovernanceDtoOwnerOperationalRoleEnum)[keyof typeof UpdateOwnerGovernanceDtoOwnerOperationalRoleEnum];
export const UpdateOwnerGovernanceDtoOwnerOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type UpdateOwnerGovernanceDtoOwnerOwnershipNatureEnum =
  (typeof UpdateOwnerGovernanceDtoOwnerOwnershipNatureEnum)[keyof typeof UpdateOwnerGovernanceDtoOwnerOwnershipNatureEnum];

/**
 *
 * @export
 * @interface UpdatePasswordDto
 */
export interface UpdatePasswordDto {
  /**
   *
   * @type {string}
   * @memberof UpdatePasswordDto
   */
  password: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePasswordDto
   */
  token: string;
}
/**
 *
 * @export
 * @interface UpdatePlaceholderMemberDto
 */
export interface UpdatePlaceholderMemberDto {
  /**
   *
   * @type {string}
   * @memberof UpdatePlaceholderMemberDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePlaceholderMemberDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePlaceholderMemberDto
   */
  estimatedEmail?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePlaceholderMemberDto
   */
  operationalRole?: UpdatePlaceholderMemberDtoOperationalRoleEnum;
  /**
   *
   * @type {number}
   * @memberof UpdatePlaceholderMemberDto
   */
  shares?: number;
  /**
   *
   * @type {string}
   * @memberof UpdatePlaceholderMemberDto
   */
  ownershipNature?: UpdatePlaceholderMemberDtoOwnershipNatureEnum;
  /**
   * Household id to attach this placeholder to.
   * @type {string}
   * @memberof UpdatePlaceholderMemberDto
   */
  householdId?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdatePlaceholderMemberDto
   */
  isMandate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpdatePlaceholderMemberDto
   */
  hasVotingRights?: boolean;
}

export const UpdatePlaceholderMemberDtoOperationalRoleEnum = {
  Gestionnaire: 'GESTIONNAIRE',
  Proprietaire: 'PROPRIETAIRE',
  Visiteur: 'VISITEUR',
} as const;

export type UpdatePlaceholderMemberDtoOperationalRoleEnum =
  (typeof UpdatePlaceholderMemberDtoOperationalRoleEnum)[keyof typeof UpdatePlaceholderMemberDtoOperationalRoleEnum];
export const UpdatePlaceholderMemberDtoOwnershipNatureEnum = {
  PleinePropriete: 'PLEINE_PROPRIETE',
  Usufruit: 'USUFRUIT',
  NuePropriete: 'NUE_PROPRIETE',
} as const;

export type UpdatePlaceholderMemberDtoOwnershipNatureEnum =
  (typeof UpdatePlaceholderMemberDtoOwnershipNatureEnum)[keyof typeof UpdatePlaceholderMemberDtoOwnershipNatureEnum];

/**
 *
 * @export
 * @interface UpdateProjectDto
 */
export interface UpdateProjectDto {
  /**
   *
   * @type {string}
   * @memberof UpdateProjectDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateProjectDto
   */
  status?: UpdateProjectDtoStatusEnum;
  /**
   *
   * @type {Dayjs}
   * @memberof UpdateProjectDto
   */
  deadline?: Dayjs;
  /**
   *
   * @type {number}
   * @memberof UpdateProjectDto
   */
  estimatedDuration?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateProjectDto
   */
  estimatedDurationUnit?: UpdateProjectDtoEstimatedDurationUnitEnum;
  /**
   *
   * @type {number}
   * @memberof UpdateProjectDto
   */
  estimatedCost?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateProjectDto
   */
  description?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof UpdateProjectDto
   */
  completionDate?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof UpdateProjectDto
   */
  label?: UpdateProjectDtoLabelEnum | null;
  /**
   *
   * @type {string}
   * @memberof UpdateProjectDto
   */
  priority?: UpdateProjectDtoPriorityEnum | null;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateProjectDto
   */
  memberIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateProjectDto
   */
  participantIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateProjectDto
   */
  attachmentIds?: Array<string>;
}

export const UpdateProjectDtoStatusEnum = {
  IdeaBox: 'IDEA_BOX',
  IdeaToVote: 'IDEA_TO_VOTE',
  ProjectValidated: 'PROJECT_VALIDATED',
  ProjectInProgress: 'PROJECT_IN_PROGRESS',
  ProjectCompleted: 'PROJECT_COMPLETED',
} as const;

export type UpdateProjectDtoStatusEnum =
  (typeof UpdateProjectDtoStatusEnum)[keyof typeof UpdateProjectDtoStatusEnum];
export const UpdateProjectDtoEstimatedDurationUnitEnum = {
  Days: 'DAYS',
  Weeks: 'WEEKS',
  Months: 'MONTHS',
  Years: 'YEARS',
} as const;

export type UpdateProjectDtoEstimatedDurationUnitEnum =
  (typeof UpdateProjectDtoEstimatedDurationUnitEnum)[keyof typeof UpdateProjectDtoEstimatedDurationUnitEnum];
export const UpdateProjectDtoLabelEnum = {
  Red: 'RED',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Green: 'GREEN',
  Blue: 'BLUE',
  Purple: 'PURPLE',
  Gray: 'GRAY',
} as const;

export type UpdateProjectDtoLabelEnum =
  (typeof UpdateProjectDtoLabelEnum)[keyof typeof UpdateProjectDtoLabelEnum];
export const UpdateProjectDtoPriorityEnum = {
  High: 'HIGH',
  Medium: 'MEDIUM',
  Low: 'LOW',
} as const;

export type UpdateProjectDtoPriorityEnum =
  (typeof UpdateProjectDtoPriorityEnum)[keyof typeof UpdateProjectDtoPriorityEnum];

/**
 *
 * @export
 * @interface UpdateRoomDto
 */
export interface UpdateRoomDto {
  /**
   * ID du bâtiment auquel rattacher la pièce
   * @type {string}
   * @memberof UpdateRoomDto
   */
  buildingId?: string;
  /**
   * ID du niveau (optionnel)
   * @type {string}
   * @memberof UpdateRoomDto
   */
  floorId?: string | null;
  /**
   * Nom de la pièce
   * @type {string}
   * @memberof UpdateRoomDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateRoomDto
   */
  type?: UpdateRoomDtoTypeEnum;
  /**
   * Équipements sanitaires présents dans la pièce
   * @type {Array<string>}
   * @memberof UpdateRoomDto
   */
  features?: Array<UpdateRoomDtoFeaturesEnum>;
  /**
   * Chambre desservie par cette pièce d\'eau (« en suite »)
   * @type {string}
   * @memberof UpdateRoomDto
   */
  servedRoomId?: string | null;
  /**
   * Surface en m²
   * @type {number}
   * @memberof UpdateRoomDto
   */
  areaSqm?: number;
  /**
   *
   * @type {boolean}
   * @memberof UpdateRoomDto
   */
  isOutOfService?: boolean;
  /**
   *
   * @type {number}
   * @memberof UpdateRoomDto
   */
  position?: number;
}

export const UpdateRoomDtoTypeEnum = {
  Bedroom: 'BEDROOM',
  MasterBedroom: 'MASTER_BEDROOM',
  Dormitory: 'DORMITORY',
  StudioApartment: 'STUDIO_APARTMENT',
  DressingRoom: 'DRESSING_ROOM',
  StorageRoom: 'STORAGE_ROOM',
  LivingRoom: 'LIVING_ROOM',
  DiningRoom: 'DINING_ROOM',
  Office: 'OFFICE',
  Library: 'LIBRARY',
  Playroom: 'PLAYROOM',
  Gym: 'GYM',
  HomeCinema: 'HOME_CINEMA',
  Veranda: 'VERANDA',
  ReceptionRoom: 'RECEPTION_ROOM',
  Kitchen: 'KITCHEN',
  Pantry: 'PANTRY',
  Laundry: 'LAUNDRY',
  Larder: 'LARDER',
  Bathroom: 'BATHROOM',
  ShowerRoom: 'SHOWER_ROOM',
  PowderRoom: 'POWDER_ROOM',
  Toilet: 'TOILET',
  Entrance: 'ENTRANCE',
  Hallway: 'HALLWAY',
  Landing: 'LANDING',
  Stairwell: 'STAIRWELL',
  Mezzanine: 'MEZZANINE',
  Attic: 'ATTIC',
  Basement: 'BASEMENT',
  Cellar: 'CELLAR',
  WineCellar: 'WINE_CELLAR',
  BoilerRoom: 'BOILER_ROOM',
  Outdoor: 'OUTDOOR',
  Garden: 'GARDEN',
  Terrace: 'TERRACE',
  Balcony: 'BALCONY',
  Loggia: 'LOGGIA',
  Courtyard: 'COURTYARD',
  Pool: 'POOL',
  PoolHouse: 'POOL_HOUSE',
  Garage: 'GARAGE',
  Carport: 'CARPORT',
  ParkingSpace: 'PARKING_SPACE',
  Workshop: 'WORKSHOP',
  Shed: 'SHED',
  Outbuilding: 'OUTBUILDING',
  Barn: 'BARN',
  Stable: 'STABLE',
  CommonArea: 'COMMON_AREA',
  Lobby: 'LOBBY',
  BikeRoom: 'BIKE_ROOM',
  BinRoom: 'BIN_ROOM',
  Other: 'OTHER',
} as const;

export type UpdateRoomDtoTypeEnum =
  (typeof UpdateRoomDtoTypeEnum)[keyof typeof UpdateRoomDtoTypeEnum];
export const UpdateRoomDtoFeaturesEnum = {
  Bathtub: 'BATHTUB',
  Shower: 'SHOWER',
  Washbasin: 'WASHBASIN',
  DoubleWashbasin: 'DOUBLE_WASHBASIN',
  Toilet: 'TOILET',
  HandBasin: 'HAND_BASIN',
  Bidet: 'BIDET',
} as const;

export type UpdateRoomDtoFeaturesEnum =
  (typeof UpdateRoomDtoFeaturesEnum)[keyof typeof UpdateRoomDtoFeaturesEnum];

/**
 *
 * @export
 * @interface UpdateTaskDto
 */
export interface UpdateTaskDto {
  /**
   *
   * @type {string}
   * @memberof UpdateTaskDto
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTaskDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTaskDto
   */
  status?: UpdateTaskDtoStatusEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateTaskDto
   */
  category?: UpdateTaskDtoCategoryEnum | null;
  /**
   *
   * @type {string}
   * @memberof UpdateTaskDto
   */
  subCategory?: UpdateTaskDtoSubCategoryEnum | null;
  /**
   *
   * @type {Dayjs}
   * @memberof UpdateTaskDto
   */
  dueDate?: Dayjs;
  /**
   * Time spent in minutes
   * @type {number}
   * @memberof UpdateTaskDto
   */
  timeSpentMinutes?: number;
  /**
   * Whether the task requires being physically on site
   * @type {boolean}
   * @memberof UpdateTaskDto
   */
  requiresOnSite?: boolean;
  /**
   * User ID to assign the task to
   * @type {string}
   * @memberof UpdateTaskDto
   */
  assignedToId?: string;
  /**
   *
   * @type {Array<RelatedEntityInputDto>}
   * @memberof UpdateTaskDto
   */
  relatedEntities?: Array<RelatedEntityInputDto>;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTaskDto
   */
  attachmentIds?: Array<string>;
}

export const UpdateTaskDtoStatusEnum = {
  Todo: 'TODO',
  InProgress: 'IN_PROGRESS',
  Done: 'DONE',
} as const;

export type UpdateTaskDtoStatusEnum =
  (typeof UpdateTaskDtoStatusEnum)[keyof typeof UpdateTaskDtoStatusEnum];
export const UpdateTaskDtoCategoryEnum = {
  Technique: 'TECHNIQUE',
  VieMaison: 'VIE_MAISON',
  Gestion: 'GESTION',
} as const;

export type UpdateTaskDtoCategoryEnum =
  (typeof UpdateTaskDtoCategoryEnum)[keyof typeof UpdateTaskDtoCategoryEnum];
export const UpdateTaskDtoSubCategoryEnum = {
  Plomberie: 'PLOMBERIE',
  Electricite: 'ELECTRICITE',
  Menuiseries: 'MENUISERIES',
  PeintureEnduits: 'PEINTURE_ENDUITS',
  ReparationsDiverses: 'REPARATIONS_DIVERSES',
  Jardinage: 'JARDINAGE',
  MenageRangement: 'MENAGE_RANGEMENT',
  Decoration: 'DECORATION',
  CoursesApprovisionnement: 'COURSES_APPROVISIONNEMENT',
  Administratif: 'ADMINISTRATIF',
  Comptabilite: 'COMPTABILITE',
  Juridique: 'JURIDIQUE',
  SourcingAchats: 'SOURCING_ACHATS',
  GestionSinistres: 'GESTION_SINISTRES',
  RelationsExterieures: 'RELATIONS_EXTERIEURES',
} as const;

export type UpdateTaskDtoSubCategoryEnum =
  (typeof UpdateTaskDtoSubCategoryEnum)[keyof typeof UpdateTaskDtoSubCategoryEnum];

/**
 *
 * @export
 * @interface UpdateUserConsentsDto
 */
export interface UpdateUserConsentsDto {
  /**
   * Indicates if the user accepts the Terms of Use and Privacy Policy.
   * @type {boolean}
   * @memberof UpdateUserConsentsDto
   */
  acceptedTermsPrivacy?: boolean;
  /**
   * Version of the accepted Terms of Use and Privacy Policy.
   * @type {string}
   * @memberof UpdateUserConsentsDto
   */
  acceptedTermsPrivacyVersion?: string;
  /**
   * Indicates if the user wishes to receive commercial communications (newsletter).
   * @type {boolean}
   * @memberof UpdateUserConsentsDto
   */
  newsletterOptIn?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpdateUserConsentsDto
   */
  transactionalEmailOptIn?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpdateUserConsentsDto
   */
  transactionalPushOptIn?: boolean;
}
/**
 *
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
  /**
   * User title
   * @type {string}
   * @memberof UpdateUserDto
   */
  title: UpdateUserDtoTitleEnum;
  /**
   * ISO 8601 date string
   * @type {Dayjs}
   * @memberof UpdateUserDto
   */
  birthDate: Dayjs;
  /**
   * The user\'s first name.
   * @type {string}
   * @memberof UpdateUserDto
   */
  firstName?: string;
  /**
   * The user\'s last name.
   * @type {string}
   * @memberof UpdateUserDto
   */
  lastName?: string;
  /**
   * The Google Places ID for the user\'s new address.
   * @type {string}
   * @memberof UpdateUserDto
   */
  placeId?: string;
}

export const UpdateUserDtoTitleEnum = {
  Mr: 'mr',
  Ms: 'ms',
  Other: 'other',
} as const;

export type UpdateUserDtoTitleEnum =
  (typeof UpdateUserDtoTitleEnum)[keyof typeof UpdateUserDtoTitleEnum];

/**
 *
 * @export
 * @interface UpdateUserUtmDto
 */
export interface UpdateUserUtmDto {
  /**
   *
   * @type {string}
   * @memberof UpdateUserUtmDto
   */
  utm_source: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserUtmDto
   */
  utm_medium: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserUtmDto
   */
  utm_campaign: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserUtmDto
   */
  utm_term: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserUtmDto
   */
  utm_content: string;
}
/**
 *
 * @export
 * @interface UploadCompletionDto
 */
export interface UploadCompletionDto {
  /**
   * A list of successfully processed files, with potential OCR data.
   * @type {Array<UnifiedUploadResponseDto>}
   * @memberof UploadCompletionDto
   */
  files: Array<UnifiedUploadResponseDto>;
  /**
   *
   * @type {Array<FailureDto>}
   * @memberof UploadCompletionDto
   */
  failures: Array<FailureDto>;
}
/**
 *
 * @export
 * @interface UploadedFileDto
 */
export interface UploadedFileDto {
  /**
   * The id of the file in the virtual file system
   * @type {string}
   * @memberof UploadedFileDto
   */
  id: string;
  /**
   * The path of the folder the file is stored in
   * @type {string}
   * @memberof UploadedFileDto
   */
  path: string;
  /**
   * The name of the file as stored in the virtual file system
   * @type {string}
   * @memberof UploadedFileDto
   */
  name: string;
  /**
   * The name of the file when it was uploaded
   * @type {string}
   * @memberof UploadedFileDto
   */
  originalName: string;
  /**
   *
   * @type {SignedUrlsDto}
   * @memberof UploadedFileDto
   */
  urls?: SignedUrlsDto;
  /**
   *
   * @type {string}
   * @memberof UploadedFileDto
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof UploadedFileDto
   */
  videoId?: string;
  /**
   *
   * @type {string}
   * @memberof UploadedFileDto
   */
  type: UploadedFileDtoTypeEnum;
}

export const UploadedFileDtoTypeEnum = {
  File: 'file',
  Folder: 'folder',
  Video: 'video',
  ExternalLink: 'external_link',
} as const;

export type UploadedFileDtoTypeEnum =
  (typeof UploadedFileDtoTypeEnum)[keyof typeof UploadedFileDtoTypeEnum];

/**
 *
 * @export
 * @interface UploadedReceiptDataDto
 */
export interface UploadedReceiptDataDto {
  /**
   *
   * @type {string}
   * @memberof UploadedReceiptDataDto
   */
  tempImagePath?: string;
  /**
   * The data extracted from the receipt image via OCR
   * @type {ReceiptDataDto}
   * @memberof UploadedReceiptDataDto
   */
  ocrData: ReceiptDataDto;
  /**
   *
   * @type {string}
   * @memberof UploadedReceiptDataDto
   */
  tempImageUrl?: string;
  /**
   *
   * @type {string}
   * @memberof UploadedReceiptDataDto
   */
  tempPdfImagePath?: string;
}
/**
 *
 * @export
 * @interface UpsertBudgetForecastDto
 */
export interface UpsertBudgetForecastDto {
  /**
   *
   * @type {number}
   * @memberof UpsertBudgetForecastDto
   */
  year: number;
  /**
   *
   * @type {Array<BudgetForecastLineRequestDto>}
   * @memberof UpsertBudgetForecastDto
   */
  lines: Array<BudgetForecastLineRequestDto>;
}
/**
 *
 * @export
 * @interface UpsertInterlocutorDto
 */
export interface UpsertInterlocutorDto {
  /**
   * Existing interlocutor id (absent = new one)
   * @type {string}
   * @memberof UpsertInterlocutorDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof UpsertInterlocutorDto
   */
  title?: UpsertInterlocutorDtoTitleEnum;
  /**
   *
   * @type {string}
   * @memberof UpsertInterlocutorDto
   */
  firstName?: string;
  /**
   * Nom ou service
   * @type {string}
   * @memberof UpsertInterlocutorDto
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof UpsertInterlocutorDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof UpsertInterlocutorDto
   */
  phoneNumber?: string;
  /**
   *
   * @type {CompanyContactRole}
   * @memberof UpsertInterlocutorDto
   */
  companyRole: CompanyContactRole;
  /**
   * Libellé libre, obligatoire si le rôle est OTHER
   * @type {string}
   * @memberof UpsertInterlocutorDto
   */
  companyRoleLabel?: string;
}

export const UpsertInterlocutorDtoTitleEnum = {
  Mr: 'mr',
  Ms: 'ms',
  Other: 'other',
} as const;

export type UpsertInterlocutorDtoTitleEnum =
  (typeof UpsertInterlocutorDtoTitleEnum)[keyof typeof UpsertInterlocutorDtoTitleEnum];

/**
 *
 * @export
 * @interface UsageDto
 */
export interface UsageDto {
  /**
   *
   * @type {number}
   * @memberof UsageDto
   */
  current: number;
  /**
   *
   * @type {number}
   * @memberof UsageDto
   */
  limit: number | null;
}
/**
 *
 * @export
 * @interface UserDto
 */
export interface UserDto {
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  title?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof UserDto
   */
  birthDate?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  profilePictureUrl?: string;
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  phoneNumber?: string;
}
/**
 *
 * @export
 * @interface UserEquilibriumDto
 */
export interface UserEquilibriumDto {
  /**
   *
   * @type {number}
   * @memberof UserEquilibriumDto
   */
  myNetBalance: number;
  /**
   *
   * @type {Array<SettlementDto>}
   * @memberof UserEquilibriumDto
   */
  owedToMe: Array<SettlementDto>;
  /**
   *
   * @type {Array<SettlementDto>}
   * @memberof UserEquilibriumDto
   */
  iOwe: Array<SettlementDto>;
}
/**
 *
 * @export
 * @interface UserWithPrivateInfoDto
 */
export interface UserWithPrivateInfoDto {
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  title?: string;
  /**
   *
   * @type {Dayjs}
   * @memberof UserWithPrivateInfoDto
   */
  birthDate?: Dayjs;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  profilePictureUrl?: string;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  email: string;
  /**
   *
   * @type {boolean}
   * @memberof UserWithPrivateInfoDto
   */
  acceptedTermsPrivacy: boolean;
  /**
   *
   * @type {AddressResponseDto}
   * @memberof UserWithPrivateInfoDto
   */
  address?: AddressResponseDto;
  /**
   *
   * @type {Dayjs}
   * @memberof UserWithPrivateInfoDto
   */
  createdAt: Dayjs;
  /**
   * User opted in for transactional email notifications
   * @type {boolean}
   * @memberof UserWithPrivateInfoDto
   */
  transactionalEmailOptIn: boolean;
  /**
   * User opted in for transactional push notifications
   * @type {boolean}
   * @memberof UserWithPrivateInfoDto
   */
  transactionalPushOptIn: boolean;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  expenseNotificationPreference: UserWithPrivateInfoDtoExpenseNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  eventNotificationPreference: UserWithPrivateInfoDtoEventNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  postNotificationPreference: UserWithPrivateInfoDtoPostNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  commentNotificationPreference: UserWithPrivateInfoDtoCommentNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  practicalInformationNotificationPreference: UserWithPrivateInfoDtoPracticalInformationNotificationPreferenceEnum;
  /**
   *
   * @type {string}
   * @memberof UserWithPrivateInfoDto
   */
  favoriteAssetId?: string | null;
  /**
   * User is part of Share Heritage internal team (backoffice access)
   * @type {boolean}
   * @memberof UserWithPrivateInfoDto
   */
  isInternalAdmin: boolean;
  /**
   * User has dismissed or interacted with the first-login demo booking popup
   * @type {boolean}
   * @memberof UserWithPrivateInfoDto
   */
  hasSeenDemoPopup: boolean;
  /**
   * Placeholder members whose estimated email matches this user\'s, offered for confirmation at signup.
   * @type {Array<PendingPlaceholderMatchDto>}
   * @memberof UserWithPrivateInfoDto
   */
  pendingPlaceholderMatches?: Array<PendingPlaceholderMatchDto>;
}

export const UserWithPrivateInfoDtoExpenseNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UserWithPrivateInfoDtoExpenseNotificationPreferenceEnum =
  (typeof UserWithPrivateInfoDtoExpenseNotificationPreferenceEnum)[keyof typeof UserWithPrivateInfoDtoExpenseNotificationPreferenceEnum];
export const UserWithPrivateInfoDtoEventNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UserWithPrivateInfoDtoEventNotificationPreferenceEnum =
  (typeof UserWithPrivateInfoDtoEventNotificationPreferenceEnum)[keyof typeof UserWithPrivateInfoDtoEventNotificationPreferenceEnum];
export const UserWithPrivateInfoDtoPostNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UserWithPrivateInfoDtoPostNotificationPreferenceEnum =
  (typeof UserWithPrivateInfoDtoPostNotificationPreferenceEnum)[keyof typeof UserWithPrivateInfoDtoPostNotificationPreferenceEnum];
export const UserWithPrivateInfoDtoCommentNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UserWithPrivateInfoDtoCommentNotificationPreferenceEnum =
  (typeof UserWithPrivateInfoDtoCommentNotificationPreferenceEnum)[keyof typeof UserWithPrivateInfoDtoCommentNotificationPreferenceEnum];
export const UserWithPrivateInfoDtoPracticalInformationNotificationPreferenceEnum = {
  All: 'ALL',
  InvolvedOnly: 'INVOLVED_ONLY',
  None: 'NONE',
} as const;

export type UserWithPrivateInfoDtoPracticalInformationNotificationPreferenceEnum =
  (typeof UserWithPrivateInfoDtoPracticalInformationNotificationPreferenceEnum)[keyof typeof UserWithPrivateInfoDtoPracticalInformationNotificationPreferenceEnum];

/**
 *
 * @export
 * @interface VersionDto
 */
export interface VersionDto {
  /**
   *
   * @type {string}
   * @memberof VersionDto
   */
  version: string;
}
/**
 *
 * @export
 * @interface VideoDto
 */
export interface VideoDto {
  /**
   *
   * @type {string}
   * @memberof VideoDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof VideoDto
   */
  assetStatus: VideoDtoAssetStatusEnum;
  /**
   * The playback ID is required to read the video and its thumbnail
   * @type {string}
   * @memberof VideoDto
   */
  playbackId: string | null;
  /**
   * The playback token is required to play the video stream
   * @type {string}
   * @memberof VideoDto
   */
  playbackToken: string | null;
  /**
   * The thumbnail token is required to download the video thumbnail
   * @type {string}
   * @memberof VideoDto
   */
  thumbnailToken: string | null;
  /**
   * A convenience field that return the ready-to-use URL to stream.mux.com, alongside the playback ID and playback token.
   * @type {string}
   * @memberof VideoDto
   */
  playbackUrl: string | null;
  /**
   * A convenience field that return the ready-to-use URL to images.mux.com, alongside the playback ID and thumbnail token.
   * @type {string}
   * @memberof VideoDto
   */
  thumbnailUrl: string | null;
  /**
   * The fileId linked to the video if the file has been created for this video (usually the case when the video is ready).
   * @type {string}
   * @memberof VideoDto
   */
  fileId: string | null;
}

export const VideoDtoAssetStatusEnum = {
  Preparing: 'preparing',
  Ready: 'ready',
  Errored: 'errored',
} as const;

export type VideoDtoAssetStatusEnum =
  (typeof VideoDtoAssetStatusEnum)[keyof typeof VideoDtoAssetStatusEnum];

/**
 *
 * @export
 * @interface VideoUploadDto
 */
export interface VideoUploadDto {
  /**
   *
   * @type {string}
   * @memberof VideoUploadDto
   */
  id: string;
  /**
   * The client can upload the video directly to this URL. It is an authenticated and signed URL.
   * @type {string}
   * @memberof VideoUploadDto
   */
  uploadUrl: string;
}
/**
 *
 * @export
 * @interface VoteProjectDto
 */
export interface VoteProjectDto {
  /**
   *
   * @type {string}
   * @memberof VoteProjectDto
   */
  vote: VoteProjectDtoVoteEnum;
}

export const VoteProjectDtoVoteEnum = {
  Yes: 'YES',
  No: 'NO',
} as const;

export type VoteProjectDtoVoteEnum =
  (typeof VoteProjectDtoVoteEnum)[keyof typeof VoteProjectDtoVoteEnum];

/**
 *
 * @export
 * @interface WashroomsSummaryDto
 */
export interface WashroomsSummaryDto {
  /**
   * Salles de bain + salles d’eau
   * @type {number}
   * @memberof WashroomsSummaryDto
   */
  total: number;
  /**
   *
   * @type {Array<string>}
   * @memberof WashroomsSummaryDto
   */
  byType: Array<WashroomsSummaryDtoByTypeEnum>;
  /**
   * Équipements comptés sur toutes les pièces, pas seulement les pièces d’eau
   * @type {Array<string>}
   * @memberof WashroomsSummaryDto
   */
  byFeature: Array<WashroomsSummaryDtoByFeatureEnum>;
  /**
   * Pièces d’eau attenantes à une chambre
   * @type {number}
   * @memberof WashroomsSummaryDto
   */
  enSuite: number;
}

export const WashroomsSummaryDtoByTypeEnum = {
  Bedroom: 'BEDROOM',
  MasterBedroom: 'MASTER_BEDROOM',
  Dormitory: 'DORMITORY',
  StudioApartment: 'STUDIO_APARTMENT',
  DressingRoom: 'DRESSING_ROOM',
  StorageRoom: 'STORAGE_ROOM',
  LivingRoom: 'LIVING_ROOM',
  DiningRoom: 'DINING_ROOM',
  Office: 'OFFICE',
  Library: 'LIBRARY',
  Playroom: 'PLAYROOM',
  Gym: 'GYM',
  HomeCinema: 'HOME_CINEMA',
  Veranda: 'VERANDA',
  ReceptionRoom: 'RECEPTION_ROOM',
  Kitchen: 'KITCHEN',
  Pantry: 'PANTRY',
  Laundry: 'LAUNDRY',
  Larder: 'LARDER',
  Bathroom: 'BATHROOM',
  ShowerRoom: 'SHOWER_ROOM',
  PowderRoom: 'POWDER_ROOM',
  Toilet: 'TOILET',
  Entrance: 'ENTRANCE',
  Hallway: 'HALLWAY',
  Landing: 'LANDING',
  Stairwell: 'STAIRWELL',
  Mezzanine: 'MEZZANINE',
  Attic: 'ATTIC',
  Basement: 'BASEMENT',
  Cellar: 'CELLAR',
  WineCellar: 'WINE_CELLAR',
  BoilerRoom: 'BOILER_ROOM',
  Outdoor: 'OUTDOOR',
  Garden: 'GARDEN',
  Terrace: 'TERRACE',
  Balcony: 'BALCONY',
  Loggia: 'LOGGIA',
  Courtyard: 'COURTYARD',
  Pool: 'POOL',
  PoolHouse: 'POOL_HOUSE',
  Garage: 'GARAGE',
  Carport: 'CARPORT',
  ParkingSpace: 'PARKING_SPACE',
  Workshop: 'WORKSHOP',
  Shed: 'SHED',
  Outbuilding: 'OUTBUILDING',
  Barn: 'BARN',
  Stable: 'STABLE',
  CommonArea: 'COMMON_AREA',
  Lobby: 'LOBBY',
  BikeRoom: 'BIKE_ROOM',
  BinRoom: 'BIN_ROOM',
  Other: 'OTHER',
} as const;

export type WashroomsSummaryDtoByTypeEnum =
  (typeof WashroomsSummaryDtoByTypeEnum)[keyof typeof WashroomsSummaryDtoByTypeEnum];
export const WashroomsSummaryDtoByFeatureEnum = {
  Bathtub: 'BATHTUB',
  Shower: 'SHOWER',
  Washbasin: 'WASHBASIN',
  DoubleWashbasin: 'DOUBLE_WASHBASIN',
  Toilet: 'TOILET',
  HandBasin: 'HAND_BASIN',
  Bidet: 'BIDET',
} as const;

export type WashroomsSummaryDtoByFeatureEnum =
  (typeof WashroomsSummaryDtoByFeatureEnum)[keyof typeof WashroomsSummaryDtoByFeatureEnum];

/**
 *
 * @export
 * @interface WeatherCurrentConditionsDto
 */
export interface WeatherCurrentConditionsDto {
  /**
   *
   * @type {Dayjs}
   * @memberof WeatherCurrentConditionsDto
   */
  currentTime: Dayjs;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTimeZone}
   * @memberof WeatherCurrentConditionsDto
   */
  timeZone: WeatherCurrentConditionsDtoTimeZone;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWeatherCondition}
   * @memberof WeatherCurrentConditionsDto
   */
  weatherCondition: WeatherCurrentConditionsDtoWeatherCondition;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDto
   */
  temperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDto
   */
  feelsLikeTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDto
   */
  dewPoint: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDto
   */
  heatIndex: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDto
   */
  windChill: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoPrecipitation}
   * @memberof WeatherCurrentConditionsDto
   */
  precipitation: WeatherCurrentConditionsDtoPrecipitation;
  /**
   *
   * @type {WeatherCurrentConditionsDtoAirPressure}
   * @memberof WeatherCurrentConditionsDto
   */
  airPressure: WeatherCurrentConditionsDtoAirPressure;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWind}
   * @memberof WeatherCurrentConditionsDto
   */
  wind: WeatherCurrentConditionsDtoWind;
  /**
   *
   * @type {WeatherCurrentConditionsDtoVisibility}
   * @memberof WeatherCurrentConditionsDto
   */
  visibility: WeatherCurrentConditionsDtoVisibility;
  /**
   *
   * @type {WeatherCurrentConditionsDtoCurrentConditionsHistory}
   * @memberof WeatherCurrentConditionsDto
   */
  currentConditionsHistory: WeatherCurrentConditionsDtoCurrentConditionsHistory;
  /**
   *
   * @type {boolean}
   * @memberof WeatherCurrentConditionsDto
   */
  isDaytime: boolean;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDto
   */
  relativeHumidity: number;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDto
   */
  uvIndex: number;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDto
   */
  thunderstormProbability: number;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDto
   */
  cloudCover: number;
}
/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoAirPressure
 */
export interface WeatherCurrentConditionsDtoAirPressure {
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDtoAirPressure
   */
  meanSeaLevelMillibars: number;
}
/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoCurrentConditionsHistory
 */
export interface WeatherCurrentConditionsDtoCurrentConditionsHistory {
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDtoCurrentConditionsHistory
   */
  temperatureChange: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDtoCurrentConditionsHistory
   */
  maxTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherCurrentConditionsDtoCurrentConditionsHistory
   */
  minTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoPrecipitationQpf}
   * @memberof WeatherCurrentConditionsDtoCurrentConditionsHistory
   */
  qpf: WeatherCurrentConditionsDtoPrecipitationQpf;
}
/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoPrecipitation
 */
export interface WeatherCurrentConditionsDtoPrecipitation {
  /**
   *
   * @type {WeatherCurrentConditionsDtoPrecipitationProbability}
   * @memberof WeatherCurrentConditionsDtoPrecipitation
   */
  probability: WeatherCurrentConditionsDtoPrecipitationProbability;
  /**
   *
   * @type {WeatherCurrentConditionsDtoPrecipitationQpf}
   * @memberof WeatherCurrentConditionsDtoPrecipitation
   */
  qpf: WeatherCurrentConditionsDtoPrecipitationQpf;
}
/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoPrecipitationProbability
 */
export interface WeatherCurrentConditionsDtoPrecipitationProbability {
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoPrecipitationProbability
   */
  type: WeatherCurrentConditionsDtoPrecipitationProbabilityTypeEnum;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDtoPrecipitationProbability
   */
  percent: number;
}

export const WeatherCurrentConditionsDtoPrecipitationProbabilityTypeEnum = {
  PrecipitationTypeUnspecified: 'PRECIPITATION_TYPE_UNSPECIFIED',
  None: 'NONE',
  Snow: 'SNOW',
  Rain: 'RAIN',
  LightRain: 'LIGHT_RAIN',
  HeavyRain: 'HEAVY_RAIN',
  RainAndSnow: 'RAIN_AND_SNOW',
  Sleet: 'SLEET',
  FreezingRain: 'FREEZING_RAIN',
} as const;

export type WeatherCurrentConditionsDtoPrecipitationProbabilityTypeEnum =
  (typeof WeatherCurrentConditionsDtoPrecipitationProbabilityTypeEnum)[keyof typeof WeatherCurrentConditionsDtoPrecipitationProbabilityTypeEnum];

/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoPrecipitationQpf
 */
export interface WeatherCurrentConditionsDtoPrecipitationQpf {
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoPrecipitationQpf
   */
  unit: WeatherCurrentConditionsDtoPrecipitationQpfUnitEnum;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDtoPrecipitationQpf
   */
  quantity: number;
}

export const WeatherCurrentConditionsDtoPrecipitationQpfUnitEnum = {
  UnitUnspecified: 'UNIT_UNSPECIFIED',
  Millimeters: 'MILLIMETERS',
  Inches: 'INCHES',
  Miles: 'MILES',
  Kilometers: 'KILOMETERS',
} as const;

export type WeatherCurrentConditionsDtoPrecipitationQpfUnitEnum =
  (typeof WeatherCurrentConditionsDtoPrecipitationQpfUnitEnum)[keyof typeof WeatherCurrentConditionsDtoPrecipitationQpfUnitEnum];

/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoTemperature
 */
export interface WeatherCurrentConditionsDtoTemperature {
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoTemperature
   */
  unit: WeatherCurrentConditionsDtoTemperatureUnitEnum;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDtoTemperature
   */
  degrees: number;
}

export const WeatherCurrentConditionsDtoTemperatureUnitEnum = {
  TemperatureUnitUnspecified: 'TEMPERATURE_UNIT_UNSPECIFIED',
  Celsius: 'CELSIUS',
  Fahrenheit: 'FAHRENHEIT',
} as const;

export type WeatherCurrentConditionsDtoTemperatureUnitEnum =
  (typeof WeatherCurrentConditionsDtoTemperatureUnitEnum)[keyof typeof WeatherCurrentConditionsDtoTemperatureUnitEnum];

/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoTimeZone
 */
export interface WeatherCurrentConditionsDtoTimeZone {
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoTimeZone
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoTimeZone
   */
  version?: string;
}
/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoVisibility
 */
export interface WeatherCurrentConditionsDtoVisibility {
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoVisibility
   */
  unit: WeatherCurrentConditionsDtoVisibilityUnitEnum;
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDtoVisibility
   */
  distance: number;
}

export const WeatherCurrentConditionsDtoVisibilityUnitEnum = {
  UnitUnspecified: 'UNIT_UNSPECIFIED',
  Millimeters: 'MILLIMETERS',
  Inches: 'INCHES',
  Miles: 'MILES',
  Kilometers: 'KILOMETERS',
} as const;

export type WeatherCurrentConditionsDtoVisibilityUnitEnum =
  (typeof WeatherCurrentConditionsDtoVisibilityUnitEnum)[keyof typeof WeatherCurrentConditionsDtoVisibilityUnitEnum];

/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoWeatherCondition
 */
export interface WeatherCurrentConditionsDtoWeatherCondition {
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoWeatherCondition
   */
  iconBaseUri: string;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWeatherConditionDescription}
   * @memberof WeatherCurrentConditionsDtoWeatherCondition
   */
  description: WeatherCurrentConditionsDtoWeatherConditionDescription;
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoWeatherCondition
   */
  type: WeatherCurrentConditionsDtoWeatherConditionTypeEnum;
}

export const WeatherCurrentConditionsDtoWeatherConditionTypeEnum = {
  TypeUnspecified: 'TYPE_UNSPECIFIED',
  Clear: 'CLEAR',
  MostlyClear: 'MOSTLY_CLEAR',
  PartlyCloudy: 'PARTLY_CLOUDY',
  MostlyCloudy: 'MOSTLY_CLOUDY',
  Cloudy: 'CLOUDY',
  Windy: 'WINDY',
  WindAndRain: 'WIND_AND_RAIN',
  LightRainShowers: 'LIGHT_RAIN_SHOWERS',
  ChanceOfShowers: 'CHANCE_OF_SHOWERS',
  ScatteredShowers: 'SCATTERED_SHOWERS',
  RainShowers: 'RAIN_SHOWERS',
  HeavyRainShowers: 'HEAVY_RAIN_SHOWERS',
  LightToModerateRain: 'LIGHT_TO_MODERATE_RAIN',
  ModerateToHeavyRain: 'MODERATE_TO_HEAVY_RAIN',
  Rain: 'RAIN',
  LightRain: 'LIGHT_RAIN',
  HeavyRain: 'HEAVY_RAIN',
  RainPeriodicallyHeavy: 'RAIN_PERIODICALLY_HEAVY',
  LightSnowShowers: 'LIGHT_SNOW_SHOWERS',
  ChanceOfSnowShowers: 'CHANCE_OF_SNOW_SHOWERS',
  ScatteredSnowShowers: 'SCATTERED_SNOW_SHOWERS',
  SnowShowers: 'SNOW_SHOWERS',
  HeavySnowShowers: 'HEAVY_SNOW_SHOWERS',
  LightToModerateSnow: 'LIGHT_TO_MODERATE_SNOW',
  ModerateToHeavySnow: 'MODERATE_TO_HEAVY_SNOW',
  Snow: 'SNOW',
  LightSnow: 'LIGHT_SNOW',
  HeavySnow: 'HEAVY_SNOW',
  Snowstorm: 'SNOWSTORM',
  SnowPeriodicallyHeavy: 'SNOW_PERIODICALLY_HEAVY',
  HeavySnowStorm: 'HEAVY_SNOW_STORM',
  BlowingSnow: 'BLOWING_SNOW',
  RainAndSnow: 'RAIN_AND_SNOW',
  Hail: 'HAIL',
  HailShowers: 'HAIL_SHOWERS',
  Thunderstorm: 'THUNDERSTORM',
  Thundershower: 'THUNDERSHOWER',
  LightThunderstormRain: 'LIGHT_THUNDERSTORM_RAIN',
  ScatteredThunderstorms: 'SCATTERED_THUNDERSTORMS',
  HeavyThunderstorm: 'HEAVY_THUNDERSTORM',
} as const;

export type WeatherCurrentConditionsDtoWeatherConditionTypeEnum =
  (typeof WeatherCurrentConditionsDtoWeatherConditionTypeEnum)[keyof typeof WeatherCurrentConditionsDtoWeatherConditionTypeEnum];

/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoWeatherConditionDescription
 */
export interface WeatherCurrentConditionsDtoWeatherConditionDescription {
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoWeatherConditionDescription
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoWeatherConditionDescription
   */
  languageCode: string;
}
/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoWind
 */
export interface WeatherCurrentConditionsDtoWind {
  /**
   *
   * @type {WeatherCurrentConditionsDtoWindDirection}
   * @memberof WeatherCurrentConditionsDtoWind
   */
  direction: WeatherCurrentConditionsDtoWindDirection;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWindSpeed}
   * @memberof WeatherCurrentConditionsDtoWind
   */
  speed: WeatherCurrentConditionsDtoWindSpeed;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWindSpeed}
   * @memberof WeatherCurrentConditionsDtoWind
   */
  gust: WeatherCurrentConditionsDtoWindSpeed;
}
/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoWindDirection
 */
export interface WeatherCurrentConditionsDtoWindDirection {
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDtoWindDirection
   */
  degrees: number;
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoWindDirection
   */
  cardinal: WeatherCurrentConditionsDtoWindDirectionCardinalEnum;
}

export const WeatherCurrentConditionsDtoWindDirectionCardinalEnum = {
  CardinalDirectionUnspecified: 'CARDINAL_DIRECTION_UNSPECIFIED',
  North: 'NORTH',
  NorthNortheast: 'NORTH_NORTHEAST',
  Northeast: 'NORTHEAST',
  EastNortheast: 'EAST_NORTHEAST',
  East: 'EAST',
  EastSoutheast: 'EAST_SOUTHEAST',
  Southeast: 'SOUTHEAST',
  SouthSoutheast: 'SOUTH_SOUTHEAST',
  South: 'SOUTH',
  SouthSouthwest: 'SOUTH_SOUTHWEST',
  Southwest: 'SOUTHWEST',
  WestSouthwest: 'WEST_SOUTHWEST',
  West: 'WEST',
  WestNorthwest: 'WEST_NORTHWEST',
  Northwest: 'NORTHWEST',
  NorthNorthwest: 'NORTH_NORTHWEST',
} as const;

export type WeatherCurrentConditionsDtoWindDirectionCardinalEnum =
  (typeof WeatherCurrentConditionsDtoWindDirectionCardinalEnum)[keyof typeof WeatherCurrentConditionsDtoWindDirectionCardinalEnum];

/**
 *
 * @export
 * @interface WeatherCurrentConditionsDtoWindSpeed
 */
export interface WeatherCurrentConditionsDtoWindSpeed {
  /**
   *
   * @type {number}
   * @memberof WeatherCurrentConditionsDtoWindSpeed
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof WeatherCurrentConditionsDtoWindSpeed
   */
  unit: WeatherCurrentConditionsDtoWindSpeedUnitEnum;
}

export const WeatherCurrentConditionsDtoWindSpeedUnitEnum = {
  SpeedUnitUnspecified: 'SPEED_UNIT_UNSPECIFIED',
  KilometersPerHour: 'KILOMETERS_PER_HOUR',
  MilesPerHour: 'MILES_PER_HOUR',
} as const;

export type WeatherCurrentConditionsDtoWindSpeedUnitEnum =
  (typeof WeatherCurrentConditionsDtoWindSpeedUnitEnum)[keyof typeof WeatherCurrentConditionsDtoWindSpeedUnitEnum];

/**
 *
 * @export
 * @interface WeatherForecastDayDto
 */
export interface WeatherForecastDayDto {
  /**
   *
   * @type {WeatherForecastHourDtoInterval}
   * @memberof WeatherForecastDayDto
   */
  interval: WeatherForecastHourDtoInterval;
  /**
   *
   * @type {WeatherForecastDayDtoDisplayDate}
   * @memberof WeatherForecastDayDto
   */
  displayDate: WeatherForecastDayDtoDisplayDate;
  /**
   *
   * @type {WeatherForecastDayDtoDaytimeForecast}
   * @memberof WeatherForecastDayDto
   */
  daytimeForecast: WeatherForecastDayDtoDaytimeForecast;
  /**
   *
   * @type {WeatherForecastDayDtoDaytimeForecast}
   * @memberof WeatherForecastDayDto
   */
  nighttimeForecast: WeatherForecastDayDtoDaytimeForecast;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastDayDto
   */
  maxTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastDayDto
   */
  minTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastDayDto
   */
  feelsLikeMaxTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastDayDto
   */
  feelsLikeMinTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastDayDto
   */
  maxHeatIndex: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherForecastDayDtoSunEvents}
   * @memberof WeatherForecastDayDto
   */
  sunEvents: WeatherForecastDayDtoSunEvents;
  /**
   *
   * @type {WeatherForecastDayDtoMoonEvents}
   * @memberof WeatherForecastDayDto
   */
  moonEvents: WeatherForecastDayDtoMoonEvents;
  /**
   *
   * @type {WeatherForecastHourDtoIceThickness}
   * @memberof WeatherForecastDayDto
   */
  iceThickness?: WeatherForecastHourDtoIceThickness;
}
/**
 *
 * @export
 * @interface WeatherForecastDayDtoDaytimeForecast
 */
export interface WeatherForecastDayDtoDaytimeForecast {
  /**
   *
   * @type {WeatherForecastHourDtoInterval}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  interval: WeatherForecastHourDtoInterval;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWeatherCondition}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  weatherCondition: WeatherCurrentConditionsDtoWeatherCondition;
  /**
   *
   * @type {WeatherCurrentConditionsDtoPrecipitation}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  precipitation: WeatherCurrentConditionsDtoPrecipitation;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWind}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  wind: WeatherCurrentConditionsDtoWind;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  relativeHumidity: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  uvIndex: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  thunderstormProbability: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastDayDtoDaytimeForecast
   */
  cloudCover: number;
}
/**
 *
 * @export
 * @interface WeatherForecastDayDtoDisplayDate
 */
export interface WeatherForecastDayDtoDisplayDate {
  /**
   *
   * @type {number}
   * @memberof WeatherForecastDayDtoDisplayDate
   */
  year: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastDayDtoDisplayDate
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastDayDtoDisplayDate
   */
  day: number;
}
/**
 *
 * @export
 * @interface WeatherForecastDayDtoMoonEvents
 */
export interface WeatherForecastDayDtoMoonEvents {
  /**
   *
   * @type {Array<Dayjs>}
   * @memberof WeatherForecastDayDtoMoonEvents
   */
  moonriseTimes?: Array<Dayjs>;
  /**
   *
   * @type {Array<Dayjs>}
   * @memberof WeatherForecastDayDtoMoonEvents
   */
  moonsetTimes?: Array<Dayjs>;
  /**
   *
   * @type {string}
   * @memberof WeatherForecastDayDtoMoonEvents
   */
  moonPhase: WeatherForecastDayDtoMoonEventsMoonPhaseEnum;
}

export const WeatherForecastDayDtoMoonEventsMoonPhaseEnum = {
  MoonPhaseUnspecified: 'MOON_PHASE_UNSPECIFIED',
  NewMoon: 'NEW_MOON',
  WaxingCrescent: 'WAXING_CRESCENT',
  FirstQuarter: 'FIRST_QUARTER',
  WaxingGibbous: 'WAXING_GIBBOUS',
  FullMoon: 'FULL_MOON',
  WaningGibbous: 'WANING_GIBBOUS',
  LastQuarter: 'LAST_QUARTER',
  WaningCrescent: 'WANING_CRESCENT',
} as const;

export type WeatherForecastDayDtoMoonEventsMoonPhaseEnum =
  (typeof WeatherForecastDayDtoMoonEventsMoonPhaseEnum)[keyof typeof WeatherForecastDayDtoMoonEventsMoonPhaseEnum];

/**
 *
 * @export
 * @interface WeatherForecastDayDtoSunEvents
 */
export interface WeatherForecastDayDtoSunEvents {
  /**
   *
   * @type {Dayjs}
   * @memberof WeatherForecastDayDtoSunEvents
   */
  sunriseTime: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof WeatherForecastDayDtoSunEvents
   */
  sunsetTime: Dayjs;
}
/**
 *
 * @export
 * @interface WeatherForecastHourDto
 */
export interface WeatherForecastHourDto {
  /**
   *
   * @type {WeatherForecastHourDtoInterval}
   * @memberof WeatherForecastHourDto
   */
  interval: WeatherForecastHourDtoInterval;
  /**
   *
   * @type {WeatherForecastHourDtoDisplayDateTime}
   * @memberof WeatherForecastHourDto
   */
  displayDateTime: WeatherForecastHourDtoDisplayDateTime;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWeatherCondition}
   * @memberof WeatherForecastHourDto
   */
  weatherCondition: WeatherCurrentConditionsDtoWeatherCondition;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastHourDto
   */
  temperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastHourDto
   */
  feelsLikeTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastHourDto
   */
  dewPoint: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastHourDto
   */
  heatIndex: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastHourDto
   */
  windChill: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoTemperature}
   * @memberof WeatherForecastHourDto
   */
  wetBulbTemperature: WeatherCurrentConditionsDtoTemperature;
  /**
   *
   * @type {WeatherCurrentConditionsDtoPrecipitation}
   * @memberof WeatherForecastHourDto
   */
  precipitation: WeatherCurrentConditionsDtoPrecipitation;
  /**
   *
   * @type {WeatherCurrentConditionsDtoAirPressure}
   * @memberof WeatherForecastHourDto
   */
  airPressure: WeatherCurrentConditionsDtoAirPressure;
  /**
   *
   * @type {WeatherCurrentConditionsDtoWind}
   * @memberof WeatherForecastHourDto
   */
  wind: WeatherCurrentConditionsDtoWind;
  /**
   *
   * @type {WeatherCurrentConditionsDtoVisibility}
   * @memberof WeatherForecastHourDto
   */
  visibility: WeatherCurrentConditionsDtoVisibility;
  /**
   *
   * @type {WeatherForecastHourDtoIceThickness}
   * @memberof WeatherForecastHourDto
   */
  iceThickness?: WeatherForecastHourDtoIceThickness;
  /**
   *
   * @type {boolean}
   * @memberof WeatherForecastHourDto
   */
  isDaytime: boolean;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDto
   */
  relativeHumidity: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDto
   */
  uvIndex: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDto
   */
  thunderstormProbability: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDto
   */
  cloudCover: number;
}
/**
 *
 * @export
 * @interface WeatherForecastHourDtoDisplayDateTime
 */
export interface WeatherForecastHourDtoDisplayDateTime {
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  year: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  day: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  hours?: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  minutes?: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  seconds?: number;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  nanos?: number;
  /**
   *
   * @type {string}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  utcOffset?: string;
  /**
   *
   * @type {string}
   * @memberof WeatherForecastHourDtoDisplayDateTime
   */
  timeZone?: string;
}
/**
 *
 * @export
 * @interface WeatherForecastHourDtoIceThickness
 */
export interface WeatherForecastHourDtoIceThickness {
  /**
   *
   * @type {string}
   * @memberof WeatherForecastHourDtoIceThickness
   */
  unit: WeatherForecastHourDtoIceThicknessUnitEnum;
  /**
   *
   * @type {number}
   * @memberof WeatherForecastHourDtoIceThickness
   */
  thickness: number;
}

export const WeatherForecastHourDtoIceThicknessUnitEnum = {
  UnitUnspecified: 'UNIT_UNSPECIFIED',
  Millimeters: 'MILLIMETERS',
  Inches: 'INCHES',
  Miles: 'MILES',
  Kilometers: 'KILOMETERS',
} as const;

export type WeatherForecastHourDtoIceThicknessUnitEnum =
  (typeof WeatherForecastHourDtoIceThicknessUnitEnum)[keyof typeof WeatherForecastHourDtoIceThicknessUnitEnum];

/**
 *
 * @export
 * @interface WeatherForecastHourDtoInterval
 */
export interface WeatherForecastHourDtoInterval {
  /**
   *
   * @type {Dayjs}
   * @memberof WeatherForecastHourDtoInterval
   */
  startTime: Dayjs;
  /**
   *
   * @type {Dayjs}
   * @memberof WeatherForecastHourDtoInterval
   */
  endTime: Dayjs;
}

/**
 * AccountsStatementApi - axios parameter creator
 * @export
 */
export const AccountsStatementApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Another member\'s position and open items, read-only (finance managers only)
     * @param {string} assetId
     * @param {string} assetMemberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsStatementControllerGetMemberDetails: async (
      assetId: string,
      assetMemberId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('accountsStatementControllerGetMemberDetails', 'assetId', assetId);
      // verify required parameter 'assetMemberId' is not null or undefined
      assertParamExists(
        'accountsStatementControllerGetMemberDetails',
        'assetMemberId',
        assetMemberId
      );
      const localVarPath = `/assets/{assetId}/accounts-statement/members/{assetMemberId}/details`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'assetMemberId'}}`, encodeURIComponent(String(assetMemberId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary État des comptes: the house, each member by circuit, and a balance check
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsStatementControllerGetStatement: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('accountsStatementControllerGetStatement', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/accounts-statement`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary État des comptes, full table as a PDF (finance managers only)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsStatementControllerGetStatementPdf: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('accountsStatementControllerGetStatementPdf', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/accounts-statement/pdf`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AccountsStatementApi - functional programming interface
 * @export
 */
export const AccountsStatementApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AccountsStatementApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Another member\'s position and open items, read-only (finance managers only)
     * @param {string} assetId
     * @param {string} assetMemberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountsStatementControllerGetMemberDetails(
      assetId: string,
      assetMemberId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberStatementDetailsDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountsStatementControllerGetMemberDetails(
          assetId,
          assetMemberId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccountsStatementApi.accountsStatementControllerGetMemberDetails']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary État des comptes: the house, each member by circuit, and a balance check
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountsStatementControllerGetStatement(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountsStatementDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountsStatementControllerGetStatement(assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccountsStatementApi.accountsStatementControllerGetStatement']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary État des comptes, full table as a PDF (finance managers only)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accountsStatementControllerGetStatementPdf(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.accountsStatementControllerGetStatementPdf(
          assetId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccountsStatementApi.accountsStatementControllerGetStatementPdf']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AccountsStatementApi - factory interface
 * @export
 */
export const AccountsStatementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AccountsStatementApiFp(configuration);
  return {
    /**
     *
     * @summary Another member\'s position and open items, read-only (finance managers only)
     * @param {string} assetId
     * @param {string} assetMemberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsStatementControllerGetMemberDetails(
      assetId: string,
      assetMemberId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberStatementDetailsDto> {
      return localVarFp
        .accountsStatementControllerGetMemberDetails(assetId, assetMemberId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary État des comptes: the house, each member by circuit, and a balance check
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsStatementControllerGetStatement(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AccountsStatementDto> {
      return localVarFp
        .accountsStatementControllerGetStatement(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary État des comptes, full table as a PDF (finance managers only)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accountsStatementControllerGetStatementPdf(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .accountsStatementControllerGetStatementPdf(assetId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AccountsStatementApi - object-oriented interface
 * @export
 * @class AccountsStatementApi
 * @extends {BaseAPI}
 */
export class AccountsStatementApi extends BaseAPI {
  /**
   *
   * @summary Another member\'s position and open items, read-only (finance managers only)
   * @param {string} assetId
   * @param {string} assetMemberId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsStatementApi
   */
  public accountsStatementControllerGetMemberDetails(
    assetId: string,
    assetMemberId: string,
    options?: RawAxiosRequestConfig
  ) {
    return AccountsStatementApiFp(this.configuration)
      .accountsStatementControllerGetMemberDetails(assetId, assetMemberId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary État des comptes: the house, each member by circuit, and a balance check
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsStatementApi
   */
  public accountsStatementControllerGetStatement(assetId: string, options?: RawAxiosRequestConfig) {
    return AccountsStatementApiFp(this.configuration)
      .accountsStatementControllerGetStatement(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary État des comptes, full table as a PDF (finance managers only)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccountsStatementApi
   */
  public accountsStatementControllerGetStatementPdf(
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return AccountsStatementApiFp(this.configuration)
      .accountsStatementControllerGetStatementPdf(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get address autocomplete suggestions from Google via backend proxy.
     * @param {string} input
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesControllerGetAutocompleteSuggestions: async (
      input: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'input' is not null or undefined
      assertParamExists('addressesControllerGetAutocompleteSuggestions', 'input', input);
      const localVarPath = `/addresses/autocomplete-suggestions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (input !== undefined) {
        localVarQueryParameter['input'] = input;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AddressesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get address autocomplete suggestions from Google via backend proxy.
     * @param {string} input
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addressesControllerGetAutocompleteSuggestions(
      input: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutocompleteV2ResponseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.addressesControllerGetAutocompleteSuggestions(
          input,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AddressesApi.addressesControllerGetAutocompleteSuggestions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AddressesApiFp(configuration);
  return {
    /**
     *
     * @summary Get address autocomplete suggestions from Google via backend proxy.
     * @param {string} input
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addressesControllerGetAutocompleteSuggestions(
      input: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AutocompleteV2ResponseDto> {
      return localVarFp
        .addressesControllerGetAutocompleteSuggestions(input, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI {
  /**
   *
   * @summary Get address autocomplete suggestions from Google via backend proxy.
   * @param {string} input
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressesApi
   */
  public addressesControllerGetAutocompleteSuggestions(
    input: string,
    options?: RawAxiosRequestConfig
  ) {
    return AddressesApiFp(this.configuration)
      .addressesControllerGetAutocompleteSuggestions(input, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Clear all user cache entries from Redis (admin only)
     * @param {string} secret Admin secret token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerClearUserCache: async (
      secret: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'secret' is not null or undefined
      assertParamExists('adminControllerClearUserCache', 'secret', secret);
      const localVarPath = `/admin/clear-user-cache`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (secret !== undefined) {
        localVarQueryParameter['secret'] = secret;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Clear all user cache entries from Redis (admin only)
     * @param {string} secret Admin secret token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminControllerClearUserCache(
      secret: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.adminControllerClearUserCache(
        secret,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AdminApi.adminControllerClearUserCache']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdminApiFp(configuration);
  return {
    /**
     *
     * @summary Clear all user cache entries from Redis (admin only)
     * @param {string} secret Admin secret token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminControllerClearUserCache(
      secret: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .adminControllerClearUserCache(secret, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
  /**
   *
   * @summary Clear all user cache entries from Redis (admin only)
   * @param {string} secret Admin secret token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public adminControllerClearUserCache(secret: string, options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .adminControllerClearUserCache(secret, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AgentApi - axios parameter creator
 * @export
 */
export const AgentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Chat avec l\'assistant (stream UI message de l\'AI SDK)
     * @param {string} assetId
     * @param {ChatRequestDto} chatRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentControllerChat: async (
      assetId: string,
      chatRequestDto: ChatRequestDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('agentControllerChat', 'assetId', assetId);
      // verify required parameter 'chatRequestDto' is not null or undefined
      assertParamExists('agentControllerChat', 'chatRequestDto', chatRequestDto);
      const localVarPath = `/assets/{assetId}/agent/chat`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        chatRequestDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Transcrire une dictée vocale pour le champ de Lucien
     * @param {string} assetId
     * @param {File} [file]
     * @param {AgentControllerTranscribeLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentControllerTranscribe: async (
      assetId: string,
      file?: File,
      language?: AgentControllerTranscribeLanguageEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('agentControllerTranscribe', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/agent/transcribe`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (language !== undefined) {
        localVarFormParams.append('language', language as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AgentApi - functional programming interface
 * @export
 */
export const AgentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AgentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Chat avec l\'assistant (stream UI message de l\'AI SDK)
     * @param {string} assetId
     * @param {ChatRequestDto} chatRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentControllerChat(
      assetId: string,
      chatRequestDto: ChatRequestDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentControllerChat(
        assetId,
        chatRequestDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AgentApi.agentControllerChat']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Transcrire une dictée vocale pour le champ de Lucien
     * @param {string} assetId
     * @param {File} [file]
     * @param {AgentControllerTranscribeLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentControllerTranscribe(
      assetId: string,
      file?: File,
      language?: AgentControllerTranscribeLanguageEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentTranscriptionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentControllerTranscribe(
        assetId,
        file,
        language,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AgentApi.agentControllerTranscribe']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AgentApi - factory interface
 * @export
 */
export const AgentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AgentApiFp(configuration);
  return {
    /**
     *
     * @summary Chat avec l\'assistant (stream UI message de l\'AI SDK)
     * @param {string} assetId
     * @param {ChatRequestDto} chatRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentControllerChat(
      assetId: string,
      chatRequestDto: ChatRequestDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .agentControllerChat(assetId, chatRequestDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Transcrire une dictée vocale pour le champ de Lucien
     * @param {string} assetId
     * @param {File} [file]
     * @param {AgentControllerTranscribeLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentControllerTranscribe(
      assetId: string,
      file?: File,
      language?: AgentControllerTranscribeLanguageEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AgentTranscriptionDto> {
      return localVarFp
        .agentControllerTranscribe(assetId, file, language, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AgentApi - object-oriented interface
 * @export
 * @class AgentApi
 * @extends {BaseAPI}
 */
export class AgentApi extends BaseAPI {
  /**
   *
   * @summary Chat avec l\'assistant (stream UI message de l\'AI SDK)
   * @param {string} assetId
   * @param {ChatRequestDto} chatRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentApi
   */
  public agentControllerChat(
    assetId: string,
    chatRequestDto: ChatRequestDto,
    options?: RawAxiosRequestConfig
  ) {
    return AgentApiFp(this.configuration)
      .agentControllerChat(assetId, chatRequestDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Transcrire une dictée vocale pour le champ de Lucien
   * @param {string} assetId
   * @param {File} [file]
   * @param {AgentControllerTranscribeLanguageEnum} [language]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentApi
   */
  public agentControllerTranscribe(
    assetId: string,
    file?: File,
    language?: AgentControllerTranscribeLanguageEnum,
    options?: RawAxiosRequestConfig
  ) {
    return AgentApiFp(this.configuration)
      .agentControllerTranscribe(assetId, file, language, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const AgentControllerTranscribeLanguageEnum = {
  Fr: 'fr',
  En: 'en',
} as const;
export type AgentControllerTranscribeLanguageEnum =
  (typeof AgentControllerTranscribeLanguageEnum)[keyof typeof AgentControllerTranscribeLanguageEnum];

/**
 * AppApi - axios parameter creator
 * @export
 */
export const AppApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appControllerGetHello: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AppApi - functional programming interface
 * @export
 */
export const AppApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AppApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async appControllerGetHello(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerGetHello(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AppApi.appControllerGetHello']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AppApi - factory interface
 * @export
 */
export const AppApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AppApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    appControllerGetHello(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.appControllerGetHello(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
export class AppApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AppApi
   */
  public appControllerGetHello(options?: RawAxiosRequestConfig) {
    return AppApiFp(this.configuration)
      .appControllerGetHello(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AssetAnnouncementsApi - axios parameter creator
 * @export
 */
export const AssetAnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create an announcement on an asset
     * @param {string} assetId
     * @param {CreateAssetAnnouncementDto} createAssetAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerCreate: async (
      assetId: string,
      createAssetAnnouncementDto: CreateAssetAnnouncementDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createAssetAnnouncementDto' is not null or undefined
      assertParamExists(
        'assetAnnouncementsControllerCreate',
        'createAssetAnnouncementDto',
        createAssetAnnouncementDto
      );
      const localVarPath = `/assets/{assetId}/announcements`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAssetAnnouncementDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerDelete: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerDelete', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetAnnouncementsControllerDelete', 'id', id);
      const localVarPath = `/assets/{assetId}/announcements/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permanently dismiss an announcement for the current user
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerDismiss: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerDismiss', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetAnnouncementsControllerDismiss', 'id', id);
      const localVarPath = `/assets/{assetId}/announcements/{id}/dismiss`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the currently active announcement for an asset, if any
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerFindActive: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerFindActive', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/announcements/active`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List announcements for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/announcements`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Publish an announcement (deactivates the previous one for this asset)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerPublish: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerPublish', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetAnnouncementsControllerPublish', 'id', id);
      const localVarPath = `/assets/{assetId}/announcements/{id}/publish`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unpublish an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerUnpublish: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerUnpublish', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetAnnouncementsControllerUnpublish', 'id', id);
      const localVarPath = `/assets/{assetId}/announcements/{id}/unpublish`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateAssetAnnouncementDto} updateAssetAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerUpdate: async (
      assetId: string,
      id: string,
      updateAssetAnnouncementDto: UpdateAssetAnnouncementDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetAnnouncementsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetAnnouncementsControllerUpdate', 'id', id);
      // verify required parameter 'updateAssetAnnouncementDto' is not null or undefined
      assertParamExists(
        'assetAnnouncementsControllerUpdate',
        'updateAssetAnnouncementDto',
        updateAssetAnnouncementDto
      );
      const localVarPath = `/assets/{assetId}/announcements/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateAssetAnnouncementDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AssetAnnouncementsApi - functional programming interface
 * @export
 */
export const AssetAnnouncementsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssetAnnouncementsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create an announcement on an asset
     * @param {string} assetId
     * @param {CreateAssetAnnouncementDto} createAssetAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerCreate(
      assetId: string,
      createAssetAnnouncementDto: CreateAssetAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAnnouncementDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetAnnouncementsControllerCreate(
        assetId,
        createAssetAnnouncementDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetAnnouncementsControllerDelete(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Permanently dismiss an announcement for the current user
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerDismiss(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetAnnouncementsControllerDismiss(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerDismiss']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the currently active announcement for an asset, if any
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerFindActive(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAnnouncementDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assetAnnouncementsControllerFindActive(assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerFindActive']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List announcements for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetAnnouncementDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetAnnouncementsControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Publish an announcement (deactivates the previous one for this asset)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerPublish(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAnnouncementDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetAnnouncementsControllerPublish(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerPublish']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Unpublish an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerUnpublish(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAnnouncementDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assetAnnouncementsControllerUnpublish(assetId, id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerUnpublish']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateAssetAnnouncementDto} updateAssetAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetAnnouncementsControllerUpdate(
      assetId: string,
      id: string,
      updateAssetAnnouncementDto: UpdateAssetAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAnnouncementDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetAnnouncementsControllerUpdate(
        assetId,
        id,
        updateAssetAnnouncementDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetAnnouncementsApi.assetAnnouncementsControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AssetAnnouncementsApi - factory interface
 * @export
 */
export const AssetAnnouncementsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssetAnnouncementsApiFp(configuration);
  return {
    /**
     *
     * @summary Create an announcement on an asset
     * @param {string} assetId
     * @param {CreateAssetAnnouncementDto} createAssetAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerCreate(
      assetId: string,
      createAssetAnnouncementDto: CreateAssetAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetAnnouncementDto> {
      return localVarFp
        .assetAnnouncementsControllerCreate(assetId, createAssetAnnouncementDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetAnnouncementsControllerDelete(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Permanently dismiss an announcement for the current user
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerDismiss(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetAnnouncementsControllerDismiss(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the currently active announcement for an asset, if any
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerFindActive(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetAnnouncementDto> {
      return localVarFp
        .assetAnnouncementsControllerFindActive(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List announcements for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<AssetAnnouncementDto>> {
      return localVarFp
        .assetAnnouncementsControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Publish an announcement (deactivates the previous one for this asset)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerPublish(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetAnnouncementDto> {
      return localVarFp
        .assetAnnouncementsControllerPublish(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Unpublish an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerUnpublish(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetAnnouncementDto> {
      return localVarFp
        .assetAnnouncementsControllerUnpublish(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update an announcement on an asset
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateAssetAnnouncementDto} updateAssetAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetAnnouncementsControllerUpdate(
      assetId: string,
      id: string,
      updateAssetAnnouncementDto: UpdateAssetAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetAnnouncementDto> {
      return localVarFp
        .assetAnnouncementsControllerUpdate(assetId, id, updateAssetAnnouncementDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AssetAnnouncementsApi - object-oriented interface
 * @export
 * @class AssetAnnouncementsApi
 * @extends {BaseAPI}
 */
export class AssetAnnouncementsApi extends BaseAPI {
  /**
   *
   * @summary Create an announcement on an asset
   * @param {string} assetId
   * @param {CreateAssetAnnouncementDto} createAssetAnnouncementDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerCreate(
    assetId: string,
    createAssetAnnouncementDto: CreateAssetAnnouncementDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerCreate(assetId, createAssetAnnouncementDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete an announcement on an asset
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerDelete(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerDelete(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Permanently dismiss an announcement for the current user
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerDismiss(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerDismiss(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the currently active announcement for an asset, if any
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerFindActive(assetId: string, options?: RawAxiosRequestConfig) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerFindActive(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List announcements for an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Publish an announcement (deactivates the previous one for this asset)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerPublish(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerPublish(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Unpublish an announcement on an asset
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerUnpublish(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerUnpublish(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an announcement on an asset
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateAssetAnnouncementDto} updateAssetAnnouncementDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetAnnouncementsApi
   */
  public assetAnnouncementsControllerUpdate(
    assetId: string,
    id: string,
    updateAssetAnnouncementDto: UpdateAssetAnnouncementDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetAnnouncementsApiFp(this.configuration)
      .assetAnnouncementsControllerUpdate(assetId, id, updateAssetAnnouncementDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AssetMembershipApi - axios parameter creator
 * @export
 */
export const AssetMembershipApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Remove a member from an asset (fails if blockers exist)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerDelete: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('membersControllerDelete', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('membersControllerDelete', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/members/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get asset members, owner, and pending invitations
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerFindOne: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('membersControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/members`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Check whether a member can be safely deleted (returns blockers if any references prevent deletion)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerGetDeletionCheck: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('membersControllerGetDeletionCheck', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('membersControllerGetDeletionCheck', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/members/{id}/deletion-check`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a member\'s annual budget forecast position (KPI: reste à provisionner)
     * @param {string} assetId
     * @param {string} userId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerGetForecastSummary: async (
      assetId: string,
      userId: string,
      year: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('membersControllerGetForecastSummary', 'assetId', assetId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('membersControllerGetForecastSummary', 'userId', userId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('membersControllerGetForecastSummary', 'year', year);
      const localVarPath = `/assets/{assetId}/members/{userId}/forecast-summary`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a member\'s role within an asset (deprecated - use permissions endpoint)
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberRoleDto} updateMemberRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerUpdate: async (
      id: string,
      assetId: string,
      updateMemberRoleDto: UpdateMemberRoleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('membersControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('membersControllerUpdate', 'assetId', assetId);
      // verify required parameter 'updateMemberRoleDto' is not null or undefined
      assertParamExists('membersControllerUpdate', 'updateMemberRoleDto', updateMemberRoleDto);
      const localVarPath = `/assets/{assetId}/members/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMemberRoleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a member\'s governance attributes (role, shares, ownership)
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberGovernanceDto} updateMemberGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerUpdateGovernance: async (
      id: string,
      assetId: string,
      updateMemberGovernanceDto: UpdateMemberGovernanceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('membersControllerUpdateGovernance', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('membersControllerUpdateGovernance', 'assetId', assetId);
      // verify required parameter 'updateMemberGovernanceDto' is not null or undefined
      assertParamExists(
        'membersControllerUpdateGovernance',
        'updateMemberGovernanceDto',
        updateMemberGovernanceDto
      );
      const localVarPath = `/assets/{assetId}/members/{id}/governance`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMemberGovernanceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a member\'s granular permissions within an asset
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberPermissionsDto} updateMemberPermissionsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerUpdatePermissions: async (
      id: string,
      assetId: string,
      updateMemberPermissionsDto: UpdateMemberPermissionsDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('membersControllerUpdatePermissions', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('membersControllerUpdatePermissions', 'assetId', assetId);
      // verify required parameter 'updateMemberPermissionsDto' is not null or undefined
      assertParamExists(
        'membersControllerUpdatePermissions',
        'updateMemberPermissionsDto',
        updateMemberPermissionsDto
      );
      const localVarPath = `/assets/{assetId}/members/{id}/permissions`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMemberPermissionsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AssetMembershipApi - functional programming interface
 * @export
 */
export const AssetMembershipApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssetMembershipApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Remove a member from an asset (fails if blockers exist)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async membersControllerDelete(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.membersControllerDelete(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetMembershipApi.membersControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get asset members, owner, and pending invitations
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async membersControllerFindOne(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetMembersDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.membersControllerFindOne(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetMembershipApi.membersControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Check whether a member can be safely deleted (returns blockers if any references prevent deletion)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async membersControllerGetDeletionCheck(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberDeletionCheckDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.membersControllerGetDeletionCheck(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetMembershipApi.membersControllerGetDeletionCheck']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a member\'s annual budget forecast position (KPI: reste à provisionner)
     * @param {string} assetId
     * @param {string} userId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async membersControllerGetForecastSummary(
      assetId: string,
      userId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberForecastSummaryDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.membersControllerGetForecastSummary(
        assetId,
        userId,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetMembershipApi.membersControllerGetForecastSummary']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a member\'s role within an asset (deprecated - use permissions endpoint)
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberRoleDto} updateMemberRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async membersControllerUpdate(
      id: string,
      assetId: string,
      updateMemberRoleDto: UpdateMemberRoleDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.membersControllerUpdate(
        id,
        assetId,
        updateMemberRoleDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetMembershipApi.membersControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a member\'s governance attributes (role, shares, ownership)
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberGovernanceDto} updateMemberGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async membersControllerUpdateGovernance(
      id: string,
      assetId: string,
      updateMemberGovernanceDto: UpdateMemberGovernanceDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.membersControllerUpdateGovernance(
        id,
        assetId,
        updateMemberGovernanceDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetMembershipApi.membersControllerUpdateGovernance']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a member\'s granular permissions within an asset
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberPermissionsDto} updateMemberPermissionsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async membersControllerUpdatePermissions(
      id: string,
      assetId: string,
      updateMemberPermissionsDto: UpdateMemberPermissionsDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.membersControllerUpdatePermissions(
        id,
        assetId,
        updateMemberPermissionsDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetMembershipApi.membersControllerUpdatePermissions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AssetMembershipApi - factory interface
 * @export
 */
export const AssetMembershipApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssetMembershipApiFp(configuration);
  return {
    /**
     *
     * @summary Remove a member from an asset (fails if blockers exist)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerDelete(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .membersControllerDelete(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get asset members, owner, and pending invitations
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerFindOne(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetMembersDto> {
      return localVarFp
        .membersControllerFindOne(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Check whether a member can be safely deleted (returns blockers if any references prevent deletion)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerGetDeletionCheck(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberDeletionCheckDto> {
      return localVarFp
        .membersControllerGetDeletionCheck(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get a member\'s annual budget forecast position (KPI: reste à provisionner)
     * @param {string} assetId
     * @param {string} userId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerGetForecastSummary(
      assetId: string,
      userId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberForecastSummaryDto> {
      return localVarFp
        .membersControllerGetForecastSummary(assetId, userId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a member\'s role within an asset (deprecated - use permissions endpoint)
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberRoleDto} updateMemberRoleDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerUpdate(
      id: string,
      assetId: string,
      updateMemberRoleDto: UpdateMemberRoleDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetMemberDto> {
      return localVarFp
        .membersControllerUpdate(id, assetId, updateMemberRoleDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a member\'s governance attributes (role, shares, ownership)
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberGovernanceDto} updateMemberGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerUpdateGovernance(
      id: string,
      assetId: string,
      updateMemberGovernanceDto: UpdateMemberGovernanceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetMemberDto> {
      return localVarFp
        .membersControllerUpdateGovernance(id, assetId, updateMemberGovernanceDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a member\'s granular permissions within an asset
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateMemberPermissionsDto} updateMemberPermissionsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    membersControllerUpdatePermissions(
      id: string,
      assetId: string,
      updateMemberPermissionsDto: UpdateMemberPermissionsDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetMemberDto> {
      return localVarFp
        .membersControllerUpdatePermissions(id, assetId, updateMemberPermissionsDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AssetMembershipApi - object-oriented interface
 * @export
 * @class AssetMembershipApi
 * @extends {BaseAPI}
 */
export class AssetMembershipApi extends BaseAPI {
  /**
   *
   * @summary Remove a member from an asset (fails if blockers exist)
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetMembershipApi
   */
  public membersControllerDelete(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return AssetMembershipApiFp(this.configuration)
      .membersControllerDelete(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get asset members, owner, and pending invitations
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetMembershipApi
   */
  public membersControllerFindOne(assetId: string, options?: RawAxiosRequestConfig) {
    return AssetMembershipApiFp(this.configuration)
      .membersControllerFindOne(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Check whether a member can be safely deleted (returns blockers if any references prevent deletion)
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetMembershipApi
   */
  public membersControllerGetDeletionCheck(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetMembershipApiFp(this.configuration)
      .membersControllerGetDeletionCheck(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a member\'s annual budget forecast position (KPI: reste à provisionner)
   * @param {string} assetId
   * @param {string} userId
   * @param {string} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetMembershipApi
   */
  public membersControllerGetForecastSummary(
    assetId: string,
    userId: string,
    year: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetMembershipApiFp(this.configuration)
      .membersControllerGetForecastSummary(assetId, userId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a member\'s role within an asset (deprecated - use permissions endpoint)
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateMemberRoleDto} updateMemberRoleDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetMembershipApi
   */
  public membersControllerUpdate(
    id: string,
    assetId: string,
    updateMemberRoleDto: UpdateMemberRoleDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetMembershipApiFp(this.configuration)
      .membersControllerUpdate(id, assetId, updateMemberRoleDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a member\'s governance attributes (role, shares, ownership)
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateMemberGovernanceDto} updateMemberGovernanceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetMembershipApi
   */
  public membersControllerUpdateGovernance(
    id: string,
    assetId: string,
    updateMemberGovernanceDto: UpdateMemberGovernanceDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetMembershipApiFp(this.configuration)
      .membersControllerUpdateGovernance(id, assetId, updateMemberGovernanceDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a member\'s granular permissions within an asset
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateMemberPermissionsDto} updateMemberPermissionsDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetMembershipApi
   */
  public membersControllerUpdatePermissions(
    id: string,
    assetId: string,
    updateMemberPermissionsDto: UpdateMemberPermissionsDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetMembershipApiFp(this.configuration)
      .membersControllerUpdatePermissions(id, assetId, updateMemberPermissionsDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AssetStorageApi - axios parameter creator
 * @export
 */
export const AssetStorageApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Add an external URL link as a document
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerAddExternalLink: async (
      assetId: string,
      body: object,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerAddExternalLink', 'assetId', assetId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('assetStorageControllerAddExternalLink', 'body', body);
      const localVarPath = `/assets/{assetId}/items/external-link`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new directory
     * @param {string} assetId
     * @param {CreateDirectoryDto} createDirectoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerCreateDirectory: async (
      assetId: string,
      createDirectoryDto: CreateDirectoryDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerCreateDirectory', 'assetId', assetId);
      // verify required parameter 'createDirectoryDto' is not null or undefined
      assertParamExists(
        'assetStorageControllerCreateDirectory',
        'createDirectoryDto',
        createDirectoryDto
      );
      const localVarPath = `/assets/{assetId}/items/directory`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createDirectoryDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List files and directories at a specific path
     * @param {string} assetId
     * @param {string} [path] The path within the asset storage to list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerFindAll: async (
      assetId: string,
      path?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/items`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (path !== undefined) {
        localVarQueryParameter['path'] = path;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a temporary public URL for a file
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerFindOne: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerFindOne', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetStorageControllerFindOne', 'id', id);
      const localVarPath = `/assets/{assetId}/items/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Move an item to a new path
     * @param {string} assetId
     * @param {string} id
     * @param {MoveItemDto} moveItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerMoveFile: async (
      assetId: string,
      id: string,
      moveItemDto: MoveItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerMoveFile', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetStorageControllerMoveFile', 'id', id);
      // verify required parameter 'moveItemDto' is not null or undefined
      assertParamExists('assetStorageControllerMoveFile', 'moveItemDto', moveItemDto);
      const localVarPath = `/assets/{assetId}/items/{id}/move`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        moveItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete an item (file or directory)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerRemove: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerRemove', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetStorageControllerRemove', 'id', id);
      const localVarPath = `/assets/{assetId}/items/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Rename an item
     * @param {string} assetId
     * @param {string} id
     * @param {RenameItemDto} renameItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerRenameItem: async (
      assetId: string,
      id: string,
      renameItemDto: RenameItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerRenameItem', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetStorageControllerRenameItem', 'id', id);
      // verify required parameter 'renameItemDto' is not null or undefined
      assertParamExists('assetStorageControllerRenameItem', 'renameItemDto', renameItemDto);
      const localVarPath = `/assets/{assetId}/items/{id}/rename`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        renameItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload one or more files
     * @param {string} assetId
     * @param {Array<File>} files Files to upload.
     * @param {string} path Target path in asset storage.
     * @param {string} [context]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerUploadFiles: async (
      assetId: string,
      files: Array<File>,
      path: string,
      context?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('assetStorageControllerUploadFiles', 'assetId', assetId);
      // verify required parameter 'files' is not null or undefined
      assertParamExists('assetStorageControllerUploadFiles', 'files', files);
      // verify required parameter 'path' is not null or undefined
      assertParamExists('assetStorageControllerUploadFiles', 'path', path);
      const localVarPath = `/assets/{assetId}/items/file`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (files) {
        files.forEach(element => {
          localVarFormParams.append('files', element as any);
        });
      }

      if (path !== undefined) {
        localVarFormParams.append('path', path as any);
      }

      if (context !== undefined) {
        localVarFormParams.append('context', context as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AssetStorageApi - functional programming interface
 * @export
 */
export const AssetStorageApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssetStorageApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Add an external URL link as a document
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerAddExternalLink(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetStorageItemDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assetStorageControllerAddExternalLink(
          assetId,
          body,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerAddExternalLink']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new directory
     * @param {string} assetId
     * @param {CreateDirectoryDto} createDirectoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerCreateDirectory(
      assetId: string,
      createDirectoryDto: CreateDirectoryDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assetStorageControllerCreateDirectory(
          assetId,
          createDirectoryDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerCreateDirectory']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List files and directories at a specific path
     * @param {string} assetId
     * @param {string} [path] The path within the asset storage to list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerFindAll(
      assetId: string,
      path?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetStorageItemDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetStorageControllerFindAll(
        assetId,
        path,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a temporary public URL for a file
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileInfoDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetStorageControllerFindOne(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Move an item to a new path
     * @param {string} assetId
     * @param {string} id
     * @param {MoveItemDto} moveItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerMoveFile(
      assetId: string,
      id: string,
      moveItemDto: MoveItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetStorageControllerMoveFile(
        assetId,
        id,
        moveItemDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerMoveFile']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete an item (file or directory)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerRemove(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetStorageControllerRemove(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerRemove']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Rename an item
     * @param {string} assetId
     * @param {string} id
     * @param {RenameItemDto} renameItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerRenameItem(
      assetId: string,
      id: string,
      renameItemDto: RenameItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetStorageControllerRenameItem(
        assetId,
        id,
        renameItemDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerRenameItem']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Upload one or more files
     * @param {string} assetId
     * @param {Array<File>} files Files to upload.
     * @param {string} path Target path in asset storage.
     * @param {string} [context]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetStorageControllerUploadFiles(
      assetId: string,
      files: Array<File>,
      path: string,
      context?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadCompletionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetStorageControllerUploadFiles(
        assetId,
        files,
        path,
        context,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetStorageApi.assetStorageControllerUploadFiles']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AssetStorageApi - factory interface
 * @export
 */
export const AssetStorageApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssetStorageApiFp(configuration);
  return {
    /**
     *
     * @summary Add an external URL link as a document
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerAddExternalLink(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetStorageItemDto> {
      return localVarFp
        .assetStorageControllerAddExternalLink(assetId, body, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new directory
     * @param {string} assetId
     * @param {CreateDirectoryDto} createDirectoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerCreateDirectory(
      assetId: string,
      createDirectoryDto: CreateDirectoryDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetStorageControllerCreateDirectory(assetId, createDirectoryDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List files and directories at a specific path
     * @param {string} assetId
     * @param {string} [path] The path within the asset storage to list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerFindAll(
      assetId: string,
      path?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<AssetStorageItemDto>> {
      return localVarFp
        .assetStorageControllerFindAll(assetId, path, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get a temporary public URL for a file
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FileInfoDto> {
      return localVarFp
        .assetStorageControllerFindOne(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Move an item to a new path
     * @param {string} assetId
     * @param {string} id
     * @param {MoveItemDto} moveItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerMoveFile(
      assetId: string,
      id: string,
      moveItemDto: MoveItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetStorageControllerMoveFile(assetId, id, moveItemDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete an item (file or directory)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerRemove(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetStorageControllerRemove(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Rename an item
     * @param {string} assetId
     * @param {string} id
     * @param {RenameItemDto} renameItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerRenameItem(
      assetId: string,
      id: string,
      renameItemDto: RenameItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetStorageControllerRenameItem(assetId, id, renameItemDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Upload one or more files
     * @param {string} assetId
     * @param {Array<File>} files Files to upload.
     * @param {string} path Target path in asset storage.
     * @param {string} [context]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetStorageControllerUploadFiles(
      assetId: string,
      files: Array<File>,
      path: string,
      context?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UploadCompletionDto> {
      return localVarFp
        .assetStorageControllerUploadFiles(assetId, files, path, context, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AssetStorageApi - object-oriented interface
 * @export
 * @class AssetStorageApi
 * @extends {BaseAPI}
 */
export class AssetStorageApi extends BaseAPI {
  /**
   *
   * @summary Add an external URL link as a document
   * @param {string} assetId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerAddExternalLink(
    assetId: string,
    body: object,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerAddExternalLink(assetId, body, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new directory
   * @param {string} assetId
   * @param {CreateDirectoryDto} createDirectoryDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerCreateDirectory(
    assetId: string,
    createDirectoryDto: CreateDirectoryDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerCreateDirectory(assetId, createDirectoryDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List files and directories at a specific path
   * @param {string} assetId
   * @param {string} [path] The path within the asset storage to list.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerFindAll(
    assetId: string,
    path?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerFindAll(assetId, path, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a temporary public URL for a file
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerFindOne(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerFindOne(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Move an item to a new path
   * @param {string} assetId
   * @param {string} id
   * @param {MoveItemDto} moveItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerMoveFile(
    assetId: string,
    id: string,
    moveItemDto: MoveItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerMoveFile(assetId, id, moveItemDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete an item (file or directory)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerRemove(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerRemove(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Rename an item
   * @param {string} assetId
   * @param {string} id
   * @param {RenameItemDto} renameItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerRenameItem(
    assetId: string,
    id: string,
    renameItemDto: RenameItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerRenameItem(assetId, id, renameItemDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Upload one or more files
   * @param {string} assetId
   * @param {Array<File>} files Files to upload.
   * @param {string} path Target path in asset storage.
   * @param {string} [context]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetStorageApi
   */
  public assetStorageControllerUploadFiles(
    assetId: string,
    files: Array<File>,
    path: string,
    context?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssetStorageApiFp(this.configuration)
      .assetStorageControllerUploadFiles(assetId, files, path, context, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Archive an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerArchiveAsset: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerArchiveAsset', 'id', id);
      const localVarPath = `/assets/{id}/archive`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new asset
     * @param {CreateAssetDto} createAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerCreate: async (
      createAssetDto: CreateAssetDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createAssetDto' is not null or undefined
      assertParamExists('assetsControllerCreate', 'createAssetDto', createAssetDto);
      const localVarPath = `/assets`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAssetDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Invite one or more users to an asset
     * @param {string} id
     * @param {CreateInvitationsDto} createInvitationsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerCreateInvitations: async (
      id: string,
      createInvitationsDto: CreateInvitationsDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerCreateInvitations', 'id', id);
      // verify required parameter 'createInvitationsDto' is not null or undefined
      assertParamExists(
        'assetsControllerCreateInvitations',
        'createInvitationsDto',
        createInvitationsDto
      );
      const localVarPath = `/assets/{id}/invitations`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createInvitationsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Process onboarding summary: legal structure, co-owners, feed item
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerCreateOnboardingSummary: async (
      id: string,
      body: object,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerCreateOnboardingSummary', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('assetsControllerCreateOnboardingSummary', 'body', body);
      const localVarPath = `/assets/{id}/items/onboarding-summary`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Remove street view panorama from an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerDeleteStreetView: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerDeleteStreetView', 'id', id);
      const localVarPath = `/assets/{id}/street-view`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all assets for the current user (owned or member of)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/assets`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get an asset\'s detailed and enriched information
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerFindOne: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerFindOne', 'id', id);
      const localVarPath = `/assets/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get street view panorama data for an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerGetStreetView: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerGetStreetView', 'id', id);
      const localVarPath = `/assets/{id}/street-view`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unarchive an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUnarchiveAsset: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerUnarchiveAsset', 'id', id);
      const localVarPath = `/assets/{id}/unarchive`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an asset
     * @param {string} id
     * @param {UpdateAssetDto} updateAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdate: async (
      id: string,
      updateAssetDto: UpdateAssetDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerUpdate', 'id', id);
      // verify required parameter 'updateAssetDto' is not null or undefined
      assertParamExists('assetsControllerUpdate', 'updateAssetDto', updateAssetDto);
      const localVarPath = `/assets/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateAssetDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update the annual budget cap for an asset
     * @param {string} id
     * @param {UpdateBudgetCapDto} updateBudgetCapDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateBudgetCap: async (
      id: string,
      updateBudgetCapDto: UpdateBudgetCapDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerUpdateBudgetCap', 'id', id);
      // verify required parameter 'updateBudgetCapDto' is not null or undefined
      assertParamExists(
        'assetsControllerUpdateBudgetCap',
        'updateBudgetCapDto',
        updateBudgetCapDto
      );
      const localVarPath = `/assets/{id}/budget-cap`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBudgetCapDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update the governance configuration for an asset
     * @param {string} id
     * @param {UpdateGovernanceDto} updateGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateGovernance: async (
      id: string,
      updateGovernanceDto: UpdateGovernanceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerUpdateGovernance', 'id', id);
      // verify required parameter 'updateGovernanceDto' is not null or undefined
      assertParamExists(
        'assetsControllerUpdateGovernance',
        'updateGovernanceDto',
        updateGovernanceDto
      );
      const localVarPath = `/assets/{id}/governance`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateGovernanceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update the owner governance (shares, ownership nature, voting rights)
     * @param {string} id
     * @param {UpdateOwnerGovernanceDto} updateOwnerGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateOwnerGovernance: async (
      id: string,
      updateOwnerGovernanceDto: UpdateOwnerGovernanceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerUpdateOwnerGovernance', 'id', id);
      // verify required parameter 'updateOwnerGovernanceDto' is not null or undefined
      assertParamExists(
        'assetsControllerUpdateOwnerGovernance',
        'updateOwnerGovernanceDto',
        updateOwnerGovernanceDto
      );
      const localVarPath = `/assets/{id}/governance/owner`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateOwnerGovernanceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Set or update street view panorama for an asset
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateStreetView: async (
      id: string,
      body: object,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerUpdateStreetView', 'id', id);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('assetsControllerUpdateStreetView', 'body', body);
      const localVarPath = `/assets/{id}/street-view`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload a temporary photo for an asset
     * @param {string} id
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUploadTemporaryPhoto: async (
      id: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assetsControllerUploadTemporaryPhoto', 'id', id);
      const localVarPath = `/assets/{id}/temporary-photo`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Archive an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerArchiveAsset(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerArchiveAsset(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerArchiveAsset']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new asset
     * @param {CreateAssetDto} createAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerCreate(
      createAssetDto: CreateAssetDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerCreate(
        createAssetDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerCreate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Invite one or more users to an asset
     * @param {string} id
     * @param {CreateInvitationsDto} createInvitationsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerCreateInvitations(
      id: string,
      createInvitationsDto: CreateInvitationsDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerCreateInvitations(
        id,
        createInvitationsDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerCreateInvitations']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Process onboarding summary: legal structure, co-owners, feed item
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerCreateOnboardingSummary(
      id: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assetsControllerCreateOnboardingSummary(id, body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerCreateOnboardingSummary']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Remove street view panorama from an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerDeleteStreetView(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerDeleteStreetView(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerDeleteStreetView']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all assets for the current user (owned or member of)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerFindAll(
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<AssetPreviewWithCommunityAndOwnerInfoDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindAll(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerFindAll']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get an asset\'s detailed and enriched information
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerFindOne(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDetailsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerFindOne(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerFindOne']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get street view panorama data for an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerGetStreetView(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerGetStreetView(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerGetStreetView']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Unarchive an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerUnarchiveAsset(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUnarchiveAsset(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerUnarchiveAsset']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an asset
     * @param {string} id
     * @param {UpdateAssetDto} updateAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerUpdate(
      id: string,
      updateAssetDto: UpdateAssetDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUpdate(
        id,
        updateAssetDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerUpdate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update the annual budget cap for an asset
     * @param {string} id
     * @param {UpdateBudgetCapDto} updateBudgetCapDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerUpdateBudgetCap(
      id: string,
      updateBudgetCapDto: UpdateBudgetCapDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AssetsControllerUpdateBudgetCap200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUpdateBudgetCap(
        id,
        updateBudgetCapDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerUpdateBudgetCap']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update the governance configuration for an asset
     * @param {string} id
     * @param {UpdateGovernanceDto} updateGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerUpdateGovernance(
      id: string,
      updateGovernanceDto: UpdateGovernanceDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUpdateGovernance(
        id,
        updateGovernanceDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerUpdateGovernance']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update the owner governance (shares, ownership nature, voting rights)
     * @param {string} id
     * @param {UpdateOwnerGovernanceDto} updateOwnerGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerUpdateOwnerGovernance(
      id: string,
      updateOwnerGovernanceDto: UpdateOwnerGovernanceDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assetsControllerUpdateOwnerGovernance(
          id,
          updateOwnerGovernanceDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerUpdateOwnerGovernance']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Set or update street view panorama for an asset
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerUpdateStreetView(
      id: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerUpdateStreetView(
        id,
        body,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerUpdateStreetView']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Upload a temporary photo for an asset
     * @param {string} id
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerUploadTemporaryPhoto(
      id: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempUploadedImageDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assetsControllerUploadTemporaryPhoto(id, file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsApi.assetsControllerUploadTemporaryPhoto']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssetsApiFp(configuration);
  return {
    /**
     *
     * @summary Archive an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerArchiveAsset(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .assetsControllerArchiveAsset(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new asset
     * @param {CreateAssetDto} createAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerCreate(
      createAssetDto: CreateAssetDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetDto> {
      return localVarFp
        .assetsControllerCreate(createAssetDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Invite one or more users to an asset
     * @param {string} id
     * @param {CreateInvitationsDto} createInvitationsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerCreateInvitations(
      id: string,
      createInvitationsDto: CreateInvitationsDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InvitationDto>> {
      return localVarFp
        .assetsControllerCreateInvitations(id, createInvitationsDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Process onboarding summary: legal structure, co-owners, feed item
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerCreateOnboardingSummary(
      id: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetsControllerCreateOnboardingSummary(id, body, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Remove street view panorama from an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerDeleteStreetView(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetsControllerDeleteStreetView(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all assets for the current user (owned or member of)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerFindAll(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<AssetPreviewWithCommunityAndOwnerInfoDto>> {
      return localVarFp.assetsControllerFindAll(options).then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get an asset\'s detailed and enriched information
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerFindOne(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetDetailsDto> {
      return localVarFp
        .assetsControllerFindOne(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get street view panorama data for an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerGetStreetView(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<object> {
      return localVarFp
        .assetsControllerGetStreetView(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Unarchive an asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUnarchiveAsset(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetsControllerUnarchiveAsset(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update an asset
     * @param {string} id
     * @param {UpdateAssetDto} updateAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdate(
      id: string,
      updateAssetDto: UpdateAssetDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetDto> {
      return localVarFp
        .assetsControllerUpdate(id, updateAssetDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update the annual budget cap for an asset
     * @param {string} id
     * @param {UpdateBudgetCapDto} updateBudgetCapDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateBudgetCap(
      id: string,
      updateBudgetCapDto: UpdateBudgetCapDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetsControllerUpdateBudgetCap200Response> {
      return localVarFp
        .assetsControllerUpdateBudgetCap(id, updateBudgetCapDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update the governance configuration for an asset
     * @param {string} id
     * @param {UpdateGovernanceDto} updateGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateGovernance(
      id: string,
      updateGovernanceDto: UpdateGovernanceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetsControllerUpdateGovernance(id, updateGovernanceDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update the owner governance (shares, ownership nature, voting rights)
     * @param {string} id
     * @param {UpdateOwnerGovernanceDto} updateOwnerGovernanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateOwnerGovernance(
      id: string,
      updateOwnerGovernanceDto: UpdateOwnerGovernanceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assetsControllerUpdateOwnerGovernance(id, updateOwnerGovernanceDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Set or update street view panorama for an asset
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUpdateStreetView(
      id: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<object> {
      return localVarFp
        .assetsControllerUpdateStreetView(id, body, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Upload a temporary photo for an asset
     * @param {string} id
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerUploadTemporaryPhoto(
      id: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TempUploadedImageDto> {
      return localVarFp
        .assetsControllerUploadTemporaryPhoto(id, file, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
  /**
   *
   * @summary Archive an asset
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerArchiveAsset(id: string, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .assetsControllerArchiveAsset(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new asset
   * @param {CreateAssetDto} createAssetDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerCreate(createAssetDto: CreateAssetDto, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .assetsControllerCreate(createAssetDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Invite one or more users to an asset
   * @param {string} id
   * @param {CreateInvitationsDto} createInvitationsDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerCreateInvitations(
    id: string,
    createInvitationsDto: CreateInvitationsDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerCreateInvitations(id, createInvitationsDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Process onboarding summary: legal structure, co-owners, feed item
   * @param {string} id
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerCreateOnboardingSummary(
    id: string,
    body: object,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerCreateOnboardingSummary(id, body, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Remove street view panorama from an asset
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerDeleteStreetView(id: string, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .assetsControllerDeleteStreetView(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all assets for the current user (owned or member of)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerFindAll(options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .assetsControllerFindAll(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get an asset\'s detailed and enriched information
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerFindOne(id: string, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .assetsControllerFindOne(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get street view panorama data for an asset
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerGetStreetView(id: string, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .assetsControllerGetStreetView(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Unarchive an asset
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerUnarchiveAsset(id: string, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .assetsControllerUnarchiveAsset(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an asset
   * @param {string} id
   * @param {UpdateAssetDto} updateAssetDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerUpdate(
    id: string,
    updateAssetDto: UpdateAssetDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerUpdate(id, updateAssetDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update the annual budget cap for an asset
   * @param {string} id
   * @param {UpdateBudgetCapDto} updateBudgetCapDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerUpdateBudgetCap(
    id: string,
    updateBudgetCapDto: UpdateBudgetCapDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerUpdateBudgetCap(id, updateBudgetCapDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update the governance configuration for an asset
   * @param {string} id
   * @param {UpdateGovernanceDto} updateGovernanceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerUpdateGovernance(
    id: string,
    updateGovernanceDto: UpdateGovernanceDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerUpdateGovernance(id, updateGovernanceDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update the owner governance (shares, ownership nature, voting rights)
   * @param {string} id
   * @param {UpdateOwnerGovernanceDto} updateOwnerGovernanceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerUpdateOwnerGovernance(
    id: string,
    updateOwnerGovernanceDto: UpdateOwnerGovernanceDto,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerUpdateOwnerGovernance(id, updateOwnerGovernanceDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Set or update street view panorama for an asset
   * @param {string} id
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerUpdateStreetView(
    id: string,
    body: object,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerUpdateStreetView(id, body, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Upload a temporary photo for an asset
   * @param {string} id
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public assetsControllerUploadTemporaryPhoto(
    id: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return AssetsApiFp(this.configuration)
      .assetsControllerUploadTemporaryPhoto(id, file, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Change password for authenticated user
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerChangePassword: async (
      changePasswordDto: ChangePasswordDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'changePasswordDto' is not null or undefined
      assertParamExists('authControllerChangePassword', 'changePasswordDto', changePasswordDto);
      const localVarPath = `/auth/change-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        changePasswordDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Check the login method for an email address
     * @param {CheckEmailStatusDto} checkEmailStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCheckEmailStatus: async (
      checkEmailStatusDto: CheckEmailStatusDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'checkEmailStatusDto' is not null or undefined
      assertParamExists(
        'authControllerCheckEmailStatus',
        'checkEmailStatusDto',
        checkEmailStatusDto
      );
      const localVarPath = `/auth/check-email-status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkEmailStatusDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Register a new user
     * @param {RegisterUserDto} registerUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCreate: async (
      registerUserDto: RegisterUserDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'registerUserDto' is not null or undefined
      assertParamExists('authControllerCreate', 'registerUserDto', registerUserDto);
      const localVarPath = `/auth/register`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerUserDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Request a password reset email
     * @param {RequestPasswordResetDto} requestPasswordResetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCreatePasswordResetRequest: async (
      requestPasswordResetDto: RequestPasswordResetDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'requestPasswordResetDto' is not null or undefined
      assertParamExists(
        'authControllerCreatePasswordResetRequest',
        'requestPasswordResetDto',
        requestPasswordResetDto
      );
      const localVarPath = `/auth/request-password-reset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestPasswordResetDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Check current impersonation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerGetImpersonateStatus: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/impersonate-status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Impersonate another user (admin only)
     * @param {string} [email] Email of the user to impersonate
     * @param {string} [userId] ID of the user to impersonate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerImpersonate: async (
      email?: string,
      userId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/impersonate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (email !== undefined) {
        localVarQueryParameter['email'] = email;
      }

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stop impersonating and return to admin account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerStopImpersonate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/stop-impersonate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Reset the password using a valid token
     * @param {UpdatePasswordDto} updatePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerUpdate: async (
      updatePasswordDto: UpdatePasswordDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'updatePasswordDto' is not null or undefined
      assertParamExists('authControllerUpdate', 'updatePasswordDto', updatePasswordDto);
      const localVarPath = `/auth/reset-password-with-token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePasswordDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Change password for authenticated user
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerChangePassword(
      changePasswordDto: ChangePasswordDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerChangePassword(
        changePasswordDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerChangePassword']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Check the login method for an email address
     * @param {CheckEmailStatusDto} checkEmailStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerCheckEmailStatus(
      checkEmailStatusDto: CheckEmailStatusDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailStatusDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCheckEmailStatus(
        checkEmailStatusDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerCheckEmailStatus']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Register a new user
     * @param {RegisterUserDto} registerUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerCreate(
      registerUserDto: RegisterUserDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithPrivateInfoDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCreate(
        registerUserDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Request a password reset email
     * @param {RequestPasswordResetDto} requestPasswordResetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerCreatePasswordResetRequest(
      requestPasswordResetDto: RequestPasswordResetDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authControllerCreatePasswordResetRequest(
          requestPasswordResetDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerCreatePasswordResetRequest']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Check current impersonation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerGetImpersonateStatus(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authControllerGetImpersonateStatus(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerGetImpersonateStatus']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Impersonate another user (admin only)
     * @param {string} [email] Email of the user to impersonate
     * @param {string} [userId] ID of the user to impersonate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerImpersonate(
      email?: string,
      userId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerImpersonate(
        email,
        userId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerImpersonate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Stop impersonating and return to admin account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerStopImpersonate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.authControllerStopImpersonate(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerStopImpersonate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Reset the password using a valid token
     * @param {UpdatePasswordDto} updatePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerUpdate(
      updatePasswordDto: UpdatePasswordDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerUpdate(
        updatePasswordDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthenticationApi.authControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthenticationApiFp(configuration);
  return {
    /**
     *
     * @summary Change password for authenticated user
     * @param {ChangePasswordDto} changePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerChangePassword(
      changePasswordDto: ChangePasswordDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponseDto> {
      return localVarFp
        .authControllerChangePassword(changePasswordDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Check the login method for an email address
     * @param {CheckEmailStatusDto} checkEmailStatusDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCheckEmailStatus(
      checkEmailStatusDto: CheckEmailStatusDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EmailStatusDto> {
      return localVarFp
        .authControllerCheckEmailStatus(checkEmailStatusDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Register a new user
     * @param {RegisterUserDto} registerUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCreate(
      registerUserDto: RegisterUserDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserWithPrivateInfoDto> {
      return localVarFp
        .authControllerCreate(registerUserDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Request a password reset email
     * @param {RequestPasswordResetDto} requestPasswordResetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerCreatePasswordResetRequest(
      requestPasswordResetDto: RequestPasswordResetDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponseDto> {
      return localVarFp
        .authControllerCreatePasswordResetRequest(requestPasswordResetDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Check current impersonation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerGetImpersonateStatus(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .authControllerGetImpersonateStatus(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Impersonate another user (admin only)
     * @param {string} [email] Email of the user to impersonate
     * @param {string} [userId] ID of the user to impersonate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerImpersonate(
      email?: string,
      userId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponseDto> {
      return localVarFp
        .authControllerImpersonate(email, userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Stop impersonating and return to admin account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerStopImpersonate(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponseDto> {
      return localVarFp
        .authControllerStopImpersonate(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Reset the password using a valid token
     * @param {UpdatePasswordDto} updatePasswordDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerUpdate(
      updatePasswordDto: UpdatePasswordDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponseDto> {
      return localVarFp
        .authControllerUpdate(updatePasswordDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
  /**
   *
   * @summary Change password for authenticated user
   * @param {ChangePasswordDto} changePasswordDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerChangePassword(
    changePasswordDto: ChangePasswordDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authControllerChangePassword(changePasswordDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Check the login method for an email address
   * @param {CheckEmailStatusDto} checkEmailStatusDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerCheckEmailStatus(
    checkEmailStatusDto: CheckEmailStatusDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authControllerCheckEmailStatus(checkEmailStatusDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Register a new user
   * @param {RegisterUserDto} registerUserDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerCreate(registerUserDto: RegisterUserDto, options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authControllerCreate(registerUserDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Request a password reset email
   * @param {RequestPasswordResetDto} requestPasswordResetDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerCreatePasswordResetRequest(
    requestPasswordResetDto: RequestPasswordResetDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authControllerCreatePasswordResetRequest(requestPasswordResetDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Check current impersonation status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerGetImpersonateStatus(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authControllerGetImpersonateStatus(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Impersonate another user (admin only)
   * @param {string} [email] Email of the user to impersonate
   * @param {string} [userId] ID of the user to impersonate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerImpersonate(
    email?: string,
    userId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authControllerImpersonate(email, userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Stop impersonating and return to admin account
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerStopImpersonate(options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .authControllerStopImpersonate(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Reset the password using a valid token
   * @param {UpdatePasswordDto} updatePasswordDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public authControllerUpdate(
    updatePasswordDto: UpdatePasswordDto,
    options?: RawAxiosRequestConfig
  ) {
    return AuthenticationApiFp(this.configuration)
      .authControllerUpdate(updatePasswordDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * BankAccountsApi - axios parameter creator
 * @export
 */
export const BankAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new shared bank account
     * @param {string} assetId
     * @param {CreateBankAccountDto} createBankAccountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerCreate: async (
      assetId: string,
      createBankAccountDto: CreateBankAccountDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createBankAccountDto' is not null or undefined
      assertParamExists(
        'bankAccountsControllerCreate',
        'createBankAccountDto',
        createBankAccountDto
      );
      const localVarPath = `/assets/{assetId}/bank-accounts`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBankAccountDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Record a manual balance statement for a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {CreateBankAccountBalanceDto} createBankAccountBalanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerCreateBalance: async (
      id: string,
      assetId: string,
      createBankAccountBalanceDto: CreateBankAccountBalanceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bankAccountsControllerCreateBalance', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerCreateBalance', 'assetId', assetId);
      // verify required parameter 'createBankAccountBalanceDto' is not null or undefined
      assertParamExists(
        'bankAccountsControllerCreateBalance',
        'createBankAccountBalanceDto',
        createBankAccountBalanceDto
      );
      const localVarPath = `/assets/{assetId}/bank-accounts/{id}/balances`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBankAccountBalanceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerDelete: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bankAccountsControllerDelete', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerDelete', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/bank-accounts/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a balance statement
     * @param {string} id
     * @param {string} assetId
     * @param {string} balanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerDeleteBalance: async (
      id: string,
      assetId: string,
      balanceId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bankAccountsControllerDeleteBalance', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerDeleteBalance', 'assetId', assetId);
      // verify required parameter 'balanceId' is not null or undefined
      assertParamExists('bankAccountsControllerDeleteBalance', 'balanceId', balanceId);
      const localVarPath = `/assets/{assetId}/bank-accounts/{id}/balances/{balanceId}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'balanceId'}}`, encodeURIComponent(String(balanceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all shared bank accounts related to an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerFindAllByAsset: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerFindAllByAsset', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/bank-accounts`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List the balance statement history of a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerFindBalances: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bankAccountsControllerFindBalances', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerFindBalances', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/bank-accounts/{id}/balances`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single bank account by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bankAccountsControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/bank-accounts/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateBankAccountDto} updateBankAccountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerUpdate: async (
      id: string,
      assetId: string,
      updateBankAccountDto: UpdateBankAccountDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('bankAccountsControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('bankAccountsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'updateBankAccountDto' is not null or undefined
      assertParamExists(
        'bankAccountsControllerUpdate',
        'updateBankAccountDto',
        updateBankAccountDto
      );
      const localVarPath = `/assets/{assetId}/bank-accounts/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBankAccountDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BankAccountsApi - functional programming interface
 * @export
 */
export const BankAccountsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BankAccountsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new shared bank account
     * @param {string} assetId
     * @param {CreateBankAccountDto} createBankAccountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerCreate(
      assetId: string,
      createBankAccountDto: CreateBankAccountDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankAccountDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountsControllerCreate(
        assetId,
        createBankAccountDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Record a manual balance statement for a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {CreateBankAccountBalanceDto} createBankAccountBalanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerCreateBalance(
      id: string,
      assetId: string,
      createBankAccountBalanceDto: CreateBankAccountBalanceDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankAccountBalanceDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountsControllerCreateBalance(
        id,
        assetId,
        createBankAccountBalanceDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerCreateBalance']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerDelete(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountsControllerDelete(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a balance statement
     * @param {string} id
     * @param {string} assetId
     * @param {string} balanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerDeleteBalance(
      id: string,
      assetId: string,
      balanceId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountsControllerDeleteBalance(
        id,
        assetId,
        balanceId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerDeleteBalance']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List all shared bank accounts related to an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerFindAllByAsset(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankAccountDto>>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.bankAccountsControllerFindAllByAsset(assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerFindAllByAsset']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List the balance statement history of a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerFindBalances(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankAccountBalanceDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountsControllerFindBalances(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerFindBalances']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single bank account by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankAccountDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountsControllerFindOne(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateBankAccountDto} updateBankAccountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bankAccountsControllerUpdate(
      id: string,
      assetId: string,
      updateBankAccountDto: UpdateBankAccountDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankAccountDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bankAccountsControllerUpdate(
        id,
        assetId,
        updateBankAccountDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BankAccountsApi.bankAccountsControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BankAccountsApi - factory interface
 * @export
 */
export const BankAccountsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BankAccountsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new shared bank account
     * @param {string} assetId
     * @param {CreateBankAccountDto} createBankAccountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerCreate(
      assetId: string,
      createBankAccountDto: CreateBankAccountDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BankAccountDto> {
      return localVarFp
        .bankAccountsControllerCreate(assetId, createBankAccountDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Record a manual balance statement for a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {CreateBankAccountBalanceDto} createBankAccountBalanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerCreateBalance(
      id: string,
      assetId: string,
      createBankAccountBalanceDto: CreateBankAccountBalanceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BankAccountBalanceDto> {
      return localVarFp
        .bankAccountsControllerCreateBalance(id, assetId, createBankAccountBalanceDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerDelete(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .bankAccountsControllerDelete(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a balance statement
     * @param {string} id
     * @param {string} assetId
     * @param {string} balanceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerDeleteBalance(
      id: string,
      assetId: string,
      balanceId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .bankAccountsControllerDeleteBalance(id, assetId, balanceId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List all shared bank accounts related to an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerFindAllByAsset(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<BankAccountDto>> {
      return localVarFp
        .bankAccountsControllerFindAllByAsset(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List the balance statement history of a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerFindBalances(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<BankAccountBalanceDto>> {
      return localVarFp
        .bankAccountsControllerFindBalances(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single bank account by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BankAccountDto> {
      return localVarFp
        .bankAccountsControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a bank account
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateBankAccountDto} updateBankAccountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bankAccountsControllerUpdate(
      id: string,
      assetId: string,
      updateBankAccountDto: UpdateBankAccountDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BankAccountDto> {
      return localVarFp
        .bankAccountsControllerUpdate(id, assetId, updateBankAccountDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * BankAccountsApi - object-oriented interface
 * @export
 * @class BankAccountsApi
 * @extends {BaseAPI}
 */
export class BankAccountsApi extends BaseAPI {
  /**
   *
   * @summary Create a new shared bank account
   * @param {string} assetId
   * @param {CreateBankAccountDto} createBankAccountDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerCreate(
    assetId: string,
    createBankAccountDto: CreateBankAccountDto,
    options?: RawAxiosRequestConfig
  ) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerCreate(assetId, createBankAccountDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Record a manual balance statement for a bank account
   * @param {string} id
   * @param {string} assetId
   * @param {CreateBankAccountBalanceDto} createBankAccountBalanceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerCreateBalance(
    id: string,
    assetId: string,
    createBankAccountBalanceDto: CreateBankAccountBalanceDto,
    options?: RawAxiosRequestConfig
  ) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerCreateBalance(id, assetId, createBankAccountBalanceDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a bank account
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerDelete(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerDelete(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a balance statement
   * @param {string} id
   * @param {string} assetId
   * @param {string} balanceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerDeleteBalance(
    id: string,
    assetId: string,
    balanceId: string,
    options?: RawAxiosRequestConfig
  ) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerDeleteBalance(id, assetId, balanceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List all shared bank accounts related to an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerFindAllByAsset(assetId: string, options?: RawAxiosRequestConfig) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerFindAllByAsset(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List the balance statement history of a bank account
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerFindBalances(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerFindBalances(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single bank account by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerFindOne(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a bank account
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateBankAccountDto} updateBankAccountDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BankAccountsApi
   */
  public bankAccountsControllerUpdate(
    id: string,
    assetId: string,
    updateBankAccountDto: UpdateBankAccountDto,
    options?: RawAxiosRequestConfig
  ) {
    return BankAccountsApiFp(this.configuration)
      .bankAccountsControllerUpdate(id, assetId, updateBankAccountDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * BudgetApi - axios parameter creator
 * @export
 */
export const BudgetApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Soft delete one budget line
     * @param {string} assetId
     * @param {string} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerDeleteLine: async (
      assetId: string,
      lineId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetControllerDeleteLine', 'assetId', assetId);
      // verify required parameter 'lineId' is not null or undefined
      assertParamExists('budgetControllerDeleteLine', 'lineId', lineId);
      const localVarPath = `/assets/{assetId}/budget/lines/{lineId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'lineId'}}`, encodeURIComponent(String(lineId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary N−1 fixed costs per category, N−1 daily-life envelope and projects still to be decided
     * @param {string} assetId
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerGetSuggestions: async (
      assetId: string,
      year: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetControllerGetSuggestions', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('budgetControllerGetSuggestions', 'year', year);
      const localVarPath = `/assets/{assetId}/budget/{year}/suggestions`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'year'}}`, encodeURIComponent(String(year)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Planned / real / variance per budget line, plus what was not planned
     * @param {string} assetId
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerGetTracking: async (
      assetId: string,
      year: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetControllerGetTracking', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('budgetControllerGetTracking', 'year', year);
      const localVarPath = `/assets/{assetId}/budget/{year}/tracking`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'year'}}`, encodeURIComponent(String(year)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Budget lines, section totals, calculated cap, balance, per-household share and fund call suggestion
     * @param {string} assetId
     * @param {number} year
     * @param {string} [fundCallFrequencyPerYear] Cadence the fund call suggestion is expressed in. Defaults to 12 (monthly).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerGetYear: async (
      assetId: string,
      year: number,
      fundCallFrequencyPerYear?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetControllerGetYear', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('budgetControllerGetYear', 'year', year);
      const localVarPath = `/assets/{assetId}/budget/{year}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'year'}}`, encodeURIComponent(String(year)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (fundCallFrequencyPerYear !== undefined) {
        localVarQueryParameter['fundCallFrequencyPerYear'] = fundCallFrequencyPerYear;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Edit one budget line (the wizard keeps using the replace-all PUT)
     * @param {string} assetId
     * @param {string} lineId
     * @param {UpdateBudgetLineDto} updateBudgetLineDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerUpdateLine: async (
      assetId: string,
      lineId: string,
      updateBudgetLineDto: UpdateBudgetLineDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetControllerUpdateLine', 'assetId', assetId);
      // verify required parameter 'lineId' is not null or undefined
      assertParamExists('budgetControllerUpdateLine', 'lineId', lineId);
      // verify required parameter 'updateBudgetLineDto' is not null or undefined
      assertParamExists('budgetControllerUpdateLine', 'updateBudgetLineDto', updateBudgetLineDto);
      const localVarPath = `/assets/{assetId}/budget/lines/{lineId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'lineId'}}`, encodeURIComponent(String(lineId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBudgetLineDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BudgetApi - functional programming interface
 * @export
 */
export const BudgetApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BudgetApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Soft delete one budget line
     * @param {string} assetId
     * @param {string} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetControllerDeleteLine(
      assetId: string,
      lineId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetControllerDeleteLine(
        assetId,
        lineId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetApi.budgetControllerDeleteLine']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary N−1 fixed costs per category, N−1 daily-life envelope and projects still to be decided
     * @param {string} assetId
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetControllerGetSuggestions(
      assetId: string,
      year: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetSuggestionsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetControllerGetSuggestions(
        assetId,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetApi.budgetControllerGetSuggestions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Planned / real / variance per budget line, plus what was not planned
     * @param {string} assetId
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetControllerGetTracking(
      assetId: string,
      year: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetTrackingDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetControllerGetTracking(
        assetId,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetApi.budgetControllerGetTracking']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Budget lines, section totals, calculated cap, balance, per-household share and fund call suggestion
     * @param {string} assetId
     * @param {number} year
     * @param {string} [fundCallFrequencyPerYear] Cadence the fund call suggestion is expressed in. Defaults to 12 (monthly).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetControllerGetYear(
      assetId: string,
      year: number,
      fundCallFrequencyPerYear?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetYearDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetControllerGetYear(
        assetId,
        year,
        fundCallFrequencyPerYear,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetApi.budgetControllerGetYear']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Edit one budget line (the wizard keeps using the replace-all PUT)
     * @param {string} assetId
     * @param {string} lineId
     * @param {UpdateBudgetLineDto} updateBudgetLineDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetControllerUpdateLine(
      assetId: string,
      lineId: string,
      updateBudgetLineDto: UpdateBudgetLineDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetYearLineDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetControllerUpdateLine(
        assetId,
        lineId,
        updateBudgetLineDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetApi.budgetControllerUpdateLine']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BudgetApi - factory interface
 * @export
 */
export const BudgetApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BudgetApiFp(configuration);
  return {
    /**
     *
     * @summary Soft delete one budget line
     * @param {string} assetId
     * @param {string} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerDeleteLine(
      assetId: string,
      lineId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .budgetControllerDeleteLine(assetId, lineId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary N−1 fixed costs per category, N−1 daily-life envelope and projects still to be decided
     * @param {string} assetId
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerGetSuggestions(
      assetId: string,
      year: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetSuggestionsDto> {
      return localVarFp
        .budgetControllerGetSuggestions(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Planned / real / variance per budget line, plus what was not planned
     * @param {string} assetId
     * @param {number} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerGetTracking(
      assetId: string,
      year: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetTrackingDto> {
      return localVarFp
        .budgetControllerGetTracking(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Budget lines, section totals, calculated cap, balance, per-household share and fund call suggestion
     * @param {string} assetId
     * @param {number} year
     * @param {string} [fundCallFrequencyPerYear] Cadence the fund call suggestion is expressed in. Defaults to 12 (monthly).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerGetYear(
      assetId: string,
      year: number,
      fundCallFrequencyPerYear?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetYearDto> {
      return localVarFp
        .budgetControllerGetYear(assetId, year, fundCallFrequencyPerYear, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Edit one budget line (the wizard keeps using the replace-all PUT)
     * @param {string} assetId
     * @param {string} lineId
     * @param {UpdateBudgetLineDto} updateBudgetLineDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetControllerUpdateLine(
      assetId: string,
      lineId: string,
      updateBudgetLineDto: UpdateBudgetLineDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetYearLineDto> {
      return localVarFp
        .budgetControllerUpdateLine(assetId, lineId, updateBudgetLineDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * BudgetApi - object-oriented interface
 * @export
 * @class BudgetApi
 * @extends {BaseAPI}
 */
export class BudgetApi extends BaseAPI {
  /**
   *
   * @summary Soft delete one budget line
   * @param {string} assetId
   * @param {string} lineId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetApi
   */
  public budgetControllerDeleteLine(
    assetId: string,
    lineId: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetApiFp(this.configuration)
      .budgetControllerDeleteLine(assetId, lineId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary N−1 fixed costs per category, N−1 daily-life envelope and projects still to be decided
   * @param {string} assetId
   * @param {number} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetApi
   */
  public budgetControllerGetSuggestions(
    assetId: string,
    year: number,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetApiFp(this.configuration)
      .budgetControllerGetSuggestions(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Planned / real / variance per budget line, plus what was not planned
   * @param {string} assetId
   * @param {number} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetApi
   */
  public budgetControllerGetTracking(
    assetId: string,
    year: number,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetApiFp(this.configuration)
      .budgetControllerGetTracking(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Budget lines, section totals, calculated cap, balance, per-household share and fund call suggestion
   * @param {string} assetId
   * @param {number} year
   * @param {string} [fundCallFrequencyPerYear] Cadence the fund call suggestion is expressed in. Defaults to 12 (monthly).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetApi
   */
  public budgetControllerGetYear(
    assetId: string,
    year: number,
    fundCallFrequencyPerYear?: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetApiFp(this.configuration)
      .budgetControllerGetYear(assetId, year, fundCallFrequencyPerYear, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Edit one budget line (the wizard keeps using the replace-all PUT)
   * @param {string} assetId
   * @param {string} lineId
   * @param {UpdateBudgetLineDto} updateBudgetLineDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetApi
   */
  public budgetControllerUpdateLine(
    assetId: string,
    lineId: string,
    updateBudgetLineDto: UpdateBudgetLineDto,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetApiFp(this.configuration)
      .budgetControllerUpdateLine(assetId, lineId, updateBudgetLineDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * BudgetForecastApi - axios parameter creator
 * @export
 */
export const BudgetForecastApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Exclude one real operation from a budget year, without deleting it
     * @param {string} assetId
     * @param {CreateBudgetForecastExclusionDto} createBudgetForecastExclusionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerExcludeExpense: async (
      assetId: string,
      createBudgetForecastExclusionDto: CreateBudgetForecastExclusionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetForecastControllerExcludeExpense', 'assetId', assetId);
      // verify required parameter 'createBudgetForecastExclusionDto' is not null or undefined
      assertParamExists(
        'budgetForecastControllerExcludeExpense',
        'createBudgetForecastExclusionDto',
        createBudgetForecastExclusionDto
      );
      const localVarPath = `/assets/{assetId}/budget-forecast/exclusions`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBudgetForecastExclusionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get budget forecast lines for a given year
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerGetLines: async (
      assetId: string,
      year: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetForecastControllerGetLines', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('budgetForecastControllerGetLines', 'year', year);
      const localVarPath = `/assets/{assetId}/budget-forecast`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the unified forecast view (recurring series + one-off expenses + manual forecast lines)
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerGetView: async (
      assetId: string,
      year: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetForecastControllerGetView', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('budgetForecastControllerGetView', 'year', year);
      const localVarPath = `/assets/{assetId}/budget-forecast/view`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Re-include a previously excluded operation in the budget
     * @param {string} assetId
     * @param {string} exclusionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerReincludeExpense: async (
      assetId: string,
      exclusionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetForecastControllerReincludeExpense', 'assetId', assetId);
      // verify required parameter 'exclusionId' is not null or undefined
      assertParamExists('budgetForecastControllerReincludeExpense', 'exclusionId', exclusionId);
      const localVarPath = `/assets/{assetId}/budget-forecast/exclusions/{exclusionId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'exclusionId'}}`, encodeURIComponent(String(exclusionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Exclude or re-include several operations at once
     * @param {string} assetId
     * @param {BulkBudgetForecastExclusionDto} bulkBudgetForecastExclusionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerSetExclusionsInBulk: async (
      assetId: string,
      bulkBudgetForecastExclusionDto: BulkBudgetForecastExclusionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetForecastControllerSetExclusionsInBulk', 'assetId', assetId);
      // verify required parameter 'bulkBudgetForecastExclusionDto' is not null or undefined
      assertParamExists(
        'budgetForecastControllerSetExclusionsInBulk',
        'bulkBudgetForecastExclusionDto',
        bulkBudgetForecastExclusionDto
      );
      const localVarPath = `/assets/{assetId}/budget-forecast/exclusions/bulk`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bulkBudgetForecastExclusionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Replace all budget forecast lines for a given year
     * @param {string} assetId
     * @param {UpsertBudgetForecastDto} upsertBudgetForecastDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerUpsertLines: async (
      assetId: string,
      upsertBudgetForecastDto: UpsertBudgetForecastDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetForecastControllerUpsertLines', 'assetId', assetId);
      // verify required parameter 'upsertBudgetForecastDto' is not null or undefined
      assertParamExists(
        'budgetForecastControllerUpsertLines',
        'upsertBudgetForecastDto',
        upsertBudgetForecastDto
      );
      const localVarPath = `/assets/{assetId}/budget-forecast`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertBudgetForecastDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a named budget sub-line under an existing rubric
     * @param {string} assetId
     * @param {CreateExpenseSubCategoryDto} createExpenseSubCategoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerCreate: async (
      assetId: string,
      createExpenseSubCategoryDto: CreateExpenseSubCategoryDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expenseSubCategoryControllerCreate', 'assetId', assetId);
      // verify required parameter 'createExpenseSubCategoryDto' is not null or undefined
      assertParamExists(
        'expenseSubCategoryControllerCreate',
        'createExpenseSubCategoryDto',
        createExpenseSubCategoryDto
      );
      const localVarPath = `/assets/{assetId}/budget/sub-categories`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createExpenseSubCategoryDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a budget sub-line
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerDelete: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expenseSubCategoryControllerDelete', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('expenseSubCategoryControllerDelete', 'id', id);
      const localVarPath = `/assets/{assetId}/budget/sub-categories/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List the named budget sub-lines for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerFindAllByAsset: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expenseSubCategoryControllerFindAllByAsset', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/budget/sub-categories`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Rename or reorder a budget sub-line
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateExpenseSubCategoryDto} updateExpenseSubCategoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerUpdate: async (
      assetId: string,
      id: string,
      updateExpenseSubCategoryDto: UpdateExpenseSubCategoryDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expenseSubCategoryControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('expenseSubCategoryControllerUpdate', 'id', id);
      // verify required parameter 'updateExpenseSubCategoryDto' is not null or undefined
      assertParamExists(
        'expenseSubCategoryControllerUpdate',
        'updateExpenseSubCategoryDto',
        updateExpenseSubCategoryDto
      );
      const localVarPath = `/assets/{assetId}/budget/sub-categories/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateExpenseSubCategoryDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BudgetForecastApi - functional programming interface
 * @export
 */
export const BudgetForecastApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BudgetForecastApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Exclude one real operation from a budget year, without deleting it
     * @param {string} assetId
     * @param {CreateBudgetForecastExclusionDto} createBudgetForecastExclusionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetForecastControllerExcludeExpense(
      assetId: string,
      createBudgetForecastExclusionDto: CreateBudgetForecastExclusionDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetForecastExclusionDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.budgetForecastControllerExcludeExpense(
          assetId,
          createBudgetForecastExclusionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.budgetForecastControllerExcludeExpense']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get budget forecast lines for a given year
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetForecastControllerGetLines(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BudgetForecastLineDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetForecastControllerGetLines(
        assetId,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.budgetForecastControllerGetLines']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the unified forecast view (recurring series + one-off expenses + manual forecast lines)
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetForecastControllerGetView(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetForecastViewDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetForecastControllerGetView(
        assetId,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.budgetForecastControllerGetView']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Re-include a previously excluded operation in the budget
     * @param {string} assetId
     * @param {string} exclusionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetForecastControllerReincludeExpense(
      assetId: string,
      exclusionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.budgetForecastControllerReincludeExpense(
          assetId,
          exclusionId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.budgetForecastControllerReincludeExpense']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Exclude or re-include several operations at once
     * @param {string} assetId
     * @param {BulkBudgetForecastExclusionDto} bulkBudgetForecastExclusionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetForecastControllerSetExclusionsInBulk(
      assetId: string,
      bulkBudgetForecastExclusionDto: BulkBudgetForecastExclusionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.budgetForecastControllerSetExclusionsInBulk(
          assetId,
          bulkBudgetForecastExclusionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.budgetForecastControllerSetExclusionsInBulk']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Replace all budget forecast lines for a given year
     * @param {string} assetId
     * @param {UpsertBudgetForecastDto} upsertBudgetForecastDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetForecastControllerUpsertLines(
      assetId: string,
      upsertBudgetForecastDto: UpsertBudgetForecastDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BudgetForecastLineDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.budgetForecastControllerUpsertLines(
        assetId,
        upsertBudgetForecastDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.budgetForecastControllerUpsertLines']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a named budget sub-line under an existing rubric
     * @param {string} assetId
     * @param {CreateExpenseSubCategoryDto} createExpenseSubCategoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expenseSubCategoryControllerCreate(
      assetId: string,
      createExpenseSubCategoryDto: CreateExpenseSubCategoryDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseSubCategoryDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expenseSubCategoryControllerCreate(
        assetId,
        createExpenseSubCategoryDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.expenseSubCategoryControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a budget sub-line
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expenseSubCategoryControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expenseSubCategoryControllerDelete(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.expenseSubCategoryControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List the named budget sub-lines for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expenseSubCategoryControllerFindAllByAsset(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExpenseSubCategoryDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.expenseSubCategoryControllerFindAllByAsset(
          assetId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.expenseSubCategoryControllerFindAllByAsset']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Rename or reorder a budget sub-line
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateExpenseSubCategoryDto} updateExpenseSubCategoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expenseSubCategoryControllerUpdate(
      assetId: string,
      id: string,
      updateExpenseSubCategoryDto: UpdateExpenseSubCategoryDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseSubCategoryDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expenseSubCategoryControllerUpdate(
        assetId,
        id,
        updateExpenseSubCategoryDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetForecastApi.expenseSubCategoryControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BudgetForecastApi - factory interface
 * @export
 */
export const BudgetForecastApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BudgetForecastApiFp(configuration);
  return {
    /**
     *
     * @summary Exclude one real operation from a budget year, without deleting it
     * @param {string} assetId
     * @param {CreateBudgetForecastExclusionDto} createBudgetForecastExclusionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerExcludeExpense(
      assetId: string,
      createBudgetForecastExclusionDto: CreateBudgetForecastExclusionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetForecastExclusionDto> {
      return localVarFp
        .budgetForecastControllerExcludeExpense(assetId, createBudgetForecastExclusionDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get budget forecast lines for a given year
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerGetLines(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<BudgetForecastLineDto>> {
      return localVarFp
        .budgetForecastControllerGetLines(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the unified forecast view (recurring series + one-off expenses + manual forecast lines)
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerGetView(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetForecastViewDto> {
      return localVarFp
        .budgetForecastControllerGetView(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Re-include a previously excluded operation in the budget
     * @param {string} assetId
     * @param {string} exclusionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerReincludeExpense(
      assetId: string,
      exclusionId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .budgetForecastControllerReincludeExpense(assetId, exclusionId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Exclude or re-include several operations at once
     * @param {string} assetId
     * @param {BulkBudgetForecastExclusionDto} bulkBudgetForecastExclusionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerSetExclusionsInBulk(
      assetId: string,
      bulkBudgetForecastExclusionDto: BulkBudgetForecastExclusionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .budgetForecastControllerSetExclusionsInBulk(
          assetId,
          bulkBudgetForecastExclusionDto,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Replace all budget forecast lines for a given year
     * @param {string} assetId
     * @param {UpsertBudgetForecastDto} upsertBudgetForecastDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetForecastControllerUpsertLines(
      assetId: string,
      upsertBudgetForecastDto: UpsertBudgetForecastDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<BudgetForecastLineDto>> {
      return localVarFp
        .budgetForecastControllerUpsertLines(assetId, upsertBudgetForecastDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a named budget sub-line under an existing rubric
     * @param {string} assetId
     * @param {CreateExpenseSubCategoryDto} createExpenseSubCategoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerCreate(
      assetId: string,
      createExpenseSubCategoryDto: CreateExpenseSubCategoryDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExpenseSubCategoryDto> {
      return localVarFp
        .expenseSubCategoryControllerCreate(assetId, createExpenseSubCategoryDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a budget sub-line
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .expenseSubCategoryControllerDelete(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List the named budget sub-lines for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerFindAllByAsset(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ExpenseSubCategoryDto>> {
      return localVarFp
        .expenseSubCategoryControllerFindAllByAsset(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Rename or reorder a budget sub-line
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateExpenseSubCategoryDto} updateExpenseSubCategoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expenseSubCategoryControllerUpdate(
      assetId: string,
      id: string,
      updateExpenseSubCategoryDto: UpdateExpenseSubCategoryDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExpenseSubCategoryDto> {
      return localVarFp
        .expenseSubCategoryControllerUpdate(assetId, id, updateExpenseSubCategoryDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * BudgetForecastApi - object-oriented interface
 * @export
 * @class BudgetForecastApi
 * @extends {BaseAPI}
 */
export class BudgetForecastApi extends BaseAPI {
  /**
   *
   * @summary Exclude one real operation from a budget year, without deleting it
   * @param {string} assetId
   * @param {CreateBudgetForecastExclusionDto} createBudgetForecastExclusionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public budgetForecastControllerExcludeExpense(
    assetId: string,
    createBudgetForecastExclusionDto: CreateBudgetForecastExclusionDto,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .budgetForecastControllerExcludeExpense(assetId, createBudgetForecastExclusionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get budget forecast lines for a given year
   * @param {string} assetId
   * @param {string} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public budgetForecastControllerGetLines(
    assetId: string,
    year: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .budgetForecastControllerGetLines(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the unified forecast view (recurring series + one-off expenses + manual forecast lines)
   * @param {string} assetId
   * @param {string} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public budgetForecastControllerGetView(
    assetId: string,
    year: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .budgetForecastControllerGetView(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Re-include a previously excluded operation in the budget
   * @param {string} assetId
   * @param {string} exclusionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public budgetForecastControllerReincludeExpense(
    assetId: string,
    exclusionId: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .budgetForecastControllerReincludeExpense(assetId, exclusionId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Exclude or re-include several operations at once
   * @param {string} assetId
   * @param {BulkBudgetForecastExclusionDto} bulkBudgetForecastExclusionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public budgetForecastControllerSetExclusionsInBulk(
    assetId: string,
    bulkBudgetForecastExclusionDto: BulkBudgetForecastExclusionDto,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .budgetForecastControllerSetExclusionsInBulk(assetId, bulkBudgetForecastExclusionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Replace all budget forecast lines for a given year
   * @param {string} assetId
   * @param {UpsertBudgetForecastDto} upsertBudgetForecastDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public budgetForecastControllerUpsertLines(
    assetId: string,
    upsertBudgetForecastDto: UpsertBudgetForecastDto,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .budgetForecastControllerUpsertLines(assetId, upsertBudgetForecastDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a named budget sub-line under an existing rubric
   * @param {string} assetId
   * @param {CreateExpenseSubCategoryDto} createExpenseSubCategoryDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public expenseSubCategoryControllerCreate(
    assetId: string,
    createExpenseSubCategoryDto: CreateExpenseSubCategoryDto,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .expenseSubCategoryControllerCreate(assetId, createExpenseSubCategoryDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a budget sub-line
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public expenseSubCategoryControllerDelete(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .expenseSubCategoryControllerDelete(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List the named budget sub-lines for an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public expenseSubCategoryControllerFindAllByAsset(
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .expenseSubCategoryControllerFindAllByAsset(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Rename or reorder a budget sub-line
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateExpenseSubCategoryDto} updateExpenseSubCategoryDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetForecastApi
   */
  public expenseSubCategoryControllerUpdate(
    assetId: string,
    id: string,
    updateExpenseSubCategoryDto: UpdateExpenseSubCategoryDto,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetForecastApiFp(this.configuration)
      .expenseSubCategoryControllerUpdate(assetId, id, updateExpenseSubCategoryDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * BudgetSimulationApi - axios parameter creator
 * @export
 */
export const BudgetSimulationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get personal budget simulation for a given year
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetSimulationControllerGetSimulation: async (
      assetId: string,
      year: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetSimulationControllerGetSimulation', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('budgetSimulationControllerGetSimulation', 'year', year);
      const localVarPath = `/assets/{assetId}/budget-simulation`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Save personal budget simulation for a given year
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetSimulationControllerUpsertSimulation: async (
      assetId: string,
      body: object,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('budgetSimulationControllerUpsertSimulation', 'assetId', assetId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('budgetSimulationControllerUpsertSimulation', 'body', body);
      const localVarPath = `/assets/{assetId}/budget-simulation`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BudgetSimulationApi - functional programming interface
 * @export
 */
export const BudgetSimulationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BudgetSimulationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get personal budget simulation for a given year
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetSimulationControllerGetSimulation(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetSimulationDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.budgetSimulationControllerGetSimulation(
          assetId,
          year,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetSimulationApi.budgetSimulationControllerGetSimulation']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Save personal budget simulation for a given year
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async budgetSimulationControllerUpsertSimulation(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetSimulationDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.budgetSimulationControllerUpsertSimulation(
          assetId,
          body,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BudgetSimulationApi.budgetSimulationControllerUpsertSimulation']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BudgetSimulationApi - factory interface
 * @export
 */
export const BudgetSimulationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = BudgetSimulationApiFp(configuration);
  return {
    /**
     *
     * @summary Get personal budget simulation for a given year
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetSimulationControllerGetSimulation(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetSimulationDto> {
      return localVarFp
        .budgetSimulationControllerGetSimulation(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Save personal budget simulation for a given year
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    budgetSimulationControllerUpsertSimulation(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetSimulationDto> {
      return localVarFp
        .budgetSimulationControllerUpsertSimulation(assetId, body, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * BudgetSimulationApi - object-oriented interface
 * @export
 * @class BudgetSimulationApi
 * @extends {BaseAPI}
 */
export class BudgetSimulationApi extends BaseAPI {
  /**
   *
   * @summary Get personal budget simulation for a given year
   * @param {string} assetId
   * @param {string} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetSimulationApi
   */
  public budgetSimulationControllerGetSimulation(
    assetId: string,
    year: string,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetSimulationApiFp(this.configuration)
      .budgetSimulationControllerGetSimulation(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Save personal budget simulation for a given year
   * @param {string} assetId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BudgetSimulationApi
   */
  public budgetSimulationControllerUpsertSimulation(
    assetId: string,
    body: object,
    options?: RawAxiosRequestConfig
  ) {
    return BudgetSimulationApiFp(this.configuration)
      .budgetSimulationControllerUpsertSimulation(assetId, body, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CartographyApi - axios parameter creator
 * @export
 */
export const CartographyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a bed in a room
     * @param {string} assetId
     * @param {string} roomId
     * @param {CreateBedDto} createBedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateBed: async (
      assetId: string,
      roomId: string,
      createBedDto: CreateBedDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerCreateBed', 'assetId', assetId);
      // verify required parameter 'roomId' is not null or undefined
      assertParamExists('cartographyControllerCreateBed', 'roomId', roomId);
      // verify required parameter 'createBedDto' is not null or undefined
      assertParamExists('cartographyControllerCreateBed', 'createBedDto', createBedDto);
      const localVarPath = `/assets/{assetId}/cartography/rooms/{roomId}/beds`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'roomId'}}`, encodeURIComponent(String(roomId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBedDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a building
     * @param {string} assetId
     * @param {CreateBuildingDto} createBuildingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateBuilding: async (
      assetId: string,
      createBuildingDto: CreateBuildingDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerCreateBuilding', 'assetId', assetId);
      // verify required parameter 'createBuildingDto' is not null or undefined
      assertParamExists(
        'cartographyControllerCreateBuilding',
        'createBuildingDto',
        createBuildingDto
      );
      const localVarPath = `/assets/{assetId}/cartography/buildings`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBuildingDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a floor in a building
     * @param {string} assetId
     * @param {string} buildingId
     * @param {CreateFloorDto} createFloorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateFloor: async (
      assetId: string,
      buildingId: string,
      createFloorDto: CreateFloorDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerCreateFloor', 'assetId', assetId);
      // verify required parameter 'buildingId' is not null or undefined
      assertParamExists('cartographyControllerCreateFloor', 'buildingId', buildingId);
      // verify required parameter 'createFloorDto' is not null or undefined
      assertParamExists('cartographyControllerCreateFloor', 'createFloorDto', createFloorDto);
      const localVarPath = `/assets/{assetId}/cartography/buildings/{buildingId}/floors`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'buildingId'}}`, encodeURIComponent(String(buildingId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createFloorDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a room
     * @param {string} assetId
     * @param {CreateRoomDto} createRoomDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateRoom: async (
      assetId: string,
      createRoomDto: CreateRoomDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerCreateRoom', 'assetId', assetId);
      // verify required parameter 'createRoomDto' is not null or undefined
      assertParamExists('cartographyControllerCreateRoom', 'createRoomDto', createRoomDto);
      const localVarPath = `/assets/{assetId}/cartography/rooms`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRoomDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft-delete a bed
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteBed: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerDeleteBed', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerDeleteBed', 'id', id);
      const localVarPath = `/assets/{assetId}/cartography/beds/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft-delete a building (cascade soft on floors/rooms/beds)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteBuilding: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerDeleteBuilding', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerDeleteBuilding', 'id', id);
      const localVarPath = `/assets/{assetId}/cartography/buildings/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft-delete a floor (rooms keep existing, their floorId becomes null)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteFloor: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerDeleteFloor', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerDeleteFloor', 'id', id);
      const localVarPath = `/assets/{assetId}/cartography/floors/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft-delete a room (cascade soft on beds)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteRoom: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerDeleteRoom', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerDeleteRoom', 'id', id);
      const localVarPath = `/assets/{assetId}/cartography/rooms/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get capacity metrics for the dashboard card
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerGetSummary: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerGetSummary', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/cartography/summary`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the full cartography tree for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerGetTree: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerGetTree', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/cartography`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a bed
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateBedDto} updateBedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateBed: async (
      assetId: string,
      id: string,
      updateBedDto: UpdateBedDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerUpdateBed', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerUpdateBed', 'id', id);
      // verify required parameter 'updateBedDto' is not null or undefined
      assertParamExists('cartographyControllerUpdateBed', 'updateBedDto', updateBedDto);
      const localVarPath = `/assets/{assetId}/cartography/beds/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBedDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a building
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateBuildingDto} updateBuildingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateBuilding: async (
      assetId: string,
      id: string,
      updateBuildingDto: UpdateBuildingDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerUpdateBuilding', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerUpdateBuilding', 'id', id);
      // verify required parameter 'updateBuildingDto' is not null or undefined
      assertParamExists(
        'cartographyControllerUpdateBuilding',
        'updateBuildingDto',
        updateBuildingDto
      );
      const localVarPath = `/assets/{assetId}/cartography/buildings/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBuildingDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a floor
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateFloorDto} updateFloorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateFloor: async (
      assetId: string,
      id: string,
      updateFloorDto: UpdateFloorDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerUpdateFloor', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerUpdateFloor', 'id', id);
      // verify required parameter 'updateFloorDto' is not null or undefined
      assertParamExists('cartographyControllerUpdateFloor', 'updateFloorDto', updateFloorDto);
      const localVarPath = `/assets/{assetId}/cartography/floors/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateFloorDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a room (or toggle its isOutOfService flag)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateRoomDto} updateRoomDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateRoom: async (
      assetId: string,
      id: string,
      updateRoomDto: UpdateRoomDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('cartographyControllerUpdateRoom', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cartographyControllerUpdateRoom', 'id', id);
      // verify required parameter 'updateRoomDto' is not null or undefined
      assertParamExists('cartographyControllerUpdateRoom', 'updateRoomDto', updateRoomDto);
      const localVarPath = `/assets/{assetId}/cartography/rooms/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRoomDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CartographyApi - functional programming interface
 * @export
 */
export const CartographyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CartographyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a bed in a room
     * @param {string} assetId
     * @param {string} roomId
     * @param {CreateBedDto} createBedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerCreateBed(
      assetId: string,
      roomId: string,
      createBedDto: CreateBedDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BedDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerCreateBed(
        assetId,
        roomId,
        createBedDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerCreateBed']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a building
     * @param {string} assetId
     * @param {CreateBuildingDto} createBuildingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerCreateBuilding(
      assetId: string,
      createBuildingDto: CreateBuildingDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerCreateBuilding(
        assetId,
        createBuildingDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerCreateBuilding']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a floor in a building
     * @param {string} assetId
     * @param {string} buildingId
     * @param {CreateFloorDto} createFloorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerCreateFloor(
      assetId: string,
      buildingId: string,
      createFloorDto: CreateFloorDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerCreateFloor(
        assetId,
        buildingId,
        createFloorDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerCreateFloor']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a room
     * @param {string} assetId
     * @param {CreateRoomDto} createRoomDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerCreateRoom(
      assetId: string,
      createRoomDto: CreateRoomDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerCreateRoom(
        assetId,
        createRoomDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerCreateRoom']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft-delete a bed
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerDeleteBed(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerDeleteBed(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerDeleteBed']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft-delete a building (cascade soft on floors/rooms/beds)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerDeleteBuilding(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerDeleteBuilding(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerDeleteBuilding']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft-delete a floor (rooms keep existing, their floorId becomes null)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerDeleteFloor(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerDeleteFloor(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerDeleteFloor']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft-delete a room (cascade soft on beds)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerDeleteRoom(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerDeleteRoom(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerDeleteRoom']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get capacity metrics for the dashboard card
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerGetSummary(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartographySummaryDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerGetSummary(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerGetSummary']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the full cartography tree for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerGetTree(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CartographyTreeDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerGetTree(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerGetTree']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a bed
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateBedDto} updateBedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerUpdateBed(
      assetId: string,
      id: string,
      updateBedDto: UpdateBedDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BedDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerUpdateBed(
        assetId,
        id,
        updateBedDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerUpdateBed']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a building
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateBuildingDto} updateBuildingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerUpdateBuilding(
      assetId: string,
      id: string,
      updateBuildingDto: UpdateBuildingDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerUpdateBuilding(
        assetId,
        id,
        updateBuildingDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerUpdateBuilding']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a floor
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateFloorDto} updateFloorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerUpdateFloor(
      assetId: string,
      id: string,
      updateFloorDto: UpdateFloorDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerUpdateFloor(
        assetId,
        id,
        updateFloorDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerUpdateFloor']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a room (or toggle its isOutOfService flag)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateRoomDto} updateRoomDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cartographyControllerUpdateRoom(
      assetId: string,
      id: string,
      updateRoomDto: UpdateRoomDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cartographyControllerUpdateRoom(
        assetId,
        id,
        updateRoomDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CartographyApi.cartographyControllerUpdateRoom']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CartographyApi - factory interface
 * @export
 */
export const CartographyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CartographyApiFp(configuration);
  return {
    /**
     *
     * @summary Create a bed in a room
     * @param {string} assetId
     * @param {string} roomId
     * @param {CreateBedDto} createBedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateBed(
      assetId: string,
      roomId: string,
      createBedDto: CreateBedDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BedDto> {
      return localVarFp
        .cartographyControllerCreateBed(assetId, roomId, createBedDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a building
     * @param {string} assetId
     * @param {CreateBuildingDto} createBuildingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateBuilding(
      assetId: string,
      createBuildingDto: CreateBuildingDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BuildingDto> {
      return localVarFp
        .cartographyControllerCreateBuilding(assetId, createBuildingDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a floor in a building
     * @param {string} assetId
     * @param {string} buildingId
     * @param {CreateFloorDto} createFloorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateFloor(
      assetId: string,
      buildingId: string,
      createFloorDto: CreateFloorDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FloorDto> {
      return localVarFp
        .cartographyControllerCreateFloor(assetId, buildingId, createFloorDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a room
     * @param {string} assetId
     * @param {CreateRoomDto} createRoomDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerCreateRoom(
      assetId: string,
      createRoomDto: CreateRoomDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoomDto> {
      return localVarFp
        .cartographyControllerCreateRoom(assetId, createRoomDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft-delete a bed
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteBed(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cartographyControllerDeleteBed(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft-delete a building (cascade soft on floors/rooms/beds)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteBuilding(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cartographyControllerDeleteBuilding(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft-delete a floor (rooms keep existing, their floorId becomes null)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteFloor(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cartographyControllerDeleteFloor(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft-delete a room (cascade soft on beds)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerDeleteRoom(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .cartographyControllerDeleteRoom(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get capacity metrics for the dashboard card
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerGetSummary(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CartographySummaryDto> {
      return localVarFp
        .cartographyControllerGetSummary(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the full cartography tree for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerGetTree(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CartographyTreeDto> {
      return localVarFp
        .cartographyControllerGetTree(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a bed
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateBedDto} updateBedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateBed(
      assetId: string,
      id: string,
      updateBedDto: UpdateBedDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BedDto> {
      return localVarFp
        .cartographyControllerUpdateBed(assetId, id, updateBedDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a building
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateBuildingDto} updateBuildingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateBuilding(
      assetId: string,
      id: string,
      updateBuildingDto: UpdateBuildingDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BuildingDto> {
      return localVarFp
        .cartographyControllerUpdateBuilding(assetId, id, updateBuildingDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a floor
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateFloorDto} updateFloorDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateFloor(
      assetId: string,
      id: string,
      updateFloorDto: UpdateFloorDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FloorDto> {
      return localVarFp
        .cartographyControllerUpdateFloor(assetId, id, updateFloorDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a room (or toggle its isOutOfService flag)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateRoomDto} updateRoomDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartographyControllerUpdateRoom(
      assetId: string,
      id: string,
      updateRoomDto: UpdateRoomDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RoomDto> {
      return localVarFp
        .cartographyControllerUpdateRoom(assetId, id, updateRoomDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CartographyApi - object-oriented interface
 * @export
 * @class CartographyApi
 * @extends {BaseAPI}
 */
export class CartographyApi extends BaseAPI {
  /**
   *
   * @summary Create a bed in a room
   * @param {string} assetId
   * @param {string} roomId
   * @param {CreateBedDto} createBedDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerCreateBed(
    assetId: string,
    roomId: string,
    createBedDto: CreateBedDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerCreateBed(assetId, roomId, createBedDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a building
   * @param {string} assetId
   * @param {CreateBuildingDto} createBuildingDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerCreateBuilding(
    assetId: string,
    createBuildingDto: CreateBuildingDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerCreateBuilding(assetId, createBuildingDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a floor in a building
   * @param {string} assetId
   * @param {string} buildingId
   * @param {CreateFloorDto} createFloorDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerCreateFloor(
    assetId: string,
    buildingId: string,
    createFloorDto: CreateFloorDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerCreateFloor(assetId, buildingId, createFloorDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a room
   * @param {string} assetId
   * @param {CreateRoomDto} createRoomDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerCreateRoom(
    assetId: string,
    createRoomDto: CreateRoomDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerCreateRoom(assetId, createRoomDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft-delete a bed
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerDeleteBed(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerDeleteBed(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft-delete a building (cascade soft on floors/rooms/beds)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerDeleteBuilding(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerDeleteBuilding(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft-delete a floor (rooms keep existing, their floorId becomes null)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerDeleteFloor(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerDeleteFloor(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft-delete a room (cascade soft on beds)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerDeleteRoom(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerDeleteRoom(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get capacity metrics for the dashboard card
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerGetSummary(assetId: string, options?: RawAxiosRequestConfig) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerGetSummary(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the full cartography tree for an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerGetTree(assetId: string, options?: RawAxiosRequestConfig) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerGetTree(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a bed
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateBedDto} updateBedDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerUpdateBed(
    assetId: string,
    id: string,
    updateBedDto: UpdateBedDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerUpdateBed(assetId, id, updateBedDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a building
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateBuildingDto} updateBuildingDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerUpdateBuilding(
    assetId: string,
    id: string,
    updateBuildingDto: UpdateBuildingDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerUpdateBuilding(assetId, id, updateBuildingDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a floor
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateFloorDto} updateFloorDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerUpdateFloor(
    assetId: string,
    id: string,
    updateFloorDto: UpdateFloorDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerUpdateFloor(assetId, id, updateFloorDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a room (or toggle its isOutOfService flag)
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateRoomDto} updateRoomDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CartographyApi
   */
  public cartographyControllerUpdateRoom(
    assetId: string,
    id: string,
    updateRoomDto: UpdateRoomDto,
    options?: RawAxiosRequestConfig
  ) {
    return CartographyApiFp(this.configuration)
      .cartographyControllerUpdateRoom(assetId, id, updateRoomDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ChecklistSubmissionsApi - axios parameter creator
 * @export
 */
export const ChecklistSubmissionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Submit a filled checklist
     * @param {string} assetId
     * @param {string} checklistId
     * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerCreate: async (
      assetId: string,
      checklistId: string,
      createChecklistSubmissionDto: CreateChecklistSubmissionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistSubmissionsControllerCreate', 'assetId', assetId);
      // verify required parameter 'checklistId' is not null or undefined
      assertParamExists('checklistSubmissionsControllerCreate', 'checklistId', checklistId);
      // verify required parameter 'createChecklistSubmissionDto' is not null or undefined
      assertParamExists(
        'checklistSubmissionsControllerCreate',
        'createChecklistSubmissionDto',
        createChecklistSubmissionDto
      );
      const localVarPath = `/assets/{assetId}/checklist-submissions/checklist/{checklistId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'checklistId'}}`, encodeURIComponent(String(checklistId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createChecklistSubmissionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all submissions for a specific checklist
     * @param {string} checklistId
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerFindAllByChecklist: async (
      checklistId: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'checklistId' is not null or undefined
      assertParamExists(
        'checklistSubmissionsControllerFindAllByChecklist',
        'checklistId',
        checklistId
      );
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistSubmissionsControllerFindAllByChecklist', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/checklist-submissions/checklist/{checklistId}`
        .replace(`{${'checklistId'}}`, encodeURIComponent(String(checklistId)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all submissions by the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerFindByCurrentUser: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistSubmissionsControllerFindByCurrentUser', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/checklist-submissions/user`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a specific submission by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('checklistSubmissionsControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistSubmissionsControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/checklist-submissions/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ChecklistSubmissionsApi - functional programming interface
 * @export
 */
export const ChecklistSubmissionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChecklistSubmissionsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Submit a filled checklist
     * @param {string} assetId
     * @param {string} checklistId
     * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistSubmissionsControllerCreate(
      assetId: string,
      checklistId: string,
      createChecklistSubmissionDto: CreateChecklistSubmissionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistSubmissionDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.checklistSubmissionsControllerCreate(
          assetId,
          checklistId,
          createChecklistSubmissionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistSubmissionsApi.checklistSubmissionsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all submissions for a specific checklist
     * @param {string} checklistId
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistSubmissionsControllerFindAllByChecklist(
      checklistId: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ChecklistSubmissionSummaryDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.checklistSubmissionsControllerFindAllByChecklist(
          checklistId,
          assetId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ChecklistSubmissionsApi.checklistSubmissionsControllerFindAllByChecklist'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all submissions by the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistSubmissionsControllerFindByCurrentUser(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecklistSubmissionDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.checklistSubmissionsControllerFindByCurrentUser(
          assetId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'ChecklistSubmissionsApi.checklistSubmissionsControllerFindByCurrentUser'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a specific submission by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistSubmissionsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistSubmissionDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.checklistSubmissionsControllerFindOne(id, assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistSubmissionsApi.checklistSubmissionsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ChecklistSubmissionsApi - factory interface
 * @export
 */
export const ChecklistSubmissionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ChecklistSubmissionsApiFp(configuration);
  return {
    /**
     *
     * @summary Submit a filled checklist
     * @param {string} assetId
     * @param {string} checklistId
     * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerCreate(
      assetId: string,
      checklistId: string,
      createChecklistSubmissionDto: CreateChecklistSubmissionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistSubmissionDto> {
      return localVarFp
        .checklistSubmissionsControllerCreate(
          assetId,
          checklistId,
          createChecklistSubmissionDto,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get all submissions for a specific checklist
     * @param {string} checklistId
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerFindAllByChecklist(
      checklistId: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ChecklistSubmissionSummaryDto>> {
      return localVarFp
        .checklistSubmissionsControllerFindAllByChecklist(checklistId, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get all submissions by the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerFindByCurrentUser(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ChecklistSubmissionDto>> {
      return localVarFp
        .checklistSubmissionsControllerFindByCurrentUser(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get a specific submission by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistSubmissionsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistSubmissionDto> {
      return localVarFp
        .checklistSubmissionsControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ChecklistSubmissionsApi - object-oriented interface
 * @export
 * @class ChecklistSubmissionsApi
 * @extends {BaseAPI}
 */
export class ChecklistSubmissionsApi extends BaseAPI {
  /**
   *
   * @summary Submit a filled checklist
   * @param {string} assetId
   * @param {string} checklistId
   * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistSubmissionsApi
   */
  public checklistSubmissionsControllerCreate(
    assetId: string,
    checklistId: string,
    createChecklistSubmissionDto: CreateChecklistSubmissionDto,
    options?: RawAxiosRequestConfig
  ) {
    return ChecklistSubmissionsApiFp(this.configuration)
      .checklistSubmissionsControllerCreate(
        assetId,
        checklistId,
        createChecklistSubmissionDto,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all submissions for a specific checklist
   * @param {string} checklistId
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistSubmissionsApi
   */
  public checklistSubmissionsControllerFindAllByChecklist(
    checklistId: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ChecklistSubmissionsApiFp(this.configuration)
      .checklistSubmissionsControllerFindAllByChecklist(checklistId, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all submissions by the current user
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistSubmissionsApi
   */
  public checklistSubmissionsControllerFindByCurrentUser(
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ChecklistSubmissionsApiFp(this.configuration)
      .checklistSubmissionsControllerFindByCurrentUser(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a specific submission by ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistSubmissionsApi
   */
  public checklistSubmissionsControllerFindOne(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ChecklistSubmissionsApiFp(this.configuration)
      .checklistSubmissionsControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ChecklistTemplatesApi - axios parameter creator
 * @export
 */
export const ChecklistTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary List the ShareHeritage ready-to-use checklist templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistTemplatesControllerFindAll: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/checklist-templates`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ChecklistTemplatesApi - functional programming interface
 * @export
 */
export const ChecklistTemplatesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChecklistTemplatesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary List the ShareHeritage ready-to-use checklist templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistTemplatesControllerFindAll(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecklistTemplateDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.checklistTemplatesControllerFindAll(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistTemplatesApi.checklistTemplatesControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ChecklistTemplatesApi - factory interface
 * @export
 */
export const ChecklistTemplatesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ChecklistTemplatesApiFp(configuration);
  return {
    /**
     *
     * @summary List the ShareHeritage ready-to-use checklist templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistTemplatesControllerFindAll(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ChecklistTemplateDto>> {
      return localVarFp
        .checklistTemplatesControllerFindAll(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ChecklistTemplatesApi - object-oriented interface
 * @export
 * @class ChecklistTemplatesApi
 * @extends {BaseAPI}
 */
export class ChecklistTemplatesApi extends BaseAPI {
  /**
   *
   * @summary List the ShareHeritage ready-to-use checklist templates
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistTemplatesApi
   */
  public checklistTemplatesControllerFindAll(options?: RawAxiosRequestConfig) {
    return ChecklistTemplatesApiFp(this.configuration)
      .checklistTemplatesControllerFindAll(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ChecklistsApi - axios parameter creator
 * @export
 */
export const ChecklistsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new checklist
     * @param {string} assetId
     * @param {CreateChecklistDto} createChecklistDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerCreate: async (
      assetId: string,
      createChecklistDto: CreateChecklistDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createChecklistDto' is not null or undefined
      assertParamExists('checklistsControllerCreate', 'createChecklistDto', createChecklistDto);
      const localVarPath = `/assets/{assetId}/checklists`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createChecklistDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Draft a checklist from a voice dictation
     * @param {string} assetId
     * @param {File} [file]
     * @param {ChecklistsControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerDraftFromVoice: async (
      assetId: string,
      file?: File,
      language?: ChecklistsControllerDraftFromVoiceLanguageEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistsControllerDraftFromVoice', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/checklists/draft-from-voice`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (language !== undefined) {
        localVarFormParams.append('language', language as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all checklists for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/checklists`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single checklist by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('checklistsControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistsControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/checklists/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft delete a checklist
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerRemove: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('checklistsControllerRemove', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistsControllerRemove', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/checklists/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a checklist and its items
     * @param {string} id
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerUpdate: async (
      id: string,
      assetId: string,
      body: object,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('checklistsControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('checklistsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('checklistsControllerUpdate', 'body', body);
      const localVarPath = `/assets/{assetId}/checklists/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ChecklistsApi - functional programming interface
 * @export
 */
export const ChecklistsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChecklistsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new checklist
     * @param {string} assetId
     * @param {CreateChecklistDto} createChecklistDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistsControllerCreate(
      assetId: string,
      createChecklistDto: CreateChecklistDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checklistsControllerCreate(
        assetId,
        createChecklistDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistsApi.checklistsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Draft a checklist from a voice dictation
     * @param {string} assetId
     * @param {File} [file]
     * @param {ChecklistsControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistsControllerDraftFromVoice(
      assetId: string,
      file?: File,
      language?: ChecklistsControllerDraftFromVoiceLanguageEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistDraftDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checklistsControllerDraftFromVoice(
        assetId,
        file,
        language,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistsApi.checklistsControllerDraftFromVoice']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all checklists for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChecklistDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checklistsControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistsApi.checklistsControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single checklist by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistWithItemsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checklistsControllerFindOne(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistsApi.checklistsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft delete a checklist
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checklistsControllerRemove(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistsApi.checklistsControllerRemove']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a checklist and its items
     * @param {string} id
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checklistsControllerUpdate(
      id: string,
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checklistsControllerUpdate(
        id,
        assetId,
        body,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ChecklistsApi.checklistsControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ChecklistsApi - factory interface
 * @export
 */
export const ChecklistsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ChecklistsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new checklist
     * @param {string} assetId
     * @param {CreateChecklistDto} createChecklistDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerCreate(
      assetId: string,
      createChecklistDto: CreateChecklistDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistDto> {
      return localVarFp
        .checklistsControllerCreate(assetId, createChecklistDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Draft a checklist from a voice dictation
     * @param {string} assetId
     * @param {File} [file]
     * @param {ChecklistsControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerDraftFromVoice(
      assetId: string,
      file?: File,
      language?: ChecklistsControllerDraftFromVoiceLanguageEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistDraftDto> {
      return localVarFp
        .checklistsControllerDraftFromVoice(assetId, file, language, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all checklists for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ChecklistDto>> {
      return localVarFp
        .checklistsControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single checklist by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistWithItemsDto> {
      return localVarFp
        .checklistsControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft delete a checklist
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .checklistsControllerRemove(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a checklist and its items
     * @param {string} id
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checklistsControllerUpdate(
      id: string,
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistDto> {
      return localVarFp
        .checklistsControllerUpdate(id, assetId, body, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ChecklistsApi - object-oriented interface
 * @export
 * @class ChecklistsApi
 * @extends {BaseAPI}
 */
export class ChecklistsApi extends BaseAPI {
  /**
   *
   * @summary Create a new checklist
   * @param {string} assetId
   * @param {CreateChecklistDto} createChecklistDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistsApi
   */
  public checklistsControllerCreate(
    assetId: string,
    createChecklistDto: CreateChecklistDto,
    options?: RawAxiosRequestConfig
  ) {
    return ChecklistsApiFp(this.configuration)
      .checklistsControllerCreate(assetId, createChecklistDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Draft a checklist from a voice dictation
   * @param {string} assetId
   * @param {File} [file]
   * @param {ChecklistsControllerDraftFromVoiceLanguageEnum} [language]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistsApi
   */
  public checklistsControllerDraftFromVoice(
    assetId: string,
    file?: File,
    language?: ChecklistsControllerDraftFromVoiceLanguageEnum,
    options?: RawAxiosRequestConfig
  ) {
    return ChecklistsApiFp(this.configuration)
      .checklistsControllerDraftFromVoice(assetId, file, language, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all checklists for an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistsApi
   */
  public checklistsControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return ChecklistsApiFp(this.configuration)
      .checklistsControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single checklist by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistsApi
   */
  public checklistsControllerFindOne(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ChecklistsApiFp(this.configuration)
      .checklistsControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft delete a checklist
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistsApi
   */
  public checklistsControllerRemove(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ChecklistsApiFp(this.configuration)
      .checklistsControllerRemove(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a checklist and its items
   * @param {string} id
   * @param {string} assetId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChecklistsApi
   */
  public checklistsControllerUpdate(
    id: string,
    assetId: string,
    body: object,
    options?: RawAxiosRequestConfig
  ) {
    return ChecklistsApiFp(this.configuration)
      .checklistsControllerUpdate(id, assetId, body, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const ChecklistsControllerDraftFromVoiceLanguageEnum = {
  Fr: 'fr',
  En: 'en',
} as const;
export type ChecklistsControllerDraftFromVoiceLanguageEnum =
  (typeof ChecklistsControllerDraftFromVoiceLanguageEnum)[keyof typeof ChecklistsControllerDraftFromVoiceLanguageEnum];

/**
 * CommunityApi - axios parameter creator
 * @export
 */
export const CommunityApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Retrieve community datas in one API call
     * @param {string} timeZone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityControllerCommunityData: async (
      timeZone: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'timeZone' is not null or undefined
      assertParamExists('communityControllerCommunityData', 'timeZone', timeZone);
      const localVarPath = `/community/community-data`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (timeZone !== undefined) {
        localVarQueryParameter['timeZone'] = timeZone;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve the members of all my assets in one API call (owners included)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityControllerMembers: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/community/members`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CommunityApi - functional programming interface
 * @export
 */
export const CommunityApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CommunityApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Retrieve community datas in one API call
     * @param {string} timeZone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityControllerCommunityData(
      timeZone: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityDataDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerCommunityData(
        timeZone,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityApi.communityControllerCommunityData']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Retrieve the members of all my assets in one API call (owners included)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityControllerMembers(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityMembersDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityControllerMembers(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityApi.communityControllerMembers']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CommunityApi - factory interface
 * @export
 */
export const CommunityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CommunityApiFp(configuration);
  return {
    /**
     *
     * @summary Retrieve community datas in one API call
     * @param {string} timeZone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityControllerCommunityData(
      timeZone: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommunityDataDto> {
      return localVarFp
        .communityControllerCommunityData(timeZone, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve the members of all my assets in one API call (owners included)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityControllerMembers(options?: RawAxiosRequestConfig): AxiosPromise<CommunityMembersDto> {
      return localVarFp
        .communityControllerMembers(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CommunityApi - object-oriented interface
 * @export
 * @class CommunityApi
 * @extends {BaseAPI}
 */
export class CommunityApi extends BaseAPI {
  /**
   *
   * @summary Retrieve community datas in one API call
   * @param {string} timeZone
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApi
   */
  public communityControllerCommunityData(timeZone: string, options?: RawAxiosRequestConfig) {
    return CommunityApiFp(this.configuration)
      .communityControllerCommunityData(timeZone, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Retrieve the members of all my assets in one API call (owners included)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityApi
   */
  public communityControllerMembers(options?: RawAxiosRequestConfig) {
    return CommunityApiFp(this.configuration)
      .communityControllerMembers(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CommunityFeedApi - axios parameter creator
 * @export
 */
export const CommunityFeedApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary File a chat attachment into the Documents tree
     * @param {string} id
     * @param {string} attachmentId
     * @param {ClassifyAttachmentDto} classifyAttachmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerClassifyAttachment: async (
      id: string,
      attachmentId: string,
      classifyAttachmentDto: ClassifyAttachmentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerClassifyAttachment', 'id', id);
      // verify required parameter 'attachmentId' is not null or undefined
      assertParamExists('communityFeedControllerClassifyAttachment', 'attachmentId', attachmentId);
      // verify required parameter 'classifyAttachmentDto' is not null or undefined
      assertParamExists(
        'communityFeedControllerClassifyAttachment',
        'classifyAttachmentDto',
        classifyAttachmentDto
      );
      const localVarPath = `/community-feed/feed-item/{id}/attachments/{attachmentId}/classify`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'attachmentId'}}`, encodeURIComponent(String(attachmentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        classifyAttachmentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve the feed for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {CommunityFeedControllerCommunityFeedKindEnum} [kind]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCommunityFeed: async (
      assetId: string,
      first?: number,
      after?: string,
      kind?: CommunityFeedControllerCommunityFeedKindEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('communityFeedControllerCommunityFeed', 'assetId', assetId);
      const localVarPath = `/community-feed/feed`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (first !== undefined) {
        localVarQueryParameter['first'] = first;
      }

      if (after !== undefined) {
        localVarQueryParameter['after'] = after;
      }

      if (assetId !== undefined) {
        localVarQueryParameter['assetId'] = assetId;
      }

      if (kind !== undefined) {
        localVarQueryParameter['kind'] = kind;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a comment on a feed item
     * @param {string} id
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateComment: async (
      id: string,
      createCommentDto: CreateCommentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerCreateComment', 'id', id);
      // verify required parameter 'createCommentDto' is not null or undefined
      assertParamExists(
        'communityFeedControllerCreateComment',
        'createCommentDto',
        createCommentDto
      );
      const localVarPath = `/community-feed/feed-item/{id}/comments`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCommentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create and publish a feed item
     * @param {CreateCommunityFeedItemDto} createCommunityFeedItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateFeedItem: async (
      createCommunityFeedItemDto: CreateCommunityFeedItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createCommunityFeedItemDto' is not null or undefined
      assertParamExists(
        'communityFeedControllerCreateFeedItem',
        'createCommunityFeedItemDto',
        createCommunityFeedItemDto
      );
      const localVarPath = `/community-feed/feed-item`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCommunityFeedItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Before creating a feed item using POST /feed-item, you can call this route to upload files (images).
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateFeedItemFile: async (
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/community-feed/feed-item/file`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a like on a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateLike: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerCreateLike', 'id', id);
      const localVarPath = `/community-feed/feed-item/{id}/likes`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerDeleteFeedItem: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerDeleteFeedItem', 'id', id);
      const localVarPath = `/community-feed/feed-item/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Edit a comment from a feed item
     * @param {string} id
     * @param {string} commentId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerEditComment: async (
      id: string,
      commentId: string,
      createCommentDto: CreateCommentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerEditComment', 'id', id);
      // verify required parameter 'commentId' is not null or undefined
      assertParamExists('communityFeedControllerEditComment', 'commentId', commentId);
      // verify required parameter 'createCommentDto' is not null or undefined
      assertParamExists('communityFeedControllerEditComment', 'createCommentDto', createCommentDto);
      const localVarPath = `/community-feed/feed-item/{id}/comments/{commentId}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'commentId'}}`, encodeURIComponent(String(commentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCommentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Edit a feed item
     * @param {string} id
     * @param {EditCommunityFeedItemDto} editCommunityFeedItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerEditFeedItem: async (
      id: string,
      editCommunityFeedItemDto: EditCommunityFeedItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerEditFeedItem', 'id', id);
      // verify required parameter 'editCommunityFeedItemDto' is not null or undefined
      assertParamExists(
        'communityFeedControllerEditFeedItem',
        'editCommunityFeedItemDto',
        editCommunityFeedItemDto
      );
      const localVarPath = `/community-feed/feed-item/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editCommunityFeedItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve a single feed item by its ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerGetFeedItemById: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerGetFeedItemById', 'id', id);
      const localVarPath = `/community-feed/feed-item/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve feed of guestbook posts for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerGuestbook: async (
      assetId: string,
      first?: number,
      after?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('communityFeedControllerGuestbook', 'assetId', assetId);
      const localVarPath = `/community-feed/guestbook`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (first !== undefined) {
        localVarQueryParameter['first'] = first;
      }

      if (after !== undefined) {
        localVarQueryParameter['after'] = after;
      }

      if (assetId !== undefined) {
        localVarQueryParameter['assetId'] = assetId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List the comments of a feed item
     * @param {string} id
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerListComments: async (
      id: string,
      first?: number,
      after?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerListComments', 'id', id);
      const localVarPath = `/community-feed/feed-item/{id}/comments`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (first !== undefined) {
        localVarQueryParameter['first'] = first;
      }

      if (after !== undefined) {
        localVarQueryParameter['after'] = after;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List the likes of a feed item
     * @param {string} id
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerListLikes: async (
      id: string,
      first?: number,
      after?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerListLikes', 'id', id);
      const localVarPath = `/community-feed/feed-item/{id}/likes`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (first !== undefined) {
        localVarQueryParameter['first'] = first;
      }

      if (after !== undefined) {
        localVarQueryParameter['after'] = after;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve feed of memories for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerMemories: async (
      assetId: string,
      first?: number,
      after?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('communityFeedControllerMemories', 'assetId', assetId);
      const localVarPath = `/community-feed/memories`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (first !== undefined) {
        localVarQueryParameter['first'] = first;
      }

      if (after !== undefined) {
        localVarQueryParameter['after'] = after;
      }

      if (assetId !== undefined) {
        localVarQueryParameter['assetId'] = assetId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a comment from a feed item
     * @param {string} id
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerRemoveComment: async (
      id: string,
      commentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerRemoveComment', 'id', id);
      // verify required parameter 'commentId' is not null or undefined
      assertParamExists('communityFeedControllerRemoveComment', 'commentId', commentId);
      const localVarPath = `/community-feed/feed-item/{id}/comments/{commentId}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'commentId'}}`, encodeURIComponent(String(commentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete your own like on a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerRemoveLike: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('communityFeedControllerRemoveLike', 'id', id);
      const localVarPath = `/community-feed/feed-item/{id}/likes`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CommunityFeedApi - functional programming interface
 * @export
 */
export const CommunityFeedApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CommunityFeedApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary File a chat attachment into the Documents tree
     * @param {string} id
     * @param {string} attachmentId
     * @param {ClassifyAttachmentDto} classifyAttachmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerClassifyAttachment(
      id: string,
      attachmentId: string,
      classifyAttachmentDto: ClassifyAttachmentDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachmentDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerClassifyAttachment(
          id,
          attachmentId,
          classifyAttachmentDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerClassifyAttachment']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Retrieve the feed for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {CommunityFeedControllerCommunityFeedKindEnum} [kind]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerCommunityFeed(
      assetId: string,
      first?: number,
      after?: string,
      kind?: CommunityFeedControllerCommunityFeedKindEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommunityFeedItemDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerCommunityFeed(
          assetId,
          first,
          after,
          kind,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerCommunityFeed']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a comment on a feed item
     * @param {string} id
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerCreateComment(
      id: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerCreateComment(
          id,
          createCommentDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerCreateComment']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create and publish a feed item
     * @param {CreateCommunityFeedItemDto} createCommunityFeedItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerCreateFeedItem(
      createCommunityFeedItemDto: CreateCommunityFeedItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityFeedItemDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerCreateFeedItem(
          createCommunityFeedItemDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerCreateFeedItem']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Before creating a feed item using POST /feed-item, you can call this route to upload files (images).
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerCreateFeedItemFile(
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StorageFileDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerCreateFeedItemFile(file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerCreateFeedItemFile']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a like on a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerCreateLike(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LikeDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerCreateLike(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerCreateLike']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerDeleteFeedItem(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerDeleteFeedItem(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerDeleteFeedItem']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Edit a comment from a feed item
     * @param {string} id
     * @param {string} commentId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerEditComment(
      id: string,
      commentId: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerEditComment(
        id,
        commentId,
        createCommentDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerEditComment']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Edit a feed item
     * @param {string} id
     * @param {EditCommunityFeedItemDto} editCommunityFeedItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerEditFeedItem(
      id: string,
      editCommunityFeedItemDto: EditCommunityFeedItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityFeedItemDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerEditFeedItem(
        id,
        editCommunityFeedItemDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerEditFeedItem']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Retrieve a single feed item by its ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerGetFeedItemById(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityFeedItemDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerGetFeedItemById(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerGetFeedItemById']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Retrieve feed of guestbook posts for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerGuestbook(
      assetId: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommunityFeedItemDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerGuestbook(
        assetId,
        first,
        after,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerGuestbook']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List the comments of a feed item
     * @param {string} id
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerListComments(
      id: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommentsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerListComments(
        id,
        first,
        after,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerListComments']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List the likes of a feed item
     * @param {string} id
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerListLikes(
      id: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLikesDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerListLikes(
        id,
        first,
        after,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerListLikes']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Retrieve feed of memories for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerMemories(
      assetId: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommunityFeedItemDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerMemories(
        assetId,
        first,
        after,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerMemories']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a comment from a feed item
     * @param {string} id
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerRemoveComment(
      id: string,
      commentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.communityFeedControllerRemoveComment(
          id,
          commentId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerRemoveComment']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete your own like on a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async communityFeedControllerRemoveLike(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.communityFeedControllerRemoveLike(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CommunityFeedApi.communityFeedControllerRemoveLike']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CommunityFeedApi - factory interface
 * @export
 */
export const CommunityFeedApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CommunityFeedApiFp(configuration);
  return {
    /**
     *
     * @summary File a chat attachment into the Documents tree
     * @param {string} id
     * @param {string} attachmentId
     * @param {ClassifyAttachmentDto} classifyAttachmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerClassifyAttachment(
      id: string,
      attachmentId: string,
      classifyAttachmentDto: ClassifyAttachmentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AttachmentDto> {
      return localVarFp
        .communityFeedControllerClassifyAttachment(id, attachmentId, classifyAttachmentDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve the feed for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {CommunityFeedControllerCommunityFeedKindEnum} [kind]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCommunityFeed(
      assetId: string,
      first?: number,
      after?: string,
      kind?: CommunityFeedControllerCommunityFeedKindEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedCommunityFeedItemDto> {
      return localVarFp
        .communityFeedControllerCommunityFeed(assetId, first, after, kind, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a comment on a feed item
     * @param {string} id
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateComment(
      id: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommentDto> {
      return localVarFp
        .communityFeedControllerCreateComment(id, createCommentDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create and publish a feed item
     * @param {CreateCommunityFeedItemDto} createCommunityFeedItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateFeedItem(
      createCommunityFeedItemDto: CreateCommunityFeedItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommunityFeedItemDto> {
      return localVarFp
        .communityFeedControllerCreateFeedItem(createCommunityFeedItemDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Before creating a feed item using POST /feed-item, you can call this route to upload files (images).
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateFeedItemFile(
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<StorageFileDto> {
      return localVarFp
        .communityFeedControllerCreateFeedItemFile(file, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a like on a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerCreateLike(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LikeDto> {
      return localVarFp
        .communityFeedControllerCreateLike(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerDeleteFeedItem(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .communityFeedControllerDeleteFeedItem(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Edit a comment from a feed item
     * @param {string} id
     * @param {string} commentId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerEditComment(
      id: string,
      commentId: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommentDto> {
      return localVarFp
        .communityFeedControllerEditComment(id, commentId, createCommentDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Edit a feed item
     * @param {string} id
     * @param {EditCommunityFeedItemDto} editCommunityFeedItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerEditFeedItem(
      id: string,
      editCommunityFeedItemDto: EditCommunityFeedItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommunityFeedItemDto> {
      return localVarFp
        .communityFeedControllerEditFeedItem(id, editCommunityFeedItemDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve a single feed item by its ID
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerGetFeedItemById(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommunityFeedItemDto> {
      return localVarFp
        .communityFeedControllerGetFeedItemById(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve feed of guestbook posts for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerGuestbook(
      assetId: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedCommunityFeedItemDto> {
      return localVarFp
        .communityFeedControllerGuestbook(assetId, first, after, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List the comments of a feed item
     * @param {string} id
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerListComments(
      id: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedCommentsDto> {
      return localVarFp
        .communityFeedControllerListComments(id, first, after, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List the likes of a feed item
     * @param {string} id
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerListLikes(
      id: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedLikesDto> {
      return localVarFp
        .communityFeedControllerListLikes(id, first, after, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve feed of memories for the current user
     * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerMemories(
      assetId: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedCommunityFeedItemDto> {
      return localVarFp
        .communityFeedControllerMemories(assetId, first, after, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a comment from a feed item
     * @param {string} id
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerRemoveComment(
      id: string,
      commentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .communityFeedControllerRemoveComment(id, commentId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete your own like on a feed item
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    communityFeedControllerRemoveLike(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .communityFeedControllerRemoveLike(id, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CommunityFeedApi - object-oriented interface
 * @export
 * @class CommunityFeedApi
 * @extends {BaseAPI}
 */
export class CommunityFeedApi extends BaseAPI {
  /**
   *
   * @summary File a chat attachment into the Documents tree
   * @param {string} id
   * @param {string} attachmentId
   * @param {ClassifyAttachmentDto} classifyAttachmentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerClassifyAttachment(
    id: string,
    attachmentId: string,
    classifyAttachmentDto: ClassifyAttachmentDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerClassifyAttachment(id, attachmentId, classifyAttachmentDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Retrieve the feed for the current user
   * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
   * @param {number} [first]
   * @param {string} [after]
   * @param {CommunityFeedControllerCommunityFeedKindEnum} [kind]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerCommunityFeed(
    assetId: string,
    first?: number,
    after?: string,
    kind?: CommunityFeedControllerCommunityFeedKindEnum,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerCommunityFeed(assetId, first, after, kind, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a comment on a feed item
   * @param {string} id
   * @param {CreateCommentDto} createCommentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerCreateComment(
    id: string,
    createCommentDto: CreateCommentDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerCreateComment(id, createCommentDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create and publish a feed item
   * @param {CreateCommunityFeedItemDto} createCommunityFeedItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerCreateFeedItem(
    createCommunityFeedItemDto: CreateCommunityFeedItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerCreateFeedItem(createCommunityFeedItemDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Before creating a feed item using POST /feed-item, you can call this route to upload files (images).
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerCreateFeedItemFile(file?: File, options?: RawAxiosRequestConfig) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerCreateFeedItemFile(file, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a like on a feed item
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerCreateLike(id: string, options?: RawAxiosRequestConfig) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerCreateLike(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a feed item
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerDeleteFeedItem(id: string, options?: RawAxiosRequestConfig) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerDeleteFeedItem(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Edit a comment from a feed item
   * @param {string} id
   * @param {string} commentId
   * @param {CreateCommentDto} createCommentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerEditComment(
    id: string,
    commentId: string,
    createCommentDto: CreateCommentDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerEditComment(id, commentId, createCommentDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Edit a feed item
   * @param {string} id
   * @param {EditCommunityFeedItemDto} editCommunityFeedItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerEditFeedItem(
    id: string,
    editCommunityFeedItemDto: EditCommunityFeedItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerEditFeedItem(id, editCommunityFeedItemDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Retrieve a single feed item by its ID
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerGetFeedItemById(id: string, options?: RawAxiosRequestConfig) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerGetFeedItemById(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Retrieve feed of guestbook posts for the current user
   * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
   * @param {number} [first]
   * @param {string} [after]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerGuestbook(
    assetId: string,
    first?: number,
    after?: string,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerGuestbook(assetId, first, after, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List the comments of a feed item
   * @param {string} id
   * @param {number} [first]
   * @param {string} [after]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerListComments(
    id: string,
    first?: number,
    after?: string,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerListComments(id, first, after, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List the likes of a feed item
   * @param {string} id
   * @param {number} [first]
   * @param {string} [after]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerListLikes(
    id: string,
    first?: number,
    after?: string,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerListLikes(id, first, after, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Retrieve feed of memories for the current user
   * @param {string} assetId Bien auquel le flux est rattaché. La page est mono-bien.
   * @param {number} [first]
   * @param {string} [after]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerMemories(
    assetId: string,
    first?: number,
    after?: string,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerMemories(assetId, first, after, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a comment from a feed item
   * @param {string} id
   * @param {string} commentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerRemoveComment(
    id: string,
    commentId: string,
    options?: RawAxiosRequestConfig
  ) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerRemoveComment(id, commentId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete your own like on a feed item
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommunityFeedApi
   */
  public communityFeedControllerRemoveLike(id: string, options?: RawAxiosRequestConfig) {
    return CommunityFeedApiFp(this.configuration)
      .communityFeedControllerRemoveLike(id, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const CommunityFeedControllerCommunityFeedKindEnum = {
  Wall: 'wall',
  Journal: 'journal',
} as const;
export type CommunityFeedControllerCommunityFeedKindEnum =
  (typeof CommunityFeedControllerCommunityFeedKindEnum)[keyof typeof CommunityFeedControllerCommunityFeedKindEnum];

/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new contact for an asset
     * @param {string} assetId
     * @param {CreateContactDto} createContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerCreate: async (
      assetId: string,
      createContactDto: CreateContactDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createContactDto' is not null or undefined
      assertParamExists('contactsControllerCreate', 'createContactDto', createContactDto);
      const localVarPath = `/assets/{assetId}/contacts`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createContactDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Duplicate a contact to other assets
     * @param {string} id
     * @param {string} assetId
     * @param {DuplicateContactDto} duplicateContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerDuplicate: async (
      id: string,
      assetId: string,
      duplicateContactDto: DuplicateContactDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('contactsControllerDuplicate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerDuplicate', 'assetId', assetId);
      // verify required parameter 'duplicateContactDto' is not null or undefined
      assertParamExists('contactsControllerDuplicate', 'duplicateContactDto', duplicateContactDto);
      const localVarPath = `/assets/{assetId}/contacts/{id}/duplicate`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        duplicateContactDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all contacts in an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {ContactsControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {string} [search] Recherche (accents et majuscules ignorés) : nom, entreprise, interlocuteurs, SIRET, n° client, téléphone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerFindAll: async (
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: ContactsControllerFindAllOrderEnum,
      search?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/contacts`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['orderBy'] = orderBy;
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single contact by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('contactsControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/contacts/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all contact categories and subcategories
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerGetCategories: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerGetCategories', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/contacts/meta/categories`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Check whether a contact can be safely deleted (returns blockers if any references prevent deletion)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerGetDeletionCheck: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('contactsControllerGetDeletionCheck', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerGetDeletionCheck', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/contacts/{id}/deletion-check`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a contact (fails if blockers exist)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerRemove: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('contactsControllerRemove', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerRemove', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/contacts/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search active French companies by name or SIRET in the État\'s company directory (empty list when unavailable)
     * @param {string} assetId
     * @param {string} q Nom ou SIRET de l\&#39;entreprise (3 caractères minimum)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerSearchCompanies: async (
      assetId: string,
      q: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerSearchCompanies', 'assetId', assetId);
      // verify required parameter 'q' is not null or undefined
      assertParamExists('contactsControllerSearchCompanies', 'q', q);
      const localVarPath = `/assets/{assetId}/contacts/meta/company-search`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (q !== undefined) {
        localVarQueryParameter['q'] = q;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an existing contact
     * @param {string} id
     * @param {string} assetId
     * @param {CreateContactDto} createContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerUpdate: async (
      id: string,
      assetId: string,
      createContactDto: CreateContactDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('contactsControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'createContactDto' is not null or undefined
      assertParamExists('contactsControllerUpdate', 'createContactDto', createContactDto);
      const localVarPath = `/assets/{assetId}/contacts/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createContactDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Toggle the favorite status of a contact
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateFavoriteDto} updateFavoriteDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerUpdateFavoriteStatus: async (
      id: string,
      assetId: string,
      updateFavoriteDto: UpdateFavoriteDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('contactsControllerUpdateFavoriteStatus', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerUpdateFavoriteStatus', 'assetId', assetId);
      // verify required parameter 'updateFavoriteDto' is not null or undefined
      assertParamExists(
        'contactsControllerUpdateFavoriteStatus',
        'updateFavoriteDto',
        updateFavoriteDto
      );
      const localVarPath = `/assets/{assetId}/contacts/{id}/favorite`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateFavoriteDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload a temporary image for a contact
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerUploadTemporaryImage: async (
      assetId: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('contactsControllerUploadTemporaryImage', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/contacts/temporary-image`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new contact for an asset
     * @param {string} assetId
     * @param {CreateContactDto} createContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerCreate(
      assetId: string,
      createContactDto: CreateContactDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerCreate(
        assetId,
        createContactDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Duplicate a contact to other assets
     * @param {string} id
     * @param {string} assetId
     * @param {DuplicateContactDto} duplicateContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerDuplicate(
      id: string,
      assetId: string,
      duplicateContactDto: DuplicateContactDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DuplicateContactResultDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerDuplicate(
        id,
        assetId,
        duplicateContactDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerDuplicate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all contacts in an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {ContactsControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {string} [search] Recherche (accents et majuscules ignorés) : nom, entreprise, interlocuteurs, SIRET, n° client, téléphone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: ContactsControllerFindAllOrderEnum,
      search?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedContactsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerFindAll(
        assetId,
        page,
        limit,
        orderBy,
        order,
        search,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerFindAll']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single contact by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerFindOne(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerFindOne']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all contact categories and subcategories
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerGetCategories(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactCategoriesResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerGetCategories(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerGetCategories']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Check whether a contact can be safely deleted (returns blockers if any references prevent deletion)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerGetDeletionCheck(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactDeletionCheckDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerGetDeletionCheck(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerGetDeletionCheck']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a contact (fails if blockers exist)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerRemove(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerRemove']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Search active French companies by name or SIRET in the État\'s company directory (empty list when unavailable)
     * @param {string} assetId
     * @param {string} q Nom ou SIRET de l\&#39;entreprise (3 caractères minimum)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerSearchCompanies(
      assetId: string,
      q: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CompanySearchResultDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerSearchCompanies(
        assetId,
        q,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerSearchCompanies']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an existing contact
     * @param {string} id
     * @param {string} assetId
     * @param {CreateContactDto} createContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerUpdate(
      id: string,
      assetId: string,
      createContactDto: CreateContactDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.contactsControllerUpdate(
        id,
        assetId,
        createContactDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Toggle the favorite status of a contact
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateFavoriteDto} updateFavoriteDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerUpdateFavoriteStatus(
      id: string,
      assetId: string,
      updateFavoriteDto: UpdateFavoriteDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contactsControllerUpdateFavoriteStatus(
          id,
          assetId,
          updateFavoriteDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerUpdateFavoriteStatus']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Upload a temporary image for a contact
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async contactsControllerUploadTemporaryImage(
      assetId: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempUploadedImageDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.contactsControllerUploadTemporaryImage(
          assetId,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ContactsApi.contactsControllerUploadTemporaryImage']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ContactsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new contact for an asset
     * @param {string} assetId
     * @param {CreateContactDto} createContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerCreate(
      assetId: string,
      createContactDto: CreateContactDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ContactDto> {
      return localVarFp
        .contactsControllerCreate(assetId, createContactDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Duplicate a contact to other assets
     * @param {string} id
     * @param {string} assetId
     * @param {DuplicateContactDto} duplicateContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerDuplicate(
      id: string,
      assetId: string,
      duplicateContactDto: DuplicateContactDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DuplicateContactResultDto> {
      return localVarFp
        .contactsControllerDuplicate(id, assetId, duplicateContactDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all contacts in an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {ContactsControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {string} [search] Recherche (accents et majuscules ignorés) : nom, entreprise, interlocuteurs, SIRET, n° client, téléphone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: ContactsControllerFindAllOrderEnum,
      search?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedContactsDto> {
      return localVarFp
        .contactsControllerFindAll(assetId, page, limit, orderBy, order, search, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single contact by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ContactDto> {
      return localVarFp
        .contactsControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get all contact categories and subcategories
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerGetCategories(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ContactCategoriesResponseDto> {
      return localVarFp
        .contactsControllerGetCategories(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Check whether a contact can be safely deleted (returns blockers if any references prevent deletion)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerGetDeletionCheck(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ContactDeletionCheckDto> {
      return localVarFp
        .contactsControllerGetDeletionCheck(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a contact (fails if blockers exist)
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .contactsControllerRemove(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Search active French companies by name or SIRET in the État\'s company directory (empty list when unavailable)
     * @param {string} assetId
     * @param {string} q Nom ou SIRET de l\&#39;entreprise (3 caractères minimum)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerSearchCompanies(
      assetId: string,
      q: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<CompanySearchResultDto>> {
      return localVarFp
        .contactsControllerSearchCompanies(assetId, q, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update an existing contact
     * @param {string} id
     * @param {string} assetId
     * @param {CreateContactDto} createContactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerUpdate(
      id: string,
      assetId: string,
      createContactDto: CreateContactDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ContactDto> {
      return localVarFp
        .contactsControllerUpdate(id, assetId, createContactDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Toggle the favorite status of a contact
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateFavoriteDto} updateFavoriteDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerUpdateFavoriteStatus(
      id: string,
      assetId: string,
      updateFavoriteDto: UpdateFavoriteDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ContactDto> {
      return localVarFp
        .contactsControllerUpdateFavoriteStatus(id, assetId, updateFavoriteDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Upload a temporary image for a contact
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    contactsControllerUploadTemporaryImage(
      assetId: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TempUploadedImageDto> {
      return localVarFp
        .contactsControllerUploadTemporaryImage(assetId, file, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
  /**
   *
   * @summary Create a new contact for an asset
   * @param {string} assetId
   * @param {CreateContactDto} createContactDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerCreate(
    assetId: string,
    createContactDto: CreateContactDto,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerCreate(assetId, createContactDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Duplicate a contact to other assets
   * @param {string} id
   * @param {string} assetId
   * @param {DuplicateContactDto} duplicateContactDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerDuplicate(
    id: string,
    assetId: string,
    duplicateContactDto: DuplicateContactDto,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerDuplicate(id, assetId, duplicateContactDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all contacts in an asset (paginated)
   * @param {string} assetId
   * @param {number} [page] Page number
   * @param {number} [limit] Items per page
   * @param {string} [orderBy] Champ de tri
   * @param {ContactsControllerFindAllOrderEnum} [order] Ordre de tri
   * @param {string} [search] Recherche (accents et majuscules ignorés) : nom, entreprise, interlocuteurs, SIRET, n° client, téléphone
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerFindAll(
    assetId: string,
    page?: number,
    limit?: number,
    orderBy?: string,
    order?: ContactsControllerFindAllOrderEnum,
    search?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerFindAll(assetId, page, limit, orderBy, order, search, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single contact by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerFindOne(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ContactsApiFp(this.configuration)
      .contactsControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all contact categories and subcategories
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerGetCategories(assetId: string, options?: RawAxiosRequestConfig) {
    return ContactsApiFp(this.configuration)
      .contactsControllerGetCategories(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Check whether a contact can be safely deleted (returns blockers if any references prevent deletion)
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerGetDeletionCheck(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerGetDeletionCheck(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a contact (fails if blockers exist)
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerRemove(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ContactsApiFp(this.configuration)
      .contactsControllerRemove(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search active French companies by name or SIRET in the État\'s company directory (empty list when unavailable)
   * @param {string} assetId
   * @param {string} q Nom ou SIRET de l\&#39;entreprise (3 caractères minimum)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerSearchCompanies(
    assetId: string,
    q: string,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerSearchCompanies(assetId, q, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an existing contact
   * @param {string} id
   * @param {string} assetId
   * @param {CreateContactDto} createContactDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerUpdate(
    id: string,
    assetId: string,
    createContactDto: CreateContactDto,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerUpdate(id, assetId, createContactDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Toggle the favorite status of a contact
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateFavoriteDto} updateFavoriteDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerUpdateFavoriteStatus(
    id: string,
    assetId: string,
    updateFavoriteDto: UpdateFavoriteDto,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerUpdateFavoriteStatus(id, assetId, updateFavoriteDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Upload a temporary image for a contact
   * @param {string} assetId
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactsApi
   */
  public contactsControllerUploadTemporaryImage(
    assetId: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return ContactsApiFp(this.configuration)
      .contactsControllerUploadTemporaryImage(assetId, file, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const ContactsControllerFindAllOrderEnum = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;
export type ContactsControllerFindAllOrderEnum =
  (typeof ContactsControllerFindAllOrderEnum)[keyof typeof ContactsControllerFindAllOrderEnum];

/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Retrieve all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countriesControllerFindAll: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/countries`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Retrieve all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countriesControllerFindAll(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CountryDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.countriesControllerFindAll(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CountriesApi.countriesControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CountriesApiFp(configuration);
  return {
    /**
     *
     * @summary Retrieve all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countriesControllerFindAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<CountryDto>> {
      return localVarFp
        .countriesControllerFindAll(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
  /**
   *
   * @summary Retrieve all countries
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CountriesApi
   */
  public countriesControllerFindAll(options?: RawAxiosRequestConfig) {
    return CountriesApiFp(this.configuration)
      .countriesControllerFindAll(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get the formula and source lines behind a manager KPI aggregate
     * @param {string} assetId
     * @param {string} year
     * @param {string} metric
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerGetBreakdown: async (
      assetId: string,
      year: string,
      metric: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('dashboardControllerGetBreakdown', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('dashboardControllerGetBreakdown', 'year', year);
      // verify required parameter 'metric' is not null or undefined
      assertParamExists('dashboardControllerGetBreakdown', 'metric', metric);
      const localVarPath = `/assets/{assetId}/overview/manager/breakdown`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      if (metric !== undefined) {
        localVarQueryParameter['metric'] = metric;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get dashboard data for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerGetDashboard: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('dashboardControllerGetDashboard', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/overview`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get manager dashboard data for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerGetManagerDashboard: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('dashboardControllerGetManagerDashboard', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/overview/manager`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get the formula and source lines behind a manager KPI aggregate
     * @param {string} assetId
     * @param {string} year
     * @param {string} metric
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardControllerGetBreakdown(
      assetId: string,
      year: string,
      metric: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BudgetBreakdownDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetBreakdown(
        assetId,
        year,
        metric,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DashboardApi.dashboardControllerGetBreakdown']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get dashboard data for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardControllerGetDashboard(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardControllerGetDashboard(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DashboardApi.dashboardControllerGetDashboard']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get manager dashboard data for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dashboardControllerGetManagerDashboard(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManagerDashboardDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.dashboardControllerGetManagerDashboard(assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DashboardApi.dashboardControllerGetManagerDashboard']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DashboardApiFp(configuration);
  return {
    /**
     *
     * @summary Get the formula and source lines behind a manager KPI aggregate
     * @param {string} assetId
     * @param {string} year
     * @param {string} metric
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerGetBreakdown(
      assetId: string,
      year: string,
      metric: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BudgetBreakdownDto> {
      return localVarFp
        .dashboardControllerGetBreakdown(assetId, year, metric, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get dashboard data for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerGetDashboard(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DashboardDto> {
      return localVarFp
        .dashboardControllerGetDashboard(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get manager dashboard data for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dashboardControllerGetManagerDashboard(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ManagerDashboardDto> {
      return localVarFp
        .dashboardControllerGetManagerDashboard(assetId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
  /**
   *
   * @summary Get the formula and source lines behind a manager KPI aggregate
   * @param {string} assetId
   * @param {string} year
   * @param {string} metric
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApi
   */
  public dashboardControllerGetBreakdown(
    assetId: string,
    year: string,
    metric: string,
    options?: RawAxiosRequestConfig
  ) {
    return DashboardApiFp(this.configuration)
      .dashboardControllerGetBreakdown(assetId, year, metric, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get dashboard data for an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApi
   */
  public dashboardControllerGetDashboard(assetId: string, options?: RawAxiosRequestConfig) {
    return DashboardApiFp(this.configuration)
      .dashboardControllerGetDashboard(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get manager dashboard data for an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApi
   */
  public dashboardControllerGetManagerDashboard(assetId: string, options?: RawAxiosRequestConfig) {
    return DashboardApiFp(this.configuration)
      .dashboardControllerGetManagerDashboard(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * DocumentSuggestionsApi - axios parameter creator
 * @export
 */
export const DocumentSuggestionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Rename and move the document as suggested (optionally edited)
     * @param {string} assetId
     * @param {string} suggestionId
     * @param {AcceptDocumentSuggestionDto} acceptDocumentSuggestionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentClassificationControllerAccept: async (
      assetId: string,
      suggestionId: string,
      acceptDocumentSuggestionDto: AcceptDocumentSuggestionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('documentClassificationControllerAccept', 'assetId', assetId);
      // verify required parameter 'suggestionId' is not null or undefined
      assertParamExists('documentClassificationControllerAccept', 'suggestionId', suggestionId);
      // verify required parameter 'acceptDocumentSuggestionDto' is not null or undefined
      assertParamExists(
        'documentClassificationControllerAccept',
        'acceptDocumentSuggestionDto',
        acceptDocumentSuggestionDto
      );
      const localVarPath = `/assets/{assetId}/document-suggestions/{suggestionId}/accept`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'suggestionId'}}`, encodeURIComponent(String(suggestionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        acceptDocumentSuggestionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List the current user\'s documents being analyzed or awaiting a filing decision
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentClassificationControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('documentClassificationControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/document-suggestions`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Dismiss a filing suggestion
     * @param {string} assetId
     * @param {string} suggestionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentClassificationControllerReject: async (
      assetId: string,
      suggestionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('documentClassificationControllerReject', 'assetId', assetId);
      // verify required parameter 'suggestionId' is not null or undefined
      assertParamExists('documentClassificationControllerReject', 'suggestionId', suggestionId);
      const localVarPath = `/assets/{assetId}/document-suggestions/{suggestionId}/reject`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'suggestionId'}}`, encodeURIComponent(String(suggestionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DocumentSuggestionsApi - functional programming interface
 * @export
 */
export const DocumentSuggestionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DocumentSuggestionsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Rename and move the document as suggested (optionally edited)
     * @param {string} assetId
     * @param {string} suggestionId
     * @param {AcceptDocumentSuggestionDto} acceptDocumentSuggestionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentClassificationControllerAccept(
      assetId: string,
      suggestionId: string,
      acceptDocumentSuggestionDto: AcceptDocumentSuggestionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentSuggestionDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.documentClassificationControllerAccept(
          assetId,
          suggestionId,
          acceptDocumentSuggestionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DocumentSuggestionsApi.documentClassificationControllerAccept']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List the current user\'s documents being analyzed or awaiting a filing decision
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentClassificationControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentSuggestionDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.documentClassificationControllerFindAll(assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DocumentSuggestionsApi.documentClassificationControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Dismiss a filing suggestion
     * @param {string} assetId
     * @param {string} suggestionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async documentClassificationControllerReject(
      assetId: string,
      suggestionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.documentClassificationControllerReject(
          assetId,
          suggestionId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DocumentSuggestionsApi.documentClassificationControllerReject']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DocumentSuggestionsApi - factory interface
 * @export
 */
export const DocumentSuggestionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DocumentSuggestionsApiFp(configuration);
  return {
    /**
     *
     * @summary Rename and move the document as suggested (optionally edited)
     * @param {string} assetId
     * @param {string} suggestionId
     * @param {AcceptDocumentSuggestionDto} acceptDocumentSuggestionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentClassificationControllerAccept(
      assetId: string,
      suggestionId: string,
      acceptDocumentSuggestionDto: AcceptDocumentSuggestionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DocumentSuggestionDto> {
      return localVarFp
        .documentClassificationControllerAccept(
          assetId,
          suggestionId,
          acceptDocumentSuggestionDto,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List the current user\'s documents being analyzed or awaiting a filing decision
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentClassificationControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<DocumentSuggestionDto>> {
      return localVarFp
        .documentClassificationControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Dismiss a filing suggestion
     * @param {string} assetId
     * @param {string} suggestionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    documentClassificationControllerReject(
      assetId: string,
      suggestionId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .documentClassificationControllerReject(assetId, suggestionId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * DocumentSuggestionsApi - object-oriented interface
 * @export
 * @class DocumentSuggestionsApi
 * @extends {BaseAPI}
 */
export class DocumentSuggestionsApi extends BaseAPI {
  /**
   *
   * @summary Rename and move the document as suggested (optionally edited)
   * @param {string} assetId
   * @param {string} suggestionId
   * @param {AcceptDocumentSuggestionDto} acceptDocumentSuggestionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSuggestionsApi
   */
  public documentClassificationControllerAccept(
    assetId: string,
    suggestionId: string,
    acceptDocumentSuggestionDto: AcceptDocumentSuggestionDto,
    options?: RawAxiosRequestConfig
  ) {
    return DocumentSuggestionsApiFp(this.configuration)
      .documentClassificationControllerAccept(
        assetId,
        suggestionId,
        acceptDocumentSuggestionDto,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List the current user\'s documents being analyzed or awaiting a filing decision
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSuggestionsApi
   */
  public documentClassificationControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return DocumentSuggestionsApiFp(this.configuration)
      .documentClassificationControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Dismiss a filing suggestion
   * @param {string} assetId
   * @param {string} suggestionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSuggestionsApi
   */
  public documentClassificationControllerReject(
    assetId: string,
    suggestionId: string,
    options?: RawAxiosRequestConfig
  ) {
    return DocumentSuggestionsApiFp(this.configuration)
      .documentClassificationControllerReject(assetId, suggestionId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * EntityExportsApi - axios parameter creator
 * @export
 */
export const EntityExportsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new entity export or return an existing matching one
     * @param {string} assetId
     * @param {CreateEntityExportDto} createEntityExportDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerCreate: async (
      assetId: string,
      createEntityExportDto: CreateEntityExportDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityExportsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createEntityExportDto' is not null or undefined
      assertParamExists(
        'entityExportsControllerCreate',
        'createEntityExportDto',
        createEntityExportDto
      );
      const localVarPath = `/assets/{assetId}/exports`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createEntityExportDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all exports for an asset, optionally filtered by entity type
     * @param {string} assetId
     * @param {EntityExportsControllerFindAllEntityTypeEnum} [entityType] Optional filter by entity type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerFindAll: async (
      assetId: string,
      entityType?: EntityExportsControllerFindAllEntityTypeEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityExportsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/exports`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get details of a specific entity export by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('entityExportsControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityExportsControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/exports/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generate a new public token for an entity export
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerRefreshPublicToken: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('entityExportsControllerRefreshPublicToken', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityExportsControllerRefreshPublicToken', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/exports/{id}/refresh-token`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft delete an entity export by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerRemove: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('entityExportsControllerRemove', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityExportsControllerRemove', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/exports/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityExportsApi - functional programming interface
 * @export
 */
export const EntityExportsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EntityExportsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new entity export or return an existing matching one
     * @param {string} assetId
     * @param {CreateEntityExportDto} createEntityExportDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityExportsControllerCreate(
      assetId: string,
      createEntityExportDto: CreateEntityExportDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityExportDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.entityExportsControllerCreate(
        assetId,
        createEntityExportDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityExportsApi.entityExportsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List all exports for an asset, optionally filtered by entity type
     * @param {string} assetId
     * @param {EntityExportsControllerFindAllEntityTypeEnum} [entityType] Optional filter by entity type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityExportsControllerFindAll(
      assetId: string,
      entityType?: EntityExportsControllerFindAllEntityTypeEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityExportDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.entityExportsControllerFindAll(
        assetId,
        entityType,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityExportsApi.entityExportsControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get details of a specific entity export by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityExportsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityExportDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.entityExportsControllerFindOne(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityExportsApi.entityExportsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generate a new public token for an entity export
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityExportsControllerRefreshPublicToken(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityExportDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.entityExportsControllerRefreshPublicToken(
          id,
          assetId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityExportsApi.entityExportsControllerRefreshPublicToken']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft delete an entity export by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityExportsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.entityExportsControllerRemove(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityExportsApi.entityExportsControllerRemove']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * EntityExportsApi - factory interface
 * @export
 */
export const EntityExportsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EntityExportsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new entity export or return an existing matching one
     * @param {string} assetId
     * @param {CreateEntityExportDto} createEntityExportDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerCreate(
      assetId: string,
      createEntityExportDto: CreateEntityExportDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EntityExportDto> {
      return localVarFp
        .entityExportsControllerCreate(assetId, createEntityExportDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List all exports for an asset, optionally filtered by entity type
     * @param {string} assetId
     * @param {EntityExportsControllerFindAllEntityTypeEnum} [entityType] Optional filter by entity type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerFindAll(
      assetId: string,
      entityType?: EntityExportsControllerFindAllEntityTypeEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<EntityExportDto>> {
      return localVarFp
        .entityExportsControllerFindAll(assetId, entityType, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get details of a specific entity export by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EntityExportDto> {
      return localVarFp
        .entityExportsControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Generate a new public token for an entity export
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerRefreshPublicToken(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EntityExportDto> {
      return localVarFp
        .entityExportsControllerRefreshPublicToken(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft delete an entity export by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityExportsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .entityExportsControllerRemove(id, assetId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * EntityExportsApi - object-oriented interface
 * @export
 * @class EntityExportsApi
 * @extends {BaseAPI}
 */
export class EntityExportsApi extends BaseAPI {
  /**
   *
   * @summary Create a new entity export or return an existing matching one
   * @param {string} assetId
   * @param {CreateEntityExportDto} createEntityExportDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityExportsApi
   */
  public entityExportsControllerCreate(
    assetId: string,
    createEntityExportDto: CreateEntityExportDto,
    options?: RawAxiosRequestConfig
  ) {
    return EntityExportsApiFp(this.configuration)
      .entityExportsControllerCreate(assetId, createEntityExportDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List all exports for an asset, optionally filtered by entity type
   * @param {string} assetId
   * @param {EntityExportsControllerFindAllEntityTypeEnum} [entityType] Optional filter by entity type.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityExportsApi
   */
  public entityExportsControllerFindAll(
    assetId: string,
    entityType?: EntityExportsControllerFindAllEntityTypeEnum,
    options?: RawAxiosRequestConfig
  ) {
    return EntityExportsApiFp(this.configuration)
      .entityExportsControllerFindAll(assetId, entityType, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get details of a specific entity export by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityExportsApi
   */
  public entityExportsControllerFindOne(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return EntityExportsApiFp(this.configuration)
      .entityExportsControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generate a new public token for an entity export
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityExportsApi
   */
  public entityExportsControllerRefreshPublicToken(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return EntityExportsApiFp(this.configuration)
      .entityExportsControllerRefreshPublicToken(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft delete an entity export by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityExportsApi
   */
  public entityExportsControllerRemove(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return EntityExportsApiFp(this.configuration)
      .entityExportsControllerRemove(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const EntityExportsControllerFindAllEntityTypeEnum = {
  Contact: 'CONTACT',
  Checklist: 'CHECKLIST',
  Instruction: 'INSTRUCTION',
  Event: 'EVENT',
  AssetStorageItem: 'ASSET_STORAGE_ITEM',
  PracticalInformation: 'PRACTICAL_INFORMATION',
} as const;
export type EntityExportsControllerFindAllEntityTypeEnum =
  (typeof EntityExportsControllerFindAllEntityTypeEnum)[keyof typeof EntityExportsControllerFindAllEntityTypeEnum];

/**
 * EntityLinksApi - axios parameter creator
 * @export
 */
export const EntityLinksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} assetId
     * @param {CreateEntityLinkDto} createEntityLinkDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityLinksControllerCreate: async (
      assetId: string,
      createEntityLinkDto: CreateEntityLinkDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityLinksControllerCreate', 'assetId', assetId);
      // verify required parameter 'createEntityLinkDto' is not null or undefined
      assertParamExists('entityLinksControllerCreate', 'createEntityLinkDto', createEntityLinkDto);
      const localVarPath = `/assets/{assetId}/entity-links`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createEntityLinkDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assetId
     * @param {EntityLinksControllerFindAllEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityLinksControllerFindAll: async (
      assetId: string,
      entityType: EntityLinksControllerFindAllEntityTypeEnum,
      entityId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityLinksControllerFindAll', 'assetId', assetId);
      // verify required parameter 'entityType' is not null or undefined
      assertParamExists('entityLinksControllerFindAll', 'entityType', entityType);
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('entityLinksControllerFindAll', 'entityId', entityId);
      const localVarPath = `/assets/{assetId}/entity-links`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType;
      }

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assetId
     * @param {string} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityLinksControllerRemove: async (
      assetId: string,
      linkId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('entityLinksControllerRemove', 'assetId', assetId);
      // verify required parameter 'linkId' is not null or undefined
      assertParamExists('entityLinksControllerRemove', 'linkId', linkId);
      const localVarPath = `/assets/{assetId}/entity-links/{linkId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'linkId'}}`, encodeURIComponent(String(linkId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityLinksApi - functional programming interface
 * @export
 */
export const EntityLinksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EntityLinksApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} assetId
     * @param {CreateEntityLinkDto} createEntityLinkDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityLinksControllerCreate(
      assetId: string,
      createEntityLinkDto: CreateEntityLinkDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedEntityDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.entityLinksControllerCreate(
        assetId,
        createEntityLinkDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityLinksApi.entityLinksControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assetId
     * @param {EntityLinksControllerFindAllEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityLinksControllerFindAll(
      assetId: string,
      entityType: EntityLinksControllerFindAllEntityTypeEnum,
      entityId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkedEntityDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.entityLinksControllerFindAll(
        assetId,
        entityType,
        entityId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityLinksApi.entityLinksControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assetId
     * @param {string} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityLinksControllerRemove(
      assetId: string,
      linkId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.entityLinksControllerRemove(
        assetId,
        linkId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EntityLinksApi.entityLinksControllerRemove']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * EntityLinksApi - factory interface
 * @export
 */
export const EntityLinksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EntityLinksApiFp(configuration);
  return {
    /**
     *
     * @param {string} assetId
     * @param {CreateEntityLinkDto} createEntityLinkDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityLinksControllerCreate(
      assetId: string,
      createEntityLinkDto: CreateEntityLinkDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LinkedEntityDto> {
      return localVarFp
        .entityLinksControllerCreate(assetId, createEntityLinkDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} assetId
     * @param {EntityLinksControllerFindAllEntityTypeEnum} entityType
     * @param {string} entityId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityLinksControllerFindAll(
      assetId: string,
      entityType: EntityLinksControllerFindAllEntityTypeEnum,
      entityId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<LinkedEntityDto>> {
      return localVarFp
        .entityLinksControllerFindAll(assetId, entityType, entityId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} assetId
     * @param {string} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityLinksControllerRemove(
      assetId: string,
      linkId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .entityLinksControllerRemove(assetId, linkId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * EntityLinksApi - object-oriented interface
 * @export
 * @class EntityLinksApi
 * @extends {BaseAPI}
 */
export class EntityLinksApi extends BaseAPI {
  /**
   *
   * @param {string} assetId
   * @param {CreateEntityLinkDto} createEntityLinkDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityLinksApi
   */
  public entityLinksControllerCreate(
    assetId: string,
    createEntityLinkDto: CreateEntityLinkDto,
    options?: RawAxiosRequestConfig
  ) {
    return EntityLinksApiFp(this.configuration)
      .entityLinksControllerCreate(assetId, createEntityLinkDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} assetId
   * @param {EntityLinksControllerFindAllEntityTypeEnum} entityType
   * @param {string} entityId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityLinksApi
   */
  public entityLinksControllerFindAll(
    assetId: string,
    entityType: EntityLinksControllerFindAllEntityTypeEnum,
    entityId: string,
    options?: RawAxiosRequestConfig
  ) {
    return EntityLinksApiFp(this.configuration)
      .entityLinksControllerFindAll(assetId, entityType, entityId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} assetId
   * @param {string} linkId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityLinksApi
   */
  public entityLinksControllerRemove(
    assetId: string,
    linkId: string,
    options?: RawAxiosRequestConfig
  ) {
    return EntityLinksApiFp(this.configuration)
      .entityLinksControllerRemove(assetId, linkId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const EntityLinksControllerFindAllEntityTypeEnum = {
  Task: 'task',
  Project: 'project',
  Contact: 'contact',
  VirtualFile: 'virtualFile',
  Expense: 'expense',
  CommunityFeedItem: 'communityFeedItem',
  Room: 'room',
  Event: 'event',
  InventoryItem: 'inventoryItem',
} as const;
export type EntityLinksControllerFindAllEntityTypeEnum =
  (typeof EntityLinksControllerFindAllEntityTypeEnum)[keyof typeof EntityLinksControllerFindAllEntityTypeEnum];

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new event
     * @param {string} assetId
     * @param {CreateEventDto} createEventDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerCreate: async (
      assetId: string,
      createEventDto: CreateEventDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('eventsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createEventDto' is not null or undefined
      assertParamExists('eventsControllerCreate', 'createEventDto', createEventDto);
      const localVarPath = `/assets/{assetId}/events`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createEventDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all events for an asset within a date range
     * @param {string} startDate Start date (ISO 8601)
     * @param {string} endDate End date (ISO 8601)
     * @param {string} timezone User timezone
     * @param {string} assetId
     * @param {Array<EventsControllerFindAllEventTypesEnum>} [eventTypes] Event types to filter (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerFindAll: async (
      startDate: string,
      endDate: string,
      timezone: string,
      assetId: string,
      eventTypes?: Array<EventsControllerFindAllEventTypesEnum>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('eventsControllerFindAll', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('eventsControllerFindAll', 'endDate', endDate);
      // verify required parameter 'timezone' is not null or undefined
      assertParamExists('eventsControllerFindAll', 'timezone', timezone);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('eventsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/events`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (timezone !== undefined) {
        localVarQueryParameter['timezone'] = timezone;
      }

      if (eventTypes) {
        localVarQueryParameter['eventTypes'] = eventTypes;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single event by its ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerFindOne: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('eventsControllerFindOne', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('eventsControllerFindOne', 'id', id);
      const localVarPath = `/assets/{assetId}/events/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all events for an asset (no date range, no recurrence expansion)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerList: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('eventsControllerList', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/events/list`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft delete an event by ID
     * @param {string} assetId
     * @param {string} id
     * @param {Dayjs} [occurrenceDate] Occurrence start time if client wants to delete single occurrence of reccurring event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerRemove: async (
      assetId: string,
      id: string,
      occurrenceDate?: Dayjs,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('eventsControllerRemove', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('eventsControllerRemove', 'id', id);
      const localVarPath = `/assets/{assetId}/events/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (occurrenceDate !== undefined) {
        localVarQueryParameter['occurrenceDate'] =
          typeof (occurrenceDate as any)?.toISOString === 'function'
            ? (occurrenceDate as any).toISOString()
            : occurrenceDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an existing event
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateEventDto} updateEventDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerUpdate: async (
      assetId: string,
      id: string,
      updateEventDto: UpdateEventDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('eventsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('eventsControllerUpdate', 'id', id);
      // verify required parameter 'updateEventDto' is not null or undefined
      assertParamExists('eventsControllerUpdate', 'updateEventDto', updateEventDto);
      const localVarPath = `/assets/{assetId}/events/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateEventDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new event
     * @param {string} assetId
     * @param {CreateEventDto} createEventDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsControllerCreate(
      assetId: string,
      createEventDto: CreateEventDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerCreate(
        assetId,
        createEventDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EventsApi.eventsControllerCreate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all events for an asset within a date range
     * @param {string} startDate Start date (ISO 8601)
     * @param {string} endDate End date (ISO 8601)
     * @param {string} timezone User timezone
     * @param {string} assetId
     * @param {Array<EventsControllerFindAllEventTypesEnum>} [eventTypes] Event types to filter (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsControllerFindAll(
      startDate: string,
      endDate: string,
      timezone: string,
      assetId: string,
      eventTypes?: Array<EventsControllerFindAllEventTypesEnum>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventDetailsDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerFindAll(
        startDate,
        endDate,
        timezone,
        assetId,
        eventTypes,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EventsApi.eventsControllerFindAll']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single event by its ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetailsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerFindOne(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EventsApi.eventsControllerFindOne']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List all events for an asset (no date range, no recurrence expansion)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsControllerList(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventSummaryDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerList(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EventsApi.eventsControllerList']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft delete an event by ID
     * @param {string} assetId
     * @param {string} id
     * @param {Dayjs} [occurrenceDate] Occurrence start time if client wants to delete single occurrence of reccurring event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsControllerRemove(
      assetId: string,
      id: string,
      occurrenceDate?: Dayjs,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerRemove(
        assetId,
        id,
        occurrenceDate,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EventsApi.eventsControllerRemove']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an existing event
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateEventDto} updateEventDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventsControllerUpdate(
      assetId: string,
      id: string,
      updateEventDto: UpdateEventDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.eventsControllerUpdate(
        assetId,
        id,
        updateEventDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['EventsApi.eventsControllerUpdate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EventsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new event
     * @param {string} assetId
     * @param {CreateEventDto} createEventDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerCreate(
      assetId: string,
      createEventDto: CreateEventDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EventDto> {
      return localVarFp
        .eventsControllerCreate(assetId, createEventDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all events for an asset within a date range
     * @param {string} startDate Start date (ISO 8601)
     * @param {string} endDate End date (ISO 8601)
     * @param {string} timezone User timezone
     * @param {string} assetId
     * @param {Array<EventsControllerFindAllEventTypesEnum>} [eventTypes] Event types to filter (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerFindAll(
      startDate: string,
      endDate: string,
      timezone: string,
      assetId: string,
      eventTypes?: Array<EventsControllerFindAllEventTypesEnum>,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<EventDetailsDto>> {
      return localVarFp
        .eventsControllerFindAll(startDate, endDate, timezone, assetId, eventTypes, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single event by its ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EventDetailsDto> {
      return localVarFp
        .eventsControllerFindOne(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List all events for an asset (no date range, no recurrence expansion)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerList(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<EventSummaryDto>> {
      return localVarFp
        .eventsControllerList(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft delete an event by ID
     * @param {string} assetId
     * @param {string} id
     * @param {Dayjs} [occurrenceDate] Occurrence start time if client wants to delete single occurrence of reccurring event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerRemove(
      assetId: string,
      id: string,
      occurrenceDate?: Dayjs,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .eventsControllerRemove(assetId, id, occurrenceDate, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update an existing event
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateEventDto} updateEventDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventsControllerUpdate(
      assetId: string,
      id: string,
      updateEventDto: UpdateEventDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EventDto> {
      return localVarFp
        .eventsControllerUpdate(assetId, id, updateEventDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
  /**
   *
   * @summary Create a new event
   * @param {string} assetId
   * @param {CreateEventDto} createEventDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsControllerCreate(
    assetId: string,
    createEventDto: CreateEventDto,
    options?: RawAxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .eventsControllerCreate(assetId, createEventDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all events for an asset within a date range
   * @param {string} startDate Start date (ISO 8601)
   * @param {string} endDate End date (ISO 8601)
   * @param {string} timezone User timezone
   * @param {string} assetId
   * @param {Array<EventsControllerFindAllEventTypesEnum>} [eventTypes] Event types to filter (optional)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsControllerFindAll(
    startDate: string,
    endDate: string,
    timezone: string,
    assetId: string,
    eventTypes?: Array<EventsControllerFindAllEventTypesEnum>,
    options?: RawAxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .eventsControllerFindAll(startDate, endDate, timezone, assetId, eventTypes, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single event by its ID
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsControllerFindOne(assetId: string, id: string, options?: RawAxiosRequestConfig) {
    return EventsApiFp(this.configuration)
      .eventsControllerFindOne(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List all events for an asset (no date range, no recurrence expansion)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsControllerList(assetId: string, options?: RawAxiosRequestConfig) {
    return EventsApiFp(this.configuration)
      .eventsControllerList(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft delete an event by ID
   * @param {string} assetId
   * @param {string} id
   * @param {Dayjs} [occurrenceDate] Occurrence start time if client wants to delete single occurrence of reccurring event
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsControllerRemove(
    assetId: string,
    id: string,
    occurrenceDate?: Dayjs,
    options?: RawAxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .eventsControllerRemove(assetId, id, occurrenceDate, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an existing event
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateEventDto} updateEventDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public eventsControllerUpdate(
    assetId: string,
    id: string,
    updateEventDto: UpdateEventDto,
    options?: RawAxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .eventsControllerUpdate(assetId, id, updateEventDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const EventsControllerFindAllEventTypesEnum = {
  Occupation: 'OCCUPATION',
  Entretien: 'ENTRETIEN',
  Location: 'LOCATION',
  EndOfContract: 'END_OF_CONTRACT',
  Work: 'WORK',
  Activities: 'ACTIVITIES',
  Other: 'OTHER',
  PublicHoliday: 'PUBLIC_HOLIDAY',
  SchoolHolidayZoneA: 'SCHOOL_HOLIDAY_ZONE_A',
  SchoolHolidayZoneB: 'SCHOOL_HOLIDAY_ZONE_B',
  SchoolHolidayZoneC: 'SCHOOL_HOLIDAY_ZONE_C',
} as const;
export type EventsControllerFindAllEventTypesEnum =
  (typeof EventsControllerFindAllEventTypesEnum)[keyof typeof EventsControllerFindAllEventTypesEnum];

/**
 * ExpensesApi - axios parameter creator
 * @export
 */
export const ExpensesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new expense
     * @param {string} assetId
     * @param {CreateExpenseDto} createExpenseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerCreate: async (
      assetId: string,
      createExpenseDto: CreateExpenseDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerCreate', 'assetId', assetId);
      // verify required parameter 'createExpenseDto' is not null or undefined
      assertParamExists('expensesControllerCreate', 'createExpenseDto', createExpenseDto);
      const localVarPath = `/assets/{assetId}/expenses`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createExpenseDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new reimbursement transaction
     * @param {string} assetId
     * @param {CreateReimbursementDto} createReimbursementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerCreateReimbursement: async (
      assetId: string,
      createReimbursementDto: CreateReimbursementDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerCreateReimbursement', 'assetId', assetId);
      // verify required parameter 'createReimbursementDto' is not null or undefined
      assertParamExists(
        'expensesControllerCreateReimbursement',
        'createReimbursementDto',
        createReimbursementDto
      );
      const localVarPath = `/assets/{assetId}/expenses/reimbursements`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createReimbursementDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all expenses for an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {ExpensesControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {number} [year] Filter by year (e.g. 2026)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindAll: async (
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: ExpensesControllerFindAllOrderEnum,
      year?: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['orderBy'] = orderBy;
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order;
      }

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the deductible charges recap (régime réel) for the asset and current user
     * @param {string} assetId
     * @param {number} year Fiscal year (e.g. 2026)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindDeductibleCharges: async (
      assetId: string,
      year: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerFindDeductibleCharges', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('expensesControllerFindDeductibleCharges', 'year', year);
      const localVarPath = `/assets/{assetId}/expenses/deductible-charges`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the user\'s personal financial balance for the asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindEquilibrium: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerFindEquilibrium', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/balance`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get initial/activity/net balance breakdown for every member (Balance du bien)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindMemberBalances: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerFindMemberBalances', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/member-balances`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single expense by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('expensesControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get financial statistics for the asset
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindStats: async (
      assetId: string,
      year: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerFindStats', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('expensesControllerFindStats', 'year', year);
      const localVarPath = `/assets/{assetId}/expenses/stats`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get detailed breakdown of balance with a specific user or bank account
     * @param {string} assetId
     * @param {string} [userId] ID of the user to get balance detail with
     * @param {string} [bankAccountId] ID of the bank account to get balance detail with
     * @param {string} [contactId] ID of the contact to get balance detail with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerGetBalanceDetail: async (
      assetId: string,
      userId?: string,
      bankAccountId?: string,
      contactId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerGetBalanceDetail', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/balance/detail`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      if (bankAccountId !== undefined) {
        localVarQueryParameter['bankAccountId'] = bankAccountId;
      }

      if (contactId !== undefined) {
        localVarQueryParameter['contactId'] = contactId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the global wallet balance for the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerGetWallet: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerGetWallet', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/wallet`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Mark expenses as reimbursed, optionally creating the corresponding money transfers
     * @param {string} assetId
     * @param {MarkExpensesReimbursedDto} markExpensesReimbursedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerMarkReimbursed: async (
      assetId: string,
      markExpensesReimbursedDto: MarkExpensesReimbursedDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerMarkReimbursed', 'assetId', assetId);
      // verify required parameter 'markExpensesReimbursedDto' is not null or undefined
      assertParamExists(
        'expensesControllerMarkReimbursed',
        'markExpensesReimbursedDto',
        markExpensesReimbursedDto
      );
      const localVarPath = `/assets/{assetId}/expenses/mark-reimbursed`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        markExpensesReimbursedDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload a receipt image and parse it with OCR
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerProcessReceipt: async (
      assetId: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerProcessReceipt', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/receipts/process`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft delete an expense by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerRemove: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('expensesControllerRemove', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerRemove', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Set a custom amount for a not-yet-materialized occurrence of a recurring expense
     * @param {string} id
     * @param {string} assetId
     * @param {SetRecurrenceOccurrenceAmountDto} setRecurrenceOccurrenceAmountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerSetRecurrenceOccurrenceAmount: async (
      id: string,
      assetId: string,
      setRecurrenceOccurrenceAmountDto: SetRecurrenceOccurrenceAmountDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('expensesControllerSetRecurrenceOccurrenceAmount', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerSetRecurrenceOccurrenceAmount', 'assetId', assetId);
      // verify required parameter 'setRecurrenceOccurrenceAmountDto' is not null or undefined
      assertParamExists(
        'expensesControllerSetRecurrenceOccurrenceAmount',
        'setRecurrenceOccurrenceAmountDto',
        setRecurrenceOccurrenceAmountDto
      );
      const localVarPath = `/assets/{assetId}/expenses/{id}/recurrence/occurrence-amount`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        setRecurrenceOccurrenceAmountDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stop recurrence on an expense without deleting it
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerStopRecurrence: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('expensesControllerStopRecurrence', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerStopRecurrence', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/{id}/recurrence`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an expense by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateExpenseDto} updateExpenseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerUpdate: async (
      id: string,
      assetId: string,
      updateExpenseDto: UpdateExpenseDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('expensesControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerUpdate', 'assetId', assetId);
      // verify required parameter 'updateExpenseDto' is not null or undefined
      assertParamExists('expensesControllerUpdate', 'updateExpenseDto', updateExpenseDto);
      const localVarPath = `/assets/{assetId}/expenses/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateExpenseDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExpensesApi - functional programming interface
 * @export
 */
export const ExpensesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExpensesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new expense
     * @param {string} assetId
     * @param {CreateExpenseDto} createExpenseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerCreate(
      assetId: string,
      createExpenseDto: CreateExpenseDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseWithSharesDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerCreate(
        assetId,
        createExpenseDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new reimbursement transaction
     * @param {string} assetId
     * @param {CreateReimbursementDto} createReimbursementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerCreateReimbursement(
      assetId: string,
      createReimbursementDto: CreateReimbursementDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseWithSharesDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.expensesControllerCreateReimbursement(
          assetId,
          createReimbursementDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerCreateReimbursement']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all expenses for an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {ExpensesControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {number} [year] Filter by year (e.g. 2026)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: ExpensesControllerFindAllOrderEnum,
      year?: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedExpensesDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerFindAll(
        assetId,
        page,
        limit,
        orderBy,
        order,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerFindAll']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the deductible charges recap (régime réel) for the asset and current user
     * @param {string} assetId
     * @param {number} year Fiscal year (e.g. 2026)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerFindDeductibleCharges(
      assetId: string,
      year: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeductibleChargesDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.expensesControllerFindDeductibleCharges(
          assetId,
          year,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerFindDeductibleCharges']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the user\'s personal financial balance for the asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerFindEquilibrium(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEquilibriumDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerFindEquilibrium(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerFindEquilibrium']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get initial/activity/net balance breakdown for every member (Balance du bien)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerFindMemberBalances(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetMemberBalanceDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.expensesControllerFindMemberBalances(assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerFindMemberBalances']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single expense by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseWithSharesDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerFindOne(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerFindOne']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get financial statistics for the asset
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerFindStats(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetStatsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerFindStats(
        assetId,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerFindStats']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get detailed breakdown of balance with a specific user or bank account
     * @param {string} assetId
     * @param {string} [userId] ID of the user to get balance detail with
     * @param {string} [bankAccountId] ID of the bank account to get balance detail with
     * @param {string} [contactId] ID of the contact to get balance detail with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerGetBalanceDetail(
      assetId: string,
      userId?: string,
      bankAccountId?: string,
      contactId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BalanceDetailDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerGetBalanceDetail(
        assetId,
        userId,
        bankAccountId,
        contactId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerGetBalanceDetail']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the global wallet balance for the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerGetWallet(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalWalletDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerGetWallet(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerGetWallet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Mark expenses as reimbursed, optionally creating the corresponding money transfers
     * @param {string} assetId
     * @param {MarkExpensesReimbursedDto} markExpensesReimbursedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerMarkReimbursed(
      assetId: string,
      markExpensesReimbursedDto: MarkExpensesReimbursedDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerMarkReimbursed(
        assetId,
        markExpensesReimbursedDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerMarkReimbursed']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Upload a receipt image and parse it with OCR
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerProcessReceipt(
      assetId: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedReceiptDataDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerProcessReceipt(
        assetId,
        file,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerProcessReceipt']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft delete an expense by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerRemove(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerRemove']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Set a custom amount for a not-yet-materialized occurrence of a recurring expense
     * @param {string} id
     * @param {string} assetId
     * @param {SetRecurrenceOccurrenceAmountDto} setRecurrenceOccurrenceAmountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerSetRecurrenceOccurrenceAmount(
      id: string,
      assetId: string,
      setRecurrenceOccurrenceAmountDto: SetRecurrenceOccurrenceAmountDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.expensesControllerSetRecurrenceOccurrenceAmount(
          id,
          assetId,
          setRecurrenceOccurrenceAmountDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerSetRecurrenceOccurrenceAmount']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Stop recurrence on an expense without deleting it
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerStopRecurrence(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseWithSharesDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerStopRecurrence(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerStopRecurrence']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an expense by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateExpenseDto} updateExpenseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerUpdate(
      id: string,
      assetId: string,
      updateExpenseDto: UpdateExpenseDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExpenseWithSharesDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerUpdate(
        id,
        assetId,
        updateExpenseDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExpensesApi.expensesControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExpensesApi - factory interface
 * @export
 */
export const ExpensesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ExpensesApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new expense
     * @param {string} assetId
     * @param {CreateExpenseDto} createExpenseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerCreate(
      assetId: string,
      createExpenseDto: CreateExpenseDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExpenseWithSharesDto> {
      return localVarFp
        .expensesControllerCreate(assetId, createExpenseDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new reimbursement transaction
     * @param {string} assetId
     * @param {CreateReimbursementDto} createReimbursementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerCreateReimbursement(
      assetId: string,
      createReimbursementDto: CreateReimbursementDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExpenseWithSharesDto> {
      return localVarFp
        .expensesControllerCreateReimbursement(assetId, createReimbursementDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all expenses for an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {ExpensesControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {number} [year] Filter by year (e.g. 2026)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: ExpensesControllerFindAllOrderEnum,
      year?: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedExpensesDto> {
      return localVarFp
        .expensesControllerFindAll(assetId, page, limit, orderBy, order, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the deductible charges recap (régime réel) for the asset and current user
     * @param {string} assetId
     * @param {number} year Fiscal year (e.g. 2026)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindDeductibleCharges(
      assetId: string,
      year: number,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<DeductibleChargesDto> {
      return localVarFp
        .expensesControllerFindDeductibleCharges(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the user\'s personal financial balance for the asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindEquilibrium(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserEquilibriumDto> {
      return localVarFp
        .expensesControllerFindEquilibrium(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get initial/activity/net balance breakdown for every member (Balance du bien)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindMemberBalances(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<AssetMemberBalanceDto>> {
      return localVarFp
        .expensesControllerFindMemberBalances(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single expense by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExpenseWithSharesDto> {
      return localVarFp
        .expensesControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get financial statistics for the asset
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerFindStats(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssetStatsDto> {
      return localVarFp
        .expensesControllerFindStats(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get detailed breakdown of balance with a specific user or bank account
     * @param {string} assetId
     * @param {string} [userId] ID of the user to get balance detail with
     * @param {string} [bankAccountId] ID of the bank account to get balance detail with
     * @param {string} [contactId] ID of the contact to get balance detail with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerGetBalanceDetail(
      assetId: string,
      userId?: string,
      bankAccountId?: string,
      contactId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<BalanceDetailDto> {
      return localVarFp
        .expensesControllerGetBalanceDetail(assetId, userId, bankAccountId, contactId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the global wallet balance for the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerGetWallet(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GlobalWalletDto> {
      return localVarFp
        .expensesControllerGetWallet(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Mark expenses as reimbursed, optionally creating the corresponding money transfers
     * @param {string} assetId
     * @param {MarkExpensesReimbursedDto} markExpensesReimbursedDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerMarkReimbursed(
      assetId: string,
      markExpensesReimbursedDto: MarkExpensesReimbursedDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .expensesControllerMarkReimbursed(assetId, markExpensesReimbursedDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Upload a receipt image and parse it with OCR
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerProcessReceipt(
      assetId: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UploadedReceiptDataDto> {
      return localVarFp
        .expensesControllerProcessReceipt(assetId, file, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft delete an expense by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .expensesControllerRemove(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Set a custom amount for a not-yet-materialized occurrence of a recurring expense
     * @param {string} id
     * @param {string} assetId
     * @param {SetRecurrenceOccurrenceAmountDto} setRecurrenceOccurrenceAmountDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerSetRecurrenceOccurrenceAmount(
      id: string,
      assetId: string,
      setRecurrenceOccurrenceAmountDto: SetRecurrenceOccurrenceAmountDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .expensesControllerSetRecurrenceOccurrenceAmount(
          id,
          assetId,
          setRecurrenceOccurrenceAmountDto,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Stop recurrence on an expense without deleting it
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerStopRecurrence(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExpenseWithSharesDto> {
      return localVarFp
        .expensesControllerStopRecurrence(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update an expense by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateExpenseDto} updateExpenseDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerUpdate(
      id: string,
      assetId: string,
      updateExpenseDto: UpdateExpenseDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExpenseWithSharesDto> {
      return localVarFp
        .expensesControllerUpdate(id, assetId, updateExpenseDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ExpensesApi - object-oriented interface
 * @export
 * @class ExpensesApi
 * @extends {BaseAPI}
 */
export class ExpensesApi extends BaseAPI {
  /**
   *
   * @summary Create a new expense
   * @param {string} assetId
   * @param {CreateExpenseDto} createExpenseDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerCreate(
    assetId: string,
    createExpenseDto: CreateExpenseDto,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerCreate(assetId, createExpenseDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new reimbursement transaction
   * @param {string} assetId
   * @param {CreateReimbursementDto} createReimbursementDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerCreateReimbursement(
    assetId: string,
    createReimbursementDto: CreateReimbursementDto,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerCreateReimbursement(assetId, createReimbursementDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all expenses for an asset (paginated)
   * @param {string} assetId
   * @param {number} [page] Page number
   * @param {number} [limit] Items per page
   * @param {string} [orderBy] Champ de tri
   * @param {ExpensesControllerFindAllOrderEnum} [order] Ordre de tri
   * @param {number} [year] Filter by year (e.g. 2026)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerFindAll(
    assetId: string,
    page?: number,
    limit?: number,
    orderBy?: string,
    order?: ExpensesControllerFindAllOrderEnum,
    year?: number,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerFindAll(assetId, page, limit, orderBy, order, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the deductible charges recap (régime réel) for the asset and current user
   * @param {string} assetId
   * @param {number} year Fiscal year (e.g. 2026)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerFindDeductibleCharges(
    assetId: string,
    year: number,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerFindDeductibleCharges(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the user\'s personal financial balance for the asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerFindEquilibrium(assetId: string, options?: RawAxiosRequestConfig) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerFindEquilibrium(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get initial/activity/net balance breakdown for every member (Balance du bien)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerFindMemberBalances(assetId: string, options?: RawAxiosRequestConfig) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerFindMemberBalances(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single expense by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerFindOne(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get financial statistics for the asset
   * @param {string} assetId
   * @param {string} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerFindStats(
    assetId: string,
    year: string,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerFindStats(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get detailed breakdown of balance with a specific user or bank account
   * @param {string} assetId
   * @param {string} [userId] ID of the user to get balance detail with
   * @param {string} [bankAccountId] ID of the bank account to get balance detail with
   * @param {string} [contactId] ID of the contact to get balance detail with
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerGetBalanceDetail(
    assetId: string,
    userId?: string,
    bankAccountId?: string,
    contactId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerGetBalanceDetail(assetId, userId, bankAccountId, contactId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the global wallet balance for the current user
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerGetWallet(assetId: string, options?: RawAxiosRequestConfig) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerGetWallet(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Mark expenses as reimbursed, optionally creating the corresponding money transfers
   * @param {string} assetId
   * @param {MarkExpensesReimbursedDto} markExpensesReimbursedDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerMarkReimbursed(
    assetId: string,
    markExpensesReimbursedDto: MarkExpensesReimbursedDto,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerMarkReimbursed(assetId, markExpensesReimbursedDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Upload a receipt image and parse it with OCR
   * @param {string} assetId
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerProcessReceipt(
    assetId: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerProcessReceipt(assetId, file, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft delete an expense by ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerRemove(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerRemove(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Set a custom amount for a not-yet-materialized occurrence of a recurring expense
   * @param {string} id
   * @param {string} assetId
   * @param {SetRecurrenceOccurrenceAmountDto} setRecurrenceOccurrenceAmountDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerSetRecurrenceOccurrenceAmount(
    id: string,
    assetId: string,
    setRecurrenceOccurrenceAmountDto: SetRecurrenceOccurrenceAmountDto,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerSetRecurrenceOccurrenceAmount(
        id,
        assetId,
        setRecurrenceOccurrenceAmountDto,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Stop recurrence on an expense without deleting it
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerStopRecurrence(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerStopRecurrence(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an expense by ID
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateExpenseDto} updateExpenseDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpensesApi
   */
  public expensesControllerUpdate(
    id: string,
    assetId: string,
    updateExpenseDto: UpdateExpenseDto,
    options?: RawAxiosRequestConfig
  ) {
    return ExpensesApiFp(this.configuration)
      .expensesControllerUpdate(id, assetId, updateExpenseDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const ExpensesControllerFindAllOrderEnum = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;
export type ExpensesControllerFindAllOrderEnum =
  (typeof ExpensesControllerFindAllOrderEnum)[keyof typeof ExpensesControllerFindAllOrderEnum];

/**
 * FundCallsApi - axios parameter creator
 * @export
 */
export const FundCallsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a draft fund call and compute its lines
     * @param {string} assetId
     * @param {CreateFundCallDto} createFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerCreate: async (
      assetId: string,
      createFundCallDto: CreateFundCallDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createFundCallDto' is not null or undefined
      assertParamExists('fundCallsControllerCreate', 'createFundCallDto', createFundCallDto);
      const localVarPath = `/assets/{assetId}/fund-calls`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createFundCallDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List fund calls — a member only sees those they have a line in
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/fund-calls`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary My pending lines — banner and « Mon relevé »
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerFindMine: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerFindMine', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/fund-calls/mine`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Fund call detail with its lines
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerFindOne: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerFindOne', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('fundCallsControllerFindOne', 'id', id);
      const localVarPath = `/assets/{assetId}/fund-calls/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Signed URL of a line PDF
     * @param {string} assetId
     * @param {string} id
     * @param {string} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerGetLinePdf: async (
      assetId: string,
      id: string,
      lineId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerGetLinePdf', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('fundCallsControllerGetLinePdf', 'id', id);
      // verify required parameter 'lineId' is not null or undefined
      assertParamExists('fundCallsControllerGetLinePdf', 'lineId', lineId);
      const localVarPath = `/assets/{assetId}/fund-calls/{id}/lines/{lineId}/pdf`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'lineId'}}`, encodeURIComponent(String(lineId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft delete — DRAFT only, 409 otherwise
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerRemove: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerRemove', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('fundCallsControllerRemove', 'id', id);
      const localVarPath = `/assets/{assetId}/fund-calls/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generate the PDFs, send the emails, post to the feed
     * @param {string} assetId
     * @param {string} id
     * @param {SendFundCallDto} sendFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerSend: async (
      assetId: string,
      id: string,
      sendFundCallDto: SendFundCallDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerSend', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('fundCallsControllerSend', 'id', id);
      // verify required parameter 'sendFundCallDto' is not null or undefined
      assertParamExists('fundCallsControllerSend', 'sendFundCallDto', sendFundCallDto);
      const localVarPath = `/assets/{assetId}/fund-calls/{id}/send`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendFundCallDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Edit a DRAFT fund call — 409 once it has been sent
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateFundCallDto} updateFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerUpdate: async (
      assetId: string,
      id: string,
      updateFundCallDto: UpdateFundCallDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('fundCallsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('fundCallsControllerUpdate', 'id', id);
      // verify required parameter 'updateFundCallDto' is not null or undefined
      assertParamExists('fundCallsControllerUpdate', 'updateFundCallDto', updateFundCallDto);
      const localVarPath = `/assets/{assetId}/fund-calls/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateFundCallDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FundCallsApi - functional programming interface
 * @export
 */
export const FundCallsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FundCallsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a draft fund call and compute its lines
     * @param {string} assetId
     * @param {CreateFundCallDto} createFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerCreate(
      assetId: string,
      createFundCallDto: CreateFundCallDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FundCallDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerCreate(
        assetId,
        createFundCallDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List fund calls — a member only sees those they have a line in
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FundCallDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary My pending lines — banner and « Mon relevé »
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerFindMine(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FundCallDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerFindMine(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerFindMine']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Fund call detail with its lines
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FundCallDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerFindOne(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Signed URL of a line PDF
     * @param {string} assetId
     * @param {string} id
     * @param {string} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerGetLinePdf(
      assetId: string,
      id: string,
      lineId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FundCallPdfUrlDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerGetLinePdf(
        assetId,
        id,
        lineId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerGetLinePdf']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft delete — DRAFT only, 409 otherwise
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerRemove(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerRemove(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerRemove']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generate the PDFs, send the emails, post to the feed
     * @param {string} assetId
     * @param {string} id
     * @param {SendFundCallDto} sendFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerSend(
      assetId: string,
      id: string,
      sendFundCallDto: SendFundCallDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FundCallDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerSend(
        assetId,
        id,
        sendFundCallDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerSend']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Edit a DRAFT fund call — 409 once it has been sent
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateFundCallDto} updateFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fundCallsControllerUpdate(
      assetId: string,
      id: string,
      updateFundCallDto: UpdateFundCallDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FundCallDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fundCallsControllerUpdate(
        assetId,
        id,
        updateFundCallDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['FundCallsApi.fundCallsControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * FundCallsApi - factory interface
 * @export
 */
export const FundCallsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = FundCallsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a draft fund call and compute its lines
     * @param {string} assetId
     * @param {CreateFundCallDto} createFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerCreate(
      assetId: string,
      createFundCallDto: CreateFundCallDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FundCallDto> {
      return localVarFp
        .fundCallsControllerCreate(assetId, createFundCallDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List fund calls — a member only sees those they have a line in
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<FundCallDto>> {
      return localVarFp
        .fundCallsControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary My pending lines — banner and « Mon relevé »
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerFindMine(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<FundCallDto>> {
      return localVarFp
        .fundCallsControllerFindMine(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Fund call detail with its lines
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FundCallDto> {
      return localVarFp
        .fundCallsControllerFindOne(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Signed URL of a line PDF
     * @param {string} assetId
     * @param {string} id
     * @param {string} lineId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerGetLinePdf(
      assetId: string,
      id: string,
      lineId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FundCallPdfUrlDto> {
      return localVarFp
        .fundCallsControllerGetLinePdf(assetId, id, lineId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft delete — DRAFT only, 409 otherwise
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerRemove(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .fundCallsControllerRemove(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Generate the PDFs, send the emails, post to the feed
     * @param {string} assetId
     * @param {string} id
     * @param {SendFundCallDto} sendFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerSend(
      assetId: string,
      id: string,
      sendFundCallDto: SendFundCallDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FundCallDto> {
      return localVarFp
        .fundCallsControllerSend(assetId, id, sendFundCallDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Edit a DRAFT fund call — 409 once it has been sent
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateFundCallDto} updateFundCallDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fundCallsControllerUpdate(
      assetId: string,
      id: string,
      updateFundCallDto: UpdateFundCallDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<FundCallDto> {
      return localVarFp
        .fundCallsControllerUpdate(assetId, id, updateFundCallDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * FundCallsApi - object-oriented interface
 * @export
 * @class FundCallsApi
 * @extends {BaseAPI}
 */
export class FundCallsApi extends BaseAPI {
  /**
   *
   * @summary Create a draft fund call and compute its lines
   * @param {string} assetId
   * @param {CreateFundCallDto} createFundCallDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerCreate(
    assetId: string,
    createFundCallDto: CreateFundCallDto,
    options?: RawAxiosRequestConfig
  ) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerCreate(assetId, createFundCallDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List fund calls — a member only sees those they have a line in
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary My pending lines — banner and « Mon relevé »
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerFindMine(assetId: string, options?: RawAxiosRequestConfig) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerFindMine(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Fund call detail with its lines
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerFindOne(assetId: string, id: string, options?: RawAxiosRequestConfig) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerFindOne(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Signed URL of a line PDF
   * @param {string} assetId
   * @param {string} id
   * @param {string} lineId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerGetLinePdf(
    assetId: string,
    id: string,
    lineId: string,
    options?: RawAxiosRequestConfig
  ) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerGetLinePdf(assetId, id, lineId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft delete — DRAFT only, 409 otherwise
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerRemove(assetId: string, id: string, options?: RawAxiosRequestConfig) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerRemove(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generate the PDFs, send the emails, post to the feed
   * @param {string} assetId
   * @param {string} id
   * @param {SendFundCallDto} sendFundCallDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerSend(
    assetId: string,
    id: string,
    sendFundCallDto: SendFundCallDto,
    options?: RawAxiosRequestConfig
  ) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerSend(assetId, id, sendFundCallDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Edit a DRAFT fund call — 409 once it has been sent
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateFundCallDto} updateFundCallDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FundCallsApi
   */
  public fundCallsControllerUpdate(
    assetId: string,
    id: string,
    updateFundCallDto: UpdateFundCallDto,
    options?: RawAxiosRequestConfig
  ) {
    return FundCallsApiFp(this.configuration)
      .fundCallsControllerUpdate(assetId, id, updateFundCallDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * HouseholdsApi - axios parameter creator
 * @export
 */
export const HouseholdsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a household on an asset
     * @param {string} assetId
     * @param {CreateHouseholdDto} createHouseholdDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerCreate: async (
      assetId: string,
      createHouseholdDto: CreateHouseholdDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('householdsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createHouseholdDto' is not null or undefined
      assertParamExists('householdsControllerCreate', 'createHouseholdDto', createHouseholdDto);
      const localVarPath = `/assets/{assetId}/households`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createHouseholdDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft-delete a household and detach its members
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerDelete: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('householdsControllerDelete', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('householdsControllerDelete', 'id', id);
      const localVarPath = `/assets/{assetId}/households/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List households of an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('householdsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/households`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Net balance per household on an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindBalances: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('householdsControllerFindBalances', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/households/balances`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List asset members eligible to be attached to a household (owner included)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindEligibleMembers: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('householdsControllerFindEligibleMembers', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/households/eligible-members`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a household by id
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindOne: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('householdsControllerFindOne', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('householdsControllerFindOne', 'id', id);
      const localVarPath = `/assets/{assetId}/households/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a household
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateHouseholdDto} updateHouseholdDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerUpdate: async (
      assetId: string,
      id: string,
      updateHouseholdDto: UpdateHouseholdDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('householdsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('householdsControllerUpdate', 'id', id);
      // verify required parameter 'updateHouseholdDto' is not null or undefined
      assertParamExists('householdsControllerUpdate', 'updateHouseholdDto', updateHouseholdDto);
      const localVarPath = `/assets/{assetId}/households/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateHouseholdDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HouseholdsApi - functional programming interface
 * @export
 */
export const HouseholdsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HouseholdsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a household on an asset
     * @param {string} assetId
     * @param {CreateHouseholdDto} createHouseholdDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async householdsControllerCreate(
      assetId: string,
      createHouseholdDto: CreateHouseholdDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HouseholdDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.householdsControllerCreate(
        assetId,
        createHouseholdDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HouseholdsApi.householdsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft-delete a household and detach its members
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async householdsControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.householdsControllerDelete(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HouseholdsApi.householdsControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List households of an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async householdsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HouseholdDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.householdsControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HouseholdsApi.householdsControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Net balance per household on an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async householdsControllerFindBalances(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HouseholdBalanceDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.householdsControllerFindBalances(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HouseholdsApi.householdsControllerFindBalances']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List asset members eligible to be attached to a household (owner included)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async householdsControllerFindEligibleMembers(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HouseholdMemberDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.householdsControllerFindEligibleMembers(assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HouseholdsApi.householdsControllerFindEligibleMembers']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a household by id
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async householdsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HouseholdDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.householdsControllerFindOne(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HouseholdsApi.householdsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a household
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateHouseholdDto} updateHouseholdDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async householdsControllerUpdate(
      assetId: string,
      id: string,
      updateHouseholdDto: UpdateHouseholdDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HouseholdDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.householdsControllerUpdate(
        assetId,
        id,
        updateHouseholdDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['HouseholdsApi.householdsControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * HouseholdsApi - factory interface
 * @export
 */
export const HouseholdsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HouseholdsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a household on an asset
     * @param {string} assetId
     * @param {CreateHouseholdDto} createHouseholdDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerCreate(
      assetId: string,
      createHouseholdDto: CreateHouseholdDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<HouseholdDto> {
      return localVarFp
        .householdsControllerCreate(assetId, createHouseholdDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft-delete a household and detach its members
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .householdsControllerDelete(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List households of an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<HouseholdDto>> {
      return localVarFp
        .householdsControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Net balance per household on an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindBalances(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<HouseholdBalanceDto>> {
      return localVarFp
        .householdsControllerFindBalances(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List asset members eligible to be attached to a household (owner included)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindEligibleMembers(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<HouseholdMemberDto>> {
      return localVarFp
        .householdsControllerFindEligibleMembers(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get a household by id
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<HouseholdDto> {
      return localVarFp
        .householdsControllerFindOne(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a household
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateHouseholdDto} updateHouseholdDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    householdsControllerUpdate(
      assetId: string,
      id: string,
      updateHouseholdDto: UpdateHouseholdDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<HouseholdDto> {
      return localVarFp
        .householdsControllerUpdate(assetId, id, updateHouseholdDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * HouseholdsApi - object-oriented interface
 * @export
 * @class HouseholdsApi
 * @extends {BaseAPI}
 */
export class HouseholdsApi extends BaseAPI {
  /**
   *
   * @summary Create a household on an asset
   * @param {string} assetId
   * @param {CreateHouseholdDto} createHouseholdDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HouseholdsApi
   */
  public householdsControllerCreate(
    assetId: string,
    createHouseholdDto: CreateHouseholdDto,
    options?: RawAxiosRequestConfig
  ) {
    return HouseholdsApiFp(this.configuration)
      .householdsControllerCreate(assetId, createHouseholdDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft-delete a household and detach its members
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HouseholdsApi
   */
  public householdsControllerDelete(assetId: string, id: string, options?: RawAxiosRequestConfig) {
    return HouseholdsApiFp(this.configuration)
      .householdsControllerDelete(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List households of an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HouseholdsApi
   */
  public householdsControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return HouseholdsApiFp(this.configuration)
      .householdsControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Net balance per household on an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HouseholdsApi
   */
  public householdsControllerFindBalances(assetId: string, options?: RawAxiosRequestConfig) {
    return HouseholdsApiFp(this.configuration)
      .householdsControllerFindBalances(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List asset members eligible to be attached to a household (owner included)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HouseholdsApi
   */
  public householdsControllerFindEligibleMembers(assetId: string, options?: RawAxiosRequestConfig) {
    return HouseholdsApiFp(this.configuration)
      .householdsControllerFindEligibleMembers(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a household by id
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HouseholdsApi
   */
  public householdsControllerFindOne(assetId: string, id: string, options?: RawAxiosRequestConfig) {
    return HouseholdsApiFp(this.configuration)
      .householdsControllerFindOne(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a household
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateHouseholdDto} updateHouseholdDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HouseholdsApi
   */
  public householdsControllerUpdate(
    assetId: string,
    id: string,
    updateHouseholdDto: UpdateHouseholdDto,
    options?: RawAxiosRequestConfig
  ) {
    return HouseholdsApiFp(this.configuration)
      .householdsControllerUpdate(assetId, id, updateHouseholdDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * InitialBalancesApi - axios parameter creator
 * @export
 */
export const InitialBalancesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create/replace the initial balances batch (gestionnaire only)
     * @param {string} assetId
     * @param {CreateInitialBalancesBatchDto} createInitialBalancesBatchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerCreateBatch: async (
      assetId: string,
      createInitialBalancesBatchDto: CreateInitialBalancesBatchDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('initialBalancesControllerCreateBatch', 'assetId', assetId);
      // verify required parameter 'createInitialBalancesBatchDto' is not null or undefined
      assertParamExists(
        'initialBalancesControllerCreateBatch',
        'createInitialBalancesBatchDto',
        createInitialBalancesBatchDto
      );
      const localVarPath = `/assets/{assetId}/initial-balances/batch`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createInitialBalancesBatchDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft-delete an initial balance (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerDelete: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('initialBalancesControllerDelete', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('initialBalancesControllerDelete', 'id', id);
      const localVarPath = `/assets/{assetId}/initial-balances/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List initial balances for an asset (all members can read)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('initialBalancesControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/initial-balances`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Audit trail of initial balance modifications (all members can read)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerFindAudit: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('initialBalancesControllerFindAudit', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/initial-balances/audit`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Modify an initial balance, reason mandatory (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateInitialBalanceDto} updateInitialBalanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerUpdate: async (
      assetId: string,
      id: string,
      updateInitialBalanceDto: UpdateInitialBalanceDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('initialBalancesControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('initialBalancesControllerUpdate', 'id', id);
      // verify required parameter 'updateInitialBalanceDto' is not null or undefined
      assertParamExists(
        'initialBalancesControllerUpdate',
        'updateInitialBalanceDto',
        updateInitialBalanceDto
      );
      const localVarPath = `/assets/{assetId}/initial-balances/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateInitialBalanceDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InitialBalancesApi - functional programming interface
 * @export
 */
export const InitialBalancesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InitialBalancesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create/replace the initial balances batch (gestionnaire only)
     * @param {string} assetId
     * @param {CreateInitialBalancesBatchDto} createInitialBalancesBatchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initialBalancesControllerCreateBatch(
      assetId: string,
      createInitialBalancesBatchDto: CreateInitialBalancesBatchDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InitialBalanceDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.initialBalancesControllerCreateBatch(
          assetId,
          createInitialBalancesBatchDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InitialBalancesApi.initialBalancesControllerCreateBatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft-delete an initial balance (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initialBalancesControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initialBalancesControllerDelete(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InitialBalancesApi.initialBalancesControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List initial balances for an asset (all members can read)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initialBalancesControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InitialBalanceDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initialBalancesControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InitialBalancesApi.initialBalancesControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Audit trail of initial balance modifications (all members can read)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initialBalancesControllerFindAudit(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InitialBalanceAuditDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initialBalancesControllerFindAudit(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InitialBalancesApi.initialBalancesControllerFindAudit']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Modify an initial balance, reason mandatory (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateInitialBalanceDto} updateInitialBalanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initialBalancesControllerUpdate(
      assetId: string,
      id: string,
      updateInitialBalanceDto: UpdateInitialBalanceDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitialBalanceDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initialBalancesControllerUpdate(
        assetId,
        id,
        updateInitialBalanceDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InitialBalancesApi.initialBalancesControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * InitialBalancesApi - factory interface
 * @export
 */
export const InitialBalancesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InitialBalancesApiFp(configuration);
  return {
    /**
     *
     * @summary Create/replace the initial balances batch (gestionnaire only)
     * @param {string} assetId
     * @param {CreateInitialBalancesBatchDto} createInitialBalancesBatchDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerCreateBatch(
      assetId: string,
      createInitialBalancesBatchDto: CreateInitialBalancesBatchDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InitialBalanceDto>> {
      return localVarFp
        .initialBalancesControllerCreateBatch(assetId, createInitialBalancesBatchDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft-delete an initial balance (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .initialBalancesControllerDelete(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List initial balances for an asset (all members can read)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InitialBalanceDto>> {
      return localVarFp
        .initialBalancesControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Audit trail of initial balance modifications (all members can read)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerFindAudit(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InitialBalanceAuditDto>> {
      return localVarFp
        .initialBalancesControllerFindAudit(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Modify an initial balance, reason mandatory (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateInitialBalanceDto} updateInitialBalanceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initialBalancesControllerUpdate(
      assetId: string,
      id: string,
      updateInitialBalanceDto: UpdateInitialBalanceDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InitialBalanceDto> {
      return localVarFp
        .initialBalancesControllerUpdate(assetId, id, updateInitialBalanceDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * InitialBalancesApi - object-oriented interface
 * @export
 * @class InitialBalancesApi
 * @extends {BaseAPI}
 */
export class InitialBalancesApi extends BaseAPI {
  /**
   *
   * @summary Create/replace the initial balances batch (gestionnaire only)
   * @param {string} assetId
   * @param {CreateInitialBalancesBatchDto} createInitialBalancesBatchDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InitialBalancesApi
   */
  public initialBalancesControllerCreateBatch(
    assetId: string,
    createInitialBalancesBatchDto: CreateInitialBalancesBatchDto,
    options?: RawAxiosRequestConfig
  ) {
    return InitialBalancesApiFp(this.configuration)
      .initialBalancesControllerCreateBatch(assetId, createInitialBalancesBatchDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft-delete an initial balance (gestionnaire only)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InitialBalancesApi
   */
  public initialBalancesControllerDelete(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return InitialBalancesApiFp(this.configuration)
      .initialBalancesControllerDelete(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List initial balances for an asset (all members can read)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InitialBalancesApi
   */
  public initialBalancesControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return InitialBalancesApiFp(this.configuration)
      .initialBalancesControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Audit trail of initial balance modifications (all members can read)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InitialBalancesApi
   */
  public initialBalancesControllerFindAudit(assetId: string, options?: RawAxiosRequestConfig) {
    return InitialBalancesApiFp(this.configuration)
      .initialBalancesControllerFindAudit(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Modify an initial balance, reason mandatory (gestionnaire only)
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateInitialBalanceDto} updateInitialBalanceDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InitialBalancesApi
   */
  public initialBalancesControllerUpdate(
    assetId: string,
    id: string,
    updateInitialBalanceDto: UpdateInitialBalanceDto,
    options?: RawAxiosRequestConfig
  ) {
    return InitialBalancesApiFp(this.configuration)
      .initialBalancesControllerUpdate(assetId, id, updateInitialBalanceDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * InstructionsApi - axios parameter creator
 * @export
 */
export const InstructionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new instruction
     * @param {string} assetId
     * @param {CreateInstructionDto} createInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerCreate: async (
      assetId: string,
      createInstructionDto: CreateInstructionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createInstructionDto' is not null or undefined
      assertParamExists(
        'instructionsControllerCreate',
        'createInstructionDto',
        createInstructionDto
      );
      const localVarPath = `/assets/{assetId}/instructions`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createInstructionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Draft an instruction from a voice dictation
     * @param {string} assetId
     * @param {File} [file]
     * @param {InstructionsControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerDraftFromVoice: async (
      assetId: string,
      file?: File,
      language?: InstructionsControllerDraftFromVoiceLanguageEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerDraftFromVoice', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/instructions/draft-from-voice`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (language !== undefined) {
        localVarFormParams.append('language', language as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all instructions for an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {InstructionsControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerFindAll: async (
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: InstructionsControllerFindAllOrderEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/instructions`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['orderBy'] = orderBy;
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single instruction by its ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerFindOne: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerFindOne', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('instructionsControllerFindOne', 'id', id);
      const localVarPath = `/assets/{assetId}/instructions/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generate instruction sections using an AI model
     * @param {string} assetId
     * @param {GenerateInstructionDto} generateInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerGenerateContent: async (
      assetId: string,
      generateInstructionDto: GenerateInstructionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerGenerateContent', 'assetId', assetId);
      // verify required parameter 'generateInstructionDto' is not null or undefined
      assertParamExists(
        'instructionsControllerGenerateContent',
        'generateInstructionDto',
        generateInstructionDto
      );
      const localVarPath = `/assets/{assetId}/instructions/generate-content`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateInstructionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete an instruction
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerRemove: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerRemove', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('instructionsControllerRemove', 'id', id);
      const localVarPath = `/assets/{assetId}/instructions/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an instruction with new content
     * @param {string} assetId
     * @param {string} id
     * @param {CreateInstructionDto} createInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerUpdate: async (
      assetId: string,
      id: string,
      createInstructionDto: CreateInstructionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('instructionsControllerUpdate', 'id', id);
      // verify required parameter 'createInstructionDto' is not null or undefined
      assertParamExists(
        'instructionsControllerUpdate',
        'createInstructionDto',
        createInstructionDto
      );
      const localVarPath = `/assets/{assetId}/instructions/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createInstructionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload a temporary image for an instruction
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerUploadTemporaryImage: async (
      assetId: string,
      file?: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('instructionsControllerUploadTemporaryImage', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/instructions/temporary-image`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InstructionsApi - functional programming interface
 * @export
 */
export const InstructionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InstructionsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new instruction
     * @param {string} assetId
     * @param {CreateInstructionDto} createInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerCreate(
      assetId: string,
      createInstructionDto: CreateInstructionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsControllerCreate(
        assetId,
        createInstructionDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Draft an instruction from a voice dictation
     * @param {string} assetId
     * @param {File} [file]
     * @param {InstructionsControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerDraftFromVoice(
      assetId: string,
      file?: File,
      language?: InstructionsControllerDraftFromVoiceLanguageEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionVoiceDraftDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionsControllerDraftFromVoice(
          assetId,
          file,
          language,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerDraftFromVoice']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all instructions for an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {InstructionsControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: InstructionsControllerFindAllOrderEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedInstructionsDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsControllerFindAll(
        assetId,
        page,
        limit,
        orderBy,
        order,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single instruction by its ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsControllerFindOne(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generate instruction sections using an AI model
     * @param {string} assetId
     * @param {GenerateInstructionDto} generateInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerGenerateContent(
      assetId: string,
      generateInstructionDto: GenerateInstructionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectionsDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionsControllerGenerateContent(
          assetId,
          generateInstructionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerGenerateContent']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete an instruction
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerRemove(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsControllerRemove(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerRemove']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an instruction with new content
     * @param {string} assetId
     * @param {string} id
     * @param {CreateInstructionDto} createInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerUpdate(
      assetId: string,
      id: string,
      createInstructionDto: CreateInstructionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.instructionsControllerUpdate(
        assetId,
        id,
        createInstructionDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Upload a temporary image for an instruction
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async instructionsControllerUploadTemporaryImage(
      assetId: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TempUploadedImageDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.instructionsControllerUploadTemporaryImage(
          assetId,
          file,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InstructionsApi.instructionsControllerUploadTemporaryImage']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * InstructionsApi - factory interface
 * @export
 */
export const InstructionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InstructionsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new instruction
     * @param {string} assetId
     * @param {CreateInstructionDto} createInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerCreate(
      assetId: string,
      createInstructionDto: CreateInstructionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionDto> {
      return localVarFp
        .instructionsControllerCreate(assetId, createInstructionDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Draft an instruction from a voice dictation
     * @param {string} assetId
     * @param {File} [file]
     * @param {InstructionsControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerDraftFromVoice(
      assetId: string,
      file?: File,
      language?: InstructionsControllerDraftFromVoiceLanguageEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionVoiceDraftDto> {
      return localVarFp
        .instructionsControllerDraftFromVoice(assetId, file, language, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all instructions for an asset (paginated)
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {InstructionsControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: InstructionsControllerFindAllOrderEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedInstructionsDto> {
      return localVarFp
        .instructionsControllerFindAll(assetId, page, limit, orderBy, order, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single instruction by its ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionDto> {
      return localVarFp
        .instructionsControllerFindOne(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Generate instruction sections using an AI model
     * @param {string} assetId
     * @param {GenerateInstructionDto} generateInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerGenerateContent(
      assetId: string,
      generateInstructionDto: GenerateInstructionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SectionsDto> {
      return localVarFp
        .instructionsControllerGenerateContent(assetId, generateInstructionDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete an instruction
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerRemove(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .instructionsControllerRemove(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update an instruction with new content
     * @param {string} assetId
     * @param {string} id
     * @param {CreateInstructionDto} createInstructionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerUpdate(
      assetId: string,
      id: string,
      createInstructionDto: CreateInstructionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InstructionDto> {
      return localVarFp
        .instructionsControllerUpdate(assetId, id, createInstructionDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Upload a temporary image for an instruction
     * @param {string} assetId
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    instructionsControllerUploadTemporaryImage(
      assetId: string,
      file?: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TempUploadedImageDto> {
      return localVarFp
        .instructionsControllerUploadTemporaryImage(assetId, file, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * InstructionsApi - object-oriented interface
 * @export
 * @class InstructionsApi
 * @extends {BaseAPI}
 */
export class InstructionsApi extends BaseAPI {
  /**
   *
   * @summary Create a new instruction
   * @param {string} assetId
   * @param {CreateInstructionDto} createInstructionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerCreate(
    assetId: string,
    createInstructionDto: CreateInstructionDto,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerCreate(assetId, createInstructionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Draft an instruction from a voice dictation
   * @param {string} assetId
   * @param {File} [file]
   * @param {InstructionsControllerDraftFromVoiceLanguageEnum} [language]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerDraftFromVoice(
    assetId: string,
    file?: File,
    language?: InstructionsControllerDraftFromVoiceLanguageEnum,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerDraftFromVoice(assetId, file, language, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all instructions for an asset (paginated)
   * @param {string} assetId
   * @param {number} [page] Page number
   * @param {number} [limit] Items per page
   * @param {string} [orderBy] Champ de tri
   * @param {InstructionsControllerFindAllOrderEnum} [order] Ordre de tri
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerFindAll(
    assetId: string,
    page?: number,
    limit?: number,
    orderBy?: string,
    order?: InstructionsControllerFindAllOrderEnum,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerFindAll(assetId, page, limit, orderBy, order, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single instruction by its ID
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerFindOne(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerFindOne(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generate instruction sections using an AI model
   * @param {string} assetId
   * @param {GenerateInstructionDto} generateInstructionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerGenerateContent(
    assetId: string,
    generateInstructionDto: GenerateInstructionDto,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerGenerateContent(assetId, generateInstructionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete an instruction
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerRemove(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerRemove(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an instruction with new content
   * @param {string} assetId
   * @param {string} id
   * @param {CreateInstructionDto} createInstructionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerUpdate(
    assetId: string,
    id: string,
    createInstructionDto: CreateInstructionDto,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerUpdate(assetId, id, createInstructionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Upload a temporary image for an instruction
   * @param {string} assetId
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InstructionsApi
   */
  public instructionsControllerUploadTemporaryImage(
    assetId: string,
    file?: File,
    options?: RawAxiosRequestConfig
  ) {
    return InstructionsApiFp(this.configuration)
      .instructionsControllerUploadTemporaryImage(assetId, file, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const InstructionsControllerDraftFromVoiceLanguageEnum = {
  Fr: 'fr',
  En: 'en',
} as const;
export type InstructionsControllerDraftFromVoiceLanguageEnum =
  (typeof InstructionsControllerDraftFromVoiceLanguageEnum)[keyof typeof InstructionsControllerDraftFromVoiceLanguageEnum];
/**
 * @export
 */
export const InstructionsControllerFindAllOrderEnum = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;
export type InstructionsControllerFindAllOrderEnum =
  (typeof InstructionsControllerFindAllOrderEnum)[keyof typeof InstructionsControllerFindAllOrderEnum];

/**
 * InternalAnnouncementsApi - axios parameter creator
 * @export
 */
export const InternalAnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new announcement (internal admin)
     * @param {CreateAnnouncementDto} createAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerCreate: async (
      createAnnouncementDto: CreateAnnouncementDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createAnnouncementDto' is not null or undefined
      assertParamExists(
        'announcementsControllerCreate',
        'createAnnouncementDto',
        createAnnouncementDto
      );
      const localVarPath = `/internal/announcements`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAnnouncementDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete an announcement (internal admin)
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('announcementsControllerDelete', 'id', id);
      const localVarPath = `/internal/announcements/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all announcements (internal admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerFindAll: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/internal/announcements`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Publish an announcement (deactivates the previous active one)
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerPublish: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('announcementsControllerPublish', 'id', id);
      const localVarPath = `/internal/announcements/{id}/publish`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unpublish the currently active announcement
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerUnpublish: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('announcementsControllerUnpublish', 'id', id);
      const localVarPath = `/internal/announcements/{id}/unpublish`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an announcement (internal admin)
     * @param {string} id
     * @param {UpdateAnnouncementDto} updateAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerUpdate: async (
      id: string,
      updateAnnouncementDto: UpdateAnnouncementDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('announcementsControllerUpdate', 'id', id);
      // verify required parameter 'updateAnnouncementDto' is not null or undefined
      assertParamExists(
        'announcementsControllerUpdate',
        'updateAnnouncementDto',
        updateAnnouncementDto
      );
      const localVarPath = `/internal/announcements/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateAnnouncementDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InternalAnnouncementsApi - functional programming interface
 * @export
 */
export const InternalAnnouncementsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InternalAnnouncementsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new announcement (internal admin)
     * @param {CreateAnnouncementDto} createAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async announcementsControllerCreate(
      createAnnouncementDto: CreateAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.announcementsControllerCreate(
        createAnnouncementDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InternalAnnouncementsApi.announcementsControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete an announcement (internal admin)
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async announcementsControllerDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.announcementsControllerDelete(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InternalAnnouncementsApi.announcementsControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List all announcements (internal admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async announcementsControllerFindAll(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnnouncementDto>>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.announcementsControllerFindAll(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InternalAnnouncementsApi.announcementsControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Publish an announcement (deactivates the previous active one)
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async announcementsControllerPublish(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.announcementsControllerPublish(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InternalAnnouncementsApi.announcementsControllerPublish']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Unpublish the currently active announcement
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async announcementsControllerUnpublish(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.announcementsControllerUnpublish(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InternalAnnouncementsApi.announcementsControllerUnpublish']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an announcement (internal admin)
     * @param {string} id
     * @param {UpdateAnnouncementDto} updateAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async announcementsControllerUpdate(
      id: string,
      updateAnnouncementDto: UpdateAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnnouncementDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.announcementsControllerUpdate(
        id,
        updateAnnouncementDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InternalAnnouncementsApi.announcementsControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * InternalAnnouncementsApi - factory interface
 * @export
 */
export const InternalAnnouncementsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InternalAnnouncementsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new announcement (internal admin)
     * @param {CreateAnnouncementDto} createAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerCreate(
      createAnnouncementDto: CreateAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AnnouncementDto> {
      return localVarFp
        .announcementsControllerCreate(createAnnouncementDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete an announcement (internal admin)
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .announcementsControllerDelete(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List all announcements (internal admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerFindAll(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<AnnouncementDto>> {
      return localVarFp
        .announcementsControllerFindAll(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Publish an announcement (deactivates the previous active one)
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerPublish(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AnnouncementDto> {
      return localVarFp
        .announcementsControllerPublish(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Unpublish the currently active announcement
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerUnpublish(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AnnouncementDto> {
      return localVarFp
        .announcementsControllerUnpublish(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update an announcement (internal admin)
     * @param {string} id
     * @param {UpdateAnnouncementDto} updateAnnouncementDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    announcementsControllerUpdate(
      id: string,
      updateAnnouncementDto: UpdateAnnouncementDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AnnouncementDto> {
      return localVarFp
        .announcementsControllerUpdate(id, updateAnnouncementDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * InternalAnnouncementsApi - object-oriented interface
 * @export
 * @class InternalAnnouncementsApi
 * @extends {BaseAPI}
 */
export class InternalAnnouncementsApi extends BaseAPI {
  /**
   *
   * @summary Create a new announcement (internal admin)
   * @param {CreateAnnouncementDto} createAnnouncementDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalAnnouncementsApi
   */
  public announcementsControllerCreate(
    createAnnouncementDto: CreateAnnouncementDto,
    options?: RawAxiosRequestConfig
  ) {
    return InternalAnnouncementsApiFp(this.configuration)
      .announcementsControllerCreate(createAnnouncementDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete an announcement (internal admin)
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalAnnouncementsApi
   */
  public announcementsControllerDelete(id: string, options?: RawAxiosRequestConfig) {
    return InternalAnnouncementsApiFp(this.configuration)
      .announcementsControllerDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List all announcements (internal admin)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalAnnouncementsApi
   */
  public announcementsControllerFindAll(options?: RawAxiosRequestConfig) {
    return InternalAnnouncementsApiFp(this.configuration)
      .announcementsControllerFindAll(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Publish an announcement (deactivates the previous active one)
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalAnnouncementsApi
   */
  public announcementsControllerPublish(id: string, options?: RawAxiosRequestConfig) {
    return InternalAnnouncementsApiFp(this.configuration)
      .announcementsControllerPublish(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Unpublish the currently active announcement
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalAnnouncementsApi
   */
  public announcementsControllerUnpublish(id: string, options?: RawAxiosRequestConfig) {
    return InternalAnnouncementsApiFp(this.configuration)
      .announcementsControllerUnpublish(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an announcement (internal admin)
   * @param {string} id
   * @param {UpdateAnnouncementDto} updateAnnouncementDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalAnnouncementsApi
   */
  public announcementsControllerUpdate(
    id: string,
    updateAnnouncementDto: UpdateAnnouncementDto,
    options?: RawAxiosRequestConfig
  ) {
    return InternalAnnouncementsApiFp(this.configuration)
      .announcementsControllerUpdate(id, updateAnnouncementDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * InventoryApi - axios parameter creator
 * @export
 */
export const InventoryApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Ajouter un objet (avec action et souvenir éventuels)
     * @param {string} assetId
     * @param {CreateInventoryItemDto} createInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerCreate: async (
      assetId: string,
      createInventoryItemDto: CreateInventoryItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerCreate', 'assetId', assetId);
      // verify required parameter 'createInventoryItemDto' is not null or undefined
      assertParamExists(
        'inventoryControllerCreate',
        'createInventoryItemDto',
        createInventoryItemDto
      );
      const localVarPath = `/assets/{assetId}/inventory/items`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createInventoryItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Lucien prépare une fiche à partir des photos et de la voix
     * @param {string} assetId
     * @param {Array<string>} photoIds
     * @param {Array<File>} [file] Ce que le membre a dit, en un ou plusieurs morceaux (dans l’ordre)
     * @param {string} [roomId]
     * @param {InventoryControllerDraftLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerDraft: async (
      assetId: string,
      photoIds: Array<string>,
      file?: Array<File>,
      roomId?: string,
      language?: InventoryControllerDraftLanguageEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerDraft', 'assetId', assetId);
      // verify required parameter 'photoIds' is not null or undefined
      assertParamExists('inventoryControllerDraft', 'photoIds', photoIds);
      const localVarPath = `/assets/{assetId}/inventory/draft`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file) {
        file.forEach(element => {
          localVarFormParams.append('file', element as any);
        });
      }

      if (photoIds) {
        localVarFormParams.append('photoIds', photoIds.join(COLLECTION_FORMATS.csv));
      }

      if (roomId !== undefined) {
        localVarFormParams.append('roomId', roomId as any);
      }

      if (language !== undefined) {
        localVarFormParams.append('language', language as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Sortir un objet de l\'inventaire (cassé, donné, vendu…)
     * @param {string} assetId
     * @param {string} itemId
     * @param {ExitInventoryItemDto} exitInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExit: async (
      assetId: string,
      itemId: string,
      exitInventoryItemDto: ExitInventoryItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerExit', 'assetId', assetId);
      // verify required parameter 'itemId' is not null or undefined
      assertParamExists('inventoryControllerExit', 'itemId', itemId);
      // verify required parameter 'exitInventoryItemDto' is not null or undefined
      assertParamExists('inventoryControllerExit', 'exitInventoryItemDto', exitInventoryItemDto);
      const localVarPath = `/assets/{assetId}/inventory/items/{itemId}/exit`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        exitInventoryItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Objets sortis de l\'inventaire (cassés, donnés, vendus…)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExited: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerExited', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/inventory/exited`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary PDF pour l\'assureur (gestionnaires) et rappel dans un an
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExportAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerExportAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/inventory/export`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Fiche PDF d\'un objet, pour une déclaration de vol ou de perte
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExportItem: async (
      assetId: string,
      itemId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerExportItem', 'assetId', assetId);
      // verify required parameter 'itemId' is not null or undefined
      assertParamExists('inventoryControllerExportItem', 'itemId', itemId);
      const localVarPath = `/assets/{assetId}/inventory/items/{itemId}/export`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Fiche d\'un objet
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerFindOne: async (
      assetId: string,
      itemId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerFindOne', 'assetId', assetId);
      // verify required parameter 'itemId' is not null or undefined
      assertParamExists('inventoryControllerFindOne', 'itemId', itemId);
      const localVarPath = `/assets/{assetId}/inventory/items/{itemId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Objets présents dans la maison, totaux et règle d\'usure
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerOverview: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerOverview', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/inventory`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Remettre un objet sorti dans l\'inventaire
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerPutBack: async (
      assetId: string,
      itemId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerPutBack', 'assetId', assetId);
      // verify required parameter 'itemId' is not null or undefined
      assertParamExists('inventoryControllerPutBack', 'itemId', itemId);
      const localVarPath = `/assets/{assetId}/inventory/items/{itemId}/put-back`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Supprimer un objet ajouté par erreur (gestionnaires ou auteur)
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerRemove: async (
      assetId: string,
      itemId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerRemove', 'assetId', assetId);
      // verify required parameter 'itemId' is not null or undefined
      assertParamExists('inventoryControllerRemove', 'itemId', itemId);
      const localVarPath = `/assets/{assetId}/inventory/items/{itemId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Annuler la suppression d’un objet
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerRestore: async (
      assetId: string,
      itemId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerRestore', 'assetId', assetId);
      // verify required parameter 'itemId' is not null or undefined
      assertParamExists('inventoryControllerRestore', 'itemId', itemId);
      const localVarPath = `/assets/{assetId}/inventory/items/{itemId}/restore`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Modifier un objet (gestionnaires ou auteur)
     * @param {string} assetId
     * @param {string} itemId
     * @param {UpdateInventoryItemDto} updateInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerUpdate: async (
      assetId: string,
      itemId: string,
      updateInventoryItemDto: UpdateInventoryItemDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerUpdate', 'assetId', assetId);
      // verify required parameter 'itemId' is not null or undefined
      assertParamExists('inventoryControllerUpdate', 'itemId', itemId);
      // verify required parameter 'updateInventoryItemDto' is not null or undefined
      assertParamExists(
        'inventoryControllerUpdate',
        'updateInventoryItemDto',
        updateInventoryItemDto
      );
      const localVarPath = `/assets/{assetId}/inventory/items/{itemId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'itemId'}}`, encodeURIComponent(String(itemId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateInventoryItemDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Règle d\'usure de la maison (gestionnaires)
     * @param {string} assetId
     * @param {UpdateInventorySettingsDto} updateInventorySettingsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerUpdateSettings: async (
      assetId: string,
      updateInventorySettingsDto: UpdateInventorySettingsDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerUpdateSettings', 'assetId', assetId);
      // verify required parameter 'updateInventorySettingsDto' is not null or undefined
      assertParamExists(
        'inventoryControllerUpdateSettings',
        'updateInventorySettingsDto',
        updateInventorySettingsDto
      );
      const localVarPath = `/assets/{assetId}/inventory/settings`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateInventorySettingsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Ranger une facture photographiée dans Documents (« Factures de l\'inventaire »)
     * @param {string} assetId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerUploadInvoice: async (
      assetId: string,
      file: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inventoryControllerUploadInvoice', 'assetId', assetId);
      // verify required parameter 'file' is not null or undefined
      assertParamExists('inventoryControllerUploadInvoice', 'file', file);
      const localVarPath = `/assets/{assetId}/inventory/invoices`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InventoryApi - functional programming interface
 * @export
 */
export const InventoryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InventoryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Ajouter un objet (avec action et souvenir éventuels)
     * @param {string} assetId
     * @param {CreateInventoryItemDto} createInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerCreate(
      assetId: string,
      createInventoryItemDto: CreateInventoryItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryCreatedDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerCreate(
        assetId,
        createInventoryItemDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Lucien prépare une fiche à partir des photos et de la voix
     * @param {string} assetId
     * @param {Array<string>} photoIds
     * @param {Array<File>} [file] Ce que le membre a dit, en un ou plusieurs morceaux (dans l’ordre)
     * @param {string} [roomId]
     * @param {InventoryControllerDraftLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerDraft(
      assetId: string,
      photoIds: Array<string>,
      file?: Array<File>,
      roomId?: string,
      language?: InventoryControllerDraftLanguageEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryDraftDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerDraft(
        assetId,
        photoIds,
        file,
        roomId,
        language,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerDraft']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Sortir un objet de l\'inventaire (cassé, donné, vendu…)
     * @param {string} assetId
     * @param {string} itemId
     * @param {ExitInventoryItemDto} exitInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerExit(
      assetId: string,
      itemId: string,
      exitInventoryItemDto: ExitInventoryItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerExit(
        assetId,
        itemId,
        exitInventoryItemDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerExit']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Objets sortis de l\'inventaire (cassés, donnés, vendus…)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerExited(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InventoryItemDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerExited(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerExited']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary PDF pour l\'assureur (gestionnaires) et rappel dans un an
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerExportAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryPdfDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerExportAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerExportAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Fiche PDF d\'un objet, pour une déclaration de vol ou de perte
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerExportItem(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryPdfDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerExportItem(
        assetId,
        itemId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerExportItem']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Fiche d\'un objet
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerFindOne(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerFindOne(
        assetId,
        itemId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Objets présents dans la maison, totaux et règle d\'usure
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerOverview(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryOverviewDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerOverview(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerOverview']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Remettre un objet sorti dans l\'inventaire
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerPutBack(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerPutBack(
        assetId,
        itemId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerPutBack']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Supprimer un objet ajouté par erreur (gestionnaires ou auteur)
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerRemove(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerRemove(
        assetId,
        itemId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerRemove']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Annuler la suppression d’un objet
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerRestore(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerRestore(
        assetId,
        itemId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerRestore']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Modifier un objet (gestionnaires ou auteur)
     * @param {string} assetId
     * @param {string} itemId
     * @param {UpdateInventoryItemDto} updateInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerUpdate(
      assetId: string,
      itemId: string,
      updateInventoryItemDto: UpdateInventoryItemDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryItemDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerUpdate(
        assetId,
        itemId,
        updateInventoryItemDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Règle d\'usure de la maison (gestionnaires)
     * @param {string} assetId
     * @param {UpdateInventorySettingsDto} updateInventorySettingsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerUpdateSettings(
      assetId: string,
      updateInventorySettingsDto: UpdateInventorySettingsDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventorySettingsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerUpdateSettings(
        assetId,
        updateInventorySettingsDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerUpdateSettings']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Ranger une facture photographiée dans Documents (« Factures de l\'inventaire »)
     * @param {string} assetId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inventoryControllerUploadInvoice(
      assetId: string,
      file: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InventoryInvoiceDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inventoryControllerUploadInvoice(
        assetId,
        file,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InventoryApi.inventoryControllerUploadInvoice']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * InventoryApi - factory interface
 * @export
 */
export const InventoryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InventoryApiFp(configuration);
  return {
    /**
     *
     * @summary Ajouter un objet (avec action et souvenir éventuels)
     * @param {string} assetId
     * @param {CreateInventoryItemDto} createInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerCreate(
      assetId: string,
      createInventoryItemDto: CreateInventoryItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryCreatedDto> {
      return localVarFp
        .inventoryControllerCreate(assetId, createInventoryItemDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Lucien prépare une fiche à partir des photos et de la voix
     * @param {string} assetId
     * @param {Array<string>} photoIds
     * @param {Array<File>} [file] Ce que le membre a dit, en un ou plusieurs morceaux (dans l’ordre)
     * @param {string} [roomId]
     * @param {InventoryControllerDraftLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerDraft(
      assetId: string,
      photoIds: Array<string>,
      file?: Array<File>,
      roomId?: string,
      language?: InventoryControllerDraftLanguageEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryDraftDto> {
      return localVarFp
        .inventoryControllerDraft(assetId, photoIds, file, roomId, language, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Sortir un objet de l\'inventaire (cassé, donné, vendu…)
     * @param {string} assetId
     * @param {string} itemId
     * @param {ExitInventoryItemDto} exitInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExit(
      assetId: string,
      itemId: string,
      exitInventoryItemDto: ExitInventoryItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryItemDto> {
      return localVarFp
        .inventoryControllerExit(assetId, itemId, exitInventoryItemDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Objets sortis de l\'inventaire (cassés, donnés, vendus…)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExited(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InventoryItemDto>> {
      return localVarFp
        .inventoryControllerExited(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary PDF pour l\'assureur (gestionnaires) et rappel dans un an
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExportAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryPdfDto> {
      return localVarFp
        .inventoryControllerExportAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Fiche PDF d\'un objet, pour une déclaration de vol ou de perte
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerExportItem(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryPdfDto> {
      return localVarFp
        .inventoryControllerExportItem(assetId, itemId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Fiche d\'un objet
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerFindOne(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryItemDto> {
      return localVarFp
        .inventoryControllerFindOne(assetId, itemId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Objets présents dans la maison, totaux et règle d\'usure
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerOverview(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryOverviewDto> {
      return localVarFp
        .inventoryControllerOverview(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Remettre un objet sorti dans l\'inventaire
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerPutBack(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryItemDto> {
      return localVarFp
        .inventoryControllerPutBack(assetId, itemId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Supprimer un objet ajouté par erreur (gestionnaires ou auteur)
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerRemove(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .inventoryControllerRemove(assetId, itemId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Annuler la suppression d’un objet
     * @param {string} assetId
     * @param {string} itemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerRestore(
      assetId: string,
      itemId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryItemDto> {
      return localVarFp
        .inventoryControllerRestore(assetId, itemId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Modifier un objet (gestionnaires ou auteur)
     * @param {string} assetId
     * @param {string} itemId
     * @param {UpdateInventoryItemDto} updateInventoryItemDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerUpdate(
      assetId: string,
      itemId: string,
      updateInventoryItemDto: UpdateInventoryItemDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryItemDto> {
      return localVarFp
        .inventoryControllerUpdate(assetId, itemId, updateInventoryItemDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Règle d\'usure de la maison (gestionnaires)
     * @param {string} assetId
     * @param {UpdateInventorySettingsDto} updateInventorySettingsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerUpdateSettings(
      assetId: string,
      updateInventorySettingsDto: UpdateInventorySettingsDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventorySettingsDto> {
      return localVarFp
        .inventoryControllerUpdateSettings(assetId, updateInventorySettingsDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Ranger une facture photographiée dans Documents (« Factures de l\'inventaire »)
     * @param {string} assetId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inventoryControllerUploadInvoice(
      assetId: string,
      file: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InventoryInvoiceDto> {
      return localVarFp
        .inventoryControllerUploadInvoice(assetId, file, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
export class InventoryApi extends BaseAPI {
  /**
   *
   * @summary Ajouter un objet (avec action et souvenir éventuels)
   * @param {string} assetId
   * @param {CreateInventoryItemDto} createInventoryItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerCreate(
    assetId: string,
    createInventoryItemDto: CreateInventoryItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerCreate(assetId, createInventoryItemDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Lucien prépare une fiche à partir des photos et de la voix
   * @param {string} assetId
   * @param {Array<string>} photoIds
   * @param {Array<File>} [file] Ce que le membre a dit, en un ou plusieurs morceaux (dans l’ordre)
   * @param {string} [roomId]
   * @param {InventoryControllerDraftLanguageEnum} [language]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerDraft(
    assetId: string,
    photoIds: Array<string>,
    file?: Array<File>,
    roomId?: string,
    language?: InventoryControllerDraftLanguageEnum,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerDraft(assetId, photoIds, file, roomId, language, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Sortir un objet de l\'inventaire (cassé, donné, vendu…)
   * @param {string} assetId
   * @param {string} itemId
   * @param {ExitInventoryItemDto} exitInventoryItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerExit(
    assetId: string,
    itemId: string,
    exitInventoryItemDto: ExitInventoryItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerExit(assetId, itemId, exitInventoryItemDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Objets sortis de l\'inventaire (cassés, donnés, vendus…)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerExited(assetId: string, options?: RawAxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerExited(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary PDF pour l\'assureur (gestionnaires) et rappel dans un an
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerExportAll(assetId: string, options?: RawAxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerExportAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Fiche PDF d\'un objet, pour une déclaration de vol ou de perte
   * @param {string} assetId
   * @param {string} itemId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerExportItem(
    assetId: string,
    itemId: string,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerExportItem(assetId, itemId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Fiche d\'un objet
   * @param {string} assetId
   * @param {string} itemId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerFindOne(
    assetId: string,
    itemId: string,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerFindOne(assetId, itemId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Objets présents dans la maison, totaux et règle d\'usure
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerOverview(assetId: string, options?: RawAxiosRequestConfig) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerOverview(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Remettre un objet sorti dans l\'inventaire
   * @param {string} assetId
   * @param {string} itemId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerPutBack(
    assetId: string,
    itemId: string,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerPutBack(assetId, itemId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Supprimer un objet ajouté par erreur (gestionnaires ou auteur)
   * @param {string} assetId
   * @param {string} itemId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerRemove(
    assetId: string,
    itemId: string,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerRemove(assetId, itemId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Annuler la suppression d’un objet
   * @param {string} assetId
   * @param {string} itemId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerRestore(
    assetId: string,
    itemId: string,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerRestore(assetId, itemId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Modifier un objet (gestionnaires ou auteur)
   * @param {string} assetId
   * @param {string} itemId
   * @param {UpdateInventoryItemDto} updateInventoryItemDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerUpdate(
    assetId: string,
    itemId: string,
    updateInventoryItemDto: UpdateInventoryItemDto,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerUpdate(assetId, itemId, updateInventoryItemDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Règle d\'usure de la maison (gestionnaires)
   * @param {string} assetId
   * @param {UpdateInventorySettingsDto} updateInventorySettingsDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerUpdateSettings(
    assetId: string,
    updateInventorySettingsDto: UpdateInventorySettingsDto,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerUpdateSettings(assetId, updateInventorySettingsDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Ranger une facture photographiée dans Documents (« Factures de l\'inventaire »)
   * @param {string} assetId
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InventoryApi
   */
  public inventoryControllerUploadInvoice(
    assetId: string,
    file: File,
    options?: RawAxiosRequestConfig
  ) {
    return InventoryApiFp(this.configuration)
      .inventoryControllerUploadInvoice(assetId, file, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const InventoryControllerDraftLanguageEnum = {
  Fr: 'fr',
  En: 'en',
} as const;
export type InventoryControllerDraftLanguageEnum =
  (typeof InventoryControllerDraftLanguageEnum)[keyof typeof InventoryControllerDraftLanguageEnum];

/**
 * InvitationsApi - axios parameter creator
 * @export
 */
export const InvitationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept an invitation with the current authenticated user
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerAccept: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('invitationsControllerAccept', 'token', token);
      const localVarPath = `/invitations/{token}/accept`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete an invitation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('invitationsControllerDelete', 'id', id);
      const localVarPath = `/invitations/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all pending invitations for the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerFindMyPendingInvitations: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/invitations/my-pending`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resend an invitation email
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerResend: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('invitationsControllerResend', 'id', id);
      const localVarPath = `/invitations/{id}/resend`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Validate an invitation token
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerValidate: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('invitationsControllerValidate', 'token', token);
      const localVarPath = `/invitations/{token}/validate`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InvitationsApi - functional programming interface
 * @export
 */
export const InvitationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InvitationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Accept an invitation with the current authenticated user
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationsControllerAccept(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerAccept(
        token,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InvitationsApi.invitationsControllerAccept']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete an invitation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationsControllerDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerDelete(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InvitationsApi.invitationsControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all pending invitations for the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationsControllerFindMyPendingInvitations(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvitationDto>>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.invitationsControllerFindMyPendingInvitations(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InvitationsApi.invitationsControllerFindMyPendingInvitations']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resend an invitation email
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationsControllerResend(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerResend(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InvitationsApi.invitationsControllerResend']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Validate an invitation token
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitationsControllerValidate(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitationDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitationsControllerValidate(
        token,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InvitationsApi.invitationsControllerValidate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * InvitationsApi - factory interface
 * @export
 */
export const InvitationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InvitationsApiFp(configuration);
  return {
    /**
     *
     * @summary Accept an invitation with the current authenticated user
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerAccept(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InvitationDto> {
      return localVarFp
        .invitationsControllerAccept(token, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete an invitation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerDelete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .invitationsControllerDelete(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get all pending invitations for the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerFindMyPendingInvitations(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InvitationDto>> {
      return localVarFp
        .invitationsControllerFindMyPendingInvitations(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Resend an invitation email
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerResend(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .invitationsControllerResend(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Validate an invitation token
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitationsControllerValidate(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InvitationDto> {
      return localVarFp
        .invitationsControllerValidate(token, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * InvitationsApi - object-oriented interface
 * @export
 * @class InvitationsApi
 * @extends {BaseAPI}
 */
export class InvitationsApi extends BaseAPI {
  /**
   *
   * @summary Accept an invitation with the current authenticated user
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationsApi
   */
  public invitationsControllerAccept(token: string, options?: RawAxiosRequestConfig) {
    return InvitationsApiFp(this.configuration)
      .invitationsControllerAccept(token, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete an invitation
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationsApi
   */
  public invitationsControllerDelete(id: string, options?: RawAxiosRequestConfig) {
    return InvitationsApiFp(this.configuration)
      .invitationsControllerDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all pending invitations for the currently authenticated user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationsApi
   */
  public invitationsControllerFindMyPendingInvitations(options?: RawAxiosRequestConfig) {
    return InvitationsApiFp(this.configuration)
      .invitationsControllerFindMyPendingInvitations(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resend an invitation email
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationsApi
   */
  public invitationsControllerResend(id: string, options?: RawAxiosRequestConfig) {
    return InvitationsApiFp(this.configuration)
      .invitationsControllerResend(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Validate an invitation token
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationsApi
   */
  public invitationsControllerValidate(token: string, options?: RawAxiosRequestConfig) {
    return InvitationsApiFp(this.configuration)
      .invitationsControllerValidate(token, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * InviteCodesApi - axios parameter creator
 * @export
 */
export const InviteCodesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept an invite code with the current authenticated user
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerAccept: async (
      code: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists('inviteCodesControllerAccept', 'code', code);
      const localVarPath = `/invite-codes/{code}/accept`.replace(
        `{${'code'}}`,
        encodeURIComponent(String(code))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create or regenerate an invite code for an asset
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerCreate: async (
      assetId: string,
      body: object,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inviteCodesControllerCreate', 'assetId', assetId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('inviteCodesControllerCreate', 'body', body);
      const localVarPath = `/assets/{assetId}/invite-codes`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the invite code for an asset (creates one if none exists)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerFindByAsset: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('inviteCodesControllerFindByAsset', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/invite-codes`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Validate an invite code and return its details
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerValidate: async (
      code: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'code' is not null or undefined
      assertParamExists('inviteCodesControllerValidate', 'code', code);
      const localVarPath = `/invite-codes/{code}/validate`.replace(
        `{${'code'}}`,
        encodeURIComponent(String(code))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InviteCodesApi - functional programming interface
 * @export
 */
export const InviteCodesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InviteCodesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Accept an invite code with the current authenticated user
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inviteCodesControllerAccept(
      code: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteCodeValidationDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inviteCodesControllerAccept(
        code,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InviteCodesApi.inviteCodesControllerAccept']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create or regenerate an invite code for an asset
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inviteCodesControllerCreate(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteCodeDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inviteCodesControllerCreate(
        assetId,
        body,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InviteCodesApi.inviteCodesControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the invite code for an asset (creates one if none exists)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inviteCodesControllerFindByAsset(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteCodeDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inviteCodesControllerFindByAsset(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InviteCodesApi.inviteCodesControllerFindByAsset']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Validate an invite code and return its details
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async inviteCodesControllerValidate(
      code: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteCodeValidationDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.inviteCodesControllerValidate(
        code,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['InviteCodesApi.inviteCodesControllerValidate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * InviteCodesApi - factory interface
 * @export
 */
export const InviteCodesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InviteCodesApiFp(configuration);
  return {
    /**
     *
     * @summary Accept an invite code with the current authenticated user
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerAccept(
      code: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InviteCodeValidationDto> {
      return localVarFp
        .inviteCodesControllerAccept(code, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create or regenerate an invite code for an asset
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerCreate(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InviteCodeDto> {
      return localVarFp
        .inviteCodesControllerCreate(assetId, body, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the invite code for an asset (creates one if none exists)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerFindByAsset(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InviteCodeDto> {
      return localVarFp
        .inviteCodesControllerFindByAsset(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Validate an invite code and return its details
     * @param {string} code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteCodesControllerValidate(
      code: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InviteCodeValidationDto> {
      return localVarFp
        .inviteCodesControllerValidate(code, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * InviteCodesApi - object-oriented interface
 * @export
 * @class InviteCodesApi
 * @extends {BaseAPI}
 */
export class InviteCodesApi extends BaseAPI {
  /**
   *
   * @summary Accept an invite code with the current authenticated user
   * @param {string} code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteCodesApi
   */
  public inviteCodesControllerAccept(code: string, options?: RawAxiosRequestConfig) {
    return InviteCodesApiFp(this.configuration)
      .inviteCodesControllerAccept(code, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create or regenerate an invite code for an asset
   * @param {string} assetId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteCodesApi
   */
  public inviteCodesControllerCreate(
    assetId: string,
    body: object,
    options?: RawAxiosRequestConfig
  ) {
    return InviteCodesApiFp(this.configuration)
      .inviteCodesControllerCreate(assetId, body, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the invite code for an asset (creates one if none exists)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteCodesApi
   */
  public inviteCodesControllerFindByAsset(assetId: string, options?: RawAxiosRequestConfig) {
    return InviteCodesApiFp(this.configuration)
      .inviteCodesControllerFindByAsset(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Validate an invite code and return its details
   * @param {string} code
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InviteCodesApi
   */
  public inviteCodesControllerValidate(code: string, options?: RawAxiosRequestConfig) {
    return InviteCodesApiFp(this.configuration)
      .inviteCodesControllerValidate(code, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * MemberRemindersApi - axios parameter creator
 * @export
 */
export const MemberRemindersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Cancel a reminder that has not been sent yet (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerCancel: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memberRemindersControllerCancel', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('memberRemindersControllerCancel', 'id', id);
      const localVarPath = `/assets/{assetId}/reminders/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create (and possibly immediately send) a reminder (gestionnaire only)
     * @param {string} assetId
     * @param {CreateMemberReminderDto} createMemberReminderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerCreate: async (
      assetId: string,
      createMemberReminderDto: CreateMemberReminderDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memberRemindersControllerCreate', 'assetId', assetId);
      // verify required parameter 'createMemberReminderDto' is not null or undefined
      assertParamExists(
        'memberRemindersControllerCreate',
        'createMemberReminderDto',
        createMemberReminderDto
      );
      const localVarPath = `/assets/{assetId}/reminders`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createMemberReminderDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all reminders for an asset (gestionnaire only)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memberRemindersControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/reminders`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary A member\'s own reminder history (self or gestionnaire)
     * @param {string} assetId
     * @param {string} memberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerFindForMember: async (
      assetId: string,
      memberId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memberRemindersControllerFindForMember', 'assetId', assetId);
      // verify required parameter 'memberId' is not null or undefined
      assertParamExists('memberRemindersControllerFindForMember', 'memberId', memberId);
      const localVarPath = `/assets/{assetId}/members/{memberId}/reminders`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'memberId'}}`, encodeURIComponent(String(memberId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Trigger immediate delivery of a reminder (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerSendNow: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memberRemindersControllerSendNow', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('memberRemindersControllerSendNow', 'id', id);
      const localVarPath = `/assets/{assetId}/reminders/{id}/send-now`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Modify a draft or scheduled reminder (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateMemberReminderDto} updateMemberReminderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerUpdate: async (
      assetId: string,
      id: string,
      updateMemberReminderDto: UpdateMemberReminderDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memberRemindersControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('memberRemindersControllerUpdate', 'id', id);
      // verify required parameter 'updateMemberReminderDto' is not null or undefined
      assertParamExists(
        'memberRemindersControllerUpdate',
        'updateMemberReminderDto',
        updateMemberReminderDto
      );
      const localVarPath = `/assets/{assetId}/reminders/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMemberReminderDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MemberRemindersApi - functional programming interface
 * @export
 */
export const MemberRemindersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MemberRemindersApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Cancel a reminder that has not been sent yet (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberRemindersControllerCancel(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memberRemindersControllerCancel(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemberRemindersApi.memberRemindersControllerCancel']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create (and possibly immediately send) a reminder (gestionnaire only)
     * @param {string} assetId
     * @param {CreateMemberReminderDto} createMemberReminderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberRemindersControllerCreate(
      assetId: string,
      createMemberReminderDto: CreateMemberReminderDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberReminderDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memberRemindersControllerCreate(
        assetId,
        createMemberReminderDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemberRemindersApi.memberRemindersControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List all reminders for an asset (gestionnaire only)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberRemindersControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberReminderDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memberRemindersControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemberRemindersApi.memberRemindersControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary A member\'s own reminder history (self or gestionnaire)
     * @param {string} assetId
     * @param {string} memberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberRemindersControllerFindForMember(
      assetId: string,
      memberId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberReminderDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.memberRemindersControllerFindForMember(
          assetId,
          memberId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemberRemindersApi.memberRemindersControllerFindForMember']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Trigger immediate delivery of a reminder (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberRemindersControllerSendNow(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberReminderDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memberRemindersControllerSendNow(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemberRemindersApi.memberRemindersControllerSendNow']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Modify a draft or scheduled reminder (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateMemberReminderDto} updateMemberReminderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memberRemindersControllerUpdate(
      assetId: string,
      id: string,
      updateMemberReminderDto: UpdateMemberReminderDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberReminderDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memberRemindersControllerUpdate(
        assetId,
        id,
        updateMemberReminderDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemberRemindersApi.memberRemindersControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MemberRemindersApi - factory interface
 * @export
 */
export const MemberRemindersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MemberRemindersApiFp(configuration);
  return {
    /**
     *
     * @summary Cancel a reminder that has not been sent yet (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerCancel(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .memberRemindersControllerCancel(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create (and possibly immediately send) a reminder (gestionnaire only)
     * @param {string} assetId
     * @param {CreateMemberReminderDto} createMemberReminderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerCreate(
      assetId: string,
      createMemberReminderDto: CreateMemberReminderDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberReminderDto> {
      return localVarFp
        .memberRemindersControllerCreate(assetId, createMemberReminderDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List all reminders for an asset (gestionnaire only)
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<MemberReminderDto>> {
      return localVarFp
        .memberRemindersControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary A member\'s own reminder history (self or gestionnaire)
     * @param {string} assetId
     * @param {string} memberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerFindForMember(
      assetId: string,
      memberId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<MemberReminderDto>> {
      return localVarFp
        .memberRemindersControllerFindForMember(assetId, memberId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Trigger immediate delivery of a reminder (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerSendNow(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberReminderDto> {
      return localVarFp
        .memberRemindersControllerSendNow(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Modify a draft or scheduled reminder (gestionnaire only)
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateMemberReminderDto} updateMemberReminderDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberRemindersControllerUpdate(
      assetId: string,
      id: string,
      updateMemberReminderDto: UpdateMemberReminderDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberReminderDto> {
      return localVarFp
        .memberRemindersControllerUpdate(assetId, id, updateMemberReminderDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * MemberRemindersApi - object-oriented interface
 * @export
 * @class MemberRemindersApi
 * @extends {BaseAPI}
 */
export class MemberRemindersApi extends BaseAPI {
  /**
   *
   * @summary Cancel a reminder that has not been sent yet (gestionnaire only)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberRemindersApi
   */
  public memberRemindersControllerCancel(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemberRemindersApiFp(this.configuration)
      .memberRemindersControllerCancel(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create (and possibly immediately send) a reminder (gestionnaire only)
   * @param {string} assetId
   * @param {CreateMemberReminderDto} createMemberReminderDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberRemindersApi
   */
  public memberRemindersControllerCreate(
    assetId: string,
    createMemberReminderDto: CreateMemberReminderDto,
    options?: RawAxiosRequestConfig
  ) {
    return MemberRemindersApiFp(this.configuration)
      .memberRemindersControllerCreate(assetId, createMemberReminderDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List all reminders for an asset (gestionnaire only)
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberRemindersApi
   */
  public memberRemindersControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return MemberRemindersApiFp(this.configuration)
      .memberRemindersControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary A member\'s own reminder history (self or gestionnaire)
   * @param {string} assetId
   * @param {string} memberId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberRemindersApi
   */
  public memberRemindersControllerFindForMember(
    assetId: string,
    memberId: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemberRemindersApiFp(this.configuration)
      .memberRemindersControllerFindForMember(assetId, memberId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Trigger immediate delivery of a reminder (gestionnaire only)
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberRemindersApi
   */
  public memberRemindersControllerSendNow(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemberRemindersApiFp(this.configuration)
      .memberRemindersControllerSendNow(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Modify a draft or scheduled reminder (gestionnaire only)
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateMemberReminderDto} updateMemberReminderDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemberRemindersApi
   */
  public memberRemindersControllerUpdate(
    assetId: string,
    id: string,
    updateMemberReminderDto: UpdateMemberReminderDto,
    options?: RawAxiosRequestConfig
  ) {
    return MemberRemindersApiFp(this.configuration)
      .memberRemindersControllerUpdate(assetId, id, updateMemberReminderDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * MemoriesApi - axios parameter creator
 * @export
 */
export const MemoriesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Ajouter un récit vocal à un souvenir
     * @param {string} assetId
     * @param {string} memoryId
     * @param {File} file
     * @param {number} durationSeconds
     * @param {string} [speakerId]
     * @param {string} [speakerName]
     * @param {string} [transcript]
     * @param {MemoriesControllerAddRecordingLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerAddRecording: async (
      assetId: string,
      memoryId: string,
      file: File,
      durationSeconds: number,
      speakerId?: string,
      speakerName?: string,
      transcript?: string,
      language?: MemoriesControllerAddRecordingLanguageEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerAddRecording', 'assetId', assetId);
      // verify required parameter 'memoryId' is not null or undefined
      assertParamExists('memoriesControllerAddRecording', 'memoryId', memoryId);
      // verify required parameter 'file' is not null or undefined
      assertParamExists('memoriesControllerAddRecording', 'file', file);
      // verify required parameter 'durationSeconds' is not null or undefined
      assertParamExists('memoriesControllerAddRecording', 'durationSeconds', durationSeconds);
      const localVarPath = `/assets/{assetId}/memories/{memoryId}/recordings`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'memoryId'}}`, encodeURIComponent(String(memoryId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (durationSeconds !== undefined) {
        localVarFormParams.append('durationSeconds', durationSeconds as any);
      }

      if (speakerId !== undefined) {
        localVarFormParams.append('speakerId', speakerId as any);
      }

      if (speakerName !== undefined) {
        localVarFormParams.append('speakerName', speakerName as any);
      }

      if (transcript !== undefined) {
        localVarFormParams.append('transcript', transcript as any);
      }

      if (language !== undefined) {
        localVarFormParams.append('language', language as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Créer un souvenir
     * @param {string} assetId
     * @param {CreateMemoryDto} createMemoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerCreate: async (
      assetId: string,
      createMemoryDto: CreateMemoryDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerCreate', 'assetId', assetId);
      // verify required parameter 'createMemoryDto' is not null or undefined
      assertParamExists('memoriesControllerCreate', 'createMemoryDto', createMemoryDto);
      const localVarPath = `/assets/{assetId}/memories`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createMemoryDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Lucien propose un souvenir à partir d’un récit (rien n’est enregistré)
     * @param {string} assetId
     * @param {File} file
     * @param {MemoriesControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerDraftFromVoice: async (
      assetId: string,
      file: File,
      language?: MemoriesControllerDraftFromVoiceLanguageEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerDraftFromVoice', 'assetId', assetId);
      // verify required parameter 'file' is not null or undefined
      assertParamExists('memoriesControllerDraftFromVoice', 'file', file);
      const localVarPath = `/assets/{assetId}/memories/draft-from-voice`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (language !== undefined) {
        localVarFormParams.append('language', language as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Fiche d\'un souvenir
     * @param {string} assetId
     * @param {string} memoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerFindOne: async (
      assetId: string,
      memoryId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerFindOne', 'assetId', assetId);
      // verify required parameter 'memoryId' is not null or undefined
      assertParamExists('memoriesControllerFindOne', 'memoryId', memoryId);
      const localVarPath = `/assets/{assetId}/memories/{memoryId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'memoryId'}}`, encodeURIComponent(String(memoryId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Supprimer un souvenir (auteur ou gestionnaire, réversible)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerRemove: async (
      assetId: string,
      memoryId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerRemove', 'assetId', assetId);
      // verify required parameter 'memoryId' is not null or undefined
      assertParamExists('memoriesControllerRemove', 'memoryId', memoryId);
      const localVarPath = `/assets/{assetId}/memories/{memoryId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'memoryId'}}`, encodeURIComponent(String(memoryId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retirer un récit (conteur, enregistreur ou gestionnaire)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {string} recordingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerRemoveRecording: async (
      assetId: string,
      memoryId: string,
      recordingId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerRemoveRecording', 'assetId', assetId);
      // verify required parameter 'memoryId' is not null or undefined
      assertParamExists('memoriesControllerRemoveRecording', 'memoryId', memoryId);
      // verify required parameter 'recordingId' is not null or undefined
      assertParamExists('memoriesControllerRemoveRecording', 'recordingId', recordingId);
      const localVarPath = `/assets/{assetId}/memories/{memoryId}/recordings/{recordingId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'memoryId'}}`, encodeURIComponent(String(memoryId)))
        .replace(`{${'recordingId'}}`, encodeURIComponent(String(recordingId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Frise de la mémoire de la maison
     * @param {string} assetId
     * @param {MemoriesControllerTimelineKindEnum} [kind]
     * @param {boolean} [withVoice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerTimeline: async (
      assetId: string,
      kind?: MemoriesControllerTimelineKindEnum,
      withVoice?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerTimeline', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/memories`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (kind !== undefined) {
        localVarQueryParameter['kind'] = kind;
      }

      if (withVoice !== undefined) {
        localVarQueryParameter['withVoice'] = withVoice;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Modifier un souvenir (auteur ou gestionnaire)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {UpdateMemoryDto} updateMemoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerUpdate: async (
      assetId: string,
      memoryId: string,
      updateMemoryDto: UpdateMemoryDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('memoriesControllerUpdate', 'assetId', assetId);
      // verify required parameter 'memoryId' is not null or undefined
      assertParamExists('memoriesControllerUpdate', 'memoryId', memoryId);
      // verify required parameter 'updateMemoryDto' is not null or undefined
      assertParamExists('memoriesControllerUpdate', 'updateMemoryDto', updateMemoryDto);
      const localVarPath = `/assets/{assetId}/memories/{memoryId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'memoryId'}}`, encodeURIComponent(String(memoryId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMemoryDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MemoriesApi - functional programming interface
 * @export
 */
export const MemoriesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MemoriesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Ajouter un récit vocal à un souvenir
     * @param {string} assetId
     * @param {string} memoryId
     * @param {File} file
     * @param {number} durationSeconds
     * @param {string} [speakerId]
     * @param {string} [speakerName]
     * @param {string} [transcript]
     * @param {MemoriesControllerAddRecordingLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerAddRecording(
      assetId: string,
      memoryId: string,
      file: File,
      durationSeconds: number,
      speakerId?: string,
      speakerName?: string,
      transcript?: string,
      language?: MemoriesControllerAddRecordingLanguageEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryRecordingDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerAddRecording(
        assetId,
        memoryId,
        file,
        durationSeconds,
        speakerId,
        speakerName,
        transcript,
        language,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerAddRecording']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Créer un souvenir
     * @param {string} assetId
     * @param {CreateMemoryDto} createMemoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerCreate(
      assetId: string,
      createMemoryDto: CreateMemoryDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerCreate(
        assetId,
        createMemoryDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Lucien propose un souvenir à partir d’un récit (rien n’est enregistré)
     * @param {string} assetId
     * @param {File} file
     * @param {MemoriesControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerDraftFromVoice(
      assetId: string,
      file: File,
      language?: MemoriesControllerDraftFromVoiceLanguageEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryDraftDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerDraftFromVoice(
        assetId,
        file,
        language,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerDraftFromVoice']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Fiche d\'un souvenir
     * @param {string} assetId
     * @param {string} memoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerFindOne(
      assetId: string,
      memoryId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerFindOne(
        assetId,
        memoryId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerFindOne']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Supprimer un souvenir (auteur ou gestionnaire, réversible)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerRemove(
      assetId: string,
      memoryId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerRemove(
        assetId,
        memoryId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerRemove']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Retirer un récit (conteur, enregistreur ou gestionnaire)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {string} recordingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerRemoveRecording(
      assetId: string,
      memoryId: string,
      recordingId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerRemoveRecording(
        assetId,
        memoryId,
        recordingId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerRemoveRecording']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Frise de la mémoire de la maison
     * @param {string} assetId
     * @param {MemoriesControllerTimelineKindEnum} [kind]
     * @param {boolean} [withVoice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerTimeline(
      assetId: string,
      kind?: MemoriesControllerTimelineKindEnum,
      withVoice?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryTimelineDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerTimeline(
        assetId,
        kind,
        withVoice,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerTimeline']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Modifier un souvenir (auteur ou gestionnaire)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {UpdateMemoryDto} updateMemoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async memoriesControllerUpdate(
      assetId: string,
      memoryId: string,
      updateMemoryDto: UpdateMemoryDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.memoriesControllerUpdate(
        assetId,
        memoryId,
        updateMemoryDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MemoriesApi.memoriesControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MemoriesApi - factory interface
 * @export
 */
export const MemoriesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MemoriesApiFp(configuration);
  return {
    /**
     *
     * @summary Ajouter un récit vocal à un souvenir
     * @param {string} assetId
     * @param {string} memoryId
     * @param {File} file
     * @param {number} durationSeconds
     * @param {string} [speakerId]
     * @param {string} [speakerName]
     * @param {string} [transcript]
     * @param {MemoriesControllerAddRecordingLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerAddRecording(
      assetId: string,
      memoryId: string,
      file: File,
      durationSeconds: number,
      speakerId?: string,
      speakerName?: string,
      transcript?: string,
      language?: MemoriesControllerAddRecordingLanguageEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemoryRecordingDto> {
      return localVarFp
        .memoriesControllerAddRecording(
          assetId,
          memoryId,
          file,
          durationSeconds,
          speakerId,
          speakerName,
          transcript,
          language,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Créer un souvenir
     * @param {string} assetId
     * @param {CreateMemoryDto} createMemoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerCreate(
      assetId: string,
      createMemoryDto: CreateMemoryDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemoryDto> {
      return localVarFp
        .memoriesControllerCreate(assetId, createMemoryDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Lucien propose un souvenir à partir d’un récit (rien n’est enregistré)
     * @param {string} assetId
     * @param {File} file
     * @param {MemoriesControllerDraftFromVoiceLanguageEnum} [language]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerDraftFromVoice(
      assetId: string,
      file: File,
      language?: MemoriesControllerDraftFromVoiceLanguageEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemoryDraftDto> {
      return localVarFp
        .memoriesControllerDraftFromVoice(assetId, file, language, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Fiche d\'un souvenir
     * @param {string} assetId
     * @param {string} memoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerFindOne(
      assetId: string,
      memoryId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemoryDto> {
      return localVarFp
        .memoriesControllerFindOne(assetId, memoryId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Supprimer un souvenir (auteur ou gestionnaire, réversible)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerRemove(
      assetId: string,
      memoryId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .memoriesControllerRemove(assetId, memoryId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Retirer un récit (conteur, enregistreur ou gestionnaire)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {string} recordingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerRemoveRecording(
      assetId: string,
      memoryId: string,
      recordingId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .memoriesControllerRemoveRecording(assetId, memoryId, recordingId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Frise de la mémoire de la maison
     * @param {string} assetId
     * @param {MemoriesControllerTimelineKindEnum} [kind]
     * @param {boolean} [withVoice]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerTimeline(
      assetId: string,
      kind?: MemoriesControllerTimelineKindEnum,
      withVoice?: boolean,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemoryTimelineDto> {
      return localVarFp
        .memoriesControllerTimeline(assetId, kind, withVoice, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Modifier un souvenir (auteur ou gestionnaire)
     * @param {string} assetId
     * @param {string} memoryId
     * @param {UpdateMemoryDto} updateMemoryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memoriesControllerUpdate(
      assetId: string,
      memoryId: string,
      updateMemoryDto: UpdateMemoryDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemoryDto> {
      return localVarFp
        .memoriesControllerUpdate(assetId, memoryId, updateMemoryDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * MemoriesApi - object-oriented interface
 * @export
 * @class MemoriesApi
 * @extends {BaseAPI}
 */
export class MemoriesApi extends BaseAPI {
  /**
   *
   * @summary Ajouter un récit vocal à un souvenir
   * @param {string} assetId
   * @param {string} memoryId
   * @param {File} file
   * @param {number} durationSeconds
   * @param {string} [speakerId]
   * @param {string} [speakerName]
   * @param {string} [transcript]
   * @param {MemoriesControllerAddRecordingLanguageEnum} [language]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerAddRecording(
    assetId: string,
    memoryId: string,
    file: File,
    durationSeconds: number,
    speakerId?: string,
    speakerName?: string,
    transcript?: string,
    language?: MemoriesControllerAddRecordingLanguageEnum,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerAddRecording(
        assetId,
        memoryId,
        file,
        durationSeconds,
        speakerId,
        speakerName,
        transcript,
        language,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Créer un souvenir
   * @param {string} assetId
   * @param {CreateMemoryDto} createMemoryDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerCreate(
    assetId: string,
    createMemoryDto: CreateMemoryDto,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerCreate(assetId, createMemoryDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Lucien propose un souvenir à partir d’un récit (rien n’est enregistré)
   * @param {string} assetId
   * @param {File} file
   * @param {MemoriesControllerDraftFromVoiceLanguageEnum} [language]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerDraftFromVoice(
    assetId: string,
    file: File,
    language?: MemoriesControllerDraftFromVoiceLanguageEnum,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerDraftFromVoice(assetId, file, language, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Fiche d\'un souvenir
   * @param {string} assetId
   * @param {string} memoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerFindOne(
    assetId: string,
    memoryId: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerFindOne(assetId, memoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Supprimer un souvenir (auteur ou gestionnaire, réversible)
   * @param {string} assetId
   * @param {string} memoryId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerRemove(
    assetId: string,
    memoryId: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerRemove(assetId, memoryId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Retirer un récit (conteur, enregistreur ou gestionnaire)
   * @param {string} assetId
   * @param {string} memoryId
   * @param {string} recordingId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerRemoveRecording(
    assetId: string,
    memoryId: string,
    recordingId: string,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerRemoveRecording(assetId, memoryId, recordingId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Frise de la mémoire de la maison
   * @param {string} assetId
   * @param {MemoriesControllerTimelineKindEnum} [kind]
   * @param {boolean} [withVoice]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerTimeline(
    assetId: string,
    kind?: MemoriesControllerTimelineKindEnum,
    withVoice?: boolean,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerTimeline(assetId, kind, withVoice, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Modifier un souvenir (auteur ou gestionnaire)
   * @param {string} assetId
   * @param {string} memoryId
   * @param {UpdateMemoryDto} updateMemoryDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MemoriesApi
   */
  public memoriesControllerUpdate(
    assetId: string,
    memoryId: string,
    updateMemoryDto: UpdateMemoryDto,
    options?: RawAxiosRequestConfig
  ) {
    return MemoriesApiFp(this.configuration)
      .memoriesControllerUpdate(assetId, memoryId, updateMemoryDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const MemoriesControllerAddRecordingLanguageEnum = {
  Fr: 'fr',
  En: 'en',
} as const;
export type MemoriesControllerAddRecordingLanguageEnum =
  (typeof MemoriesControllerAddRecordingLanguageEnum)[keyof typeof MemoriesControllerAddRecordingLanguageEnum];
/**
 * @export
 */
export const MemoriesControllerDraftFromVoiceLanguageEnum = {
  Fr: 'fr',
  En: 'en',
} as const;
export type MemoriesControllerDraftFromVoiceLanguageEnum =
  (typeof MemoriesControllerDraftFromVoiceLanguageEnum)[keyof typeof MemoriesControllerDraftFromVoiceLanguageEnum];
/**
 * @export
 */
export const MemoriesControllerTimelineKindEnum = {
  Family: 'FAMILY',
  Celebration: 'CELEBRATION',
  House: 'HOUSE',
  Works: 'WORKS',
  InMemory: 'IN_MEMORY',
} as const;
export type MemoriesControllerTimelineKindEnum =
  (typeof MemoriesControllerTimelineKindEnum)[keyof typeof MemoriesControllerTimelineKindEnum];

/**
 * MoneyTransferApi - axios parameter creator
 * @export
 */
export const MoneyTransferApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} assetId
     * @param {CreateMoneyTransferDto} createMoneyTransferDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerCreate: async (
      assetId: string,
      createMoneyTransferDto: CreateMoneyTransferDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('moneyTransferControllerCreate', 'assetId', assetId);
      // verify required parameter 'createMoneyTransferDto' is not null or undefined
      assertParamExists(
        'moneyTransferControllerCreate',
        'createMoneyTransferDto',
        createMoneyTransferDto
      );
      const localVarPath = `/assets/{assetId}/money-transfers`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createMoneyTransferDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerDelete: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('moneyTransferControllerDelete', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('moneyTransferControllerDelete', 'id', id);
      const localVarPath = `/assets/{assetId}/money-transfers/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerFindAll: async (
      assetId: string,
      year: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('moneyTransferControllerFindAll', 'assetId', assetId);
      // verify required parameter 'year' is not null or undefined
      assertParamExists('moneyTransferControllerFindAll', 'year', year);
      const localVarPath = `/assets/{assetId}/money-transfers`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateMoneyTransferDto} updateMoneyTransferDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerUpdate: async (
      assetId: string,
      id: string,
      updateMoneyTransferDto: UpdateMoneyTransferDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('moneyTransferControllerUpdate', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('moneyTransferControllerUpdate', 'id', id);
      // verify required parameter 'updateMoneyTransferDto' is not null or undefined
      assertParamExists(
        'moneyTransferControllerUpdate',
        'updateMoneyTransferDto',
        updateMoneyTransferDto
      );
      const localVarPath = `/assets/{assetId}/money-transfers/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMoneyTransferDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MoneyTransferApi - functional programming interface
 * @export
 */
export const MoneyTransferApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MoneyTransferApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} assetId
     * @param {CreateMoneyTransferDto} createMoneyTransferDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async moneyTransferControllerCreate(
      assetId: string,
      createMoneyTransferDto: CreateMoneyTransferDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.moneyTransferControllerCreate(
        assetId,
        createMoneyTransferDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MoneyTransferApi.moneyTransferControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async moneyTransferControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.moneyTransferControllerDelete(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MoneyTransferApi.moneyTransferControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async moneyTransferControllerFindAll(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.moneyTransferControllerFindAll(
        assetId,
        year,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MoneyTransferApi.moneyTransferControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateMoneyTransferDto} updateMoneyTransferDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async moneyTransferControllerUpdate(
      assetId: string,
      id: string,
      updateMoneyTransferDto: UpdateMoneyTransferDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.moneyTransferControllerUpdate(
        assetId,
        id,
        updateMoneyTransferDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MoneyTransferApi.moneyTransferControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MoneyTransferApi - factory interface
 * @export
 */
export const MoneyTransferApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MoneyTransferApiFp(configuration);
  return {
    /**
     *
     * @param {string} assetId
     * @param {CreateMoneyTransferDto} createMoneyTransferDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerCreate(
      assetId: string,
      createMoneyTransferDto: CreateMoneyTransferDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .moneyTransferControllerCreate(assetId, createMoneyTransferDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerDelete(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .moneyTransferControllerDelete(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} assetId
     * @param {string} year
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerFindAll(
      assetId: string,
      year: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .moneyTransferControllerFindAll(assetId, year, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @param {string} assetId
     * @param {string} id
     * @param {UpdateMoneyTransferDto} updateMoneyTransferDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    moneyTransferControllerUpdate(
      assetId: string,
      id: string,
      updateMoneyTransferDto: UpdateMoneyTransferDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .moneyTransferControllerUpdate(assetId, id, updateMoneyTransferDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * MoneyTransferApi - object-oriented interface
 * @export
 * @class MoneyTransferApi
 * @extends {BaseAPI}
 */
export class MoneyTransferApi extends BaseAPI {
  /**
   *
   * @param {string} assetId
   * @param {CreateMoneyTransferDto} createMoneyTransferDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MoneyTransferApi
   */
  public moneyTransferControllerCreate(
    assetId: string,
    createMoneyTransferDto: CreateMoneyTransferDto,
    options?: RawAxiosRequestConfig
  ) {
    return MoneyTransferApiFp(this.configuration)
      .moneyTransferControllerCreate(assetId, createMoneyTransferDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MoneyTransferApi
   */
  public moneyTransferControllerDelete(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return MoneyTransferApiFp(this.configuration)
      .moneyTransferControllerDelete(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} assetId
   * @param {string} year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MoneyTransferApi
   */
  public moneyTransferControllerFindAll(
    assetId: string,
    year: string,
    options?: RawAxiosRequestConfig
  ) {
    return MoneyTransferApiFp(this.configuration)
      .moneyTransferControllerFindAll(assetId, year, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} assetId
   * @param {string} id
   * @param {UpdateMoneyTransferDto} updateMoneyTransferDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MoneyTransferApi
   */
  public moneyTransferControllerUpdate(
    assetId: string,
    id: string,
    updateMoneyTransferDto: UpdateMoneyTransferDto,
    options?: RawAxiosRequestConfig
  ) {
    return MoneyTransferApiFp(this.configuration)
      .moneyTransferControllerUpdate(assetId, id, updateMoneyTransferDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PhotoTagsApi - axios parameter creator
 * @export
 */
export const PhotoTagsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Tag a member on a photo
     * @param {CreatePhotoTagDto} createPhotoTagDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerAddTag: async (
      createPhotoTagDto: CreatePhotoTagDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createPhotoTagDto' is not null or undefined
      assertParamExists('photoTagsControllerAddTag', 'createPhotoTagDto', createPhotoTagDto);
      const localVarPath = `/photo-tags`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPhotoTagDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get photo album for a member
     * @param {string} memberId
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerGetMemberPhotoAlbum: async (
      memberId: string,
      limit?: number,
      cursor?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'memberId' is not null or undefined
      assertParamExists('photoTagsControllerGetMemberPhotoAlbum', 'memberId', memberId);
      const localVarPath = `/members/{memberId}/photos`.replace(
        `{${'memberId'}}`,
        encodeURIComponent(String(memberId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (cursor !== undefined) {
        localVarQueryParameter['cursor'] = cursor;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all tags for a photo
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerGetTagsForPhoto: async (
      fileId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('photoTagsControllerGetTagsForPhoto', 'fileId', fileId);
      const localVarPath = `/storage-files/{fileId}/tags`.replace(
        `{${'fileId'}}`,
        encodeURIComponent(String(fileId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Remove a tag from a photo
     * @param {string} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerRemoveTag: async (
      tagId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tagId' is not null or undefined
      assertParamExists('photoTagsControllerRemoveTag', 'tagId', tagId);
      const localVarPath = `/photo-tags/{tagId}`.replace(
        `{${'tagId'}}`,
        encodeURIComponent(String(tagId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PhotoTagsApi - functional programming interface
 * @export
 */
export const PhotoTagsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PhotoTagsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Tag a member on a photo
     * @param {CreatePhotoTagDto} createPhotoTagDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photoTagsControllerAddTag(
      createPhotoTagDto: CreatePhotoTagDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaggedMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.photoTagsControllerAddTag(
        createPhotoTagDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PhotoTagsApi.photoTagsControllerAddTag']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get photo album for a member
     * @param {string} memberId
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photoTagsControllerGetMemberPhotoAlbum(
      memberId: string,
      limit?: number,
      cursor?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberPhotoAlbumDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.photoTagsControllerGetMemberPhotoAlbum(
          memberId,
          limit,
          cursor,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PhotoTagsApi.photoTagsControllerGetMemberPhotoAlbum']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all tags for a photo
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photoTagsControllerGetTagsForPhoto(
      fileId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaggedMemberDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.photoTagsControllerGetTagsForPhoto(
        fileId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PhotoTagsApi.photoTagsControllerGetTagsForPhoto']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Remove a tag from a photo
     * @param {string} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async photoTagsControllerRemoveTag(
      tagId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.photoTagsControllerRemoveTag(
        tagId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PhotoTagsApi.photoTagsControllerRemoveTag']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PhotoTagsApi - factory interface
 * @export
 */
export const PhotoTagsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PhotoTagsApiFp(configuration);
  return {
    /**
     *
     * @summary Tag a member on a photo
     * @param {CreatePhotoTagDto} createPhotoTagDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerAddTag(
      createPhotoTagDto: CreatePhotoTagDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TaggedMemberDto> {
      return localVarFp
        .photoTagsControllerAddTag(createPhotoTagDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get photo album for a member
     * @param {string} memberId
     * @param {number} [limit]
     * @param {string} [cursor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerGetMemberPhotoAlbum(
      memberId: string,
      limit?: number,
      cursor?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MemberPhotoAlbumDto> {
      return localVarFp
        .photoTagsControllerGetMemberPhotoAlbum(memberId, limit, cursor, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get all tags for a photo
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerGetTagsForPhoto(
      fileId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<TaggedMemberDto>> {
      return localVarFp
        .photoTagsControllerGetTagsForPhoto(fileId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Remove a tag from a photo
     * @param {string} tagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoTagsControllerRemoveTag(
      tagId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .photoTagsControllerRemoveTag(tagId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PhotoTagsApi - object-oriented interface
 * @export
 * @class PhotoTagsApi
 * @extends {BaseAPI}
 */
export class PhotoTagsApi extends BaseAPI {
  /**
   *
   * @summary Tag a member on a photo
   * @param {CreatePhotoTagDto} createPhotoTagDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotoTagsApi
   */
  public photoTagsControllerAddTag(
    createPhotoTagDto: CreatePhotoTagDto,
    options?: RawAxiosRequestConfig
  ) {
    return PhotoTagsApiFp(this.configuration)
      .photoTagsControllerAddTag(createPhotoTagDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get photo album for a member
   * @param {string} memberId
   * @param {number} [limit]
   * @param {string} [cursor]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotoTagsApi
   */
  public photoTagsControllerGetMemberPhotoAlbum(
    memberId: string,
    limit?: number,
    cursor?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PhotoTagsApiFp(this.configuration)
      .photoTagsControllerGetMemberPhotoAlbum(memberId, limit, cursor, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all tags for a photo
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotoTagsApi
   */
  public photoTagsControllerGetTagsForPhoto(fileId: string, options?: RawAxiosRequestConfig) {
    return PhotoTagsApiFp(this.configuration)
      .photoTagsControllerGetTagsForPhoto(fileId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Remove a tag from a photo
   * @param {string} tagId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PhotoTagsApi
   */
  public photoTagsControllerRemoveTag(tagId: string, options?: RawAxiosRequestConfig) {
    return PhotoTagsApiFp(this.configuration)
      .photoTagsControllerRemoveTag(tagId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PlaceholderMembersApi - axios parameter creator
 * @export
 */
export const PlaceholderMembersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Manager-initiated merge into an existing user, no email check.
     * @param {string} id
     * @param {ConvertPlaceholderMemberDto} convertPlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerConvert: async (
      id: string,
      convertPlaceholderMemberDto: ConvertPlaceholderMemberDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('placeholderMembersControllerConvert', 'id', id);
      // verify required parameter 'convertPlaceholderMemberDto' is not null or undefined
      assertParamExists(
        'placeholderMembersControllerConvert',
        'convertPlaceholderMemberDto',
        convertPlaceholderMemberDto
      );
      const localVarPath = `/placeholder-members/{id}/convert`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        convertPlaceholderMemberDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a placeholder member on an asset
     * @param {string} assetId
     * @param {CreatePlaceholderMemberDto} createPlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerCreate: async (
      assetId: string,
      createPlaceholderMemberDto: CreatePlaceholderMemberDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('placeholderMembersControllerCreate', 'assetId', assetId);
      // verify required parameter 'createPlaceholderMemberDto' is not null or undefined
      assertParamExists(
        'placeholderMembersControllerCreate',
        'createPlaceholderMemberDto',
        createPlaceholderMemberDto
      );
      const localVarPath = `/assets/{assetId}/placeholder-members`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPlaceholderMemberDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a placeholder member
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('placeholderMembersControllerDelete', 'id', id);
      const localVarPath = `/placeholder-members/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List placeholder members of an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('placeholderMembersControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/placeholder-members`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List placeholder members matching the current user\'s email, pending confirmation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerFindPendingMatches: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/placeholder-members/pending-matches`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Self-service merge: the current user confirms a placeholder is actually them (estimatedEmail must match).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerFuse: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('placeholderMembersControllerFuse', 'id', id);
      const localVarPath = `/placeholder-members/{id}/fuse`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a placeholder member
     * @param {string} id
     * @param {UpdatePlaceholderMemberDto} updatePlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerUpdate: async (
      id: string,
      updatePlaceholderMemberDto: UpdatePlaceholderMemberDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('placeholderMembersControllerUpdate', 'id', id);
      // verify required parameter 'updatePlaceholderMemberDto' is not null or undefined
      assertParamExists(
        'placeholderMembersControllerUpdate',
        'updatePlaceholderMemberDto',
        updatePlaceholderMemberDto
      );
      const localVarPath = `/placeholder-members/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePlaceholderMemberDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlaceholderMembersApi - functional programming interface
 * @export
 */
export const PlaceholderMembersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlaceholderMembersApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Manager-initiated merge into an existing user, no email check.
     * @param {string} id
     * @param {ConvertPlaceholderMemberDto} convertPlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async placeholderMembersControllerConvert(
      id: string,
      convertPlaceholderMemberDto: ConvertPlaceholderMemberDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceholderMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderMembersControllerConvert(
        id,
        convertPlaceholderMemberDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlaceholderMembersApi.placeholderMembersControllerConvert']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a placeholder member on an asset
     * @param {string} assetId
     * @param {CreatePlaceholderMemberDto} createPlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async placeholderMembersControllerCreate(
      assetId: string,
      createPlaceholderMemberDto: CreatePlaceholderMemberDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceholderMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderMembersControllerCreate(
        assetId,
        createPlaceholderMemberDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlaceholderMembersApi.placeholderMembersControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a placeholder member
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async placeholderMembersControllerDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderMembersControllerDelete(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlaceholderMembersApi.placeholderMembersControllerDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List placeholder members of an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async placeholderMembersControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlaceholderMemberDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderMembersControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlaceholderMembersApi.placeholderMembersControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List placeholder members matching the current user\'s email, pending confirmation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async placeholderMembersControllerFindPendingMatches(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingPlaceholderMatchDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.placeholderMembersControllerFindPendingMatches(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'PlaceholderMembersApi.placeholderMembersControllerFindPendingMatches'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Self-service merge: the current user confirms a placeholder is actually them (estimatedEmail must match).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async placeholderMembersControllerFuse(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceholderMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderMembersControllerFuse(
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlaceholderMembersApi.placeholderMembersControllerFuse']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a placeholder member
     * @param {string} id
     * @param {UpdatePlaceholderMemberDto} updatePlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async placeholderMembersControllerUpdate(
      id: string,
      updatePlaceholderMemberDto: UpdatePlaceholderMemberDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaceholderMemberDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderMembersControllerUpdate(
        id,
        updatePlaceholderMemberDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlaceholderMembersApi.placeholderMembersControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlaceholderMembersApi - factory interface
 * @export
 */
export const PlaceholderMembersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PlaceholderMembersApiFp(configuration);
  return {
    /**
     *
     * @summary Manager-initiated merge into an existing user, no email check.
     * @param {string} id
     * @param {ConvertPlaceholderMemberDto} convertPlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerConvert(
      id: string,
      convertPlaceholderMemberDto: ConvertPlaceholderMemberDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlaceholderMemberDto> {
      return localVarFp
        .placeholderMembersControllerConvert(id, convertPlaceholderMemberDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a placeholder member on an asset
     * @param {string} assetId
     * @param {CreatePlaceholderMemberDto} createPlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerCreate(
      assetId: string,
      createPlaceholderMemberDto: CreatePlaceholderMemberDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlaceholderMemberDto> {
      return localVarFp
        .placeholderMembersControllerCreate(assetId, createPlaceholderMemberDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a placeholder member
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .placeholderMembersControllerDelete(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List placeholder members of an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<PlaceholderMemberDto>> {
      return localVarFp
        .placeholderMembersControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List placeholder members matching the current user\'s email, pending confirmation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerFindPendingMatches(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<PendingPlaceholderMatchDto>> {
      return localVarFp
        .placeholderMembersControllerFindPendingMatches(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Self-service merge: the current user confirms a placeholder is actually them (estimatedEmail must match).
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerFuse(
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlaceholderMemberDto> {
      return localVarFp
        .placeholderMembersControllerFuse(id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a placeholder member
     * @param {string} id
     * @param {UpdatePlaceholderMemberDto} updatePlaceholderMemberDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    placeholderMembersControllerUpdate(
      id: string,
      updatePlaceholderMemberDto: UpdatePlaceholderMemberDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlaceholderMemberDto> {
      return localVarFp
        .placeholderMembersControllerUpdate(id, updatePlaceholderMemberDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PlaceholderMembersApi - object-oriented interface
 * @export
 * @class PlaceholderMembersApi
 * @extends {BaseAPI}
 */
export class PlaceholderMembersApi extends BaseAPI {
  /**
   *
   * @summary Manager-initiated merge into an existing user, no email check.
   * @param {string} id
   * @param {ConvertPlaceholderMemberDto} convertPlaceholderMemberDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaceholderMembersApi
   */
  public placeholderMembersControllerConvert(
    id: string,
    convertPlaceholderMemberDto: ConvertPlaceholderMemberDto,
    options?: RawAxiosRequestConfig
  ) {
    return PlaceholderMembersApiFp(this.configuration)
      .placeholderMembersControllerConvert(id, convertPlaceholderMemberDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a placeholder member on an asset
   * @param {string} assetId
   * @param {CreatePlaceholderMemberDto} createPlaceholderMemberDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaceholderMembersApi
   */
  public placeholderMembersControllerCreate(
    assetId: string,
    createPlaceholderMemberDto: CreatePlaceholderMemberDto,
    options?: RawAxiosRequestConfig
  ) {
    return PlaceholderMembersApiFp(this.configuration)
      .placeholderMembersControllerCreate(assetId, createPlaceholderMemberDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a placeholder member
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaceholderMembersApi
   */
  public placeholderMembersControllerDelete(id: string, options?: RawAxiosRequestConfig) {
    return PlaceholderMembersApiFp(this.configuration)
      .placeholderMembersControllerDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List placeholder members of an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaceholderMembersApi
   */
  public placeholderMembersControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return PlaceholderMembersApiFp(this.configuration)
      .placeholderMembersControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List placeholder members matching the current user\'s email, pending confirmation
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaceholderMembersApi
   */
  public placeholderMembersControllerFindPendingMatches(options?: RawAxiosRequestConfig) {
    return PlaceholderMembersApiFp(this.configuration)
      .placeholderMembersControllerFindPendingMatches(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Self-service merge: the current user confirms a placeholder is actually them (estimatedEmail must match).
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaceholderMembersApi
   */
  public placeholderMembersControllerFuse(id: string, options?: RawAxiosRequestConfig) {
    return PlaceholderMembersApiFp(this.configuration)
      .placeholderMembersControllerFuse(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a placeholder member
   * @param {string} id
   * @param {UpdatePlaceholderMemberDto} updatePlaceholderMemberDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlaceholderMembersApi
   */
  public placeholderMembersControllerUpdate(
    id: string,
    updatePlaceholderMemberDto: UpdatePlaceholderMemberDto,
    options?: RawAxiosRequestConfig
  ) {
    return PlaceholderMembersApiFp(this.configuration)
      .placeholderMembersControllerUpdate(id, updatePlaceholderMemberDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PracticalInformationApi - axios parameter creator
 * @export
 */
export const PracticalInformationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Attach already-uploaded files to a practical information entry
     * @param {string} assetId
     * @param {string} id
     * @param {AddPracticalInformationAttachmentsDto} addPracticalInformationAttachmentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerAddAttachments: async (
      assetId: string,
      id: string,
      addPracticalInformationAttachmentsDto: AddPracticalInformationAttachmentsDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('practicalInformationControllerAddAttachments', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('practicalInformationControllerAddAttachments', 'id', id);
      // verify required parameter 'addPracticalInformationAttachmentsDto' is not null or undefined
      assertParamExists(
        'practicalInformationControllerAddAttachments',
        'addPracticalInformationAttachmentsDto',
        addPracticalInformationAttachmentsDto
      );
      const localVarPath = `/assets/{assetId}/practical-information/{id}/attachments`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addPracticalInformationAttachmentsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create new practical information
     * @param {string} assetId
     * @param {CreatePracticalInformationDto} createPracticalInformationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerCreate: async (
      assetId: string,
      createPracticalInformationDto: CreatePracticalInformationDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('practicalInformationControllerCreate', 'assetId', assetId);
      // verify required parameter 'createPracticalInformationDto' is not null or undefined
      assertParamExists(
        'practicalInformationControllerCreate',
        'createPracticalInformationDto',
        createPracticalInformationDto
      );
      const localVarPath = `/assets/{assetId}/practical-information`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPracticalInformationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all practical information for an asset
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {PracticalInformationControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerFindAll: async (
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: PracticalInformationControllerFindAllOrderEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('practicalInformationControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/practical-information`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['orderBy'] = orderBy;
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find practical information by ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerFindOne: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('practicalInformationControllerFindOne', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('practicalInformationControllerFindOne', 'id', id);
      const localVarPath = `/assets/{assetId}/practical-information/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Soft delete practical information by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerRemove: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('practicalInformationControllerRemove', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('practicalInformationControllerRemove', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/practical-information/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Detach a file from a practical information entry
     * @param {string} assetId
     * @param {string} id
     * @param {string} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerRemoveAttachment: async (
      assetId: string,
      id: string,
      attachmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('practicalInformationControllerRemoveAttachment', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('practicalInformationControllerRemoveAttachment', 'id', id);
      // verify required parameter 'attachmentId' is not null or undefined
      assertParamExists(
        'practicalInformationControllerRemoveAttachment',
        'attachmentId',
        attachmentId
      );
      const localVarPath = `/assets/{assetId}/practical-information/{id}/attachments/{attachmentId}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'attachmentId'}}`, encodeURIComponent(String(attachmentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update existing practical information
     * @param {string} id
     * @param {string} assetId
     * @param {CreatePracticalInformationDto} createPracticalInformationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerUpdate: async (
      id: string,
      assetId: string,
      createPracticalInformationDto: CreatePracticalInformationDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('practicalInformationControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('practicalInformationControllerUpdate', 'assetId', assetId);
      // verify required parameter 'createPracticalInformationDto' is not null or undefined
      assertParamExists(
        'practicalInformationControllerUpdate',
        'createPracticalInformationDto',
        createPracticalInformationDto
      );
      const localVarPath = `/assets/{assetId}/practical-information/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPracticalInformationDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PracticalInformationApi - functional programming interface
 * @export
 */
export const PracticalInformationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PracticalInformationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Attach already-uploaded files to a practical information entry
     * @param {string} assetId
     * @param {string} id
     * @param {AddPracticalInformationAttachmentsDto} addPracticalInformationAttachmentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async practicalInformationControllerAddAttachments(
      assetId: string,
      id: string,
      addPracticalInformationAttachmentsDto: AddPracticalInformationAttachmentsDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalInformationDetailDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.practicalInformationControllerAddAttachments(
          assetId,
          id,
          addPracticalInformationAttachmentsDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'PracticalInformationApi.practicalInformationControllerAddAttachments'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create new practical information
     * @param {string} assetId
     * @param {CreatePracticalInformationDto} createPracticalInformationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async practicalInformationControllerCreate(
      assetId: string,
      createPracticalInformationDto: CreatePracticalInformationDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalInformationDetailDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.practicalInformationControllerCreate(
          assetId,
          createPracticalInformationDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PracticalInformationApi.practicalInformationControllerCreate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all practical information for an asset
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {PracticalInformationControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async practicalInformationControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: PracticalInformationControllerFindAllOrderEnum,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPracticalInformationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.practicalInformationControllerFindAll(
          assetId,
          page,
          limit,
          orderBy,
          order,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PracticalInformationApi.practicalInformationControllerFindAll']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find practical information by ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async practicalInformationControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalInformationDetailDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.practicalInformationControllerFindOne(assetId, id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PracticalInformationApi.practicalInformationControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Soft delete practical information by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async practicalInformationControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.practicalInformationControllerRemove(id, assetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PracticalInformationApi.practicalInformationControllerRemove']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Detach a file from a practical information entry
     * @param {string} assetId
     * @param {string} id
     * @param {string} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async practicalInformationControllerRemoveAttachment(
      assetId: string,
      id: string,
      attachmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.practicalInformationControllerRemoveAttachment(
          assetId,
          id,
          attachmentId,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'PracticalInformationApi.practicalInformationControllerRemoveAttachment'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update existing practical information
     * @param {string} id
     * @param {string} assetId
     * @param {CreatePracticalInformationDto} createPracticalInformationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async practicalInformationControllerUpdate(
      id: string,
      assetId: string,
      createPracticalInformationDto: CreatePracticalInformationDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalInformationDetailDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.practicalInformationControllerUpdate(
          id,
          assetId,
          createPracticalInformationDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PracticalInformationApi.practicalInformationControllerUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PracticalInformationApi - factory interface
 * @export
 */
export const PracticalInformationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PracticalInformationApiFp(configuration);
  return {
    /**
     *
     * @summary Attach already-uploaded files to a practical information entry
     * @param {string} assetId
     * @param {string} id
     * @param {AddPracticalInformationAttachmentsDto} addPracticalInformationAttachmentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerAddAttachments(
      assetId: string,
      id: string,
      addPracticalInformationAttachmentsDto: AddPracticalInformationAttachmentsDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PracticalInformationDetailDto> {
      return localVarFp
        .practicalInformationControllerAddAttachments(
          assetId,
          id,
          addPracticalInformationAttachmentsDto,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create new practical information
     * @param {string} assetId
     * @param {CreatePracticalInformationDto} createPracticalInformationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerCreate(
      assetId: string,
      createPracticalInformationDto: CreatePracticalInformationDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PracticalInformationDetailDto> {
      return localVarFp
        .practicalInformationControllerCreate(assetId, createPracticalInformationDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all practical information for an asset
     * @param {string} assetId
     * @param {number} [page] Page number
     * @param {number} [limit] Items per page
     * @param {string} [orderBy] Champ de tri
     * @param {PracticalInformationControllerFindAllOrderEnum} [order] Ordre de tri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerFindAll(
      assetId: string,
      page?: number,
      limit?: number,
      orderBy?: string,
      order?: PracticalInformationControllerFindAllOrderEnum,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedPracticalInformationDto> {
      return localVarFp
        .practicalInformationControllerFindAll(assetId, page, limit, orderBy, order, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find practical information by ID
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PracticalInformationDetailDto> {
      return localVarFp
        .practicalInformationControllerFindOne(assetId, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Soft delete practical information by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .practicalInformationControllerRemove(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Detach a file from a practical information entry
     * @param {string} assetId
     * @param {string} id
     * @param {string} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerRemoveAttachment(
      assetId: string,
      id: string,
      attachmentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .practicalInformationControllerRemoveAttachment(assetId, id, attachmentId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update existing practical information
     * @param {string} id
     * @param {string} assetId
     * @param {CreatePracticalInformationDto} createPracticalInformationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    practicalInformationControllerUpdate(
      id: string,
      assetId: string,
      createPracticalInformationDto: CreatePracticalInformationDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PracticalInformationDetailDto> {
      return localVarFp
        .practicalInformationControllerUpdate(id, assetId, createPracticalInformationDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PracticalInformationApi - object-oriented interface
 * @export
 * @class PracticalInformationApi
 * @extends {BaseAPI}
 */
export class PracticalInformationApi extends BaseAPI {
  /**
   *
   * @summary Attach already-uploaded files to a practical information entry
   * @param {string} assetId
   * @param {string} id
   * @param {AddPracticalInformationAttachmentsDto} addPracticalInformationAttachmentsDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PracticalInformationApi
   */
  public practicalInformationControllerAddAttachments(
    assetId: string,
    id: string,
    addPracticalInformationAttachmentsDto: AddPracticalInformationAttachmentsDto,
    options?: RawAxiosRequestConfig
  ) {
    return PracticalInformationApiFp(this.configuration)
      .practicalInformationControllerAddAttachments(
        assetId,
        id,
        addPracticalInformationAttachmentsDto,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create new practical information
   * @param {string} assetId
   * @param {CreatePracticalInformationDto} createPracticalInformationDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PracticalInformationApi
   */
  public practicalInformationControllerCreate(
    assetId: string,
    createPracticalInformationDto: CreatePracticalInformationDto,
    options?: RawAxiosRequestConfig
  ) {
    return PracticalInformationApiFp(this.configuration)
      .practicalInformationControllerCreate(assetId, createPracticalInformationDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all practical information for an asset
   * @param {string} assetId
   * @param {number} [page] Page number
   * @param {number} [limit] Items per page
   * @param {string} [orderBy] Champ de tri
   * @param {PracticalInformationControllerFindAllOrderEnum} [order] Ordre de tri
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PracticalInformationApi
   */
  public practicalInformationControllerFindAll(
    assetId: string,
    page?: number,
    limit?: number,
    orderBy?: string,
    order?: PracticalInformationControllerFindAllOrderEnum,
    options?: RawAxiosRequestConfig
  ) {
    return PracticalInformationApiFp(this.configuration)
      .practicalInformationControllerFindAll(assetId, page, limit, orderBy, order, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find practical information by ID
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PracticalInformationApi
   */
  public practicalInformationControllerFindOne(
    assetId: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return PracticalInformationApiFp(this.configuration)
      .practicalInformationControllerFindOne(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Soft delete practical information by ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PracticalInformationApi
   */
  public practicalInformationControllerRemove(
    id: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return PracticalInformationApiFp(this.configuration)
      .practicalInformationControllerRemove(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Detach a file from a practical information entry
   * @param {string} assetId
   * @param {string} id
   * @param {string} attachmentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PracticalInformationApi
   */
  public practicalInformationControllerRemoveAttachment(
    assetId: string,
    id: string,
    attachmentId: string,
    options?: RawAxiosRequestConfig
  ) {
    return PracticalInformationApiFp(this.configuration)
      .practicalInformationControllerRemoveAttachment(assetId, id, attachmentId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update existing practical information
   * @param {string} id
   * @param {string} assetId
   * @param {CreatePracticalInformationDto} createPracticalInformationDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PracticalInformationApi
   */
  public practicalInformationControllerUpdate(
    id: string,
    assetId: string,
    createPracticalInformationDto: CreatePracticalInformationDto,
    options?: RawAxiosRequestConfig
  ) {
    return PracticalInformationApiFp(this.configuration)
      .practicalInformationControllerUpdate(id, assetId, createPracticalInformationDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const PracticalInformationControllerFindAllOrderEnum = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;
export type PracticalInformationControllerFindAllOrderEnum =
  (typeof PracticalInformationControllerFindAllOrderEnum)[keyof typeof PracticalInformationControllerFindAllOrderEnum];

/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Mode contributeur : tout membre pouvant uploader des fichiers peut ajouter des PJ à un projet existant, sans avoir le droit de modifier le reste du projet.
     * @summary Add attachments to a project (any member with file upload permission)
     * @param {string} id
     * @param {string} assetId
     * @param {AddProjectAttachmentsDto} addProjectAttachmentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerAddAttachments: async (
      id: string,
      assetId: string,
      addProjectAttachmentsDto: AddProjectAttachmentsDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerAddAttachments', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerAddAttachments', 'assetId', assetId);
      // verify required parameter 'addProjectAttachmentsDto' is not null or undefined
      assertParamExists(
        'projectsControllerAddAttachments',
        'addProjectAttachmentsDto',
        addProjectAttachmentsDto
      );
      const localVarPath = `/assets/{assetId}/projects/{id}/attachments`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addProjectAttachmentsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new project
     * @param {string} assetId
     * @param {CreateProjectDto} createProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerCreate: async (
      assetId: string,
      createProjectDto: CreateProjectDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerCreate', 'assetId', assetId);
      // verify required parameter 'createProjectDto' is not null or undefined
      assertParamExists('projectsControllerCreate', 'createProjectDto', createProjectDto);
      const localVarPath = `/assets/{assetId}/projects`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createProjectDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a comment on a project
     * @param {string} id
     * @param {string} assetId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerCreateComment: async (
      id: string,
      assetId: string,
      createCommentDto: CreateCommentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerCreateComment', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerCreateComment', 'assetId', assetId);
      // verify required parameter 'createCommentDto' is not null or undefined
      assertParamExists('projectsControllerCreateComment', 'createCommentDto', createCommentDto);
      const localVarPath = `/assets/{assetId}/projects/{id}/comments`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCommentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Edit a comment on a project
     * @param {string} id
     * @param {string} commentId
     * @param {string} assetId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerEditComment: async (
      id: string,
      commentId: string,
      assetId: string,
      createCommentDto: CreateCommentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerEditComment', 'id', id);
      // verify required parameter 'commentId' is not null or undefined
      assertParamExists('projectsControllerEditComment', 'commentId', commentId);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerEditComment', 'assetId', assetId);
      // verify required parameter 'createCommentDto' is not null or undefined
      assertParamExists('projectsControllerEditComment', 'createCommentDto', createCommentDto);
      const localVarPath = `/assets/{assetId}/projects/{id}/comments/{commentId}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'commentId'}}`, encodeURIComponent(String(commentId)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCommentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all projects for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerFindAll: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/projects`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single project by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/projects/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Like a project
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerLike: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerLike', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerLike', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/projects/{id}/like`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List the comments of a project
     * @param {string} id
     * @param {string} assetId
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerListComments: async (
      id: string,
      assetId: string,
      first?: number,
      after?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerListComments', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerListComments', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/projects/{id}/comments`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (first !== undefined) {
        localVarQueryParameter['first'] = first;
      }

      if (after !== undefined) {
        localVarQueryParameter['after'] = after;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a project by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerRemove: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerRemove', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerRemove', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/projects/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a comment from a project
     * @param {string} id
     * @param {string} commentId
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerRemoveComment: async (
      id: string,
      commentId: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerRemoveComment', 'id', id);
      // verify required parameter 'commentId' is not null or undefined
      assertParamExists('projectsControllerRemoveComment', 'commentId', commentId);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerRemoveComment', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/projects/{id}/comments/{commentId}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'commentId'}}`, encodeURIComponent(String(commentId)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unlike a project
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerUnlike: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerUnlike', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerUnlike', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/projects/{id}/like`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a project by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateProjectDto} updateProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerUpdate: async (
      id: string,
      assetId: string,
      updateProjectDto: UpdateProjectDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerUpdate', 'assetId', assetId);
      // verify required parameter 'updateProjectDto' is not null or undefined
      assertParamExists('projectsControllerUpdate', 'updateProjectDto', updateProjectDto);
      const localVarPath = `/assets/{assetId}/projects/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateProjectDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Vote on a project
     * @param {string} id
     * @param {string} assetId
     * @param {VoteProjectDto} voteProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerVote: async (
      id: string,
      assetId: string,
      voteProjectDto: VoteProjectDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('projectsControllerVote', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('projectsControllerVote', 'assetId', assetId);
      // verify required parameter 'voteProjectDto' is not null or undefined
      assertParamExists('projectsControllerVote', 'voteProjectDto', voteProjectDto);
      const localVarPath = `/assets/{assetId}/projects/{id}/vote`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        voteProjectDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration);
  return {
    /**
     * Mode contributeur : tout membre pouvant uploader des fichiers peut ajouter des PJ à un projet existant, sans avoir le droit de modifier le reste du projet.
     * @summary Add attachments to a project (any member with file upload permission)
     * @param {string} id
     * @param {string} assetId
     * @param {AddProjectAttachmentsDto} addProjectAttachmentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerAddAttachments(
      id: string,
      assetId: string,
      addProjectAttachmentsDto: AddProjectAttachmentsDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerAddAttachments(
        id,
        assetId,
        addProjectAttachmentsDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerAddAttachments']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new project
     * @param {string} assetId
     * @param {CreateProjectDto} createProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerCreate(
      assetId: string,
      createProjectDto: CreateProjectDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerCreate(
        assetId,
        createProjectDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a comment on a project
     * @param {string} id
     * @param {string} assetId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerCreateComment(
      id: string,
      assetId: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerCreateComment(
        id,
        assetId,
        createCommentDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerCreateComment']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Edit a comment on a project
     * @param {string} id
     * @param {string} commentId
     * @param {string} assetId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerEditComment(
      id: string,
      commentId: string,
      assetId: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerEditComment(
        id,
        commentId,
        assetId,
        createCommentDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerEditComment']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all projects for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerFindAll(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerFindAll']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single project by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerFindOne(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerFindOne']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Like a project
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerLike(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerLike(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerLike']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List the comments of a project
     * @param {string} id
     * @param {string} assetId
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerListComments(
      id: string,
      assetId: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommentsDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerListComments(
        id,
        assetId,
        first,
        after,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerListComments']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a project by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerRemove(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerRemove']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a comment from a project
     * @param {string} id
     * @param {string} commentId
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerRemoveComment(
      id: string,
      commentId: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerRemoveComment(
        id,
        commentId,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerRemoveComment']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Unlike a project
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerUnlike(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerUnlike(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerUnlike']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a project by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateProjectDto} updateProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerUpdate(
      id: string,
      assetId: string,
      updateProjectDto: UpdateProjectDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerUpdate(
        id,
        assetId,
        updateProjectDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Vote on a project
     * @param {string} id
     * @param {string} assetId
     * @param {VoteProjectDto} voteProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectsControllerVote(
      id: string,
      assetId: string,
      voteProjectDto: VoteProjectDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.projectsControllerVote(
        id,
        assetId,
        voteProjectDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ProjectsApi.projectsControllerVote']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectsApiFp(configuration);
  return {
    /**
     * Mode contributeur : tout membre pouvant uploader des fichiers peut ajouter des PJ à un projet existant, sans avoir le droit de modifier le reste du projet.
     * @summary Add attachments to a project (any member with file upload permission)
     * @param {string} id
     * @param {string} assetId
     * @param {AddProjectAttachmentsDto} addProjectAttachmentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerAddAttachments(
      id: string,
      assetId: string,
      addProjectAttachmentsDto: AddProjectAttachmentsDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectDto> {
      return localVarFp
        .projectsControllerAddAttachments(id, assetId, addProjectAttachmentsDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new project
     * @param {string} assetId
     * @param {CreateProjectDto} createProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerCreate(
      assetId: string,
      createProjectDto: CreateProjectDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectDto> {
      return localVarFp
        .projectsControllerCreate(assetId, createProjectDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create a comment on a project
     * @param {string} id
     * @param {string} assetId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerCreateComment(
      id: string,
      assetId: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommentDto> {
      return localVarFp
        .projectsControllerCreateComment(id, assetId, createCommentDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Edit a comment on a project
     * @param {string} id
     * @param {string} commentId
     * @param {string} assetId
     * @param {CreateCommentDto} createCommentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerEditComment(
      id: string,
      commentId: string,
      assetId: string,
      createCommentDto: CreateCommentDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CommentDto> {
      return localVarFp
        .projectsControllerEditComment(id, commentId, assetId, createCommentDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all projects for an asset
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerFindAll(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ProjectDto>> {
      return localVarFp
        .projectsControllerFindAll(assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single project by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectDto> {
      return localVarFp
        .projectsControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Like a project
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerLike(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .projectsControllerLike(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary List the comments of a project
     * @param {string} id
     * @param {string} assetId
     * @param {number} [first]
     * @param {string} [after]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerListComments(
      id: string,
      assetId: string,
      first?: number,
      after?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PaginatedCommentsDto> {
      return localVarFp
        .projectsControllerListComments(id, assetId, first, after, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a project by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .projectsControllerRemove(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a comment from a project
     * @param {string} id
     * @param {string} commentId
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerRemoveComment(
      id: string,
      commentId: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .projectsControllerRemoveComment(id, commentId, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Unlike a project
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerUnlike(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .projectsControllerUnlike(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a project by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateProjectDto} updateProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerUpdate(
      id: string,
      assetId: string,
      updateProjectDto: UpdateProjectDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProjectDto> {
      return localVarFp
        .projectsControllerUpdate(id, assetId, updateProjectDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Vote on a project
     * @param {string} id
     * @param {string} assetId
     * @param {VoteProjectDto} voteProjectDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectsControllerVote(
      id: string,
      assetId: string,
      voteProjectDto: VoteProjectDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .projectsControllerVote(id, assetId, voteProjectDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
  /**
   * Mode contributeur : tout membre pouvant uploader des fichiers peut ajouter des PJ à un projet existant, sans avoir le droit de modifier le reste du projet.
   * @summary Add attachments to a project (any member with file upload permission)
   * @param {string} id
   * @param {string} assetId
   * @param {AddProjectAttachmentsDto} addProjectAttachmentsDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerAddAttachments(
    id: string,
    assetId: string,
    addProjectAttachmentsDto: AddProjectAttachmentsDto,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerAddAttachments(id, assetId, addProjectAttachmentsDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new project
   * @param {string} assetId
   * @param {CreateProjectDto} createProjectDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerCreate(
    assetId: string,
    createProjectDto: CreateProjectDto,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerCreate(assetId, createProjectDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a comment on a project
   * @param {string} id
   * @param {string} assetId
   * @param {CreateCommentDto} createCommentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerCreateComment(
    id: string,
    assetId: string,
    createCommentDto: CreateCommentDto,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerCreateComment(id, assetId, createCommentDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Edit a comment on a project
   * @param {string} id
   * @param {string} commentId
   * @param {string} assetId
   * @param {CreateCommentDto} createCommentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerEditComment(
    id: string,
    commentId: string,
    assetId: string,
    createCommentDto: CreateCommentDto,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerEditComment(id, commentId, assetId, createCommentDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all projects for an asset
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerFindAll(assetId: string, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerFindAll(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single project by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerFindOne(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Like a project
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerLike(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerLike(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List the comments of a project
   * @param {string} id
   * @param {string} assetId
   * @param {number} [first]
   * @param {string} [after]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerListComments(
    id: string,
    assetId: string,
    first?: number,
    after?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerListComments(id, assetId, first, after, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a project by ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerRemove(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerRemove(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a comment from a project
   * @param {string} id
   * @param {string} commentId
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerRemoveComment(
    id: string,
    commentId: string,
    assetId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerRemoveComment(id, commentId, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Unlike a project
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerUnlike(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerUnlike(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a project by ID
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateProjectDto} updateProjectDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerUpdate(
    id: string,
    assetId: string,
    updateProjectDto: UpdateProjectDto,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerUpdate(id, assetId, updateProjectDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Vote on a project
   * @param {string} id
   * @param {string} assetId
   * @param {VoteProjectDto} voteProjectDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public projectsControllerVote(
    id: string,
    assetId: string,
    voteProjectDto: VoteProjectDto,
    options?: RawAxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .projectsControllerVote(id, assetId, voteProjectDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PublicAnnouncementsApi - axios parameter creator
 * @export
 */
export const PublicAnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get the currently active announcement, if any
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicAnnouncementsControllerFindActive: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/public/announcements/active`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PublicAnnouncementsApi - functional programming interface
 * @export
 */
export const PublicAnnouncementsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PublicAnnouncementsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get the currently active announcement, if any
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicAnnouncementsControllerFindActive(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicAnnouncementDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.publicAnnouncementsControllerFindActive(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PublicAnnouncementsApi.publicAnnouncementsControllerFindActive']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PublicAnnouncementsApi - factory interface
 * @export
 */
export const PublicAnnouncementsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PublicAnnouncementsApiFp(configuration);
  return {
    /**
     *
     * @summary Get the currently active announcement, if any
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicAnnouncementsControllerFindActive(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PublicAnnouncementDto> {
      return localVarFp
        .publicAnnouncementsControllerFindActive(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PublicAnnouncementsApi - object-oriented interface
 * @export
 * @class PublicAnnouncementsApi
 * @extends {BaseAPI}
 */
export class PublicAnnouncementsApi extends BaseAPI {
  /**
   *
   * @summary Get the currently active announcement, if any
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicAnnouncementsApi
   */
  public publicAnnouncementsControllerFindActive(options?: RawAxiosRequestConfig) {
    return PublicAnnouncementsApiFp(this.configuration)
      .publicAnnouncementsControllerFindActive(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * PublicExportsApi - axios parameter creator
 * @export
 */
export const PublicExportsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a public checklist submission for a checklist from a public export
     * @param {string} token
     * @param {string} id
     * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicChecklistSubmissionsControllerCreatePublicChecklistSubmission: async (
      token: string,
      id: string,
      createChecklistSubmissionDto: CreateChecklistSubmissionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists(
        'publicChecklistSubmissionsControllerCreatePublicChecklistSubmission',
        'token',
        token
      );
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        'publicChecklistSubmissionsControllerCreatePublicChecklistSubmission',
        'id',
        id
      );
      // verify required parameter 'createChecklistSubmissionDto' is not null or undefined
      assertParamExists(
        'publicChecklistSubmissionsControllerCreatePublicChecklistSubmission',
        'createChecklistSubmissionDto',
        createChecklistSubmissionDto
      );
      const localVarPath = `/public/exports/{token}/checklists/{id}/submissions`
        .replace(`{${'token'}}`, encodeURIComponent(String(token)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createChecklistSubmissionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get details of a checklist from a public export
     * @param {string} token
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicChecklistSubmissionsControllerGetPublicChecklistById: async (
      token: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists(
        'publicChecklistSubmissionsControllerGetPublicChecklistById',
        'token',
        token
      );
      // verify required parameter 'id' is not null or undefined
      assertParamExists('publicChecklistSubmissionsControllerGetPublicChecklistById', 'id', id);
      const localVarPath = `/public/exports/{token}/checklists/{id}`
        .replace(`{${'token'}}`, encodeURIComponent(String(token)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a specific entity detail from a public export
     * @param {string} token
     * @param {string} id
     * @param {string} [startDate] Start date for filtering events (ISO format).
     * @param {string} [endDate] End date for filtering events (ISO format).
     * @param {string} [timezone] Timezone for date calculations (default: UTC).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerFindEntityById: async (
      token: string,
      id: string,
      startDate?: string,
      endDate?: string,
      timezone?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('publicExportsControllerFindEntityById', 'token', token);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('publicExportsControllerFindEntityById', 'id', id);
      const localVarPath = `/public/exports/{token}/entities/{id}`
        .replace(`{${'token'}}`, encodeURIComponent(String(token)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (timezone !== undefined) {
        localVarQueryParameter['timezone'] = timezone;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get public export metadata (without entities)
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerFindMetadata: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('publicExportsControllerFindMetadata', 'token', token);
      const localVarPath = `/public/exports/{token}/metadata`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get public export with its associated entities
     * @param {string} token
     * @param {string} [startDate] Start date for filtering events (ISO format).
     * @param {string} [endDate] End date for filtering events (ISO format).
     * @param {string} [timezone] Timezone for date calculations (default: UTC).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerFindOne: async (
      token: string,
      startDate?: string,
      endDate?: string,
      timezone?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('publicExportsControllerFindOne', 'token', token);
      const localVarPath = `/public/exports/{token}`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] = startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] = endDate;
      }

      if (timezone !== undefined) {
        localVarQueryParameter['timezone'] = timezone;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get iCal feed for a public event export
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerGetCalendarFeed: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('publicExportsControllerGetCalendarFeed', 'token', token);
      const localVarPath = `/public/exports/{token}/calendar.ics`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PublicExportsApi - functional programming interface
 * @export
 */
export const PublicExportsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PublicExportsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a public checklist submission for a checklist from a public export
     * @param {string} token
     * @param {string} id
     * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicChecklistSubmissionsControllerCreatePublicChecklistSubmission(
      token: string,
      id: string,
      createChecklistSubmissionDto: CreateChecklistSubmissionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistSubmissionDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.publicChecklistSubmissionsControllerCreatePublicChecklistSubmission(
          token,
          id,
          createChecklistSubmissionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'PublicExportsApi.publicChecklistSubmissionsControllerCreatePublicChecklistSubmission'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get details of a checklist from a public export
     * @param {string} token
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicChecklistSubmissionsControllerGetPublicChecklistById(
      token: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChecklistWithItemsDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.publicChecklistSubmissionsControllerGetPublicChecklistById(
          token,
          id,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'PublicExportsApi.publicChecklistSubmissionsControllerGetPublicChecklistById'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a specific entity detail from a public export
     * @param {string} token
     * @param {string} id
     * @param {string} [startDate] Start date for filtering events (ISO format).
     * @param {string} [endDate] End date for filtering events (ISO format).
     * @param {string} [timezone] Timezone for date calculations (default: UTC).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicExportsControllerFindEntityById(
      token: string,
      id: string,
      startDate?: string,
      endDate?: string,
      timezone?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.publicExportsControllerFindEntityById(
          token,
          id,
          startDate,
          endDate,
          timezone,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PublicExportsApi.publicExportsControllerFindEntityById']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get public export metadata (without entities)
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicExportsControllerFindMetadata(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityExportDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.publicExportsControllerFindMetadata(
        token,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PublicExportsApi.publicExportsControllerFindMetadata']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get public export with its associated entities
     * @param {string} token
     * @param {string} [startDate] Start date for filtering events (ISO format).
     * @param {string} [endDate] End date for filtering events (ISO format).
     * @param {string} [timezone] Timezone for date calculations (default: UTC).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicExportsControllerFindOne(
      token: string,
      startDate?: string,
      endDate?: string,
      timezone?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportWithEntitiesDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.publicExportsControllerFindOne(
        token,
        startDate,
        endDate,
        timezone,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PublicExportsApi.publicExportsControllerFindOne']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get iCal feed for a public event export
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async publicExportsControllerGetCalendarFeed(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.publicExportsControllerGetCalendarFeed(token, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PublicExportsApi.publicExportsControllerGetCalendarFeed']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PublicExportsApi - factory interface
 * @export
 */
export const PublicExportsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PublicExportsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a public checklist submission for a checklist from a public export
     * @param {string} token
     * @param {string} id
     * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicChecklistSubmissionsControllerCreatePublicChecklistSubmission(
      token: string,
      id: string,
      createChecklistSubmissionDto: CreateChecklistSubmissionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistSubmissionDto> {
      return localVarFp
        .publicChecklistSubmissionsControllerCreatePublicChecklistSubmission(
          token,
          id,
          createChecklistSubmissionDto,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get details of a checklist from a public export
     * @param {string} token
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicChecklistSubmissionsControllerGetPublicChecklistById(
      token: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ChecklistWithItemsDto> {
      return localVarFp
        .publicChecklistSubmissionsControllerGetPublicChecklistById(token, id, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get a specific entity detail from a public export
     * @param {string} token
     * @param {string} id
     * @param {string} [startDate] Start date for filtering events (ISO format).
     * @param {string} [endDate] End date for filtering events (ISO format).
     * @param {string} [timezone] Timezone for date calculations (default: UTC).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerFindEntityById(
      token: string,
      id: string,
      startDate?: string,
      endDate?: string,
      timezone?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .publicExportsControllerFindEntityById(token, id, startDate, endDate, timezone, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get public export metadata (without entities)
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerFindMetadata(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<EntityExportDto> {
      return localVarFp
        .publicExportsControllerFindMetadata(token, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get public export with its associated entities
     * @param {string} token
     * @param {string} [startDate] Start date for filtering events (ISO format).
     * @param {string} [endDate] End date for filtering events (ISO format).
     * @param {string} [timezone] Timezone for date calculations (default: UTC).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerFindOne(
      token: string,
      startDate?: string,
      endDate?: string,
      timezone?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ExportWithEntitiesDto> {
      return localVarFp
        .publicExportsControllerFindOne(token, startDate, endDate, timezone, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get iCal feed for a public event export
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    publicExportsControllerGetCalendarFeed(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .publicExportsControllerGetCalendarFeed(token, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * PublicExportsApi - object-oriented interface
 * @export
 * @class PublicExportsApi
 * @extends {BaseAPI}
 */
export class PublicExportsApi extends BaseAPI {
  /**
   *
   * @summary Create a public checklist submission for a checklist from a public export
   * @param {string} token
   * @param {string} id
   * @param {CreateChecklistSubmissionDto} createChecklistSubmissionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicExportsApi
   */
  public publicChecklistSubmissionsControllerCreatePublicChecklistSubmission(
    token: string,
    id: string,
    createChecklistSubmissionDto: CreateChecklistSubmissionDto,
    options?: RawAxiosRequestConfig
  ) {
    return PublicExportsApiFp(this.configuration)
      .publicChecklistSubmissionsControllerCreatePublicChecklistSubmission(
        token,
        id,
        createChecklistSubmissionDto,
        options
      )
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get details of a checklist from a public export
   * @param {string} token
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicExportsApi
   */
  public publicChecklistSubmissionsControllerGetPublicChecklistById(
    token: string,
    id: string,
    options?: RawAxiosRequestConfig
  ) {
    return PublicExportsApiFp(this.configuration)
      .publicChecklistSubmissionsControllerGetPublicChecklistById(token, id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a specific entity detail from a public export
   * @param {string} token
   * @param {string} id
   * @param {string} [startDate] Start date for filtering events (ISO format).
   * @param {string} [endDate] End date for filtering events (ISO format).
   * @param {string} [timezone] Timezone for date calculations (default: UTC).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicExportsApi
   */
  public publicExportsControllerFindEntityById(
    token: string,
    id: string,
    startDate?: string,
    endDate?: string,
    timezone?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PublicExportsApiFp(this.configuration)
      .publicExportsControllerFindEntityById(token, id, startDate, endDate, timezone, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get public export metadata (without entities)
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicExportsApi
   */
  public publicExportsControllerFindMetadata(token: string, options?: RawAxiosRequestConfig) {
    return PublicExportsApiFp(this.configuration)
      .publicExportsControllerFindMetadata(token, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get public export with its associated entities
   * @param {string} token
   * @param {string} [startDate] Start date for filtering events (ISO format).
   * @param {string} [endDate] End date for filtering events (ISO format).
   * @param {string} [timezone] Timezone for date calculations (default: UTC).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicExportsApi
   */
  public publicExportsControllerFindOne(
    token: string,
    startDate?: string,
    endDate?: string,
    timezone?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PublicExportsApiFp(this.configuration)
      .publicExportsControllerFindOne(token, startDate, endDate, timezone, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get iCal feed for a public event export
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PublicExportsApi
   */
  public publicExportsControllerGetCalendarFeed(token: string, options?: RawAxiosRequestConfig) {
    return PublicExportsApiFp(this.configuration)
      .publicExportsControllerGetCalendarFeed(token, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new task
     * @param {string} assetId
     * @param {CreateTaskDto} createTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerCreate: async (
      assetId: string,
      createTaskDto: CreateTaskDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('tasksControllerCreate', 'assetId', assetId);
      // verify required parameter 'createTaskDto' is not null or undefined
      assertParamExists('tasksControllerCreate', 'createTaskDto', createTaskDto);
      const localVarPath = `/assets/{assetId}/tasks`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTaskDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find all tasks for an asset
     * @param {string} assetId
     * @param {TasksControllerFindAllRelatedEntityTypeEnum} [relatedEntityType] Filter tasks by related entity type
     * @param {string} [relatedEntityId] Filter tasks by related entity ID
     * @param {boolean} [requiresOnSite] Filter to only tasks that require being on site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerFindAll: async (
      assetId: string,
      relatedEntityType?: TasksControllerFindAllRelatedEntityTypeEnum,
      relatedEntityId?: string,
      requiresOnSite?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('tasksControllerFindAll', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/tasks`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (relatedEntityType !== undefined) {
        localVarQueryParameter['relatedEntityType'] = relatedEntityType;
      }

      if (relatedEntityId !== undefined) {
        localVarQueryParameter['relatedEntityId'] = relatedEntityId;
      }

      if (requiresOnSite !== undefined) {
        localVarQueryParameter['requiresOnSite'] = requiresOnSite;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find a single task by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerFindOne: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksControllerFindOne', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('tasksControllerFindOne', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/tasks/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a task by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerRemove: async (
      id: string,
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksControllerRemove', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('tasksControllerRemove', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/tasks/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a task by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateTaskDto} updateTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerUpdate: async (
      id: string,
      assetId: string,
      updateTaskDto: UpdateTaskDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tasksControllerUpdate', 'id', id);
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('tasksControllerUpdate', 'assetId', assetId);
      // verify required parameter 'updateTaskDto' is not null or undefined
      assertParamExists('tasksControllerUpdate', 'updateTaskDto', updateTaskDto);
      const localVarPath = `/assets/{assetId}/tasks/{id}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateTaskDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new task
     * @param {string} assetId
     * @param {CreateTaskDto} createTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksControllerCreate(
      assetId: string,
      createTaskDto: CreateTaskDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksControllerCreate(
        assetId,
        createTaskDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TasksApi.tasksControllerCreate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find all tasks for an asset
     * @param {string} assetId
     * @param {TasksControllerFindAllRelatedEntityTypeEnum} [relatedEntityType] Filter tasks by related entity type
     * @param {string} [relatedEntityId] Filter tasks by related entity ID
     * @param {boolean} [requiresOnSite] Filter to only tasks that require being on site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksControllerFindAll(
      assetId: string,
      relatedEntityType?: TasksControllerFindAllRelatedEntityTypeEnum,
      relatedEntityId?: string,
      requiresOnSite?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksControllerFindAll(
        assetId,
        relatedEntityType,
        relatedEntityId,
        requiresOnSite,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TasksApi.tasksControllerFindAll']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find a single task by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksControllerFindOne(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TasksApi.tasksControllerFindOne']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a task by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksControllerRemove(
        id,
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TasksApi.tasksControllerRemove']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a task by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateTaskDto} updateTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tasksControllerUpdate(
      id: string,
      assetId: string,
      updateTaskDto: UpdateTaskDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tasksControllerUpdate(
        id,
        assetId,
        updateTaskDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TasksApi.tasksControllerUpdate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TasksApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new task
     * @param {string} assetId
     * @param {CreateTaskDto} createTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerCreate(
      assetId: string,
      createTaskDto: CreateTaskDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TaskDto> {
      return localVarFp
        .tasksControllerCreate(assetId, createTaskDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find all tasks for an asset
     * @param {string} assetId
     * @param {TasksControllerFindAllRelatedEntityTypeEnum} [relatedEntityType] Filter tasks by related entity type
     * @param {string} [relatedEntityId] Filter tasks by related entity ID
     * @param {boolean} [requiresOnSite] Filter to only tasks that require being on site
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerFindAll(
      assetId: string,
      relatedEntityType?: TasksControllerFindAllRelatedEntityTypeEnum,
      relatedEntityId?: string,
      requiresOnSite?: boolean,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<TaskDto>> {
      return localVarFp
        .tasksControllerFindAll(
          assetId,
          relatedEntityType,
          relatedEntityId,
          requiresOnSite,
          options
        )
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Find a single task by its ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerFindOne(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TaskDto> {
      return localVarFp
        .tasksControllerFindOne(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a task by ID
     * @param {string} id
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerRemove(
      id: string,
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .tasksControllerRemove(id, assetId, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update a task by ID
     * @param {string} id
     * @param {string} assetId
     * @param {UpdateTaskDto} updateTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tasksControllerUpdate(
      id: string,
      assetId: string,
      updateTaskDto: UpdateTaskDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TaskDto> {
      return localVarFp
        .tasksControllerUpdate(id, assetId, updateTaskDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
  /**
   *
   * @summary Create a new task
   * @param {string} assetId
   * @param {CreateTaskDto} createTaskDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public tasksControllerCreate(
    assetId: string,
    createTaskDto: CreateTaskDto,
    options?: RawAxiosRequestConfig
  ) {
    return TasksApiFp(this.configuration)
      .tasksControllerCreate(assetId, createTaskDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find all tasks for an asset
   * @param {string} assetId
   * @param {TasksControllerFindAllRelatedEntityTypeEnum} [relatedEntityType] Filter tasks by related entity type
   * @param {string} [relatedEntityId] Filter tasks by related entity ID
   * @param {boolean} [requiresOnSite] Filter to only tasks that require being on site
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public tasksControllerFindAll(
    assetId: string,
    relatedEntityType?: TasksControllerFindAllRelatedEntityTypeEnum,
    relatedEntityId?: string,
    requiresOnSite?: boolean,
    options?: RawAxiosRequestConfig
  ) {
    return TasksApiFp(this.configuration)
      .tasksControllerFindAll(assetId, relatedEntityType, relatedEntityId, requiresOnSite, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find a single task by its ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public tasksControllerFindOne(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .tasksControllerFindOne(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a task by ID
   * @param {string} id
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public tasksControllerRemove(id: string, assetId: string, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .tasksControllerRemove(id, assetId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a task by ID
   * @param {string} id
   * @param {string} assetId
   * @param {UpdateTaskDto} updateTaskDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public tasksControllerUpdate(
    id: string,
    assetId: string,
    updateTaskDto: UpdateTaskDto,
    options?: RawAxiosRequestConfig
  ) {
    return TasksApiFp(this.configuration)
      .tasksControllerUpdate(id, assetId, updateTaskDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const TasksControllerFindAllRelatedEntityTypeEnum = {
  Project: 'project',
  Event: 'event',
  Expense: 'expense',
  Checklist: 'checklist',
  CommunityFeedItem: 'communityFeedItem',
} as const;
export type TasksControllerFindAllRelatedEntityTypeEnum =
  (typeof TasksControllerFindAllRelatedEntityTypeEnum)[keyof typeof TasksControllerFindAllRelatedEntityTypeEnum];

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Check if a push subscription belongs to the current user
     * @param {CheckPushSubscriptionDto} checkPushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerCheckPushSubscription: async (
      checkPushSubscriptionDto: CheckPushSubscriptionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'checkPushSubscriptionDto' is not null or undefined
      assertParamExists(
        'userControllerCheckPushSubscription',
        'checkPushSubscriptionDto',
        checkPushSubscriptionDto
      );
      const localVarPath = `/user/me/push-subscription/check`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkPushSubscriptionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a user\'s push notification subscription
     * @param {DeletePushSubscriptionDto} deletePushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerDeletePushSubscription: async (
      deletePushSubscriptionDto: DeletePushSubscriptionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'deletePushSubscriptionDto' is not null or undefined
      assertParamExists(
        'userControllerDeletePushSubscription',
        'deletePushSubscriptionDto',
        deletePushSubscriptionDto
      );
      const localVarPath = `/user/me/push-subscription`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePushSubscriptionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all pending tasks assigned to the current user across all assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerFindMyTasks: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/me/tasks`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the profile of the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerFindOne: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/user/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Marks the demo booking popup as seen for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerMarkDemoPopupSeen: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/me/demo-popup-seen`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create or update user\'s push notification subscription
     * @param {CreatePushSubscriptionDto} createPushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerSavePushSubscription: async (
      createPushSubscriptionDto: CreatePushSubscriptionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'createPushSubscriptionDto' is not null or undefined
      assertParamExists(
        'userControllerSavePushSubscription',
        'createPushSubscriptionDto',
        createPushSubscriptionDto
      );
      const localVarPath = `/user/me/push-subscription`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPushSubscriptionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Set or unset the favorite asset for the current user
     * @param {SetFavoriteAssetDto} setFavoriteAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerSetFavoriteAsset: async (
      setFavoriteAssetDto: SetFavoriteAssetDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'setFavoriteAssetDto' is not null or undefined
      assertParamExists(
        'userControllerSetFavoriteAsset',
        'setFavoriteAssetDto',
        setFavoriteAssetDto
      );
      const localVarPath = `/user/me/favorite-asset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        setFavoriteAssetDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update user consents (Terms of Use, Privacy Policy, Newsletter)
     * @param {UpdateUserConsentsDto} updateUserConsentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateConsents: async (
      updateUserConsentsDto: UpdateUserConsentsDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateUserConsentsDto' is not null or undefined
      assertParamExists(
        'userControllerUpdateConsents',
        'updateUserConsentsDto',
        updateUserConsentsDto
      );
      const localVarPath = `/user/me/consents`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserConsentsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset detail selection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetDetailSelectionDate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/me/ping/asset-detail-selection`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset name completion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetNameCompletionDate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/me/ping/asset-name-completion`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset onboarding invitation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetOnboardingInvitationDate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/me/ping/asset-onboarding-invitation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset type selection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetTypeSelectionDate: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/user/me/ping/asset-type-selection`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update user notification preferences
     * @param {UpdateNotificationPreferencesDto} updateNotificationPreferencesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateNotificationPreferences: async (
      updateNotificationPreferencesDto: UpdateNotificationPreferencesDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateNotificationPreferencesDto' is not null or undefined
      assertParamExists(
        'userControllerUpdateNotificationPreferences',
        'updateNotificationPreferencesDto',
        updateNotificationPreferencesDto
      );
      const localVarPath = `/user/me/notification-preferences`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateNotificationPreferencesDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload or update the user profile picture
     * @param {File} file The image file for the profile picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateProfilePicture: async (
      file: File,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('userControllerUpdateProfilePicture', 'file', file);
      const localVarPath = `/user/profile-picture`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update the profile of the currently authenticated user
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateUser: async (
      updateUserDto: UpdateUserDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateUserDto' is not null or undefined
      assertParamExists('userControllerUpdateUser', 'updateUserDto', updateUserDto);
      const localVarPath = `/user/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update user utm
     * @param {UpdateUserUtmDto} updateUserUtmDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateUserUtm: async (
      updateUserUtmDto: UpdateUserUtmDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateUserUtmDto' is not null or undefined
      assertParamExists('userControllerUpdateUserUtm', 'updateUserUtmDto', updateUserUtmDto);
      const localVarPath = `/user/me/utm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserUtmDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Check if a push subscription belongs to the current user
     * @param {CheckPushSubscriptionDto} checkPushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerCheckPushSubscription(
      checkPushSubscriptionDto: CheckPushSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushSubscriptionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCheckPushSubscription(
        checkPushSubscriptionDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerCheckPushSubscription']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a user\'s push notification subscription
     * @param {DeletePushSubscriptionDto} deletePushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerDeletePushSubscription(
      deletePushSubscriptionDto: DeletePushSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userControllerDeletePushSubscription(
          deletePushSubscriptionDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerDeletePushSubscription']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all pending tasks assigned to the current user across all assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerFindMyTasks(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MyTaskSummaryDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerFindMyTasks(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerFindMyTasks']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the profile of the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerFindOne(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithPrivateInfoDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerFindOne(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerFindOne']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Marks the demo booking popup as seen for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerMarkDemoPopupSeen(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userControllerMarkDemoPopupSeen(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerMarkDemoPopupSeen']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create or update user\'s push notification subscription
     * @param {CreatePushSubscriptionDto} createPushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerSavePushSubscription(
      createPushSubscriptionDto: CreatePushSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSavePushSubscription(
        createPushSubscriptionDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerSavePushSubscription']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Set or unset the favorite asset for the current user
     * @param {SetFavoriteAssetDto} setFavoriteAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerSetFavoriteAsset(
      setFavoriteAssetDto: SetFavoriteAssetDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithPrivateInfoDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSetFavoriteAsset(
        setFavoriteAssetDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerSetFavoriteAsset']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update user consents (Terms of Use, Privacy Policy, Newsletter)
     * @param {UpdateUserConsentsDto} updateUserConsentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateConsents(
      updateUserConsentsDto: UpdateUserConsentsDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithPrivateInfoDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateConsents(
        updateUserConsentsDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateConsents']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset detail selection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateLastAssetDetailSelectionDate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userControllerUpdateLastAssetDetailSelectionDate(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateLastAssetDetailSelectionDate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset name completion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateLastAssetNameCompletionDate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userControllerUpdateLastAssetNameCompletionDate(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateLastAssetNameCompletionDate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset onboarding invitation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateLastAssetOnboardingInvitationDate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userControllerUpdateLastAssetOnboardingInvitationDate(
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateLastAssetOnboardingInvitationDate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset type selection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateLastAssetTypeSelectionDate(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userControllerUpdateLastAssetTypeSelectionDate(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateLastAssetTypeSelectionDate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update user notification preferences
     * @param {UpdateNotificationPreferencesDto} updateNotificationPreferencesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateNotificationPreferences(
      updateNotificationPreferencesDto: UpdateNotificationPreferencesDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithPrivateInfoDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userControllerUpdateNotificationPreferences(
          updateNotificationPreferencesDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateNotificationPreferences']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Upload or update the user profile picture
     * @param {File} file The image file for the profile picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateProfilePicture(
      file: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfilePictureDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateProfilePicture(
        file,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateProfilePicture']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update the profile of the currently authenticated user
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateUser(
      updateUserDto: UpdateUserDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithPrivateInfoDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateUser(
        updateUserDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateUser']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update user utm
     * @param {UpdateUserUtmDto} updateUserUtmDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userControllerUpdateUserUtm(
      updateUserUtmDto: UpdateUserUtmDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdateUserUtm(
        updateUserUtmDto,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.userControllerUpdateUserUtm']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserApiFp(configuration);
  return {
    /**
     *
     * @summary Check if a push subscription belongs to the current user
     * @param {CheckPushSubscriptionDto} checkPushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerCheckPushSubscription(
      checkPushSubscriptionDto: CheckPushSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PushSubscriptionDto> {
      return localVarFp
        .userControllerCheckPushSubscription(checkPushSubscriptionDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a user\'s push notification subscription
     * @param {DeletePushSubscriptionDto} deletePushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerDeletePushSubscription(
      deletePushSubscriptionDto: DeletePushSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .userControllerDeletePushSubscription(deletePushSubscriptionDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get all pending tasks assigned to the current user across all assets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerFindMyTasks(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<MyTaskSummaryDto>> {
      return localVarFp
        .userControllerFindMyTasks(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Get the profile of the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerFindOne(options?: RawAxiosRequestConfig): AxiosPromise<UserWithPrivateInfoDto> {
      return localVarFp.userControllerFindOne(options).then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Marks the demo booking popup as seen for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerMarkDemoPopupSeen(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .userControllerMarkDemoPopupSeen(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Create or update user\'s push notification subscription
     * @param {CreatePushSubscriptionDto} createPushSubscriptionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerSavePushSubscription(
      createPushSubscriptionDto: CreatePushSubscriptionDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .userControllerSavePushSubscription(createPushSubscriptionDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Set or unset the favorite asset for the current user
     * @param {SetFavoriteAssetDto} setFavoriteAssetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerSetFavoriteAsset(
      setFavoriteAssetDto: SetFavoriteAssetDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserWithPrivateInfoDto> {
      return localVarFp
        .userControllerSetFavoriteAsset(setFavoriteAssetDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update user consents (Terms of Use, Privacy Policy, Newsletter)
     * @param {UpdateUserConsentsDto} updateUserConsentsDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateConsents(
      updateUserConsentsDto: UpdateUserConsentsDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserWithPrivateInfoDto> {
      return localVarFp
        .userControllerUpdateConsents(updateUserConsentsDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset detail selection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetDetailSelectionDate(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .userControllerUpdateLastAssetDetailSelectionDate(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset name completion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetNameCompletionDate(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .userControllerUpdateLastAssetNameCompletionDate(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset onboarding invitation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetOnboardingInvitationDate(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .userControllerUpdateLastAssetOnboardingInvitationDate(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Updates the timestamp for the user\'s last asset type selection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateLastAssetTypeSelectionDate(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .userControllerUpdateLastAssetTypeSelectionDate(options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update user notification preferences
     * @param {UpdateNotificationPreferencesDto} updateNotificationPreferencesDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateNotificationPreferences(
      updateNotificationPreferencesDto: UpdateNotificationPreferencesDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserWithPrivateInfoDto> {
      return localVarFp
        .userControllerUpdateNotificationPreferences(updateNotificationPreferencesDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Upload or update the user profile picture
     * @param {File} file The image file for the profile picture.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateProfilePicture(
      file: File,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ProfilePictureDto> {
      return localVarFp
        .userControllerUpdateProfilePicture(file, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update the profile of the currently authenticated user
     * @param {UpdateUserDto} updateUserDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateUser(
      updateUserDto: UpdateUserDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserWithPrivateInfoDto> {
      return localVarFp
        .userControllerUpdateUser(updateUserDto, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Update user utm
     * @param {UpdateUserUtmDto} updateUserUtmDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userControllerUpdateUserUtm(
      updateUserUtmDto: UpdateUserUtmDto,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UserDto> {
      return localVarFp
        .userControllerUpdateUserUtm(updateUserUtmDto, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   *
   * @summary Check if a push subscription belongs to the current user
   * @param {CheckPushSubscriptionDto} checkPushSubscriptionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerCheckPushSubscription(
    checkPushSubscriptionDto: CheckPushSubscriptionDto,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userControllerCheckPushSubscription(checkPushSubscriptionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a user\'s push notification subscription
   * @param {DeletePushSubscriptionDto} deletePushSubscriptionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerDeletePushSubscription(
    deletePushSubscriptionDto: DeletePushSubscriptionDto,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userControllerDeletePushSubscription(deletePushSubscriptionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all pending tasks assigned to the current user across all assets
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerFindMyTasks(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerFindMyTasks(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the profile of the currently authenticated user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerFindOne(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerFindOne(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Marks the demo booking popup as seen for the current user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerMarkDemoPopupSeen(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerMarkDemoPopupSeen(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create or update user\'s push notification subscription
   * @param {CreatePushSubscriptionDto} createPushSubscriptionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerSavePushSubscription(
    createPushSubscriptionDto: CreatePushSubscriptionDto,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userControllerSavePushSubscription(createPushSubscriptionDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Set or unset the favorite asset for the current user
   * @param {SetFavoriteAssetDto} setFavoriteAssetDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerSetFavoriteAsset(
    setFavoriteAssetDto: SetFavoriteAssetDto,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userControllerSetFavoriteAsset(setFavoriteAssetDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update user consents (Terms of Use, Privacy Policy, Newsletter)
   * @param {UpdateUserConsentsDto} updateUserConsentsDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateConsents(
    updateUserConsentsDto: UpdateUserConsentsDto,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userControllerUpdateConsents(updateUserConsentsDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Updates the timestamp for the user\'s last asset detail selection
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateLastAssetDetailSelectionDate(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerUpdateLastAssetDetailSelectionDate(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Updates the timestamp for the user\'s last asset name completion
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateLastAssetNameCompletionDate(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerUpdateLastAssetNameCompletionDate(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Updates the timestamp for the user\'s last asset onboarding invitation
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateLastAssetOnboardingInvitationDate(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerUpdateLastAssetOnboardingInvitationDate(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Updates the timestamp for the user\'s last asset type selection
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateLastAssetTypeSelectionDate(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerUpdateLastAssetTypeSelectionDate(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update user notification preferences
   * @param {UpdateNotificationPreferencesDto} updateNotificationPreferencesDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateNotificationPreferences(
    updateNotificationPreferencesDto: UpdateNotificationPreferencesDto,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userControllerUpdateNotificationPreferences(updateNotificationPreferencesDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Upload or update the user profile picture
   * @param {File} file The image file for the profile picture.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateProfilePicture(file: File, options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerUpdateProfilePicture(file, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update the profile of the currently authenticated user
   * @param {UpdateUserDto} updateUserDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateUser(updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userControllerUpdateUser(updateUserDto, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update user utm
   * @param {UpdateUserUtmDto} updateUserUtmDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userControllerUpdateUserUtm(
    updateUserUtmDto: UpdateUserUtmDto,
    options?: RawAxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userControllerUpdateUserUtm(updateUserUtmDto, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * VersionApi - axios parameter creator
 * @export
 */
export const VersionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    versionControllerGetVersion: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/version`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VersionApi - functional programming interface
 * @export
 */
export const VersionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VersionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async versionControllerGetVersion(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VersionDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.versionControllerGetVersion(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['VersionApi.versionControllerGetVersion']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * VersionApi - factory interface
 * @export
 */
export const VersionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = VersionApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    versionControllerGetVersion(options?: RawAxiosRequestConfig): AxiosPromise<VersionDto> {
      return localVarFp
        .versionControllerGetVersion(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * VersionApi - object-oriented interface
 * @export
 * @class VersionApi
 * @extends {BaseAPI}
 */
export class VersionApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VersionApi
   */
  public versionControllerGetVersion(options?: RawAxiosRequestConfig) {
    return VersionApiFp(this.configuration)
      .versionControllerGetVersion(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * VideosApi - axios parameter creator
 * @export
 */
export const VideosApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary A direct upload URL allow the client to directly upload a video to MUX through a signed URL.
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerCreateDirectUploadUrl: async (
      assetId: string,
      body: object,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('videosControllerCreateDirectUploadUrl', 'assetId', assetId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists('videosControllerCreateDirectUploadUrl', 'body', body);
      const localVarPath = `/assets/{assetId}/videos/create-direct-upload-url`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieve a previously saved video, with its playback URL (if the video is ready). You can poll this route if you are waiting for the video processing.
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerFindOne: async (
      assetId: string,
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('videosControllerFindOne', 'assetId', assetId);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('videosControllerFindOne', 'id', id);
      const localVarPath = `/assets/{assetId}/videos/{id}`
        .replace(`{${'assetId'}}`, encodeURIComponent(String(assetId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VideosApi - functional programming interface
 * @export
 */
export const VideosApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VideosApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary A direct upload URL allow the client to directly upload a video to MUX through a signed URL.
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerCreateDirectUploadUrl(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoUploadDto>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.videosControllerCreateDirectUploadUrl(
          assetId,
          body,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['VideosApi.videosControllerCreateDirectUploadUrl']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Retrieve a previously saved video, with its playback URL (if the video is ready). You can poll this route if you are waiting for the video processing.
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.videosControllerFindOne(
        assetId,
        id,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['VideosApi.videosControllerFindOne']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * VideosApi - factory interface
 * @export
 */
export const VideosApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = VideosApiFp(configuration);
  return {
    /**
     *
     * @summary A direct upload URL allow the client to directly upload a video to MUX through a signed URL.
     * @param {string} assetId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerCreateDirectUploadUrl(
      assetId: string,
      body: object,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<VideoUploadDto> {
      return localVarFp
        .videosControllerCreateDirectUploadUrl(assetId, body, options)
        .then(request => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieve a previously saved video, with its playback URL (if the video is ready). You can poll this route if you are waiting for the video processing.
     * @param {string} assetId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerFindOne(
      assetId: string,
      id: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<VideoDto> {
      return localVarFp
        .videosControllerFindOne(assetId, id, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * VideosApi - object-oriented interface
 * @export
 * @class VideosApi
 * @extends {BaseAPI}
 */
export class VideosApi extends BaseAPI {
  /**
   *
   * @summary A direct upload URL allow the client to directly upload a video to MUX through a signed URL.
   * @param {string} assetId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public videosControllerCreateDirectUploadUrl(
    assetId: string,
    body: object,
    options?: RawAxiosRequestConfig
  ) {
    return VideosApiFp(this.configuration)
      .videosControllerCreateDirectUploadUrl(assetId, body, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Retrieve a previously saved video, with its playback URL (if the video is ready). You can poll this route if you are waiting for the video processing.
   * @param {string} assetId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public videosControllerFindOne(assetId: string, id: string, options?: RawAxiosRequestConfig) {
    return VideosApiFp(this.configuration)
      .videosControllerFindOne(assetId, id, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * VideosMuxWebhookApi - axios parameter creator
 * @export
 */
export const VideosMuxWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary This is the endpoint MUX will call when any events happen on their side. (Webhook)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosMuxWebhookControllerMuxWebhook: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/mux-webhook`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VideosMuxWebhookApi - functional programming interface
 * @export
 */
export const VideosMuxWebhookApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VideosMuxWebhookApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary This is the endpoint MUX will call when any events happen on their side. (Webhook)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosMuxWebhookControllerMuxWebhook(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.videosMuxWebhookControllerMuxWebhook(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['VideosMuxWebhookApi.videosMuxWebhookControllerMuxWebhook']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * VideosMuxWebhookApi - factory interface
 * @export
 */
export const VideosMuxWebhookApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = VideosMuxWebhookApiFp(configuration);
  return {
    /**
     *
     * @summary This is the endpoint MUX will call when any events happen on their side. (Webhook)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosMuxWebhookControllerMuxWebhook(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .videosMuxWebhookControllerMuxWebhook(options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * VideosMuxWebhookApi - object-oriented interface
 * @export
 * @class VideosMuxWebhookApi
 * @extends {BaseAPI}
 */
export class VideosMuxWebhookApi extends BaseAPI {
  /**
   *
   * @summary This is the endpoint MUX will call when any events happen on their side. (Webhook)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosMuxWebhookApi
   */
  public videosMuxWebhookControllerMuxWebhook(options?: RawAxiosRequestConfig) {
    return VideosMuxWebhookApiFp(this.configuration)
      .videosMuxWebhookControllerMuxWebhook(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * WalletApi - axios parameter creator
 * @export
 */
export const WalletApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get the global wallet balance for the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerGetWallet: async (
      assetId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assetId' is not null or undefined
      assertParamExists('expensesControllerGetWallet', 'assetId', assetId);
      const localVarPath = `/assets/{assetId}/expenses/wallet`.replace(
        `{${'assetId'}}`,
        encodeURIComponent(String(assetId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WalletApi - functional programming interface
 * @export
 */
export const WalletApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WalletApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get the global wallet balance for the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expensesControllerGetWallet(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalWalletDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expensesControllerGetWallet(
        assetId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['WalletApi.expensesControllerGetWallet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * WalletApi - factory interface
 * @export
 */
export const WalletApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = WalletApiFp(configuration);
  return {
    /**
     *
     * @summary Get the global wallet balance for the current user
     * @param {string} assetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expensesControllerGetWallet(
      assetId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GlobalWalletDto> {
      return localVarFp
        .expensesControllerGetWallet(assetId, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * WalletApi - object-oriented interface
 * @export
 * @class WalletApi
 * @extends {BaseAPI}
 */
export class WalletApi extends BaseAPI {
  /**
   *
   * @summary Get the global wallet balance for the current user
   * @param {string} assetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WalletApi
   */
  public expensesControllerGetWallet(assetId: string, options?: RawAxiosRequestConfig) {
    return WalletApiFp(this.configuration)
      .expensesControllerGetWallet(assetId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * WeatherApi - axios parameter creator
 * @export
 */
export const WeatherApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Retrieve the weather data for all your assets.
     * @param {string} languageCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    weatherControllerForAllMyAssets: async (
      languageCode: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'languageCode' is not null or undefined
      assertParamExists('weatherControllerForAllMyAssets', 'languageCode', languageCode);
      const localVarPath = `/weather/for-all-my-assets`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (languageCode !== undefined) {
        localVarQueryParameter['languageCode'] = languageCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WeatherApi - functional programming interface
 * @export
 */
export const WeatherApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WeatherApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Retrieve the weather data for all your assets.
     * @param {string} languageCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async weatherControllerForAllMyAssets(
      languageCode: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetWeatherDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.weatherControllerForAllMyAssets(
        languageCode,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['WeatherApi.weatherControllerForAllMyAssets']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * WeatherApi - factory interface
 * @export
 */
export const WeatherApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = WeatherApiFp(configuration);
  return {
    /**
     *
     * @summary Retrieve the weather data for all your assets.
     * @param {string} languageCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    weatherControllerForAllMyAssets(
      languageCode: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<AssetWeatherDto>> {
      return localVarFp
        .weatherControllerForAllMyAssets(languageCode, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * WeatherApi - object-oriented interface
 * @export
 * @class WeatherApi
 * @extends {BaseAPI}
 */
export class WeatherApi extends BaseAPI {
  /**
   *
   * @summary Retrieve the weather data for all your assets.
   * @param {string} languageCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WeatherApi
   */
  public weatherControllerForAllMyAssets(languageCode: string, options?: RawAxiosRequestConfig) {
    return WeatherApiFp(this.configuration)
      .weatherControllerForAllMyAssets(languageCode, options)
      .then(request => request(this.axios, this.basePath));
  }
}
